import React, { Component } from "react";
import ReactDOM from "react-dom";
import { NumericFormat } from 'react-number-format';
import { 
    Accordion, 
    Alert, 
    Badge, 
    Button, 
    Card, 
    Col, 
    Collapse,
    Dropdown,
    DropdownButton,
    Form, 
    Modal, 
    OverlayTrigger, 
    ProgressBar, 
    Row, 
    Spinner, 
    Tab, 
    Table, 
    Tabs, 
    Tooltip 
} from "react-bootstrap";

import api from "../../services/api";
import ModalRelatosEtapaAtual from "./ModalRelatosEtapaAtual";
import { IMaskInput } from "react-imask";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { debounceAsync } from '../../utils/debounce';
import { 
    destinatariosMensagem, 
    executeFunctionByName, 
    formataCNPJ, 
    formataCPF, 
    formataDataApi,
    formataDataExibicao, 
    formataDataHoraExibicao, 
    formatarValor, 
    formatarValorAPI, 
    formatarValorAPISemDecimais,
    formatarValorLocal, 
    getCurrentUser, 
    getDataAtual, 
    grupoEtario, 
    hasPerm, 
    isUUID,
    kitsStatus,
    motivosAplicacao,
    responsaveisEtapas,
    situacoesAgendamento,
    statusAtendimento,
    tiposAcesso,
    tiposArquivos,
    tiposCancelamento,
    tiposPaciente,
    tiposSessoesAtendExtra,
    tiposSessoesCampos,
    isLaudoBloqueadoParaUsuarioAtual,
    isDadosConfirmacaoBloqueadosParaUsuarioAtual,
} from '../../common/utils';
import { 
    FaCheck, 
    FaCheckCircle, 
    FaCheckDouble, 
    FaChevronDown, 
    FaChevronUp, 
    FaClock, 
    FaDownload, 
    FaEdit, 
    FaExclamation, 
    FaExclamationTriangle, 
    FaEye, 
    FaFile, 
    FaFilePdf, 
    FaHistory, 
    FaInfoCircle,
    FaLaptopHouse,
    FaLock,
    FaNotesMedical, 
    FaPause, 
    FaPencilAlt, 
    FaPhone, 
    FaPhoneSlash,
    FaPlay, 
    FaPlus, 
    FaQuestionCircle, 
    FaReceipt,
    FaRegClock, 
    FaSortDown,
    FaSortUp,
    FaStream, 
    FaTimes, 
    FaTrash, 
    FaUpload,
    FaUser, 
    FaWhatsapp 
} from "react-icons/fa"; 
import Paginacao from '../../common/pagination';
import FormularioRender from '../Formularios/FormularioRender';
import axios from 'axios';
import * as Sentry from "@sentry/react";
import moment from "moment-timezone";
import ExamesComponent from '../Exames/ExamesComponent';
import AtendimentosHiPlatformParaAtendimento from "../AtendimentosHiPlatform/AtendimentosHiPlatformAtendimentos";
import GotoConnectAtendimentos from "../GotoConnect/GotoConnectAtendimentos";
import MedicosEdit from "../Medicos/MedicosEdit";
import PacientesEdit from "../Pacientes/PacientesEdit";
import ComplianceAtendimento from "../Compliance/ComplianceAtendimento";
import ConfirmarRealizacaoModal from "../Modals/ConfirmarRealizacaoModal";      
import ModalPersonalizadoServicos from "../Modals/ModalPersonalizadoServicos";  
import FormularioEventoModal from "../Modals/FormularioEventoModal";
import PhenylalanineHistoryChart from "./PhenylalanineHistoryChart";
import { buscarFormularioEvento, EVENTOS } from "../../services/eventosForm";
import { PDFDocument, StandardFonts, PDFName, PDFString, PDFBool } from 'pdf-lib';
import { getConfig } from "../../common/config";

const CAMPO_SLUG_REPORT_REFERENCE = "report-reference-number";
const CAMPO_SLUG_ODC_AMOSTRA_ACEITA = "odc_amostra_aceita";
const FARMACO_SUMMARY_TEXT_LIMIT_DEFAULT = 980;

const categoriasLaboratorio = ['laboratorio_diagnostico', 'hospitais', 'clinicas', 'cooperativas_saude', 'transporte', 'logistica'];

const verificarOcultarEtapa = (ocultar_etapa_array, prestador_categoria) => {
    // Verifica diretamente se a categoria está na lista
    if (ocultar_etapa_array.includes(prestador_categoria)) {
        return true;
    }
    // Se ocultar_etapa contém laboratorio_diagnostico, verifica se a categoria do prestador está no grupo
    if (ocultar_etapa_array.includes('laboratorio_diagnostico') && categoriasLaboratorio.includes(prestador_categoria)) {
        return true;
    }
    return false;
}

const formatarValorRelato = (valor) => {
    // Verifica se é boolean
    if (valor === "true") return 'Sim';
    if (valor === "false") return 'Não';
    
    // Verifica se é data no formato YYYY-MM-DD
    if (valor && /^\d{4}-\d{2}-\d{2}$/.test(valor)) {
        const [ano, mes, dia] = valor.split('-');
        return `${dia}/${mes}/${ano}`;
    }
    
    return valor;
};
       
class AtendimentosEdit extends Component {
    constructor(props) {
        super(props);
        this._submittingRelato = false; // Flag de instância para prevenir duplo submit no registro de etapa
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEtapaAtual = this.handleChangeEtapaAtual.bind(this);
        this.handleChangeAgendamento = this.handleChangeAgendamento.bind(this);
        this.handleChangeAgendamentoEdit = this.handleChangeAgendamentoEdit.bind(this);
        this.onChangeArquivo = this.onChangeArquivo.bind(this);
        this.handleChangeCampo = this.handleChangeCampo.bind(this);
        this.handleChangeCampoAsync = this.handleChangeCampoAsync.bind(this);
        this.handleLaboratorioVinculadoChange = this.handleLaboratorioVinculadoChange.bind(this);
        this.handlePasteCep = this.handlePasteCep.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.toggleDetalhesRelato = this.toggleDetalhesRelato.bind(this);

        this.onChangeCep = this.onChangeCep.bind(this);
        this.onChangeEndereco = this.onChangeEndereco.bind(this);
        this.onChangeNumero = this.onChangeNumero.bind(this);
        this.onChangeComplemento = this.onChangeComplemento.bind(this);
        this.onChangeNome = this.onChangeNome.bind(this);
        this.onChangeCidade = this.onChangeCidade.bind(this);
        this.onChangeUF = this.onChangeUF.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.logsOnClickPagina = this.logsOnClickPagina.bind(this);

        this.fileInput = React.createRef();
        this.fileInputComprovante = React.createRef();
        this.fileInputComprovanteLaboratorio = React.createRef();
        this.fileInputTermoAssinado = React.createRef();

        this.parseProgramaConfiguracoes = this.parseProgramaConfiguracoes.bind(this);
        this.getProgramaConfig = this.getProgramaConfig.bind(this);
        this.carregaPrestadoresDebounced = debounceAsync(this.carregaPrestadores.bind(this), 500);
        
        this.list_generos = {
            "F": "Feminino",
            "M": "Masculino",
            "O": "Prefere não informar",
            "NI": "Não informado"
        };

        this.list_tipo_agendamento = {
            "novo": "Novo",
            "adequacao": "Adequação",
            "renovacao": "Renovação",
        },

        this.list_meeting_tipos_host = {
            "prestador": "Prestador",
            "operador": "Operador",            
        },

        this.state = {
            atendimento_id: '',
            uuid: '',
            tab_key: 'dadosAtendimento',
            activeKey: null, //etapa ativa do histórico
            pendingEtapaAccordionKey: null,
            is_perfil_medico: false,
            is_perfil_laboratorio: false,
            is_creating: false,
            is_loading_paciente: false,
            agendamento_id: '',
            agendamento_selecionado: [],
            beneficiario_id: '',
            beneficiario_nome: '',
            beneficiario_celular: '',
            beneficiario_atendimentos: false,
            beneficiario_atendimento_aberto_id: '',
            beneficiario_dados: [],
            cancelado: false,
            atendente_id: '',
            atendente_nome: '',
            data: '',
            pdf_termo_prestador: '',
            lets_sign_documento_id: '',
            lets_sign_documento_assinado_url: '',
            lets_sign_msg_erro: '',
            lets_doc_status: '',
            lets_assinatura_status: '',
            regerandoTermoLaboratorio: false,
            programa_id: '',
            programa_uuid: '',
            programa_nome: '',
            exige_cpf_atendimento: true,
            doenca_id: '',
            doenca_nome: '',
            recebe_kit_paciente: false,
            doenca_idade_maxima: 0,
            doenca_idade_minima: 0,
            programa_dados: [],
            programa_planos: [],
            botoes_atendimento: [],
            dicas: [],
            botao_atual: {},
            showModalBotao: false,
            plano_servicos: [],
            servicos_prestadores: [],
            plano_unico: false,
            justificativa_limite: '',
            confirmacao_diagnostico: false,
            finalizado: false,
            optin_data: '',
            optin_data_laboratorio: '',
            optin_ip: '',
            optin_telefone: '',
            optin_termo_conteudo: '',
            termo_paciente_pdf_comprovante: '',
            termo_prestador_pdf_comprovante: '',
            etapa_id: '',
            etapa_nome: '',
            etapa_conteudo_mensagem: '',
            etapa_atendimento_id: '',
            etapa_atendimento_status: '',
            etapa_atendimento_data_status: '',
            etapas_ocultas: 0,
            cliente_id: '',
            cliente_nome: '',
            paciente_id: "",
            medico_id: '',
            medico_atual_id: '',
            medico_nome: '',
            laboratorio_id: '',
            laboratorio_nome: '',
            laboratorios: [],
            laboratorios_medico: [],
            prestador_logado_id: '',
            prestador_logado_categoria: '',
            plano_id: '',
            plano_nome: '',
            finalizar_etapa: false,
            dataHelper: '',
            beneficiarioHelper: '',
            atendenteHelper: '',
            programaHelper: '',
            etapaHelper: '',
            clienteHelper: '',
            loading: false,
            loadingAgendamentos: true,
            agendamentos: [],
            agendamentos_data: {},
            agendamentos_page_numb: 1,
            agendamentos_limite: 20,
            dados_agendamento: [],
            agendamento_data: '',
            agendamento_prestador_id: '',
            agendamento_prestador_nome: '',
            agendamento_valor: '',
            agendamento_servico_procedimento_id: '',
            agendamento_servico_procedimento_nome: '',
            agendamento_servico_procedimento_limite: '',
            agendamento_servico_video_conferencia: '',
            agendamento_medico_id: '',
            agendamento_medico_nome: '',
            agendamento_servico_terapia: false,
            agendamento_terapia_id: '',
            agendamento_terapia_nome: '',
            anotacoes: '',

            local_nome: '',
            local_cep: '',
            local_endereco: '',
            local_numero: '',
            local_complemento: '',
            local_cidade: '',
            local_uf: '',
            informarLocalRealizacao: true,
            solicitarAceiteRecusa: false, 
            servicoMonitoria: false, 

            showHistoricoAgendamentosModal: false,
            historicoAgendamentosRows: [],
            historicoAgendamentosLoading: false,
            historicoAgendamentosErro: '',
            historicoAgendamentosAgendamentoId: null,
            historicoAgendamentosPrestadoresMap: {},

            showDespesasAgendamentosModal: false,
            despesasAgendamentosLoading: false,
            despesasAgendamentosErro: '',
            despesasAgendamentosRows: [],
            despesasAgendamentosAgendamentoId: null,

            despesasAgendamentosCategorias: [],
            despesasAgendamentosShowForm: false,
            despesasAgendamentosForm: { descricao: '', valor: '', data: '', despesa_categoria_id: '', categoria_outros: '', comprovanteFile: null},

            acoes: [],
            programa_acao_id: '',
            programa_acao_nome: '',
            programa_acao_descricao: '',
            programa_acao_observacoes: '',
            programa_acao_data: '',
            programa_acao_hora: '',
            programa_acao_realizado: '',
            showModalAcoes: false,
            showModal: false,
            produtos: [],
            produto_id: '',
            produto_nome: '',
            produto_valor: '',
            programa_produto_id: '',
            programa_produto_nome: '',
            programa_produto_valor: '',
            dosagens: [],
            dosagem_id: '',
            dosagem_nome: '',
            dosagem_quantidade: '',
            dosagem_apresentacao_id: '',
            dosagem_apresentacao_descricao: '',
            showModalDosagem: false,
            compras: [],
            exames: [],
            compra_id: '',
            compra_nome: '',
            compra_farmacia_id: '',
            compra_farmacia_nome: '',
            compra_etapa_id: '',
            compra_etapa_nome: '',
            compra_data_compra: '',
            compra_data_proxima_compra: '',
            showModalCompra: false,
            etapas_todas_atendimento: [],
            etapas_atendimento: [],
            relatos_atendimento: [],
            etapa_atual: {},
            etapa_relato: {},
            etapas_status: [],
            formulario_id: '',
            showModalDescricao: false,
            showModalAgendamento: false,
            showModalVisualizarAgendamento: false,
            showConfirmarRealizacaoModal: false,
            agendamentoParaConfirmar: null,
            showModalPersonalizadoServicos: false,
            agendamentoFormularioDinamico: null,
            showModalArquivos: false,
            showModalArquivosEdit: false,
            showModalTermosPaciente: false,
            showModalServicoAtendimento: false,
            tipo_arquivo_agendamento: '',
            arquivo_upload: '',
            arquivo: '',
            arquivo_nome: '',
            arquivos: [],
            arquivo_aprovado: false,
            arquivo_tipo: '',
            arquivo_id: '',
            arquivo_atual: '',
            dados_usuario: '',
            dados_criador_atendimento: {},
            permite_editar: true,
            showModalRelatosEdit: false,
            showModalRelatosEtapaAtual: false,
            camposFormulario: [],
            valoresCampos: {},
            valoresCamposExtra: {},
            valoresCamposExtraPaciente: {},
            camposOutro: {},
            selecaoFinalizaEtapa: {},
            historicoEtapas: [],
            relatosPorEtapa: {},
            showModalPaciente: false,
            showModalAtendimentoPaciente: false,
            showModalConsultaHistoricoLigacoes: false,
            cpf: '',
            nome: "",
            data_nascimento: "",
            email: "",
            telefone: "",
            endereco_telefone: "",
            celular: "",
            genero: "NI",
            cep: '',
            nome_local: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
            tipo_cuidador: '',
            cuidador_nome: '',
            cuidador_cpf: '',
            cuidador_data_nascimento: '',
            cuidador_endereco: '',
            cuidador_celular: '',
            cuidador_telefone: '',
            cuidador_email: '',
            nomeLocalHelper: "",
            nomeHelper: "",
            dataNascimentoHelper: "",
            cpfHelper: "",
            emailHelper: "",
            telefoneHelper: "",
            enderecoTelefoneHelper: "",
            celularHelper: "",
            cepHelper: '',
            enderecoHelper: '',
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cidadeHelper: '',
            ufHelper: '',
            tipoCuidadorHelper: '',
            cuidadorNomeHelper: "",
            cuidadorCpfHelper: "",
            cuidadorDataNascimentoHelper: "",
            cuidadorEnderecoHelper: "",
            cuidadorCelularHelper: "",
            cuidadorTelefoneHelper: "",
            cuidadorEmailHelper: "",
            clienteIdHelper: '',
            goToAccessToken: "",
            goToClient_id: "",
            goToLinhasUsuario: "",
            goToErroMensagem: "",
            goToLinhasAtendente: [],
            goToLinhaLigar: '',
            goToInitiatorId: '',
            goToLigacaoRealizada: true,
            goToLoaderLigacao: false,
            opcaoModalRelato: 'cadastrar_etapa',
            tipo_cancelamento: '',
            etapa_voltar: '',
            etapa_voltar_nome: '',
            motivo_cancelamento: '',
            label_outras_acoes: 'Atualizar Status',
            programa_select_key: 0,
            medico_select_key: 0,
            beneficiario_select_key: 0,
            servicos_etapa: [],
            relato_servico_procedimento_id: '',
            relato_servico_procedimento_nome: '',
            servicos_atendimento: [],
            servicos_atendimento_all: [],
            servicos_atendimento_data: {},
            servicos_atendimento_page_numb: 1,
            servicos_atendimento_limite: 50,
            servicos_atendimento_loading: false,
            servico_modal: [],
            total_servicos: 0,
            relato_tipo_paciente: '',
            tipo_paciente: '',
            valor_servico_edicao: 0,
            data_servico_edicao: 0,
            exibirDetalhesRelato: {},
            atendimento_campos: [],
            pacientes_campos: [],
            camposExtraCadastrados: [],
            showModalMonitoria: false,
            showModalProduto: false,
            monitoria: [],
            monitoria_tipos: [],
            monitoria_id: "",
            monitoria_tipo: "",
            monitoria_tipo_id: "",
            monitoria_status: "",
            monitoria_status_id: "",
            monitoria_motivo: "",
            monitoria_page_numb: 1,
            monitoria_limite: 10,
            monitoria_loading: false,
            monitoria_ordem: 'data_agendada',
            monitoria_ordem_direcao: 'desc',
            monitoria_dosagens: [],
            programa_status_id: '',
            motivo_status: '',
            optin_telefone_chamada_id: '',
            servico_agendamento_key: 0,
            doenca_outros: '',
            programa_status_slug: '',
            camposOutrosExtra: {},
            dados_medico: {},
            logs_atendimento: [],
            logs_atendimento_campos: [],
            showModalCamposHistorico: false,
            proxima_acao: null,
            alterar_medico: false,
            templates_whatsapp: [],
            reativar_atendimento: false,
            showModalHistorico: false,
            historicoCampos: [],
            nomeCampoHistorico: '',
            medico_data_alteracao: '',
            showModalTemplateWhatsapp: false,
            optout_data: '',
            optout_motivo_id: '',
            optout_motivo_outros: '',
            optout_motivo_titulo: '',
            idade_minima: 0,
            idade_maxima: 0,
            servico_procedimento_id: '',
            formulario_pesquisa_id: '',
            formulario_pesquisa_respondida: '',
            showModalAnotacoes: false,
            aceita_kit_paciente: false,
            recebe_kit_paciente: false,
            kitsEnviados: [],
            showModalKit: false,
            showNovoEndereco: false,
            data_envio: '',
            descricao: '',
            novo_endereco: '',
            enderecos: [],
            enderecoSelecionado: null,
            exames_extras_solicitacao: [],
            showModalNovoEndereco: false,
            novoEndereco: {
                nome: '',
                cep: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: ''
            },
            endereco_kit_id: '',
            enderecoVisualizado: null,
            showModalEndereco: false,
            usingEnderecoAtual: false,
            cpf_nao_informado: false,
            meeting_tipo_host: 'prestador',
            showModalPrestador: false,
            prestadorDados: {},
            prestadorAgendamento: null, // Agendamento relacionado ao modal do prestador
            prestadorServico: null, // Serviço relacionado ao modal do prestador (aba Serviços Relacionados)
            alterandoPrestadorAgendamentoId: null, 
            loadingAlterarPrestador: false,
            motivosCancelamento: [],      
            motivoSelecionado: '',          
            motivoOutro: '',             
            logs_limite: 30,
            logs_page_numb: 1,
            extra_valores_beneficiario_list: [],
            dados_programa: {},
            dados_cliente: {},
            disabledInputMedico: false,
            repetidor_list: [{ atendimento_campo_id: null, nome: '', slug: '', descricao: '', tipo: '', obrigatorio: '', opcoes: ''}],
            cadastro_teste: false,
            produto_descricao: '',
            is_aplicacao_realizado: false,
            editingCampoValues: {},
            campoEditadoValores: {},
            updatingCampoValues: {},
            showHistoricoModal: false,
            historicoAceites: [],
            historicoLoading: false,
            historicoError: '',
            finalizar_recorrencia: false,
            enviarKitAgendamento: null, // 'sim' | 'nao'
            novoEnderecoKit: {
                nome: '',
                cep: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: '',
            },
            dataEnvioKit: '',
            historicoPendente: null,
            uploadTermoAssinadoId: '',
            produtosOpcoes: [],
            goto_hist_data_inicio: '',
            goto_hist_data_final: '',
            goto_hist_num_telefone: '',
            goto_hist_campo_id: '',
            lista_historico_ligacoes: [],
            autoSolicitarExames: false,
            showModalEditKit: false,
            editKitLoading: false,
            editKit: {
                id: null,
                descricao: '',
                data_envio: '',              
                status: '',                  
                data_envio_realizado: '',    
                endereco_id: null,
                endereco_compacto: '',
                dados_kit: {},       
            },
            kitsProgramaLoading: false,
            kitsProgramaOptions: [],   
            kitSelecionadoId: '',   
            agendamento_tipo: '',  
            modal_relato_tipo: '', 
            tempReportRef: null,
            camposMaxLengthOverrides: {},
            loadingCamposFormulario: false,
            agendamento_original_data: null,   
            reagendamentos: [],               
            showModalReagendamentos: false, 
            programa_config: {},
            agendamento_exige_termo_aceite: false,   
            agendamento_termo_pdf_url: '',
            agendamento_termo_assinado_file: null,
            agendamento_termo_assinado_url: '',
            agendamento_termo_helper: '',
            permite_alterar_valor_agendamento: false,

            dropdownAbertoId: null,
            dropdownPosition: { top: 0, left: 0 },
            // FormularioEvento (aprovação de laudo)
            showFormularioEventoModal: false,
            formularioEventoData: null,
            arquivoParaAprovar: null,
            // FormularioEvento (aprovação durante confirmação de serviço)
            showFormularioEventoModalConfirmacao: false,
            formularioEventoDataConfirmacao: null,
            agendamentoParaConfirmarComFormulario: null,
            dadosFormularioAprovacaoColetados: null,
        };

        // Configuração padrão e específica para cada status com ícones
        this.statusConfig = {
            aguardando: { background: '#dddddd', color: '#252f4a', text: 'Aguardando', icon: <FaRegClock /> },
            parado: { background: '#eb4961', color: '#fff', text: 'Parado', icon: <FaPause /> },
            em_andamento: { background: '#5e74fb', color: '#fff', text: 'Em Andamento', icon: <FaPlay /> },
            concluido: { background: '#3cc172', color: '#fff', text: 'Concluído', icon: <FaCheck /> },
            cancelado: { background: '#eb4961', color: '#fff', text: 'Cancelado', icon: <FaTimes /> },
        };

        this.list_sexos = {"F": "Feminino", "M": "Masculino", "O": "Outro"};

        this.list_tipos_cuidadores = {
            "pais": "Pais",
            "conjuge": "Cônjuge",
            "filho": "Filho",
            "parente": "Parente",
            "outro": "Outro",
        }  

        this.list_tipos_pessoa = {"fisica": "Física", "juridica": "Jurídica"};

        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };
    }
    
    parseProgramaConfiguracoes = (configuracoes) => {
        if (!configuracoes) return {};
        if (typeof configuracoes === 'object') return configuracoes;
        if (typeof configuracoes === 'string') {
            try {
                const parsed = JSON.parse(configuracoes);
                return (parsed && typeof parsed === 'object') ? parsed : {};
            } catch (error) {
                console.error('Falha ao interpretar configurações do programa', error);
                return {};
            }
        }
        return {};
    };
    
    getProgramaConfig = (path, fallback) => {
        return getConfig(this.state.programa_config, path, fallback);
    };
    
    setProgramaConfig = (programaData) => {
        // A chave 'configuracoes' pode estar na raiz ou dentro de 'dados_programa'
        const configSource = programaData.configuracoes || programaData.dados_programa?.configuracoes;
        const programaConfig = this.parseProgramaConfiguracoes(configSource);
        this.setState({ programa_config: programaConfig });
    };

    parseCamposPdfEntries = (raw) => {
        if (!raw) return [];

        if (Array.isArray(raw)) {
            return raw.filter(Boolean);
        }

        if (typeof raw === 'string') {
            try {
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed.filter(Boolean) : [parsed];
            } catch (e) {
                console.warn('campos_pdf string inválido', e);
                return [];
            }
        }

        if (typeof raw === 'object') {
            return [raw];
        }

        return [];
    };

    normalizePdfFieldName = (name = '') => {
        return String(name || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
    };

    isSummaryPdfFieldName = (name = '') => {
        const normalized = this.normalizePdfFieldName(name);
        return normalized.includes('summary of event') && normalized.includes('additional information');
    };

    inferSummaryFieldLimitFromTemplate = async (templateUrl, pdfFieldName, fontSize = 10) => {
        try {
            const resp = await fetch(templateUrl, { cache: 'no-store' });
            if (!resp.ok) throw new Error(`Falha ao baixar o PDF (HTTP ${resp.status})`);

            const ct = resp.headers.get('content-type') || '';
            if (!ct.includes('pdf')) throw new Error('Arquivo de template inválido');

            const arrayBuf = await resp.arrayBuffer();
            const pdfDoc = await PDFDocument.load(arrayBuf);
            const form = pdfDoc.getForm();
            const field = form.getTextField(pdfFieldName);
            const widget = field?.acroField?.getWidgets?.()[0];
            const rect = widget?.getRectangle?.();

            if (!rect?.width || !rect?.height) {
                return FARMACO_SUMMARY_TEXT_LIMIT_DEFAULT;
            }

            const helv = await pdfDoc.embedFont(StandardFonts.Helvetica);
            const effectiveFontSize = Number(fontSize) > 0 ? Number(fontSize) : 10;
            const alphabet = 'abcdefghijklmnopqrstuvwxyz';
            const avgCharWidth = (helv.widthOfTextAtSize(alphabet, effectiveFontSize) / alphabet.length) || (effectiveFontSize * 0.52);

            const safeLines = Math.max(1, Math.floor(rect.height / (effectiveFontSize * 1.2)) - 1);
            const safeCharsPerLine = Math.max(20, Math.floor((rect.width / avgCharWidth) * 0.88));
            const estimated = safeLines * safeCharsPerLine;

            return Math.max(300, Math.min(2000, estimated));
        } catch (error) {
            console.warn('Não foi possível inferir limite do campo Summary no template PDF', error);
            return FARMACO_SUMMARY_TEXT_LIMIT_DEFAULT;
        }
    };

    buildFarmacoMaxLengthOverrides = async (campos = [], templateUrl = '') => {
        const summaryTargets = [];

        for (const campo of campos) {
            const entries = this.parseCamposPdfEntries(campo?.campos_pdf);
            for (const item of entries) {
                const fieldName = item?.name || item?.pdf_field_name || '';
                const fieldType = (item?.type || item?.pdf_field_type || 'text').toString().toLowerCase();
                const isTextType = !fieldType || fieldType === 'text' || fieldType.includes('text');
                if (!isTextType) continue;
                if (!this.isSummaryPdfFieldName(fieldName)) continue;

                summaryTargets.push({
                    campoId: campo.id,
                    campoNome: campo.nome,
                    fieldName,
                    fontSize: item?.fontSize ?? null,
                });
            }
        }

        if (!summaryTargets.length) {
            return {};
        }

        const overrides = {};
        for (const target of summaryTargets) {
            const limit = templateUrl
                ? await this.inferSummaryFieldLimitFromTemplate(templateUrl, target.fieldName, target.fontSize || 10)
                : FARMACO_SUMMARY_TEXT_LIMIT_DEFAULT;
            overrides[target.campoId] = limit;
        }

        return overrides;
    };

    getCampoValorAsTexto = (valor, campoId, camposOutro = {}) => {
        if (valor && typeof valor === 'object' && 'target' in valor) {
            const { target } = valor;
            if (target?.type === 'file' && target?.files?.length) return '';
            valor = target?.value;
        }

        if (Array.isArray(valor)) {
            return valor.map(v => (v ?? '').toString()).join(', ');
        }

        if (valor === null || valor === undefined) {
            return '';
        }

        let texto = typeof valor === 'string' ? valor : String(valor);
        if (['outro', 'outros'].includes(texto.trim().toLowerCase()) && camposOutro && camposOutro[campoId]) {
            texto = `Outro - ${String(camposOutro[campoId]).trim()}`;
        }

        return texto;
    };

    validateCamposMaxLength = (valoresCampos = {}, camposOutro = {}, maxLengthOverrides = {}) => {
        const campos = this.state.camposFormulario || [];

        for (const [campoIdRaw, max] of Object.entries(maxLengthOverrides || {})) {
            const campoId = Number(campoIdRaw);
            const maxLen = Number(max);
            if (!maxLen) continue;

            const valorTexto = this.getCampoValorAsTexto(valoresCampos[campoId], campoId, camposOutro);
            if ((valorTexto || '').length <= maxLen) continue;

            const campo = campos.find(c => Number(c.id) === campoId);
            const campoNome = campo?.nome || 'Summary of event / additional information';

            return {
                campoNome,
                maxLen,
                atual: valorTexto.length,
            };
        }

        return null;
    };
    
    fetchDetalhesServico = async (servicoId) => {
        try {
            // endpoint do seu CRUD de serviços/procedimentos — ajuste se necessário
            const { data } = await api.get(`/servicos_procedimentos/${servicoId}/`);
            // O serializer de serviços já faz to_representation com URLs assinadas
            const exige = !!data.exige_termo_aceite;
            const pdfUrl = data.termo_aceite_pdf || ''; // já vem assinado se existir
            this.setState({
                agendamento_exige_termo_aceite: exige,
                agendamento_termo_pdf_url: pdfUrl,
                agendamento_termo_helper: '',
                });
        } catch (e) {
            console.error('Falha ao buscar detalhes do serviço', e);
            this.setState({
            agendamento_exige_termo_aceite: false,
            agendamento_termo_pdf_url: '',
            });
        }
    };

    shouldShowExamesTab = () => {
        const { atendimento_id, programa_dados, etapa_nome, dados_usuario, extra_valores_beneficiario_list, pacientes_campos } = this.state;
        
        if (!atendimento_id || !dados_usuario) return false;
        
        const { habilitar_exames, configuracoes } = programa_dados || {};
        const tipo_usuario = dados_usuario.tipo_usuario || '';
        const prestador_categoria = dados_usuario.prestador_categoria || '';

        const temPermissaoBasica = habilitar_exames && (
            tipo_usuario === '' || 
            tipo_usuario === 'gestor' || 
            tipo_usuario === 'operador' || 
            prestador_categoria === 'medicos'
        );

        if (!temPermissaoBasica) return false;

        let config = this.getProgramaConfig('control_show_tab_exames');
        
        if (!config && configuracoes) {
            const configsParsed = this.parseProgramaConfiguracoes(configuracoes);
            config = configsParsed['control_show_tab_exames'] || configsParsed['control-show-tab-exames'];
        }

        if (!config) return true;

        // Regra: deny-profiles
        const denyProfiles = config['deny-profiles'] || config['deny_profiles'];
        if (denyProfiles && Array.isArray(denyProfiles)) {
             if (denyProfiles.includes(prestador_categoria)) return false;
             if (denyProfiles.includes(tipo_usuario)) return false;
        }

        // Regra: etapas
        if (config.etapas && Array.isArray(config.etapas)) {
             let aplicarRegraEtapa = true;
             
             if (config.profiles && Array.isArray(config.profiles)) {
                 const perfilCorresponde = config.profiles.includes(prestador_categoria) || config.profiles.includes(tipo_usuario);
                 if (!perfilCorresponde) {
                     aplicarRegraEtapa = false;
                 }
             }
             
             if (aplicarRegraEtapa) {
                 if (!config.etapas.includes(etapa_nome)) {
                     return false;
                 }
             }
        }

        // Regra: validate_fields (NOVO)
        if (config.validate_fields && Array.isArray(config.validate_fields)) {
            if (config.exception_profiles && Array.isArray(config.exception_profiles)) {
                 const isException = config.exception_profiles.includes(prestador_categoria) || config.exception_profiles.includes(tipo_usuario);
                 if (isException) return true; 
            }

            const camposDef = pacientes_campos || [];
            const valoresExtras = extra_valores_beneficiario_list || [];

            for (const rule of config.validate_fields) {
                if (rule.profiles && Array.isArray(rule.profiles)) {
                     const userMatches = rule.profiles.includes(prestador_categoria) || rule.profiles.includes(tipo_usuario);
                     if (!userMatches) continue; 
                }

                if (rule.etapas && Array.isArray(rule.etapas)) {
                    if (!rule.etapas.includes(etapa_nome)) continue;
                }

                const fieldDef = camposDef.find(c => c.slug === rule.slug);
                if (!fieldDef) continue; 

                const fieldValObj = valoresExtras.find(v => (v.beneficiario_campo_id === fieldDef.id) || (v.campo_id === fieldDef.id));
                const valor = fieldValObj ? fieldValObj.valor : null;

                if (!valor) return false; 

                if (rule.type === 'date-diff-days') {
                    const today = new Date();
                    today.setHours(0,0,0,0);
                    
                    let dateVal = new Date(valor);
                    const parts = valor.split('-');
                    if (parts.length === 3) {
                         dateVal = new Date(parts[0], parts[1]-1, parts[2]);
                    }
                    dateVal.setHours(0,0,0,0);

                    if (isNaN(dateVal.getTime())) return false;

                    const diffTime = Math.abs(today - dateVal);
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

                    if (rule.operator === 'gt' && !(diffDays > rule.value)) return false;
                    if (rule.operator === 'gte' && !(diffDays >= rule.value)) return false;
                    if (rule.operator === 'lt' && !(diffDays < rule.value)) return false;
                    if (rule.operator === 'lte' && !(diffDays <= rule.value)) return false;
                    if (rule.operator === 'eq' && !(diffDays === rule.value)) return false;

                } else if (rule.type === 'equals') {
                    if (valor != rule.value) return false;
                }
            }
        }

        return true;
    };
    
    onChangeTermoAssinado = (event) => {
        const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
        if (file && file.type !== 'application/pdf') {
            this.setState({ agendamento_termo_helper: 'Envie um arquivo PDF válido.', agendamento_termo_assinado_file: null });
            if (this.fileInputTermoAssinado.current) this.fileInputTermoAssinado.current.value = '';
            return;
        }
        this.setState({ agendamento_termo_assinado_file: file, agendamento_termo_helper: '' });
    };
    
    limparTermoAssinado = () => {
        this.setState({ agendamento_termo_assinado_file: null, agendamento_termo_helper: '' });
        if (this.fileInputTermoAssinado.current) this.fileInputTermoAssinado.current.value = '';
    };
    
    componentDidMount(){
        const id = this.props.router.params.id;

        // Verifica se o ID é um número inteiro ou não é um UUID válido
        if(id) {
            const isInteger = /^\d+$/.test(id);

            if (isInteger || !isUUID(id)) {
                window.location.href = '/sem-permissao';
                return;
            }
        }

        //Verifica se tem paciente por parâmetro
        const searchParams = new URLSearchParams(this.props.router.location.search);
        const pacienteId = searchParams.get('paciente');
        if (pacienteId) {
            this.carregaBeneficiarioPorId(pacienteId);
        }

        const tab = searchParams.get('t');
        const etapaParam = searchParams.get('etapa');
        this.setState({ 
            tab_key: tab === 'historico' ? 'historicoEtapas' : 'dadosAtendimento'
        });

        this.setState({
            uuid: id,
            loading: true,
            erroLoadRegistro: ''
        })

        const dados_user = getCurrentUser();     
        this.setState({
            dados_usuario: dados_user,
        })

        //Verifica se oculta o menu atendimentos
        if(dados_user['ambiente_programa_id']) {
            const programa_id = dados_user['ambiente_programa_id'];
            const cachedOcultarReceptivos = localStorage.getItem(`programa_ocultar_receptivos_${programa_id}`);
            const cachedOcultarAtendimentos = localStorage.getItem(`programa_ocultar_atendimentos_${programa_id}`);

            if(cachedOcultarAtendimentos === 'sim' && cachedOcultarReceptivos === 'nao') {
                window.location.href = '/atendimentos-receptivo';
                return;
            }
        }

        if(dados_user['tipo_usuario'] == 'prestador') {
            if(dados_user['prestador_categoria'] == 'medicos' || dados_user['prestador_categoria'] == 'multiprofissionais') {
                this.setState({
                    is_perfil_medico: true
                })
            } else {
                this.setState({
                    is_perfil_laboratorio: true
                })
            }
        }

        if(id){
            this.carregarDadosAtendimento(id, etapaParam, dados_user);
        }
        else {

            this.carregaDadosPrograma();
            this.carregaPlanosPrograma();

            if(dados_user['ambiente_programa_id']) {
                this.carregaCamposExtraPrograma();
                this.carregaCamposExtraPaciente();
            }
            
            this.setState({
                carteira_id: '',
                titulo_pagina: 'Adicionar Atendimento',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    carregarDadosAtendimento = (id, etapaParam = null, dados_user = getCurrentUser()) => {
            //consulta os dados do atendimento na api
            api.get(`/atendimentos/${id}/`)
            .then(response => {
                const dadosResponse = response.data;
                const dados = this.tratarNulos(dadosResponse);
                const programaConfig = this.parseProgramaConfiguracoes(dados.dados_programa?.configuracoes);

                //Verifica, se tem ambiente de programa e a ID é de outro
                if(dados_user['ambiente_programa_id'] && dados_user['ambiente_programa_id'] != dados.programa_id) {
                    window.location.href = '/sem-permissao';
                    return;
                }

                let goToClient_id = ''
                if(dados.dados_cliente.goto_connect){
                    goToClient_id = dados.dados_cliente.goto_connect.client_id;
                }

                //Verifica campos extras
                const valoresInicial = {};

                dados.extra_valores_list.forEach(campo => {
                    if (campo.repetidor_list && campo.repetidor_list.length) {
                        // 1) extrai definições únicas de subcampo
                        const definicoes = campo.repetidor_list.filter((v,i,arr) =>
                            arr.findIndex(x => x.subcampo_id === v.subcampo_id) === i
                        );
                        const subCount = definicoes.length;

                        // 2) agrupa em chunks e monta objetos { subcampo_id: valor }
                        const rows = [];
                        for (let i = 0; i < campo.repetidor_list.length; i += subCount) {
                            const chunk = campo.repetidor_list.slice(i, i + subCount);
                            const obj = {};
                            chunk.forEach(r => {
                                obj[r.subcampo_id] = {
                                    id:    r.id,       // o ID do registro vindo do banco
                                    valor: r.valor     // o valor original
                                };
                            });
                            rows.push(obj);
                        }

                        valoresInicial[campo.campo_id] = rows;
                    }
                });

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    uuid: dados.uuid,
                    atendimento_id: dados.id,
                    beneficiario_id: dados.beneficiario_id,
                    atendente_id: dados.atendente_id ,
                    data: dados.data || '',
                    programa_id: dados.programa_id,
                    programa_uuid: dados.programa_uuid,
                    etapa_id: dados.etapa_id,
                    optin_data: dados.optin_data,
                    optin_data_laboratorio: dados.optin_data_laboratorio,
                    optin_ip: dados.optin_ip || '',
                    optin_telefone: dados.optin_telefone,
                    optin_termo_conteudo: dados.option_termo_conteudo,
                    termo_paciente_pdf_comprovante: dados.termo_paciente_pdf_comprovante,
                    termo_prestador_pdf_comprovante: dados.termo_prestador_pdf_comprovante,
                    cliente_id: dados.cliente_id,
                    plano_id: dados.plano_id,
                    plano_nome: dados.dados_plano.nome,
                    doenca_id: dados.doenca_id,
                    doenca_nome: dados.dados_doenca.nome,
                    doenca_idade_minima: dados.dados_doenca.idade_minima || 0,
                    pdf_termo_prestador: dados.pdf_termo_prestador,
                    lets_sign_documento_id: dados.lets_sign_documento_id,
                    lets_sign_documento_assinado_url: dados.lets_sign_documento_assinado_url,
                    lets_sign_msg_erro: dados.lets_sign_msg_erro,
                    lets_doc_status: dados.lets_doc_status,
                    lets_assinatura_status: dados.lets_assinatura_status,
                    finalizado: dados.finalizado,
                    beneficiario_nome: dados.dados_beneficiario.nome,
                    beneficiario_celular: dados.dados_beneficiario.celular,
                    beneficiario_dados: dados.dados_beneficiario,
                    atendente_nome: dados.dados_atendente.nome,
                    cliente_nome: dados.dados_cliente.nome,
                    programa_nome: dados.dados_programa.nome,
                    exige_cpf_atendimento: dados.dados_programa.exige_cpf_atendimento,
                    etapa_nome: dados.dados_etapa.nome,
                    medico_id: dados.medico_id,
                    medico_atual_id: dados.medico_id,
                    medico_nome: dados.dados_medico.nome,
                    laboratorio_id: dados.laboratorio_id,
                    laboratorio_nome: dados.dados_laboratorio.nome_fantasia,
                    etapa_atendimento_id: (dados.dados_etapa_status && dados.dados_etapa_status.id) ? dados.dados_etapa_status.id : '',
                    etapa_atendimento_status: (dados.dados_etapa_status && dados.dados_etapa_status.status) ? dados.dados_etapa_status.status : '',
                    etapa_atendimento_data_status: (dados.dados_etapa_status && dados.dados_etapa_status.data_cadastro) ? dados.dados_etapa_status.data_cadastro : '',
                    goToClient_id: goToClient_id,
                    cancelado: dados.cancelado,
                    camposExtraCadastrados: dados.extra_valores_list,
                    extra_valores_beneficiario_list: dados.extra_valores_beneficiario_list,
                    loading: false,
                    titulo_pagina: 'Jornada de Atendimento',
                    tipo_paciente: dados.tipo_paciente,
                    dados_criador_atendimento: dados.dados_criador_atendimento || {},
                    programa_status_id: dados.programa_status_id,
                    programa_status_slug: dados.dados_programa_status?.slug,
                    optin_telefone_chamada_id: dados.optin_telefone_chamada_id,
                    doenca_outros: dados.doenca_outros,
                    dados_medico: dados.dados_medico,
                    proxima_acao: dados.proxima_acao,
                    medico_data_alteracao: dados.medico_data_alteracao,
                    optout_data: dados.optout_data,
                    optout_motivo_id: dados.optout_motivo_id,
                    optout_motivo_outros: dados.optout_motivo_outros,
                    optout_motivo_titulo: dados.optout_motivo_titulo,
                    idade_minima: dados.dados_doenca.idade_minima,
                    idade_maxima: dados.dados_doenca.idade_maxima,
                    termo_programa_pdf: dados.termo_programa_pdf,
                    formulario_pesquisa_id: dados.dados_etapa.formulario_pesquisa_id,
                    formulario_pesquisa_respondida: dados.dados_etapa.pesquisa_respondida,
                    atendimento_validado: dados.atendimento_validado,
                    recebe_kit_paciente: dados.recebe_kit_paciente,
                    cadastro_teste: dados.cadastro_teste,
                    produto_descricao: dados.produto_descricao,
                    valoresCamposExtra: valoresInicial,
                    exames_extras_solicitacao: dados.exames_extras_solicitacao || [],
                    programa_config: programaConfig,
                    agendamento_termo_assinado_url: dados.termo_aceite_assinado || "",
                    dados_agendamento: dados.dados_agendamento || [],
                }, () => {
                    this.setProgramaConfig(dados)
                    
                    if(!dados.dados_beneficiario.cpf && !dados.dados_programa.exige_cpf_atendimento) {
                        this.setState({
                            cpf_nao_informado: true
                        });
                    }
                    //Verifica se tem etapa para trazer aberto
                    if (etapaParam) {
                        const compKey = `${etapaParam}-0`;
                        this.setState({ pendingEtapaAccordionKey: compKey });
                    }
                    if(!dados.dados_programa.termo_paciente_pdf && dados.dados_programa.termo_id){
                        if(!dados.termo_programa_pdf && !dados.optin_data){
                            api.post(`/atendimentos/regerar_termos/`, {
                                atendimento_id: this.state.atendimento_id,
                                tipo: "programa"
                            })
                            .then(response => {
                                window.location.reload();
                            })
                            .catch(error => {
                                console.error('Erro ao regerar termo:', error);
                                Sentry.captureException('Erro ao regerar termo:', error);
                            });
                        } 
                    }

                    //Carrega produtos do programa
                    this.fetchProdutosPrograma();

                    this.carregarAcoes();
                    this.carregarEtapas();
                    this.carregarEtapasStatus();
                    this.carregarRelatosAtendimento();
                    this.carregaEtapaAtual();
                    this.carregarProdutos();
                    this.carregaDadosPrograma();
                    this.carregaPlanosPrograma();      
                    this.carregaCamposExtraPrograma();              
                    this.carregaCamposExtraPaciente();
                    this.carregarAgendamentos();
                    this.carregarExames();
                    this.checkGotoToken();
                    this.verificaBloqueioEdicao();
                    this.carregaBotoesAtendimento(this.state.programa_id);

                    this.buscarEnderecos();
                    this.buscarKitsAgendados();

                    this.loadHistoricoTermos();
                    this.getDadosMedico();
                    this.getDadosBeneficiario();
                    this.carregarEnderecoExtra();

                    window.addEventListener('storage', this.handleStorageChange);
                })  
            })
            .catch(error => {

                let erro_msg = 'Erro ao consultar atendimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })

                //exibe a pagina 404
                //this.props.router.navigate("/404");
            });
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);

        if (this.carregaPrestadoresDebounced && this.carregaPrestadoresDebounced.cancel) {
            this.carregaPrestadoresDebounced.cancel();
        }
    }

    handleListagemHiPlatform = (listagem, atendimento_id) => {
        console.log("Listagem recebida:", listagem);
        console.log("ID do atendimento atual:", atendimento_id);

        // Se quiser salvar no state para uso em outro lugar:
        this.setState({
            lista_hi_platform: listagem,
        });
    }

    handleStorageChange = (event) => {
        if (event.key === 'tokenG') {
            this.checkGotoToken();
        }
    }

    quebraLinhaHistorico = (descricao) => {
        return descricao
    }

    checkGotoToken = () => {
        const token = localStorage.getItem('tokenG');
        if (token) {
            this.setState({ goToAccessToken: token });            
            this.consultaLinhasGoto(token)
        }
    }

    verificaBloqueioEdicao = () => {
        const tipos_acesso = tiposAcesso();
        
        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'industria') {
                this.setState({ permite_editar: false });            
            }            
        }
    }

    alterarServicoAtendimento = (item_id, servico_procedimento_id, faturamento) => {
        const MySwal = withReactContent(Swal);
        const valorFormatadoAPI = formatarValorAPI(this.state.valor_servico_edicao);

        if(!servico_procedimento_id){
            MySwal.fire(
                'Erro!',
                'O serviço deve ser informado',
                'error'
            );
            return
        }

        if(!this.state.data_servico_edicao){
            MySwal.fire(
                'Atenção!',
                'É obrigatório o preenchimento da data',
                'error'
            );

            return
        }

        if(faturamento){
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: 'Atenção!',
                text: "Este serviço possui um faturamento associado. A alteração do valor irá modificar o valor total do faturamento. Deseja continuar?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, alterar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setState({ loading: true });

                    api.put(`/atendimentos/servicos/${item_id}/`, { 
                        atendimento_id: this.state.atendimento_id,
                        servico_procedimento_id: servico_procedimento_id,
                        data: this.state.data_servico_edicao,
                        valor: valorFormatadoAPI,
                    })
                    .then(response => {
                        MySwal.fire(
                            'Alterado!',
                            'O serviço foi alterado com sucesso.',
                            'success'
                        );

                        this.setState({ loading: false, agendamento_termo_assinado_file: "", excluir_termo_assinado: false, });
                        
                        //consulta os serviços do atendimento
                        this.handleCloseModalServicoAtendimento();
                        this.getServicosAtendimento();
                        this.getServicosAtendimentoAll();
                    })
                    .catch(error => {
                        Sentry.captureException('Houve um erro ao tentar alterar o serviço do atendimento. Por favor, tente novamente.', error);

                        MySwal.fire(
                            'Erro!',
                            'Houve um erro ao tentar alterar o serviço do atendimento. Por favor, tente novamente.',
                            'error'
                        );
                        this.setState({ loading: false });
                    });
                }
            });
        } else {
            this.setState({ loading: true });

            api.put(`/atendimentos/servicos/${item_id}/`, { 
                atendimento_id: this.state.atendimento_id,
                servico_procedimento_id: servico_procedimento_id,
                data: this.state.data_servico_edicao,
                valor: valorFormatadoAPI,
            })
            .then(response => {
                MySwal.fire(
                    'Alterado!',
                    'O serviço foi alterado com sucesso.',
                    'success'
                );

                this.setState({ loading: false });
                
                //consulta os serviços do atendimento
                this.handleCloseModalServicoAtendimento();
                this.getServicosAtendimento();
                this.getServicosAtendimentoAll();
            })
            .catch(error => {
                Sentry.captureException('Houve um erro ao tentar alterar o serviço do atendimento. Por favor, tente novamente.', error);

                MySwal.fire(
                    'Erro!',
                    'Houve um erro ao tentar alterar o serviço do atendimento. Por favor, tente novamente.',
                    'error'
                );
                this.setState({ loading: false });
            });    
        }        
    }

    gerarServicoRelacionadoAgendamento = (agendamento) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Permitir Faturamento?',
            text: `Deseja gerar o serviço relacionado para este agendamento finalizado (${agendamento.dados_servico_procedimento?.nome}) e permitir seu faturamento?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1fac1fff',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, gerar serviço!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
                const payload = {
                    adicionar_servico_atendimento: true,
                    situacao: "finalizado",
                };
                api.put(`/agendamentos/${agendamento.id}/`, payload)
                .then(response => {
                    MySwal.fire(
                        'Sucesso!',
                        'Serviço relacionado gerado com sucesso.',
                        'success'
                    );
                    
                    // Create relato se etapa estiver disponivel
                    /*const etapaId = this.state.etapa_atual?.id || agendamento.etapa_atual?.id;
                    const atendimentoId = this.state.atendimento_id;
                    
                    if (etapaId && atendimentoId) {
                        const dataRealizacaoFormatted = moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");
                        const relatoFormData = new FormData();
                        relatoFormData.append("data", dataRealizacaoFormatted);
                        relatoFormData.append("etapa_id", etapaId);
                        relatoFormData.append("atendimento_id", atendimentoId);
                        relatoFormData.append("tipo", "etapa");
                        relatoFormData.append("titulo", `Realização de ${agendamento.dados_servico_procedimento?.nome}`);
                        relatoFormData.append("servico_procedimento_id", agendamento.servico_procedimento_id);
                        relatoFormData.append("ignorar_cadastro_servico", true);
                        relatoFormData.append("agendamento_id", agendamento.id);

                        api.post("/atendimentos/relatos/", relatoFormData).catch(e => console.error("Erro relato", e));
                    }*/
                    
                    this.carregarDadosAtendimento(this.state.atendimento_id);
                    this.getServicosAtendimento();
                    this.getServicosAtendimentoAll();
                })
                .catch(error => {
                    Sentry.captureException('Houve um erro ao tentar gerar o serviço.', error);
                    const errorMessage = error.response?.data?.message || error.response?.data?.detail || 'Houve um erro ao tentar gerar o serviço do agendamento. Por favor, tente novamente.';
                    MySwal.fire(
                        'Erro!',
                        errorMessage,
                        'error'
                    );
                    this.setState({ loading: false });
                });    
            }
        });
    }

    deletarServicoAtendimento = async (item) => {
        const MySwal = withReactContent(Swal);
        const itemId = item.id;
        const agendamentoId = item.agendamento_id;

        // Serviço sem agendamento relacionado: fluxo simples de exclusão
        if (!agendamentoId) {
            const result = await MySwal.fire({
                title: 'Excluir serviço?',
                text: "Tem certeza que deseja excluir este serviço do atendimento?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, excluir!',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;

            this.setState({ loading: true });
            Swal.fire({
                title: 'Excluindo serviço...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            try {
                await api.delete(`/atendimentos/servicos/${itemId}/`);
                MySwal.fire('Excluído!', 'O serviço foi excluído com sucesso.', 'success');
                this.getServicosAtendimento();
                this.getServicosAtendimentoAll();
            } catch (error) {
                Sentry.captureException('Houve um erro ao tentar excluir o serviço do atendimento. Por favor, tente novamente.', error);
                MySwal.fire('Erro!', 'Houve um erro ao tentar excluir o serviço do atendimento. Por favor, tente novamente.', 'error');
            } finally {
                this.setState({ loading: false });
            }
            return;
        }

        // Serviço com agendamento relacionado: perguntar o que fazer com o agendamento
        const escolha = await MySwal.fire({
            title: 'Excluir serviço',
            html: `Este serviço possui o agendamento <strong>#${agendamentoId}</strong> relacionado, que já foi finalizado.<br/><br/>O que deseja fazer com o agendamento ao excluir o serviço?`,
            icon: 'question',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: 'Cancelar agendamento',
            denyButtonText: 'Voltar para "Liberado"',
            cancelButtonText: 'Fechar',
            confirmButtonColor: '#d33',
            denyButtonColor: '#3085d6',
            cancelButtonColor: '#6c757d',
            reverseButtons: true,
        });

        if (escolha.isDismissed) return;

        // Fluxo: voltar agendamento para "Liberado"
        if (escolha.isDenied) {
            const confirmar = await MySwal.fire({
                title: 'Voltar agendamento para "Liberado"?',
                html: `O serviço será excluído e o agendamento <strong>#${agendamentoId}</strong> voltará para a situação "Liberado".`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, excluir e voltar!',
                cancelButtonText: 'Cancelar'
            });

            if (!confirmar.isConfirmed) return;

            this.setState({ loading: true });
            Swal.fire({
                title: 'Excluindo serviço e voltando agendamento para "Liberado"...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            try {
                await api.delete(`/atendimentos/servicos/${itemId}/`);
                await api.put(`/agendamentos/${agendamentoId}/`, { situacao: 'liberado' });
                MySwal.fire('Excluído!', 'O serviço foi excluído e o agendamento voltou para "Liberado".', 'success');
                this.getServicosAtendimento();
                this.getServicosAtendimentoAll();
                this.carregarAgendamentos();
            } catch (error) {
                Sentry.captureException('Houve um erro ao excluir o serviço e voltar o agendamento para liberado.', error);
                MySwal.fire('Erro!', 'Houve um erro ao excluir o serviço e/ou voltar o agendamento. Por favor, tente novamente.', 'error');
            } finally {
                this.setState({ loading: false });
            }
            return;
        }

        // Fluxo: cancelar agendamento (com motivo)
        const dados_usuario = getCurrentUser();
        const programa_id = this.state.programa_id || dados_usuario.ambiente_programa_id;

        let motivos = [];
        try {
            const resp = await api.get(`/agendamentos/motivos_cancelamento/?programa_id=${programa_id}`);
            motivos = resp.data.results || [];
        } catch (err) {
            console.error('Erro ao buscar motivos de cancelamento', err);
        }

        const escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
        const temMotivos = motivos.length > 0;
        const motivoOptions = motivos.map(m => `<option value="${escapeHtml(m.id)}">${escapeHtml(m.titulo)}</option>`).join('');

        const html = `
            <div style="text-align: left;">
                <p>Ao excluir o serviço, o agendamento <strong>#${escapeHtml(agendamentoId)}</strong> será <strong>cancelado</strong>. Informe o motivo do cancelamento:</p>
                ${temMotivos ? `
                    <div class="mb-2">
                        <label for="swal-motivo-select" class="form-label">Motivo do cancelamento</label>
                        <select id="swal-motivo-select" class="form-select">
                            <option value="">Selecione...</option>
                            ${motivoOptions}
                            <option value="outro">Outro</option>
                        </select>
                    </div>
                ` : ''}
                <div class="mb-2" id="swal-motivo-outro-wrapper" style="display: ${temMotivos ? 'none' : 'block'};">
                    <label for="swal-motivo-outro" class="form-label">Descreva o motivo</label>
                    <textarea id="swal-motivo-outro" class="form-control" rows="2"></textarea>
                </div>
            </div>
        `;

        const result = await MySwal.fire({
            title: 'Excluir serviço e cancelar agendamento?',
            html: html,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir e cancelar!',
            cancelButtonText: 'Fechar',
            focusConfirm: false,
            didOpen: () => {
                const select = document.getElementById('swal-motivo-select');
                const outroWrapper = document.getElementById('swal-motivo-outro-wrapper');
                if (select && outroWrapper) {
                    select.addEventListener('change', () => {
                        outroWrapper.style.display = select.value === 'outro' ? 'block' : 'none';
                    });
                }
            },
            preConfirm: () => {
                const select = document.getElementById('swal-motivo-select');
                const outroEl = document.getElementById('swal-motivo-outro');
                const motivoSelecionado = select ? select.value : '';
                const motivoOutro = outroEl ? outroEl.value.trim() : '';

                if (temMotivos && !motivoSelecionado) {
                    Swal.showValidationMessage('Selecione o motivo do cancelamento.');
                    return false;
                }

                if ((!temMotivos || motivoSelecionado === 'outro') && !motivoOutro) {
                    Swal.showValidationMessage('Descreva o motivo do cancelamento.');
                    return false;
                }

                return { motivoSelecionado, motivoOutro };
            }
        });

        if (!result.isConfirmed) return;

        const { motivoSelecionado, motivoOutro } = result.value;
        const payloadCancelamento = {
            situacao: 'cancelado',
            data_cancelamento: getDataAtual(),
        };
        if (motivoSelecionado && motivoSelecionado !== 'outro') {
            payloadCancelamento.motivo_id = motivoSelecionado;
        } else {
            payloadCancelamento.motivo_outro = motivoOutro;
        }

        this.setState({ loading: true });
        Swal.fire({
            title: 'Excluindo serviço e cancelando agendamento...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });
        try {
            await api.delete(`/atendimentos/servicos/${itemId}/`);
            await api.put(`/agendamentos/${agendamentoId}/`, payloadCancelamento);
            MySwal.fire('Excluído!', 'O serviço foi excluído e o agendamento relacionado foi cancelado.', 'success');
            this.getServicosAtendimento();
            this.getServicosAtendimentoAll();
            this.carregarAgendamentos();
        } catch (error) {
            Sentry.captureException('Houve um erro ao excluir o serviço e cancelar o agendamento relacionado.', error);
            MySwal.fire('Erro!', 'Houve um erro ao excluir o serviço e/ou cancelar o agendamento. Por favor, tente novamente.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    }

    handleExcluirAgendamento = (agendamento_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir agendamento?',
            text: "Tem certeza que deseja excluir este agendamento? Esta ação não pode ser desfeita.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
                Swal.fire({
                    title: 'Excluindo agendamento...',
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });

                api.delete(`/agendamentos/${agendamento_id}/`)
                    .then(() => {
                        MySwal.fire('Excluído!', 'O agendamento foi excluído com sucesso.', 'success');
                        this.setState({ loading: false });
                        this.carregarAgendamentos();
                        this.getServicosAtendimentoAll();
                    })
                    .catch(error => {
                        Sentry.captureException('Houve um erro ao tentar excluir o agendamento.', error);
                        MySwal.fire('Erro!', 'Houve um erro ao tentar excluir o agendamento. Por favor, tente novamente.', 'error');
                        this.setState({ loading: false });
                    });
            }
        });
    }

    deletarProdutoAtendimento = (item_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir produto?',
            text: "Tem certeza que deseja excluir este produto do atendimento?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
    
                api.delete(`/atendimentos/produtos/${item_id}/`)
                .then(response => {
                    MySwal.fire(
                        'Excluído!',
                        'O produto foi excluído com sucesso.',
                        'success'
                    );
                    this.setState({ loading: false });
                    //consulta os produtos do atendimento
                    this.carregarProdutos();
                })
                .catch(error => {
                    Sentry.captureException('Houve um erro ao tentar excluir o produto do atendimento. Por favor, tente novamente.', error);

                    MySwal.fire(
                        'Erro!',
                        'Houve um erro ao tentar excluir  o produto do atendimento. Por favor, tente novamente.',
                        'error'
                    );
                    this.setState({ loading: false });
                });
            }
        });
    }

    formatarTextoComQuebrasDeLinha(texto) {
        return texto.split('\n').map((item, key) => {
            return <span key={key}>{item}<br/></span>;
        });
    }

    carregaBeneficiarioPorId = async (pacienteId) => {
        let dados_usuario = getCurrentUser();
        const cliente_id = (dados_usuario['ambiente_cliente_id']) ? dados_usuario['ambiente_cliente_id'] : '';
        if(cliente_id) {
            try {
                const response = await api.get(`/pessoas/beneficiarios/${pacienteId}/?cliente_id=${cliente_id}`);
                if (response.data) {
                    const beneficiario = {
                        value: response.data.id,
                        label: response.data.nome
                    };
                    this.handleChange({ value: beneficiario.value, label: beneficiario.label }, 'beneficiario_id');
                }
            } catch (error) {
                console.error('Erro ao carregar beneficiário por ID:', error);
                //Sentry.captureException('Erro ao carregar beneficiário por ID:', error);
            }
        }
    };

    carregaPlanosPrograma = async () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            try {
                const response = await api.get(`/planos/?programa_id=${programa_id}`);
                const opcoes = response.data.results.map(plano => ({
                    id: plano.id,
                    nome: plano.nome
                }));
                this.setState({ programa_planos: opcoes });
    
                if (opcoes.length === 1) {
                    this.setState({ plano_id: opcoes[0].id, plano_nome: opcoes[0].nome, plano_unico: true });
                } else if (opcoes.length === 0) {
                    this.setState({ plano_unico: true });
                }
    
                // Agora carrega os serviços para cada plano
                const servicosPromises = opcoes.map(plano => this.carregaServicoPlano(plano.id));
                const servicosPorPlano = await Promise.all(servicosPromises);
                // Cria um mapeamento de id de plano para os serviços
                const servicosMap = opcoes.reduce((acc, plano, index) => {
                    acc[plano.id] = servicosPorPlano[index];
                    return acc;
                }, {});
    
                if(!this.state.atendimento_id) {
                    this.setState({ plano_servicos: servicosMap }, () => {
                        //this.carregaLaboratorioExclusivo();
                        this.carregaLaboratoriosPrograma();
                    });
                }
    
            } catch (error) {
                console.error('Erro ao carregar planos:', error);
                //Sentry.captureException('Erro ao carregar planos:', error);

                this.setState({ programa_planos: [], plano_servicos: {}, plano_unico: true });                
            }
        }
    };

    carregaCamposExtraPrograma = async () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            try {
                const response = await api.get(`/atendimentos/campos/?programa_id=${programa_id}&order_by=asc&order=ordem&limit=500`);
                this.setState({ atendimento_campos: response.data.results });
    
            } catch (error) {
                console.error('Erro ao carregar campos:', error);
                Sentry.captureException('Erro ao carregar campos:', error);
            }
        }
    };

    carregarMonitoriaStatus = async (busca) => {
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id && hasPerm('view_atendimentos_aplicacoes')) {
            try {
                const response = await api.get(`/programas/aplicacoes-status/?programa_id=${programa_id}&nome=${busca}`);
                //const response = await api.get(`/programas/aplicacoes-status/`);
                const opcoesFiltradas = response.data.results
                    // só pega os que tiverem status === true
                    .filter(statusmonitoria => statusmonitoria.status === true)
                    // depois mapeia pro formato { value, label }
                    .map(statusmonitoria => ({
                        value: statusmonitoria.id,
                        label: statusmonitoria.nome,
                }));
                return opcoesFiltradas;
            } catch (error) {
                console.error('Erro ao carregar campos:', error);
                Sentry.captureException('Erro ao carregar campos:', error);
            }
        }
    };

    carregarProdutosProgramaAtendimento = async (busca) => {
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            try {
                const response = await api.get(`/programas/produtos/?programa=${programa_id}&produto=${busca}`);
                //const response = await api.get(`/programas/aplicacoes-status/`);
                const opcoesFiltradas = response.data.results.map(produto => ({
                    value: produto.produto_id,
                    label: produto.dados_produto.nome,
                    valor: produto.valor
                }));

                return opcoesFiltradas;
            } catch (error) {
                console.error('Erro ao carregar campos:', error);
                Sentry.captureException('Erro ao carregar campos:', error);
            }
        }
    };

    carregarProdutoApresentacao = async (busca) => {
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        const produto_id = this.state.dosagem_produto_id;
        if (programa_id && produto_id) {
            try {
                const response = await api.get(`/programas/produtos/apresentacoes/?programa=${programa_id}&produto=${produto_id}&apresentacao=${busca}`);
                //const response = await api.get(`/programas/aplicacoes-status/`);
                const opcoesFiltradas = response.data.results.map(apresentacao => ({
                    value: apresentacao.id,
                    label: apresentacao.descricao
                }));

                return opcoesFiltradas;
            } catch (error) {
                console.error('Erro ao carregar apresentações:', error);
                Sentry.captureException('Erro ao carregar apresentações:', error);
            }
        }
    };

    carregaCamposExtraPaciente = async () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            try {
                const response = await api.get(`/pessoas/beneficiarios/campos/?programa_id=${programa_id}&order_by=asc&order=ordem&limit=100`);
                this.setState({ pacientes_campos: response.data.results });
    
            } catch (error) {
                console.error('Erro ao carregar campos do paciente:', error);
                Sentry.captureException('Erro ao carregar campos do paciente:', error);
            }
        }
    };

    validarCamposExtra = () => {
        let camposInvalidos = [];
        const dados_usuario = getCurrentUser();
        const valorPorSlug = this.preCadGetValoresFiltrados();

        const MySwal = withReactContent(Swal);
        
        // Percorre os campos agrupados
        this.state.atendimento_campos.forEach((campo) => {
            let isVisivel = true;

            // --- PRESTADOR: mesma regra do renderizaCamposExtra ---
            if (dados_usuario.tipo_usuario === 'prestador') {
                if (!campo.mascara?.startsWith("show-on-prestador=")) {
                    isVisivel = false;
                } else {
                    const allowed = campo.mascara.split("=")[1].split("|");
                    if (!allowed.includes(dados_usuario.prestador_categoria)) {
                        isVisivel = false;
                    }
                }
            }
            
            // --- show-on-status=slug1|slug2 ---
            // Excetoção para pku_motivo_pausa_temporaria: se o campo tem valor, ignora restrição de status
            if (isVisivel && campo.mascara && campo.mascara.startsWith("show-on-status=")) {
                const temValor = campo.valor && String(campo.valor).trim() !== "";
                    const hasKeepVisible = campo.mascara?.includes('keep-visible-if-filled');
                
                    if (!temValor || !hasKeepVisible) {
                        const requiredSlugs = campo.mascara.split("=")[1].split("|");
                        if (
                            !this.state.finalizado &&
                            !this.state.cancelado &&
                            !requiredSlugs.includes(this.state.programa_status_slug)
                        ) {
                            isVisivel = false;
                        }
                }
            }

            // --- show-on[slug=valor] --- (aceita mascaras combinadas: "pre-allow | show-on[...]")
            if (isVisivel && campo.mascara && campo.mascara.includes('show-on[')) {
                if (!this.preCadShouldShowCampo(campo, valorPorSlug)) {
                    isVisivel = false;
                }
            }

            const isHabilitado = campo.mascara !== "disabled";

            // valor atual (considera estado ou valor default)
            const valorAtual = this.state.valoresCamposExtra[campo.id] ?? campo.valor ?? "";
            
            if (
                isVisivel &&
                !this.state.reativar_atendimento &&
                isHabilitado &&
                campo.obrigatorio &&
                (
                    valorAtual === null ||
                    valorAtual === undefined ||
                    String(valorAtual).trim() === ""
                )
            ) {
                camposInvalidos.push(campo.nome);
            }
        });
    
        if (camposInvalidos.length > 0) {
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: `Os seguintes campos obrigatórios não foram preenchidos:<br><br>- ${camposInvalidos.join("<br>- ")}`
            });
            return false;
        }
    
        return true;
    };

    // ========== PRÉ-CADASTRO ==========
    // Fluxo opt-in para exibir campos personalizados antes da seleção de paciente.
    // Ativa-se apenas quando a máscara do campo contém "pre-allow".
    // Bloqueio de elegibilidade: campo tipo texto + mascara "information-field" + "blocks-elegibilidade"
    // + show-on[...] que avalie true. Enquanto houver bloqueio, esconde seleção de paciente e Novo Paciente.

    preCadIsPreAllow = (mascara = '') => {
        return typeof mascara === 'string' && /\bpre-allow\b/i.test(mascara);
    };

    preCadIsInformationField = (mascara = '') => {
        return typeof mascara === 'string' && mascara.includes('information-field');
    };

    preCadIsBlocksElegibilidade = (mascara = '') => {
        return typeof mascara === 'string' && /\bblocks-elegibilidade\b/i.test(mascara);
    };

    // Reutiliza matchShowOnMask extraindo apenas o trecho show-on[...] da mascara
    preCadShouldShowCampo = (campo, valorPorSlug) => {
        const mascara = campo?.mascara || '';
        if (!mascara.includes('show-on[')) return true;
        const m = mascara.match(/show-on\[[^\]]+\]/);
        if (!m) return true;
        return this.matchShowOnMask({ ...campo, mascara: m[0] }, valorPorSlug);
    };

    // Retorna valorPorSlug com campos pre-allow invisíveis zerados (em cascata).
    // Resolve o caso em que o usuário muda a resposta de um campo "pai" e o filho
    // (incluindo information-fields de bloqueio) continuava visível usando valor órfão.
    preCadGetValoresFiltrados = () => {
        const base = this.getValoresPorSlug();
        const campos = this.state.atendimento_campos || [];
        if (campos.length === 0) return base;

        const filtrado = { ...base };
        for (let i = 0; i < 10; i++) {
            let mudou = false;
            for (const c of campos) {
                if (!c.slug) continue;
                const mascara = c.mascara || '';
                if (!this.preCadIsPreAllow(mascara)) continue;
                if (!mascara.includes('show-on[')) continue;
                const m = mascara.match(/show-on\[[^\]]+\]/);
                if (!m) continue;
                const visivel = this.matchShowOnMask({ ...c, mascara: m[0] }, filtrado);
                const valorAtual = filtrado[c.slug];
                if (!visivel && valorAtual !== '' && valorAtual !== undefined && valorAtual !== null) {
                    filtrado[c.slug] = '';
                    mudou = true;
                }
            }
            if (!mudou) break;
        }
        return filtrado;
    };

    // Lê flag do programa: atendimentos.pre_cadastro_obrigar_respostas (bool)
    // Quando ativa: só libera seleção de paciente e botão Salvar depois que TODAS as perguntas visíveis forem respondidas
    preCadRequerRespostaTotal = () => {
        return !!getConfig(this.state.programa_dados?.configuracoes, 'atendimentos.pre_cadastro_obrigar_respostas', false);
    };

    preCadTemCamposPreAllow = () => {
        const campos = this.state.atendimento_campos || [];
        return campos.some(c => this.preCadIsPreAllow(c.mascara));
    };

    // Todas as perguntas visíveis (não information-field) respondidas?
    preCadTodasRespondidas = () => {
        const campos = this.state.atendimento_campos || [];
        if (campos.length === 0) return true;
        const valorPorSlug = this.preCadGetValoresFiltrados();
        for (const campo of campos) {
            const mascara = campo.mascara || '';
            if (!this.preCadIsPreAllow(mascara)) continue;
            if (this.preCadIsInformationField(mascara)) continue;
            if (!this.preCadShouldShowCampo(campo, valorPorSlug)) continue;
            const valor = this.state.valoresCamposExtra?.[campo.id] ?? campo.valor ?? '';
            if (valor === null || valor === undefined || String(valor).trim() === '') {
                return false;
            }
        }
        return true;
    };

    // True em qualquer cenário que deva ocultar a seleção "Pacientes Cadastrados" + botão "Novo Paciente"
    // Cobre: bloqueio em novo cadastro, gate de resposta total e bloqueio detectado na edição
    preCadDeveEsconderSelecaoPaciente = () => {
        if (this.preCadIsBloqueado()) return true;
        if (this.preCadGateAtivo()) return true;
        if (this.state.atendimento_id && this.preCadTemBloqueioAtivo()) return true;
        return false;
    };

    // True quando deve esconder seleção de paciente/botão novo/salvar até o formulário estar completo
    preCadGateAtivo = () => {
        if (!this.state.programa_dados?.habilitar_pre_cadastro_basico) return false;
        if (this.state.atendimento_id) return false;
        if (!this.preCadRequerRespostaTotal()) return false;
        if (!this.preCadTemCamposPreAllow()) return false;
        return !this.preCadTodasRespondidas();
    };

    // Detecta bloqueio puro (qualquer information-field visível com blocks-elegibilidade), sem olhar para atendimento_id
    preCadTemBloqueioAtivo = () => {
        const campos = this.state.atendimento_campos || [];
        if (campos.length === 0) return false;
        const valorPorSlug = this.preCadGetValoresFiltrados();
        return campos.some((campo) => {
            const mascara = campo.mascara || '';
            if (!this.preCadIsPreAllow(mascara)) return false;
            if (!this.preCadIsInformationField(mascara)) return false;
            if (!this.preCadIsBlocksElegibilidade(mascara)) return false;
            return this.preCadShouldShowCampo(campo, valorPorSlug);
        });
    };

    // Bloqueio relevante para o fluxo de NOVO cadastro (gate de seleção de paciente/save)
    preCadIsBloqueado = () => {
        if (!this.state.programa_dados?.habilitar_pre_cadastro_basico) return false;
        if (this.state.atendimento_id) return false;
        return this.preCadTemBloqueioAtivo();
    };

    // Alerta exibido na edição do atendimento quando há bloqueio detectado (programa com pre_cadastro_obrigar_respostas)
    renderizaAlertaBloqueioPreCadastro = () => {
        if (!this.state.atendimento_id) return null;
        const habilitado = !!getConfig(this.state.programa_dados?.configuracoes, 'atendimentos.pre_cadastro_obrigar_respostas', false);
        if (!habilitado) return null;

        const campos = this.state.atendimento_campos || [];
        if (campos.length === 0) return null;
        const valorPorSlug = this.preCadGetValoresFiltrados();

        const bloqueios = campos.filter((campo) => {
            const mascara = campo.mascara || '';
            if (!this.preCadIsPreAllow(mascara)) return false;
            if (!this.preCadIsInformationField(mascara)) return false;
            if (!this.preCadIsBlocksElegibilidade(mascara)) return false;
            return this.preCadShouldShowCampo(campo, valorPorSlug);
        });

        if (bloqueios.length === 0) return null;

        return (
            <div className="mb-3">
                {bloqueios.map((campo) => (
                    <Alert variant="danger" className="mb-2" key={`alerta_bloqueio_${campo.id}`}>
                        <strong>Bloqueio de elegibilidade:</strong> {campo.descricao || 'Este atendimento foi marcado como não elegível no pré-cadastro.'}
                    </Alert>
                ))}
            </div>
        );
    };

    renderizaCamposPreCadastro = (desabilitar_edicao, programa_id) => {
        const campos = this.state.atendimento_campos || [];
        if (campos.length === 0) return null;

        // Config do programa: atendimentos.pre_cadastro_editavel_prestador (bool)
        // Quando true, ignora o desabilitar_edicao global (que bloqueia prestadores incl. médicos)
        // para que o próprio médico possa preencher o formulário de pré-cadastro.
        const permiteEdicaoPrestador = !!getConfig(this.state.programa_dados?.configuracoes, 'atendimentos.pre_cadastro_editavel_prestador', false);
        const desabilitarEdicaoEfetivo = permiteEdicaoPrestador ? false : desabilitar_edicao;

        const doencaAtendimentoId = this.state.doenca_id ? parseInt(this.state.doenca_id) : null;
        const valorPorSlug = this.preCadGetValoresFiltrados();

        const camposPreAllow = [];
        for (const item of campos) {
            if (!this.preCadIsPreAllow(item.mascara)) continue;

            const campoTemDoencas = item.doencas_list && item.doencas_list.length > 0;
            if (campoTemDoencas && doencaAtendimentoId !== null) {
                const pertence = item.doencas_list.some(d => d.doenca_id === doencaAtendimentoId);
                if (!pertence) continue;
            }

            const programa = item.programas_list?.find(p => p.programa_id === Number(programa_id));
            if (!programa) continue;

            item.valor = '';
            for (const v of (this.state.camposExtraCadastrados || [])) {
                if (v.campo_slug === item.slug) item.valor = v.valor;
            }

            camposPreAllow.push(item);
        }

        if (camposPreAllow.length === 0) return null;

        const visiveis = camposPreAllow.filter(c => this.preCadShouldShowCampo(c, valorPorSlug));
        if (visiveis.length === 0) return null;

        // Config do programa: atendimentos.pre_cadastro_mensagem_inicial (string, opcional)
        // Mensagem exibida no topo do formulário de pré-cadastro (antes das perguntas)
        const mensagemInicial = getConfig(this.state.programa_dados?.configuracoes, 'atendimentos.pre_cadastro_mensagem_inicial', '');

        return (
            <div className="pre-cadastro-campos mb-3">
                {mensagemInicial && (
                    <Alert variant="info" className="mb-3">
                        <div dangerouslySetInnerHTML={{ __html: mensagemInicial }} />
                    </Alert>
                )}
                <Row>
                    {visiveis.map((campo) => {
                        const mascara = campo.mascara || '';

                        if (this.preCadIsInformationField(mascara)) {
                            const isBloqueio = this.preCadIsBlocksElegibilidade(mascara);
                            return (
                                <Col sm={12} className="mb-3" key={`precad_info_${campo.id}`}>
                                    <Alert variant={isBloqueio ? 'danger' : 'info'} className="mb-0">
                                        {campo.nome ? <div className="fw-semibold mb-1">{campo.nome}</div> : null}
                                        <div>{campo.descricao}</div>
                                    </Alert>
                                </Col>
                            );
                        }

                        const disabled = (desabilitarEdicaoEfetivo || mascara === 'disabled' || mascara.includes('disabled')) ? true : false;
                        const tipo = campo.tipo;

                        return (
                            <Col sm={6} className="mb-3" key={`precad_${campo.id}`}>
                                <Form.Group>
                                    <Form.Label>{campo.nome} {campo.obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                    {campo.descricao && <p className="mb-1"><Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text></p>}
                                    {tipo === 'selecao' ? (
                                        <Form.Control
                                            as="select"
                                            defaultValue={campo.valor}
                                            required={campo.obrigatorio}
                                            disabled={disabled}
                                            onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                        >
                                            <option value="">Selecione...</option>
                                            {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                                const [valor, label] = opcao.split(':').map(it => it.trim());
                                                return <option key={idx} value={valor}>{label}</option>;
                                            })}
                                        </Form.Control>
                                    ) : tipo === 'radio' ? (
                                        <div>
                                            {(campo.opcoes || '').split('\n').map((opcao, indexO) => {
                                                const [valorRadio, labelRadio] = opcao.split(':');
                                                const valorSelecionado = this.state.valoresCamposExtra.hasOwnProperty(campo.id)
                                                    ? this.state.valoresCamposExtra[campo.id]
                                                    : campo.valor;
                                                return (
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        key={`precad_radio_${campo.id}_${indexO}`}
                                                        id={`precad_radio_${campo.id}_${indexO}`}
                                                        name={`precad_radio_${campo.id}`}
                                                        label={labelRadio}
                                                        value={valorRadio}
                                                        disabled={disabled}
                                                        checked={valorRadio === valorSelecionado}
                                                        onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                    />
                                                );
                                            })}
                                        </div>
                                    ) : tipo === 'checkbox' ? (
                                        <div>
                                            {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                                const [valor, label] = opcao.split(':');
                                                const selecionados = (this.state.valoresCamposExtra?.[campo.id] || '').split(',');
                                                return (
                                                    <Form.Check
                                                        key={`precad_chk_${campo.id}_${idx}`}
                                                        type="checkbox"
                                                        label={label || valor}
                                                        value={valor}
                                                        checked={selecionados.includes(valor)}
                                                        disabled={disabled}
                                                        onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, valor, e.target.checked)}
                                                    />
                                                );
                                            })}
                                        </div>
                                    ) : tipo === 'data' ? (
                                        <Form.Control
                                            type="date"
                                            defaultValue={campo.valor ? String(campo.valor).substring(0, 10) : ''}
                                            required={campo.obrigatorio}
                                            disabled={disabled}
                                            max={mascara.includes('no-future-date') ? new Date().toISOString().split('T')[0] : undefined}
                                            onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                        />
                                    ) : (tipo === 'numero' || mascara === 'number') ? (
                                        <Form.Control
                                            type="number"
                                            defaultValue={this.state.valoresCamposExtra?.[campo.id] ?? campo.valor ?? ''}
                                            required={campo.obrigatorio}
                                            disabled={disabled}
                                            onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                        />
                                    ) : tipo === 'area_texto' ? (
                                        <Form.Control
                                            as="textarea"
                                            defaultValue={campo.valor}
                                            required={campo.obrigatorio}
                                            disabled={disabled}
                                            className="custom-textarea2"
                                            onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                        />
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            defaultValue={campo.valor}
                                            required={campo.obrigatorio}
                                            disabled={disabled}
                                            onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                        />
                                    )}
                                </Form.Group>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        );
    };

    renderizaCamposExtra = (desabilitar_edicao, programa_id) => {
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {};
        let disclaimers = {}; // Para armazenar o disclaimer de cada seção
        let dados_usuario = getCurrentUser();

        if(this.state.atendimento_campos.length == 0) {
            return;
        }

        const doencaAtendimentoId = this.state.doenca_id ? parseInt(this.state.doenca_id) : null;

        for (let i = 0; i < this.state.atendimento_campos.length; i++) {
            let item = this.state.atendimento_campos[i];

            // Filtra por doença, se tiver configurada nos campos personalizados
            const campoTemDoencasVinculadas = item.doencas_list && item.doencas_list.length > 0;
            const atendimentoTemDoenca = doencaAtendimentoId !== null;

            if (campoTemDoencasVinculadas && atendimentoTemDoenca) {
                const pertenceDoenca = item.doencas_list.some(d => d.doenca_id === doencaAtendimentoId);
                if (!pertenceDoenca) {
                    continue;
                }
            }

            const programa = item.programas_list.find((p) => p.programa_id === Number(programa_id));

            if (programa) {
                const secao = programa.secao || '0_sem_sessao';

                if (!(secao in objCampos)) {
                    objCampos[secao] = [];
                    disclaimers[secao] = programa.disclaimer || null; // Salva o disclaimer da seção
                }

                // Percorre os valores dos campos
                item.valor = '';
                for (let j = 0; j < this.state.camposExtraCadastrados.length; j++) {
                    let itemValor = this.state.camposExtraCadastrados[j];

                    if (itemValor.campo_slug === item.slug) {
                        item.valor = itemValor.valor;
                    }
                }

                objCampos[secao].push(item);
            }
        }

        const valorPorSlug = this.preCadGetValoresFiltrados();

        // Filtra as seções com pelo menos um campo visível
        const secoesVisiveis = Object.keys(objCampos).filter((nome_secao) =>
            objCampos[nome_secao].some((campo) => {
                // --- PRESTADORES: somente show-on-perfil e categoria compatível
                if (dados_usuario.tipo_usuario === 'prestador') {
                    if (campo.mascara?.startsWith("show-on-prestador=")) {
                        const allowed = campo.mascara.split("=")[1].split("|");
                        return allowed.includes(dados_usuario.prestador_categoria);
                    }
                    return false;
                }

                //Verifica exibição do campo por status
                // Excetoção para pku_motivo_pausa_temporaria: se o campo tem valor, ignora restrição de status
                if (campo.mascara && campo.mascara.startsWith("show-on-status=")) {
                    const temValor = campo.valor && String(campo.valor).trim() !== "";
                        const hasKeepVisible = campo.mascara?.includes('keep-visible-if-filled');
                    
                        if (temValor && hasKeepVisible) {
                            return true; // Campo com keep-visible-if-filled e valor, sempre visível
                    }
                    
                    const requiredSlugs = campo.mascara.split("=")[1].split("|"); // Divide os slugs separados por '|'
                    return (
                        this.state.finalizado ||
                        this.state.cancelado ||
                        requiredSlugs.includes(this.state.programa_status_slug)
                    ); // Verifica se o slug atual está na lista
                }

                if (campo.mascara && campo.mascara.includes('show-on[')) {
                    return this.preCadShouldShowCampo(campo, valorPorSlug);
                }

                return true; // Campos sem restrição sempre são visíveis
            })
        );

        return (
            secoesVisiveis.map((nome_secao) => (
                objCampos[nome_secao] && objCampos[nome_secao].length > 0 && (
                    <div className="row-list" key={nome_secao}>
                        {(nome_secao && nome_secao !== "0_sem_sessao") && (
                            <div>
                                <h6 className="sessao-campos-extra mt-3 mb-3">
                                    <strong>{tiposSessoesAtendExtra[nome_secao] ? tiposSessoesAtendExtra[nome_secao] : nome_secao}</strong>
                                </h6>
                                {/* Exibe o disclaimer da seção, se existir */}
                                {disclaimers[nome_secao] && (
                                    <div className="alert alert-info" role="alert">
                                        {disclaimers[nome_secao]}
                                    </div>
                                )}
                            </div>
                        )}
                        
                        <Row>
                            {objCampos[nome_secao].map((campo) => {

                                //Verifica prestador se tem permissão para visualizar campo
                                if (dados_usuario.tipo_usuario === 'prestador') {
                                    if (!campo.mascara?.startsWith("show-on-prestador=")) return null;
                                    
                                    const allowed = campo.mascara.split("=")[1].split("|");
                                    if (!allowed.includes(dados_usuario.prestador_categoria)) return null;
                                }

                                // Verifica se o campo deve ser exibido baseado no programa_status_slug
                                // Excetção para pku_motivo_pausa_temporaria: se o campo tem valor, ignora restrição de status
                                if (campo.mascara && campo.mascara.startsWith("show-on-status=")) {
                                    const temValor = campo.valor && String(campo.valor).trim() !== "";
                                        const hasKeepVisible = campo.mascara?.includes('keep-visible-if-filled');
                                    
                                        if (!(temValor && hasKeepVisible)) {
                                        const requiredSlugs = campo.mascara.split("=")[1].split("|"); // Divide os slugs separados por '|'
                                        if (
                                            !this.state.finalizado &&
                                            !this.state.cancelado &&
                                            !requiredSlugs.includes(this.state.programa_status_slug)
                                        ) {
                                            // Não renderiza o campo se o slug não corresponder e não tem valor
                                                // OU se não tiver keep-visible-if-filled
                                            return null;
                                        }
                                    }
                                }

                                // Dependência por outro campo (ex.: show-on[local_aplicacao=Domicílio]) — aceita mascaras combinadas
                                if (campo.mascara && campo.mascara.includes('show-on[')) {
                                    if (!this.preCadShouldShowCampo(campo, valorPorSlug)) return null;
                                }

                                const programa = campo.programas_list.find(
                                    (p) => p.programa_id === Number(programa_id)
                                );

                                // Verifica se deve exibir o link "Ver histórico"
                                const mostrarHistorico = programa && programa.gerar_historico === true;

                                // Information-field: renderiza como Alert (danger se blocks-elegibilidade, info caso contrário)
                                if (this.preCadIsInformationField(campo.mascara)) {
                                    const isBloqueio = this.preCadIsBlocksElegibilidade(campo.mascara);
                                    return (
                                        <Col sm={12} className="mb-3" key={`info_${campo.id}`}>
                                            <Alert variant={isBloqueio ? 'danger' : 'info'} className="mb-0">
                                                {campo.nome ? <div className="fw-semibold mb-1">{campo.nome}</div> : null}
                                                <div>{campo.descricao}</div>
                                            </Alert>
                                        </Col>
                                    );
                                }

                                let disabled = (desabilitar_edicao || campo.mascara === 'disabled' || campo.mascara?.includes('disabled')) ? true : false;
                            
                                return (
                                    <React.Fragment key={campo.id}>
                                        {campo.tipo === 'texto' || campo.tipo === 'area_texto' || campo.tipo === 'data' || campo.tipo === 'selecao' || campo.tipo === 'radio' || campo.tipo === 'numero' || campo.tipo === 'checkbox' ? (
                                            <>
                                                <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>{campo.nome} {campo.obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                        {campo.descricao && <p className="mb-1"><Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text></p>}
                                                        {
                                                        (campo.tipo === 'selecao') ? (
                                                            <Form.Control
                                                                as="select"
                                                                defaultValue={campo.valor}
                                                                required={campo.obrigatorio}
                                                                onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                disabled={disabled}
                                                            >
                                                                <option value="">Selecione...</option>
                                                                {campo.opcoes.split('\n').map((opcao, idx) => {
                                                                    const [valor, label] = opcao.split(':').map(item => item.trim()); // Remove espaços adicionais
                                                                    return <option key={idx} value={valor}>{label}</option>;
                                                                })}
                                                            </Form.Control>

                                                            ) 
                                                        : 
                                                            (campo.tipo === 'texto' || campo.tipo === 'data' || campo.mascara === 'number') ? (
                                                                <Form.Control
                                                                    type={
                                                                        campo.mascara === 'number' ? 'number' : 
                                                                        campo.tipo === 'data' ? 'date' : 'text'
                                                                    }
                                                                    disabled={disabled}
                                                                    defaultValue={
                                                                        campo.tipo === 'data'
                                                                            ? (campo.valor ? campo.valor.substring(0, 10) : '')
                                                                            : campo.valor
                                                                    }
                                                                    required={campo.obrigatorio}
                                                                    // ---- NOVO: restringe data futura quando a máscara contém 'no-future-date' ----
                                                                    max={
                                                                        campo.tipo === 'data' && campo.mascara?.includes('no-future-date')
                                                                            ? new Date().toISOString().split('T')[0]
                                                                            : undefined
                                                                    }
                                                                    onChange={(e) => {
                                                                        if (
                                                                            campo.tipo === 'data' &&
                                                                            campo.mascara?.includes('no-future-date') &&
                                                                            e.target.value > new Date().toISOString().split('T')[0]
                                                                        ) {
                                                                            e.target.value = '';
                                                                            this.handleChangeCampoAtendExtra(campo.id, '');
                                                                            return;
                                                                        }
                                                                        this.handleChangeCampoAtendExtra(campo.id, e.target.value);
                                                                    }}
                                                                />
                                                            )
                                                            : 
                                                            (campo.tipo === 'numero' || campo.mascara === 'number') ? (
                                                                <Form.Control
                                                                  type="number"
                                                                  disabled={disabled}
                                                                  defaultValue={this.state.valoresCamposExtra?.[campo.id] || campo.valor || ''}
                                                                  required={campo.obrigatorio}
                                                                  onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                />
                                                            )
                                                            : (campo.tipo === 'checkbox') ? (
                                                                <div>
                                                                  {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                                                    const [valor, label] = opcao.split(':');
                                                                    const selecionados = (this.state.valoresCamposExtra?.[campo.id] || '').split(',');
                                                                    return (
                                                                      <Form.Check
                                                                        key={`checkbox_${campo.id}_${idx}`}
                                                                        type="checkbox"
                                                                        label={label || valor}
                                                                        value={valor}
                                                                        checked={selecionados.includes(valor)}
                                                                        disabled={disabled}
                                                                        onChange={(e) => {
                                                                          this.handleChangeCampoAtendExtra(campo.id, valor, e.target.checked);
                                                                        }}
                                                                      />
                                                                    );
                                                                  })}
                                                                </div>
                                                            )
                                                            :
                                                                (campo.tipo === 'radio') ? 
                                                                (
                                                                    <div>
                                                                        {campo.opcoes.split('\n').map((opcao, indexO) => {
                                                                            const [valorRadio, labelRadio] = opcao.split(':');
                                                                            // Verifica se já existe um valor alterado no estado; caso contrário, usa o valor original do campo
                                                                            const valorSelecionado = this.state.valoresCamposExtra.hasOwnProperty(campo.id)
                                                                                ? this.state.valoresCamposExtra[campo.id]
                                                                                : campo.valor;
                                                                            
                                                                            return (
                                                                                <Form.Check 
                                                                                    inline 
                                                                                    type="radio" 
                                                                                    label={labelRadio} 
                                                                                    key={`radio_${campo.id}_opcao_${indexO}`} 
                                                                                    id={`radio_${campo.id}_opcao_${indexO}`}
                                                                                    value={valorRadio} 
                                                                                    disabled={disabled}
                                                                                    onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                                    checked={ valorRadio === valorSelecionado }
                                                                                />                                                                                                                        
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )
                                                                :
                                                                (
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        defaultValue={campo.valor}
                                                                        required={campo.obrigatorio}
                                                                        disabled={disabled}
                                                                        className="custom-textarea2"
                                                                        onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                    />
                                                                )
                                                        }
                                                    </Form.Group>
                                                    {/* Link para ver histórico */}
                                                    {mostrarHistorico && (
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.handleShowHistorico(campo.id, campo.nome);
                                                            }}
                                                            className="text-decoration-underline text-primary small d-block mt-1"
                                                        >
                                                            Ver histórico
                                                        </a>
                                                    )}
                                                </Col>
                                                {(['outro', 'outros'].includes(this.state.valoresCamposExtra[campo.id]?.toLowerCase()) || ((['outro', 'outros'].includes(campo.valor?.toLowerCase()) || campo.valor?.startsWith("Outro - ") || campo.valor?.startsWith("Outros - ")) && !this.state.valoresCamposExtra[campo.id])) && (
                                                <Col sm={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Descreva</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={
                                                                this.state.camposOutrosExtra[campo.id] 
                                                                    ? this.state.camposOutrosExtra[campo.id] 
                                                                    : (campo.valor.startsWith("Outro - ") || campo.valor.startsWith("Outros - "))
                                                                        ? campo.valor.replace(/^Outros? - /, "")
                                                                        : campo.valor || ''
                                                            }
                                                            onChange={(e) => this.handleChangeOutroExtra(campo.id, e.target.value)}
                                                            required={true}
                                                            disabled={disabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                )}
                                            </>
                                        ) : null}
                                    
                                        {campo.tipo === 'arquivo' && (
                                            <Col sm={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>{campo.nome}</Form.Label>
                                                    <Form.Control 
                                                        type="file" 
                                                        required={campo.obrigatorio}
                                                        disabled={disabled}
                                                        onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e)}
                                                    />
                                                    {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {campo.tipo === 'repeater' && Array.isArray(campo.repetidor_list) && (
                                            <Col sm={12} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label><strong>{campo.nome}</strong></Form.Label>
                                                    
                                                    {(this.state.valoresCamposExtra[campo.id] || []).map((item, index) => (
                                                        <Row key={`${campo.id}_repetidor_${index}`} className="align-items-end mb-2 border rounded p-2">
                                                            {campo.repetidor_list.map((subcampo) => {
                                                                //const valor = item[subcampo.id] || '';
                                                                const cell  = item[subcampo.id] || {};
                                                                const valor = cell.valor || '';
                                                                
                                                                const subId = `${campo.id}_${subcampo.slug}_${index}`;
                                                                return (
                                                                    <Col sm={5} key={subId}>
                                                                        <Form.Label>{subcampo.nome}</Form.Label>
                                                                        {subcampo.tipo === 'selecao' ? (
                                                                            <Form.Control
                                                                                as="select"
                                                                                value={valor}
                                                                                required={subcampo.obrigatorio}
                                                                                onChange={(e) => this.handleChangeRepeater(campo.id, index, subcampo.slug, subcampo.id, e.target.value)}
                                                                            >
                                                                                <option value="">Selecione...</option>
                                                                                {subcampo.opcoes.split('\n').map((op, i) => {
                                                                                    const [v, l] = op.split(':').map(s => s.trim());
                                                                                    return <option key={i} value={v}>{l}</option>;
                                                                                })}
                                                                            </Form.Control>
                                                                        ) : subcampo.tipo === 'numero' ? (
                                                                            <Form.Control
                                                                                type="number"
                                                                                value={valor}
                                                                                required={subcampo.obrigatorio}
                                                                                onChange={(e) => this.handleChangeRepeater(campo.id, index, subcampo.slug, subcampo.id, e.target.value)}
                                                                            />
                                                                        ) : (
                                                                            <Form.Control
                                                                                type="text"
                                                                                value={valor}
                                                                                required={subcampo.obrigatorio}
                                                                                onChange={(e) => this.handleChangeRepeater(campo.id, index, subcampo.slug, subcampo.id, e.target.value)}
                                                                            />
                                                                        )}
                                                                    </Col>
                                                                );
                                                            })}
                                                            <Col sm="auto" className="d-flex align-items-end">
                                                                <Button variant="danger" className="btn-sm mb-1" onClick={() => this.removerRepetidor(campo.id, index, campo.nome)}>X</Button>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                    <Row>
                                                        <Col>
                                                            <Button variant="outline-success" className="btn-sm" onClick={() => this.adicionarRepetidor(campo.id, campo.repetidor_list)}>
                                                                Adicionar {campo.nome}
                                                            </Button>
                                                            {/* Link para ver histórico */}
                                                            {mostrarHistorico && (
                                                                <a
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        this.handleShowHistorico(campo.id, campo.nome);
                                                                    }}
                                                                    className="text-decoration-underline text-primary small d-block mt-1"
                                                                >
                                                                    Ver histórico
                                                                </a>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        )}

                                    </React.Fragment>
                                );
                            })}
                        </Row>
                    </div>
                )
            ))        
        );
    }

    handleAprovarArquivo = async (arquivo_id) => {
        const MySwal = withReactContent(Swal);
        const programaId = this.state.programa_dados?.id;

        try {
            // Verificar se existe formulário configurado para onApproveLaudo
            const formulario = await buscarFormularioEvento(EVENTOS.ON_APPROVE_LAUDO, programaId);
            
            if (formulario) {
                // Tem formulário - mostrar modal antes de aprovar
                this.setState({
                    showFormularioEventoModal: true,
                    formularioEventoData: formulario,
                    arquivoParaAprovar: { arquivo_id },
                });
            } else {
                // Sem formulário - aprovar direto com confirmação
                this.confirmarAprovacaoArquivo(arquivo_id, null);
            }
        } catch (error) {
            console.error("Erro ao buscar formulário de evento:", error);
            // Fallback: aprovar direto com confirmação
            this.confirmarAprovacaoArquivo(arquivo_id, null);
        }
    }

    confirmarAprovacaoArquivo = (arquivo_id, dadosFormulario) => {
        const MySwal = withReactContent(Swal);
        
        MySwal.fire({
            title: 'Aprovar Arquivo?',
            text: "Confirmar a aprovação deste documento?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, aprovar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.executarAprovacaoArquivo(arquivo_id, dadosFormulario);
            }
        });
    }

    executarAprovacaoArquivo = async (arquivo_id, dadosFormulario) => {
        const MySwal = withReactContent(Swal);
        
        this.setState({ loading: true });
        
        const payload = {
            aprovado: true,
            motivo_recusa: null
        };
        
        if (dadosFormulario) {
            payload.dados_formulario_aprovacao = dadosFormulario;
        }
        
        try {
            await api.put(`/agendamentos/arquivos/${arquivo_id}/`, payload);
            
            // Se tiver formulário e um agendamento selecionado, atualiza também o agendamento pai
            // Isso garante que os dados fiquem salvos na tabela agendamentos para exibição no histórico
            const agendamentoId = this.state.agendamento_selecionado?.id;
            if (dadosFormulario && agendamentoId) {
                await api.put(`/agendamentos/${agendamentoId}/`, {
                    dados_formulario_aprovacao: dadosFormulario
                });
            }

            this.setState({ loading: false });
            
            MySwal.fire({
                title: 'Sucesso', 
                text: 'Arquivo aprovado.', 
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            });

            if (agendamentoId) {
                this.carregaArquivosAgendamento(agendamentoId);
            }
            this.carregarAgendamentos(); 

        } catch (error) {
            this.setState({ loading: false });
            console.error("Erro ao aprovar arquivo:", error);

            if (error.response) {
                const msg = error.response?.data?.detail || 'Não foi possível aprovar.';
                MySwal.fire('Erro', msg, 'error');
            }
        }
    }

    handleFormularioEventoSuccess = async (respostas, arquivos) => {
        const { arquivoParaAprovar } = this.state;
        
        // Fechar modal
        this.setState({
            showFormularioEventoModal: false,
            formularioEventoData: null,
        });
        
        // Executar aprovação com os dados do formulário
        this.executarAprovacaoArquivo(arquivoParaAprovar.arquivo_id, respostas);
    }

    handleFormularioConfirmacaoSuccess = async (respostas, arquivos) => {
        const MySwal = withReactContent(Swal);
        
        this.setState({
            showFormularioEventoModalConfirmacao: false,
            formularioEventoDataConfirmacao: null,
            agendamentoParaConfirmarComFormulario: null,
            dadosFormularioAprovacaoColetados: null,
        });
        
        // Mostrar mensagem de sucesso
        MySwal.fire({
            title: 'Sucesso!',
            text: 'Realização de serviço e formulário de aprovação enviados com sucesso.',
            icon: 'success',
            confirmButtonColor: '#3085d6',
        });
    }

    handleRecusarArquivo = (arquivo_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Recusar Arquivo',
            text: "Motivo da não aprovação (será enviado ao laboratório):",
            input: 'textarea',
            inputPlaceholder: 'Ex: Imagem ilegível, paciente incorreto...',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#eb4961',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Recusar e Notificar',
            inputValidator: (value) => {
                if (!value) return 'A justificativa é obrigatória!'
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                this.setState({ loading: true });

                api.put(`/agendamentos/arquivos/${arquivo_id}/`, {
                    aprovado: false,
                    motivo_recusa: result.value
                })
                .then(() => {
                    this.setState({ loading: false });
                    
                    MySwal.fire({
                        title: 'Recusado', 
                        text: 'Laboratório notificado e status atualizado.', 
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    const agendamentoId = this.state.agendamento_selecionado?.id;
                    if (agendamentoId) {
                        this.carregaArquivosAgendamento(agendamentoId);
                    }
                    this.carregarAgendamentos();
                })
                .catch(error => {
                    this.setState({ loading: false });
                    console.error("Erro ao recusar arquivo:", error);
                    
                    if (error.response) {
                         const msg = error.response?.data?.detail || 'Erro ao processar a recusa.';
                         MySwal.fire('Erro', msg, 'error');
                    }
                });
            }
        });
    }

    adicionarRepetidor = (campoId, repetidores) => {
        const atuais = this.state.valoresCamposExtra[campoId] || [];
        /*const novo = {};
        repetidores.forEach(rep => {
            novo[rep.id] = '';
        });*/
        const novo = {};
        repetidores.forEach(rep => {
            novo[rep.id] = { id: null, valor: '' };
        });
        this.setState(prev => ({
            valoresCamposExtra: {
                ...prev.valoresCamposExtra,
                [campoId]: [...atuais, novo]
            }
        }));
    };

    removerRepetidor = async (campoId, index, nomeCampo) => {
        const MySwal = withReactContent(Swal);

        const resultado = await MySwal.fire({
            title: 'Confirmação',
            text: `Tem certeza que deseja remover esta linha de: ${nomeCampo}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, remover',
            cancelButtonText: 'Cancelar',
            showCloseButton: true,
        });

        if (resultado.isConfirmed) {
            const atuais = this.state.valoresCamposExtra[campoId] || [];
            atuais.splice(index, 1);
            this.setState(prev => ({
                valoresCamposExtra: {
                    ...prev.valoresCamposExtra,
                    [campoId]: [...atuais]
                }
            }));
        }
    };

    handleChangeRepeater = (campoId, index, slug, subcampo_id, valor) => {
        const novos = [...(this.state.valoresCamposExtra[campoId] || [])];
        //novos[index][subcampo_id] = valor;
        const cell = novos[index][subcampo_id] || {};
        novos[index][subcampo_id] = {
            id:    cell.id,      // mantem o id original (ou undefined, para novos)
            valor: valor         // atualiza só o valor
        };
        this.setState(prev => ({
            valoresCamposExtra: {
                ...prev.valoresCamposExtra,
                [campoId]: novos
            }
        }));
    };

    renderizaCamposExtraBeneficiario = () => {
        const {
            pacientes_campos = [],
            extra_valores_beneficiario_list = [],
        } = this.state;
    
        if (!pacientes_campos.length) return null;
        
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {}
        for(let i = 0; i < this.state.pacientes_campos.length; i++) {
            let item = this.state.pacientes_campos[i];
            const sessao = item.programas_list?.[0]?.secao || '0_sem_sessao'

            if(!(sessao in objCampos)){
                objCampos[sessao] = [];    
            }

            //percorre os valores dos campos
            item.valor = '';
            for(let j = 0; j < this.state.extra_valores_beneficiario_list.length; j++) {
                let itemValor = this.state.extra_valores_beneficiario_list[j];

                if(itemValor.campo_slug == item.slug){
                    item.valor = itemValor.valor;
                }
            }


            objCampos[sessao].push(item)
        }

        return (
            Object.keys(objCampos).map((nome_secao) => (
                <div key={nome_secao}>
                    {(nome_secao && nome_secao != '0_sem_sessao') && <h6 className="sessao-campos-extra">{(tiposSessoesAtendExtra[nome_secao]) ? tiposSessoesAtendExtra[nome_secao] : nome_secao}</h6>}
                    
                    <Row>
                        {objCampos[nome_secao].map((campo) => (
                        <React.Fragment key={campo.id}>
                            {campo.tipo === 'texto' || campo.tipo === 'area_texto' || campo.tipo === 'data' || campo.tipo === 'selecao' || campo.tipo === 'radio' || campo.tipo === 'numero' || campo.tipo === 'checkbox' ? (
                                <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>{campo.nome}</Form.Label>
                                        {
                                        (campo.tipo === 'selecao') ? (
                                            <Form.Control as="select" defaultValue={campo.valor || ''} required={campo.obrigatorio} onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}>
                                                <option value="">Selecione...</option>
                                                {campo.opcoes.split('\n').map((opcao, idx) => {
                                                    const [valor, label] = opcao.split(':');
                                                    return <option key={idx} value={valor}>{label}</option>;
                                                })}
                                            </Form.Control>
                                            ) 
                                        : 
                                            (campo.tipo === 'texto' || campo.tipo === 'data') ? (
                                                <Form.Control
                                                    type={campo.tipo === 'data' ? 'date' : 'text'}
                                                    defaultValue={campo.valor || ''}
                                                    required={campo.obrigatorio}
                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                                />
                                            )
                                            : 
                                            (campo.tipo === 'numero') ? (
                                                <Form.Control
                                                    type="number"
                                                    defaultValue={this.state.valoresCamposExtraPaciente?.[campo.id] || ''}
                                                    required={campo.obrigatorio}
                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                                />
                                            )
                                            : 
                                            (campo.tipo === 'checkbox') ? (
                                                <div>
                                                    {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                                        const [valor, label] = opcao.split(':');
                                                        const valoresSelecionados = campo.valor ? campo.valor.split(',') : [];
                                                        return (
                                                            <Form.Check
                                                            key={`checkbox_${campo.id}_${idx}`}
                                                            type="checkbox"
                                                            label={label || valor}
                                                            value={valor}
                                                            checked={(this.state.valoresCamposExtraPaciente?.[campo.id] || '').split(',').includes(valor)}
                                                            onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            )
                                            :
                                                (campo.tipo === 'radio') ? 
                                                (
                                                    <div>
                                                        {campo.opcoes.split('\n').map((opcao, indexO) => {
                                                            const [valorRadio, labelRadio] = opcao.split(':'); // Divide a opção pelo ':'
                                                            
                                                            return (
                                                                <Form.Check 
                                                                    inline 
                                                                    type="radio" 
                                                                    label={labelRadio} 
                                                                    key={`radio_${campo.id}_opcao_${indexO}`} 
                                                                    id={`radio_${campo.id}_opcao_${indexO}`}
                                                                    value={valorRadio} 
                                                                    onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                                                    checked={campo.valor == valor ? true : false}
                                                                />                                                                                                                        
                                                            );
                                                        })}
                                                    </div>
                                                )
                                                :
                                                (
                                                    <Form.Control
                                                        as={campo.tipo === 'area_texto' ? 'textarea' : 'text'}
                                                        defaultValue={campo.valor || ''}
                                                        required={campo.obrigatorio}
                                                        className={campo.tipo === 'area_texto' ? 'custom-textarea2' : ''}
                                                        onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e.target.value)}
                                                    />
                                                )
                                        }
                                        {campo.descricao && <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text>}
                                    </Form.Group>
                                </Col>
                            ) : null}
                           
                            {campo.tipo === 'arquivo' && (
                                <Col sm={6} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>{campo.nome}</Form.Label>
                                        <Form.Control 
                                            type="file" 
                                            required={campo.obrigatorio}
                                            onChange={(e) => this.handleChangeCampoPacienteExtra(campo.id, e)}
                                        />
                                        {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                                    </Form.Group>
                                </Col>
                            )}
                        </React.Fragment>
                        ))}
                    </Row>
                </div>
            ))        
        );
    }

    renderizaValoresCamposExtra = () => {
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {}
        for(let i = 0; i < this.state.camposExtraCadastrados.length; i++) {
            let item = this.state.camposExtraCadastrados[i];
            const sessao = item.programa.secao || '0_sem_sessao'

            if(!(sessao in objCampos)){
                objCampos[sessao] = [];    
            }

            objCampos[sessao].push(item)
        }

        return (
            Object.keys(objCampos).map((nome_sessao) => (
                <div key={'val_'+nome_sessao}>
                    {nome_sessao && <h6 className="sessao-campos-extra">{nome_sessao}</h6>}
                    
                    <Row>
                        {objCampos[nome_sessao].map((campo) => (
                        <React.Fragment key={campo.id}>
                            <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>{campo.campo_nome}: </Form.Label> {campo.valor}
                                </Form.Group>
                            </Col>                            
                        </React.Fragment>
                        ))}
                    </Row>
                </div>
            ))        
        );
    }

    carregaServicoPlano = async (plano_id) => {
        try {
            const response = await api.get(`/planos/regras/?plano_id=${plano_id}`);
            // Filtra os serviços/procedimentos antes de mapear
            const opcoesFiltradas = response.data.results.filter(servico => servico.servico_procedimento_id > 0).map(servico => ({
                value: servico.servico_procedimento_id,
                label: servico.dados_servico.nome,
                limite: servico.quantidade
            }));
            return opcoesFiltradas;
        } catch (error) {
            //Sentry.captureException('Erro ao carregar serviço/procedimento:', error);
            return [];
        }
    };

    carregaDadosPrograma = () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    const dadosResponse = this.tratarNulos(response.data);
                    this.setState({ programa_dados: dadosResponse }, () => {
                        this.setProgramaConfig(dadosResponse);
                        this.carregarEtapas();
                    });
                    this.carregaBotoesAtendimento(programa_id);
                    
                    this.carregarDicasPrograma(programa_id);

                    if(dadosResponse.habilitar_gestao_aplicacoes) {
                        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
                        this.carregarMonitoria();
                        this.carregarMonitoriaTipos(programa_id);
                    }
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                    //Sentry.captureException('Erro ao carregar dados do programa atual:', error);
                    
                    let erro_msg = 'Erro ao carregar dados do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregaBotoesAtendimento = (programa_id) => {
        if(programa_id) {
            api.get(`/programas/botoes/?programa_id=${programa_id}`)
                .then(response => {
                    const botoes = response.data.results;
                    this.setState({ botoes_atendimento: botoes });
                    
                    const locationState = this.props.router.location.state || {};
                    const params = new URLSearchParams(window.location.search);

                    const openPTCFromState = locationState.openPTC === true;
                    const openPTCFromQuery = params.get("openPTC") === "true";
                    const shouldOpenPTC = openPTCFromState || openPTCFromQuery;

                    if (shouldOpenPTC) {
                        console.log("AtendimentosEditV2: Flag 'openPTC' recebida. Procurando botão...");
                        
                        const ptcButton = botoes.find(
                            b => b.dados_formulario?.farmacovigilancia === true
                        );

                        if (ptcButton) {
                            console.log("Botão de FV encontrado! Armazenando Ref e abrindo modal...");
                            
                            const reportRefFromState = locationState.reportRef;
                            const reportRefFromQuery = params.get("reportRef");
                            const reportRef = reportRefFromState || reportRefFromQuery;

                            if (reportRef) {
                                this.setState({ tempReportRef: reportRef });
                            }
                            
                            this.handleShowModalBotao(ptcButton);

                            // Limpa state e também remove os query params da URL
                            this.props.router.navigate(
                                this.props.router.location.pathname,
                                {
                                    replace: true,
                                    state: {
                                        ...(locationState || {}),
                                        openPTC: false,
                                        reportRef: null
                                    }
                                }
                            );
                        } else {
                            console.warn("Flag 'openPTC' recebida, mas nenhum botão de Farmacovigilância foi encontrado na configuração deste programa.");
                        }
                    }
                })
                .catch(error => {
                    console.error('Erro ao carregar os botões de atendimento:', error);
                    let erro_msg = 'Erro ao carregar os botões de atendimento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente (botões de atendimento)';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    carregarDicasPrograma = (programa_id) => {
        if (programa_id) {
            api.get(`/programas/dicas/?programa_id=${programa_id}`)
            .then(response => {
                this.setState({ dicas: response.data.results });
            })
            .catch(error => {
                console.error('Erro ao carregar as dicas:', error);
                //Sentry.captureException('Erro ao carregar as dicas:', error);
                
                let erro_msg = 'Erro ao carregar as dicas, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente (dicas)';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    };

    avaliarRegraShowOn = (regrasArray) => {
        if (!regrasArray || !Array.isArray(regrasArray) || regrasArray.length === 0) return true;
        
        for (const regra of regrasArray) {
            const { campo, valor } = regra;
            if (this.state[campo] !== valor) {
                return false; 
            }
        }
        return true;
    }

    parseConfiguracoesEtapa = (etapa) => {
        if (!etapa || !etapa.configuracoes) return {};

        if (typeof etapa.configuracoes === 'string') {
            try {
                return JSON.parse(etapa.configuracoes);
            } catch (e) {
                return {};
            }
        }

        if (typeof etapa.configuracoes === 'object') {
            return etapa.configuracoes;
        }

        return {};
    }

    isEtapaExpansionDenied = (etapa, dadosUsuarioParam = null) => {
        if (!etapa) return false;

        const config = this.parseConfiguracoesEtapa(etapa);
        const denyProfilesRaw = config?.deny_profiles;
        if (!Array.isArray(denyProfilesRaw) || denyProfilesRaw.length === 0) {
            return false;
        }

        const denyProfiles = denyProfilesRaw
            .map(item => String(item || '').trim().toLowerCase())
            .filter(Boolean);
        if (denyProfiles.length === 0) return false;

        const dados_usuario = dadosUsuarioParam || getCurrentUser?.() || {};
        const tipoUsuario = String(dados_usuario?.tipo_usuario || '').trim().toLowerCase();
        const prestadorCategoria = String(dados_usuario?.prestador_categoria || '').trim().toLowerCase();

        if (tipoUsuario && denyProfiles.includes(tipoUsuario)) {
            return true;
        }

        if (tipoUsuario === 'prestador' && prestadorCategoria && denyProfiles.includes(prestadorCategoria)) {
            return true;
        }

        return false;
    }

    getEtapaFromAccordionKey = (key, listaExibicao = null) => {
        if (key === null || typeof key === 'undefined') return null;

        const [etapaIdStr, instanceStr] = String(key).split('-');
        const etapaId = parseInt(etapaIdStr, 10);
        if (Number.isNaN(etapaId)) return null;

        const instanceParsed = parseInt(instanceStr, 10);
        const instance = Number.isNaN(instanceParsed) ? 0 : instanceParsed;
        const lista = Array.isArray(listaExibicao)
            ? listaExibicao
            : (this.state.etapas_exibicao || this.state.etapas_atendimento || []);

        const item = lista.find((entry) => {
            const etapa = entry?.etapa || entry;
            const entryInstance = typeof entry?.instance === 'number' ? entry.instance : 0;
            return etapa?.id === etapaId && entryInstance === instance;
        });

        if (item) {
            return item?.etapa || item;
        }

        const etapasTodas = Array.isArray(this.state.etapas_todas_atendimento) ? this.state.etapas_todas_atendimento : [];
        return etapasTodas.find((etapa) => etapa.id === etapaId) || null;
    }

    isAccordionKeyBlocked = (key, listaExibicao = null) => {
        const etapa = this.getEtapaFromAccordionKey(key, listaExibicao);
        return this.isEtapaExpansionDenied(etapa);
    }

    handleHistoricoEtapaSelect = (eventKey) => {
        if (eventKey === null || typeof eventKey === 'undefined') {
            this.setState({ activeKey: null });
            return;
        }

        if (this.isAccordionKeyBlocked(eventKey)) {
            return;
        }

        this.carregarRelatosParaEtapa(eventKey);
    }

    atualizarEtapasFiltradas = () => {
        const { etapas_todas_atendimento = [] } = this.state;
        
        const etapasFiltradas = etapas_todas_atendimento.filter(etapa => {
            if (etapa.configuracoes) {
                try {
                    const config = typeof etapa.configuracoes === 'string' ? JSON.parse(etapa.configuracoes) : etapa.configuracoes;
                    if (config.show_on) {
                        return this.avaliarRegraShowOn(config.show_on);
                    }
                } catch (e) {
                    console.error("Erro ao fazer parse nas configuracoes da etapa", e);
                }
            }
            return true;
        });

        this.setState({
            etapas_atendimento: etapasFiltradas
        }, () => {
            this.recalcularEtapasExibicao();
        });
    };

    recalcularEtapasExibicao = () => {
        const { etapas_atendimento = [], etapas_status = [] } = this.state;

        // 1) Agrupar status por etapa_id e ordenar por data_cadastro (asc)
        const grupos = etapas_status.reduce((acc, s) => {
            const k = s.etapa_id;
            if (!acc[k]) acc[k] = [];
            acc[k].push(s);
            return acc;
        }, {});
        Object.keys(grupos).forEach(k => {
            grupos[k].sort((a, b) => new Date(a.data_cadastro) - new Date(b.data_cadastro));
        });

        // 2) Calcular o máximo de ocorrências (ciclos) entre todas as etapas do programa
        //    Se não houver status para alguma etapa, ainda assim exibimos o ciclo 0 dela.
        const maxOcc = etapas_atendimento.reduce((m, etapa) => {
            const len = (grupos[etapa.id]?.length || 0);
            return Math.max(m, Math.max(1, len)); // pelo menos 1 (ciclo 0)
        }, 1);

        // 3) Montar lista ciclo-a-ciclo:
        //    - ciclo 0: SEMPRE inclui todas as etapas do programa (instance=0)
        //    - ciclos >=1: inclui somente etapas que tenham essa ocorrência
        const exibicao = [];
        for (let cycle = 0; cycle < maxOcc; cycle++) {
            for (const etapa of etapas_atendimento) {
            const occArr = grupos[etapa.id] || [];
            if (cycle === 0) {
                exibicao.push({ etapa, instance: 0 });
            } else if (occArr.length > cycle) {
                exibicao.push({ etapa, instance: cycle });
            }
            }
        }

        this.setState({
            etapas_status_grouped: grupos,
            etapas_exibicao: exibicao
        }, () => {
            const updates = {};
            const { activeKey, pendingEtapaAccordionKey } = this.state;

            if (activeKey && this.isAccordionKeyBlocked(activeKey, exibicao)) {
                updates.activeKey = null;
            }

            if (pendingEtapaAccordionKey) {
                if (this.isAccordionKeyBlocked(pendingEtapaAccordionKey, exibicao)) {
                    updates.pendingEtapaAccordionKey = null;
                } else {
                    this.setState(
                        { pendingEtapaAccordionKey: null },
                        () => this.carregarRelatosParaEtapa(pendingEtapaAccordionKey)
                    );
                    return;
                }
            }

            if (Object.keys(updates).length > 0) {
                this.setState(updates);
            }
        });
    };

    carregarEtapas = () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            api.get(`/programas/etapas/?programa_id=${programa_id}&status=1`)
                .then(response => {
                    this.setState(
                    { etapas_todas_atendimento: response.data.results },
                    // se já há status carregado, filtra as etapas dinamicas e recalcula a exibicao
                    () => this.atualizarEtapasFiltradas()
                    );
                })
                .catch(error => {
                    console.error('Erro ao carregar etapas:', error);
                    let erro_msg = 'Erro ao carregar etapas do programa, tente novamente';
                    if (error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregarEtapasSelect = async (inputValue) => {
        try {
            const response = await api.get(`/programas/etapas/?programa_id=${this.state.programa_id}&status=1&nome=${inputValue}`);
            const opcoes = response.data.results
                .filter(etapa => {
                    // 1. Filtro base de ordem
                    if (etapa.ordem >= this.state.etapa_atual.ordem) return false;
                    
                    // 2. Filtro dinâmico de exibição (show-on)
                    if (etapa.configuracoes) {
                        try {
                            const config = typeof etapa.configuracoes === 'string' ? JSON.parse(etapa.configuracoes) : etapa.configuracoes;
                            if (config.show_on) {
                                return this.avaliarRegraShowOn(config.show_on);
                            }
                        } catch (e) {
                            console.error("Erro ao fazer parse nas configuracoes da etapa no dropdown", e);
                        }
                    }
                    return true;
                })
                .map(etapa => ({
                    value: etapa.id,
                    label: etapa.nome
                }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar etapas:', error);
            Sentry.captureException('Erro ao carregar etapas:', error);
            return [];
        }
    };

    carregaServicosEtapa = async () => {
        // const opcoesFiltradas = this.state.servicos_etapa.filter(servico => servico.servico_procedimento_id > 0).map(servico => ({
        //     value: servico.servico_procedimento_id,
        //     label: servico.dados_servico.nome,
        // }));

        let opcoesFiltradas = []

        let count = 0
        this.state.servicos_etapa.forEach(servico => {
            if(servico.servico_procedimento_id > 0){
                count++;

                //primeiro servico
                if(this.state.etapa_relato.servico_fixo && count == 1){
                    this.setState({
                        relato_servico_procedimento_id: servico.servico_procedimento_id,
                        relato_servico_procedimento_nome: servico.dados_servico.nome
                    })
                }

                opcoesFiltradas.push({
                    value: servico.servico_procedimento_id,
                    label: servico.dados_servico.nome,
                })
            }
        });
    
        return opcoesFiltradas;
    };

    carregarEtapasStatus = () => {
        if (this.state.atendimento_id) {
            api.get(`/atendimentos/etapas/?atendimento_id=${this.state.atendimento_id}&limit=1000`)
                .then(response => {
                    this.setState(
                    { etapas_status: response.data.results },
                    // se já há etapas do programa, recalcula a exibição
                    () => this.recalcularEtapasExibicao()
                    );
                })
                .catch(error => {
                    console.error('Erro ao carregar status das etapas:', error);
                    //Sentry.captureException('Erro ao carregar status das etapas:', error);
                    
                    let erro_msg = 'Erro ao carregar status das etapas, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    getStatusDaEtapa = (etapaId, instance = 0) => {
        const grupos = this.state.etapas_status_grouped || {};
        const arr = grupos[etapaId] || [];
        // se não existir a instância pedida, usa a última conhecida; se não houver, retorna undefined
        return arr[instance] || arr[arr.length - 1];
    };

    carregarRelatosAtendimento = () => {
        if (this.state.atendimento_id) {
            api.get(`/atendimentos/relatos/?atendimento_id=${this.state.atendimento_id}&limit=500`)
                .then(response => {
                    // Filtra apenas os relatos do tipo "atendimento"
                    const relatosAtendimento = response.data.results.filter(relato => relato.tipo === "atendimento");

                    // Agrupa os relatos por etapa_id
                    const relatosAgrupados = relatosAtendimento.reduce((acc, relato) => {
                        const { etapa_id } = relato;
                        if (!acc[etapa_id]) {
                            acc[etapa_id] = [];
                        }
                        acc[etapa_id].push(relato);
                        return acc;
                    }, {});
    
                    this.setState({ relatos_atendimento: relatosAgrupados });
                })
                .catch(error => {
                    console.error('Erro ao carregar relatos do atendimento:', error);
                    Sentry.captureException('Erro ao carregar relatos do atendimento:', error);
    
                    let erro_msg = 'Erro ao carregar relatos do atendimento, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    });
                });
        }
    };
    

    carregaEtapaAtual = () => {
        if (this.state.etapa_id) {
            api.get(`/programas/etapas/${this.state.etapa_id}/`)
                .then(response => {
                    this.setState({ etapa_atual: response.data, formulario_id: response.data.formulario_id }, () => {

                        // Após definir etapa_atual, carrega os templates de WhatsApp
                        this.carregaTemplatesWhatsapp();

                        // Verifica popup para médicos na etapa
                        this.verificarPopupEtapa();

                        //Verifica se deve abrir Modal para registrar etapa
                        const url = new URL(window.location.href);

                        // Verifica se o parâmetro 'iniciaratendimento' está presente
                        if (url.searchParams.has('iniciaratendimento')) {
                            // Atualiza o estado para abrir o modal para registrar a etata atual
                            this.handleShowModalRelatosEdit();

                            // Remove o parâmetro 'iniciaratendimento' da URL
                            url.searchParams.delete('iniciaratendimento');

                            // Atualiza a URL sem recarregar a página
                            window.history.pushState({}, '', url.toString());
                        }
                    });
                })
                .catch(error => {
                    console.error('Erro ao carregar etapa atual:', error);
                    //Sentry.captureException('Erro ao carregar etapa atual:', error);
                    
                    let erro_msg = 'Erro ao carregar etapa atual, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };
    
    /**
     * Exibe popup(s) para médicos ao abrir um atendimento,
     * conforme configuração popup_medico nas configurações da etapa atual.
     */
    verificarPopupEtapa = () => {
        if (this._popupEtapaTermoExibido) return;

        const dados_usuario = getCurrentUser();
        if (dados_usuario['prestador_categoria'] !== 'medicos') return;

        const etapa = this.state.etapa_atual;
        if (!etapa) return;

        let cfg = etapa.configuracoes;
        if (cfg && typeof cfg === 'string') {
            try { cfg = JSON.parse(cfg); } catch (e) { cfg = null; }
        }

        const popupConfig = cfg?.popup_medico;
        if (!popupConfig || !popupConfig.mensagem) return;

        this._popupEtapaTermoExibido = true;

        const doencaId = parseInt(this.state.doenca_id);

        Swal.fire({
            icon: 'info',
            title: 'Atenção',
            html: popupConfig.mensagem,
            confirmButtonText: 'OK'
        }).then((result) => {
            if (result.isConfirmed && popupConfig.popup_2 && Array.isArray(popupConfig.popup_2)) {
                const popup2 = popupConfig.popup_2.find(p => p.doencas && p.doencas.includes(doencaId));
                if (popup2 && popup2.mensagem) {
                    Swal.fire({
                        icon: 'info',
                        title: 'Atenção',
                        html: popup2.mensagem,
                        confirmButtonText: 'OK'
                    });
                }
            }
        });
    };

    carregaTemplatesWhatsapp = () => {
        const { etapa_id } = this.state;
    
        api.get(`/programas/etapas/templates-whatsapp/?etapa_id=${etapa_id}`)
            .then(response => {
                this.setState({ templates_whatsapp: response.data.results });
            })
            .catch(error => {
                console.error('Erro ao carregar templates WhatsApp:', error);
                // Você pode definir mensagens de erro no estado ou capturar no Sentry
                this.setState({ templates_whatsapp: [] }); // Define como vazio em caso de erro
            });
    };

    carregarHistoricoEtapas() {
        // Exemplo: carrega as etapas (assumindo que já tem essa informação no estado)
        const etapas = this.state.etapas_atendimento;
        this.setState({ historicoEtapas: etapas });
    
        etapas.forEach(etapa => {
            api.get(`/atendimentos/relatos/?etapa_id=${etapa.id}&atendimento_id=${this.state.atendimento_id}&limit=500`)
                .then(response => {
                    this.setState(prevState => ({
                        relatosPorEtapa: {
                            ...prevState.relatosPorEtapa,
                            [etapa.id]: response.data.results
                        }
                    }));
                });
        });
    }

    carregarRelatosParaEtapa = (key) => {
        if (key === null || typeof key === 'undefined') {
            this.setState({ activeKey: null });
            return;
        }

        if (this.isAccordionKeyBlocked(key)) {
            return;
        }

        // Normaliza chave e ids
        const [etapaIdStr, instanceStr] = String(key).split('-');
        const etapaId = parseInt(etapaIdStr, 10);
        const hasInstance = typeof instanceStr !== 'undefined';
        const compKey = hasInstance ? `${etapaId}-${instanceStr}` : String(etapaId);

        // O Accordion espera activeKey === compKey
        this.setState({ activeKey: compKey });

        if (!etapaId) return;

        // Cache: se já carregou os relatos brutos da etapa, não refaça a chamada
        // (mantemos o mesmo shape que você já usa: relatosPorEtapa[etapaId] = {carregando, dados})
        const jaTem = this.state.relatosPorEtapa[etapaId];
        if (jaTem && !jaTem.carregando && jaTem.dados && jaTem.dados.length > 0) {
            return; // já temos os dados para filtrar por instância na renderização
        }

        // Marca carregando para a etapa base
        this.setState(prev => ({
            relatosPorEtapa: {
            ...prev.relatosPorEtapa,
            [etapaId]: { carregando: true, dados: [] }
            }
        }));

        // Busca bruta por etapa apenas uma vez; a filtragem por instância fazemos no render
        api.get(`/atendimentos/relatos/?etapa_id=${etapaId}&atendimento_id=${this.state.atendimento_id}&limit=500`)
            .then(response => {
            const relatosFiltrados = response.data.results.filter(r => r.tipo !== "atendimento");
            this.setState(prev => ({
                relatosPorEtapa: {
                ...prev.relatosPorEtapa,
                [etapaId]: { carregando: false, dados: relatosFiltrados }
                }
            }));
            })
            .catch(() => {
            this.setState(prev => ({
                relatosPorEtapa: {
                ...prev.relatosPorEtapa,
                [etapaId]: { carregando: false, dados: [] }
                }
            }));
        });
    };
    
    // Usa a janela de tempo entre a ocorrência "instance" e a próxima para filtrar
    getRelatosDaEtapaInstancia = (etapaId, instance = 0) => {
        const grupos = this.state.etapas_status_grouped || {};
        const ocorrencias = grupos[etapaId] || [];

        // Se não há ocorrências mapeadas, retorna tudo que veio da API para a etapa (fallback)
        if (!ocorrencias.length) {
            return (this.state.relatosPorEtapa[etapaId]?.dados || []);
        }

        const atual = ocorrencias[instance] || ocorrencias[ocorrencias.length - 1];
        const proxima = ocorrencias[instance + 1] || null;

        // Para o ciclo 0, abre o início da janela em -Infinity para também capturar
        // relatos órfãos de ocorrências anteriores que foram apagadas (ex.: cancelamento
        // de etapa com volta para etapa anterior remove os registros de status posteriores,
        // mas mantém os relatos vinculados ao etapa_id).
        const tStart = instance === 0
            ? -Infinity
            : (atual?.data_cadastro ? new Date(atual.data_cadastro).getTime() : -Infinity);
        const tEnd = proxima?.data_cadastro ? new Date(proxima.data_cadastro).getTime() : Infinity;

        const todos = (this.state.relatosPorEtapa[etapaId]?.dados || []);
        return todos.filter(r => {
            const t = new Date(r.data).getTime();
            return t >= tStart && t < tEnd;
        });
    };

    carregarAgendamentos = (num_page = 1) => {
        let dados_usuario = getCurrentUser();
        if (this.state.atendimento_id && hasPerm('view_agendamentos')) {
            const url = `/agendamentos/?atendimento_id=${this.state.atendimento_id}&tipo_usuario=${dados_usuario['tipo_usuario']}&page=${num_page}&limit=${this.state.agendamentos_limite}`
                        
            this.setState({ loadingAgendamentos: true });

            api.get(url)
                .then(response => {
                    const dadosAgendamentos = response.data.results ? response.data.results : response.data;
                    this.setState({ 
                        agendamentos: Array.isArray(dadosAgendamentos) ? dadosAgendamentos : [],
                        agendamentos_data: response.data,
                        loadingAgendamentos: false 
                    });
                    
                    // Buscar serviços sempre que carregar os agendamentos, 
                    // para saber quais já foram faturados.
                    this.getServicosAtendimentoAll();
                })
                .catch(error => {
                    console.error('Erro ao carregar agendamentos:', error);
                    //Sentry.captureException('Erro ao carregar agendamentos:', error);
                    
                    let erro_msg = 'Erro ao carregar agendamentos, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                    this.setState({ loadingAgendamentos: false });
                });
        }
    }

    carregarExames = () => {
        if (this.state.atendimento_id) {
            api.get(`/exames/?atendimento_id=${this.state.atendimento_id}&limit=1000`)
                .then(response => {
                    this.setState({ exames: response.data.results || [] });
                })
                .catch(error => {
                    console.error('Erro ao carregar exames:', error);
                    this.setState({ exames: [] });
                });
        }
    };

    verificarExamesExtrasPendentes = () => {
        const extraExams = this.state.exames_extras_solicitacao || [];
        if (extraExams.length === 0) return false;

        // Coleta todos os servico_procedimento_id dos exames já solicitados
        const examesSolicitadosIds = [];
        const statusIgnorados = ['realizado', 'cancelado', 'recusado'];

        (this.state.exames || []).forEach(pedido => {
            (pedido.exames_solicitados || []).forEach(exame => {
                if (exame.servico_procedimento_id && !statusIgnorados.includes(exame.status)) {
                    examesSolicitadosIds.push(exame.servico_procedimento_id);
                }
            });
        });

        // Verifica se existe algum exame desbloqueado que NÃO foi solicitado
        const temExamesPendentes = extraExams.some(extraId => 
            !examesSolicitadosIds.includes(extraId)
        );

        return temExamesPendentes;
    };

    carregarAcoes = () => {
        let dados_usuario = getCurrentUser();
        if (this.state.atendimento_id) {
            const url = `/atendimentos/acoes/?atendimento_id=${this.state.atendimento_id}`
            api.get(url)
                .then(response => {
                    this.setState({ acoes: response.data });
                })
                .catch(error => {
                    console.error('Erro ao carregar ações:', error);
                    //Sentry.captureException('Erro ao carregar agendamentos:', error);
                    
                    let erro_msg = 'Erro ao carregar açõess, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                });
        }
    };

    carregarProdutos = () => {
        let dados_usuario = getCurrentUser();
        if (this.state.atendimento_id && hasPerm('view_agendamentos')) {
            const url = `/atendimentos/produtos/?atendimento_id=${this.state.atendimento_id}`
            api.get(url)
                .then(response => {
                    this.setState({ produtos: response.data });
                })
                .catch(error => {
                    console.error('Erro ao carregar produtos:', error);
                    //Sentry.captureException('Erro ao carregar produtos:', error);
                    
                    let erro_msg = 'Erro ao carregar produtos, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                });
        }
    };

    handleExcluirMonitoria = (id) => {
        Swal.fire({
            title: 'Atenção',
            text: 'Tem certeza que deseja excluir esta monitoria?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/atendimentos/aplicacoes/${id}/`)
                    .then(response => {
                        this.carregarMonitoria(this.state.monitoria_page_numb);
                        this.setState({ loading: false });
                    })
                    .catch(error => {
                        console.error('Erro ao excluir monitoria:', error);
                        this.setState({ loading: false });
                    });
            }
        })
    }

    handleOrderChangeMonitoria(campo) {
        const novaOrdem = campo;
        const novaOrdemDirecao = this.state.monitoria_ordem === campo && this.state.monitoria_ordem_direcao === 'asc' ? 'desc' : 'asc';

        this.setState({
            monitoria_ordem: novaOrdem,
            monitoria_ordem_direcao: novaOrdemDirecao,
        }, () => {
            this.carregarMonitoria(this.state.monitoria_page_numb);
        });
    }

    onClickPaginaMonitoria = (num_page) => {
        this.setState({
            monitoria_loading: true,
            monitoria_page_numb: num_page
        }, () => {
            this.carregarMonitoria(num_page)
        });
    };

    onClickPaginaAgendamentos = (num_page) => {
        this.setState({
            agendamentos_page_numb: num_page
        }, () => {
            this.carregarAgendamentos(num_page);
        });
    };

    onClickPaginaServicosAtendimento = (num_page) => {
        this.setState({
            servicos_atendimento_page_numb: num_page
        }, () => {
            this.getServicosAtendimento(num_page);
        });
    };

    carregarMonitoria = async (num_page = 1) => {
        if(this.state.monitoria_id && hasPerm('view_atendimentos_aplicacoes')){
            await api.get(`/atendimentos/aplicacoes/${this.state.monitoria_id}/`)
            .then(response => {
                const campos = response.data;
                const data = campos.data_agendada.substring(0,10);
                const data_realizacao = (campos.data_realizacao) ? campos.data_realizacao.substring(0,10) : '';
                this.setState({ 
                    monitoria_data_prevista: data,
                    monitoria_data_realizacao: data_realizacao,
                    monitoria_tipo: campos.dados_aplicacao_tipo.nome,
                    monitoria_tipo_id: campos.aplicacao_tipo_id,
                    monitoria_status_id: campos.aplicacao_status_id,
                    monitoria_status: campos.dados_aplicacao_status.nome,
                    monitoria_motivo: campos.motivo,
                    monitoria_dosagens: campos.dosagens
                  }, () => {
                    this.setState({
                        showModalMonitoria: true,
                        monitoria_loading: false
                    });
                  });

            })
            .catch(error => {
                console.error('Erro ao carregar aplicações:', error);
                //Sentry.captureException('Erro ao carregar agendamentos:', error);
                
                let erro_msg = 'Erro ao carregar aplicações, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            }); 
        }
        else if (this.state.atendimento_id && hasPerm('view_atendimentos_aplicacoes')) {
            await api.get(`/atendimentos/aplicacoes/?atendimento_id=${this.state.atendimento_id}&page=${num_page}&limit=${this.state.monitoria_limite}&order=${this.state.monitoria_ordem}&order_by=${this.state.monitoria_ordem_direcao}`)
                .then(response => {
                    this.setState({ monitoria: response.data, monitoria_loading: false });
                })
                .catch(error => {
                    console.error('Erro ao carregar aplicações:', error);
                    //Sentry.captureException('Erro ao carregar agendamentos:', error);
                    
                    let erro_msg = 'Erro ao carregar aplicações, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
        
    };

    carregarMonitoriaTipos = (programa_id) => {
        if (programa_id && hasPerm('view_atendimentos_aplicacoes')) {
            api.get(`/programas/aplicacoes-tipos/?programa_id=${programa_id}`)
            .then(response => {
                this.setState({ monitoria_tipos: response.data });
            })
            .catch(error => {
                console.error('Erro ao carregar tipos de aplicacoes:', error);
                //Sentry.captureException('Erro ao carregar agendamentos:', error);
                
                let erro_msg = 'Erro ao carregar tipos de aplicacoes, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    };

    //Cria registro do atendimento
    enviaRegistro = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            dataHelper: '',
            beneficiarioHelper: '',
            atendenteHelper: '',
            programaHelper: '',
            etapaHelper: '',
            clienteHelper: ''
        });

        // PRÉ-CADASTRO bloqueado por elegibilidade: salva o formulário sem paciente/plano/laboratório
        if (this.preCadIsBloqueado()) {
            const primeiraEtapa = (this.state.etapas_atendimento.length > 0) ? this.state.etapas_atendimento[0] : '';
            if (primeiraEtapa && primeiraEtapa.id) {
                this.salvaRegistro(primeiraEtapa.id);
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Atenção',
                    html: 'Não há etapas configuradas para o programa'
                });
            }
            return;
        }

        const dados_usuario = getCurrentUser();

        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
        const medico_id = (dados_usuario['prestador_id']) ? dados_usuario['prestador_id'] : this.state.medico_id;

        const url = `/atendimentos/?page=1&beneficiario_id=${this.state.beneficiario_id}&tipo_usuario=${dados_usuario['tipo_usuario']}&programa_id=${programa_id}`;

        api.get(url)
        .then(response => {

            let prossegue_atendimento = true;

            if(medico_id && 'results' in response.data && response.data.results.length > 0){

                const allCancelledOrFinalized = response.data.results.every(
                    resultado => resultado.cancelado === true || resultado.finalizado === true
                );

                if(!allCancelledOrFinalized) {
                    prossegue_atendimento = false;
                    Swal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: 'Atenção',
                        html: 'Este paciente já atingiu o limite de atendimentos'
                    }) 
                    this.setState({
                        loading: false
                    });
                }

            } 

            //verifica se o programa exige escolha de laboratório e se o mesmo está preenchido
            if(this.state.programa_dados.laboratorio_cadastro && !this.state.laboratorio_id) {
                prossegue_atendimento = false;
                Swal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Atenção!',
                    html: 'É obrigatório a seleção de um laboratório para prosseguir'
                }) 
                this.setState({
                    loading: false
                });
            }
            
            if(prossegue_atendimento) {
                const primeiraEtapa = (this.state.etapas_atendimento.length > 0) ? this.state.etapas_atendimento[0] : '';

                if (primeiraEtapa && primeiraEtapa.id) {
                    this.salvaRegistro(primeiraEtapa.id); // Continua o processo para criar o atendimento
                } else {
                    this.setState({
                        loading: false,
                    })
                    Swal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: 'Atenção',
                        html: 'Não há etapas configuradas para o programa'
                    })    
                }
            }
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar atendimentos do paciente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            Swal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: erro_msg
            });    

            //Sentry.captureException(erro_msg);

            this.setState({
                loading: false,
            });
        });
    
        
    };

    salvaRegistro = (etapaId) => {
        let dados_usuario = getCurrentUser();

        //Pega etapa inicial e próxima etapa
        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === etapaId);
        const proximaEtapa = (indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1)
            ? this.state.etapas_atendimento[indiceEtapaAtual + 1]
            : null;

        // Verifica etapa para envio de mensageria e para cadastro em andamento
        // Se houver bloqueio de elegibilidade no pré-cadastro, mantém na etapa atual (não avança)
        const etapaAEnviar = (this.state.programa_dados.habilitar_pre_cadastro_basico && proximaEtapa && !this.preCadIsBloqueado())
            ? proximaEtapa.id
            : etapaId;

        const formData = new FormData();
    
        const url = (this.state.atendimento_id) ? '/atendimentos/'+this.state.atendimento_id+'/' : '/atendimentos/';
        const metodo = (this.state.atendimento_id) ? 'put' : 'post';

        if (this.state.beneficiario_id) {
            formData.append('beneficiario_id', this.state.beneficiario_id);
        }

        if(dados_usuario['ambiente_cliente_id'] > 0) {
            formData.append('cliente_id', dados_usuario['ambiente_cliente_id']);
        } else {
            formData.append('cliente_id', this.state.cliente_id);
        }

        if(dados_usuario['ambiente_programa_id'] > 0) {
            formData.append('programa_id', dados_usuario['ambiente_programa_id']);
        } else {
            formData.append('programa_id', this.state.programa_id);
        }

        if (this.state.plano_id) {
            formData.append('plano_id', this.state.plano_id);
        }

        if(dados_usuario['operador_id'] > 0) {
            formData.append('atendente_id', dados_usuario['operador_id']);
        } else {
            if(this.state.atendente_id) {
                formData.append('atendente_id', this.state.atendente_id);
            }
        }

        const medicoId = (dados_usuario['prestador_id'] > 0 && (dados_usuario['prestador_categoria'] == 'medicos' || dados_usuario['prestador_categoria'] == 'multiprofissionais')) ? dados_usuario['prestador_id'] : this.state.medico_id;
        formData.append('medico_id', medicoId);

        if(dados_usuario['prestador_id'] > 0 && (dados_usuario['prestador_categoria'] != 'medicos' && dados_usuario['prestador_categoria'] != 'multiprofissionais')) {
            formData.append('laboratorio_id', dados_usuario['prestador_id']);
        } else {
            if(this.state.laboratorio_id) {
                formData.append('laboratorio_id', this.state.laboratorio_id);
            }
        }
        
        formData.append('etapa_id', etapaAEnviar); //Etapa atual do atendimento conforme validação de pré cadastro
        
        const data_atual = getDataAtual();
        
        formData.append('data', data_atual);

        if(this.state.programa_dados.validacao_doenca == "atendimento" && this.state.doenca_id) {
            formData.append('doenca_id', this.state.doenca_id);
        } else {
            if(this.state.programa_dados.doenca_principal_id) {
                formData.append('doenca_id', this.state.programa_dados.doenca_principal_id);
            }
        }

        formData.append('doenca_outros', this.state.doenca_outros || '');
        formData.append('cadastro_teste', this.state.cadastro_teste || false);


        if(this.state.servico_procedimento_id) {
            formData.append('servico_procedimento_id', this.state.servico_procedimento_id || '');
        }

        //Status inicial do programa
        if(this.state.programa_dados.dados_status) {
            const primeiroCadastroAtendimento = this.state.programa_dados.dados_status.find(item => item.tipo === "cadastro_atendimento");

            if(primeiroCadastroAtendimento) {
                formData.append('programa_status_id', primeiroCadastroAtendimento.id);
            }
        }

        formData.append('recebe_kit_paciente', this.state.recebe_kit_paciente);

        //campos extras do atendimento
        let cont = 1;
        let cancelar_voltar_etapa = false;
        let list_valores = [];

        Object.entries(this.state.valoresCamposExtra).forEach(([campoId, valor]) => {
            const campo = this.state.atendimento_campos.find(c => c.id === parseInt(campoId));

            let dados = {
                valor: "",
                file_param: "",
                campo_id: campoId,
                repeater: []
            };

            if (campo.tipo === 'repeater') {
                if (Array.isArray(valor)) {
                    valor.forEach((repetidorItem, idx) => {
                        let bloco = {};
                        Object.entries(repetidorItem).forEach(([id, val]) => {
                            bloco = {
                                'subcampo_id': id,
                                'valor': val,
                            };
                            dados.repeater.push(bloco);
                        });
                        
                    });
                }
            }

            else if (valor instanceof File) {
                let file_param = `valor_arquivo_${cont}`;
                dados.file_param = file_param;
                formData.append(file_param, valor);
            }

            else if (typeof valor === "boolean") {
                dados.valor = valor;
            }

            else if (typeof valor === "string" && ['outro', 'outros'].includes(valor.toLowerCase()) && this.state.camposOutrosExtra[campoId]) {
                dados.valor = `Outro - ${this.state.camposOutrosExtra[campoId]}`;
            }

            else {
                dados.valor = valor;
            }

            list_valores.push(dados);
            cont++;
        });

        if (list_valores.length > 0) {
            formData.append('valores', JSON.stringify(list_valores));
        }
    
        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.atendimento_id) ? 'Atendimento atualizado com sucesso' : 'Atendimento cadastrado com sucesso';

            const id_atendimento = (this.state.uuid) ? this.state.uuid : response.data.uuid;
            const idResposta     = response.data.id;

            //Atrela o médico ao paciente
            if(medicoId) {
                const dadosMedico = {
                    beneficiario_id: this.state.beneficiario_id,
                    prestador_id: medicoId,
                };
                api({
                    method: 'post',
                    url: '/pessoas/beneficiarios/medicos/',
                    data: dadosMedico,
                })
                .then(responseMedico => {
                    console.log("Médico atrelado ao paciente");
                })
                .catch(errorMedico => {
                    console.log("Erro ao atrelar médico ao paciente")
                    //Sentry.captureException("Erro ao atrelar médico ao paciente");
                });
            }

            //Verifica se é um pré cadastro básico
            // HNS-1512: precisa aguardar os POSTs de etapa concluírem antes do redirect,
            // senão a navegação cancela os requests e o atendimento fica sem registros
            // em atendimentos_atendimentos_etapas (etapa_id aponta pra etapa errada)
            let registrarEtapasPromise;
            if (this.state.programa_dados.habilitar_pre_cadastro_basico && proximaEtapa) {
                registrarEtapasPromise = Promise.all([
                    api.post('/atendimentos/etapas/', {
                        etapa_id: etapaId,
                        atendimento_id: idResposta,
                        status: 'concluido'
                    }),
                    api.post('/atendimentos/etapas/', {
                        etapa_id: proximaEtapa.id,
                        atendimento_id: idResposta,
                        status: 'em_andamento'
                    })
                ]);

                // mensageria se configurado (não bloqueia o redirect)
                if (proximaEtapa.midias_contato
                    && proximaEtapa.momento_envio === 'inicio'
                    && (proximaEtapa.tipo_envio === 'automatico' || proximaEtapa.tipo_envio === 'ambos')) {

                    api.post('/mensageria/etapa/', {
                        etapa_id: proximaEtapa.id,
                        atendimento_id: idResposta
                    }).catch(err => console.log("Mensagem da etapa não enviada", err));
                }
            } else if (!this.state.atendimento_id) {
                registrarEtapasPromise = api.post('/atendimentos/etapas/', {
                    etapa_id: etapaId,
                    atendimento_id: response.data.id,
                    status: 'em_andamento'
                });
            } else {
                registrarEtapasPromise = Promise.resolve();
            }

            return registrarEtapasPromise.then(() => {
                let mensagem = 'Pré cadastro finalizado com sucesso';
                const config_msg_pre_tratamento = getConfig(this.state.programa_dados?.configuracoes, 'atendimentos.mensagem_pre_cadastro');

                if(config_msg_pre_tratamento) {
                    mensagem = config_msg_pre_tratamento;
                }

                MySwal.fire({
                    title: 'Pré Cadastro Finalizado',
                    icon: 'success',
                    html: mensagem,
                    showCloseButton: true,
                }).then((result) => {
                    //redireciona
                    if(!id_atendimento){
                        this.props.router.navigate("/atendimentos");
                    } else {
                        if(getConfig(this.state.programa_dados?.configuracoes, 'atendimentos.habilitar_aba_novo_cadastro') === true && !this.preCadIsBloqueado()) {
                            window.location.href = `/atendimentos/edit/${id_atendimento}/?iniciaratendimento=1`;
                        } else {
                            window.location.href = `/atendimentos/edit/${id_atendimento}/`;
                        }
                    }
                });
            }).catch(errEtapa => {
                console.error("Erro ao registrar etapas do atendimento", errEtapa);
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Atenção',
                    html: 'O atendimento foi criado, mas ocorreu um erro ao registrar as etapas. Acesse o atendimento e verifique antes de continuar.',
                }).then(() => {
                    if(id_atendimento) {
                        window.location.href = `/atendimentos/edit/${id_atendimento}/`;
                    } else {
                        this.props.router.navigate("/atendimentos");
                    }
                });
                this.setState({ loading: false });
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o atendimento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'data'){
                        this.setState({ dataHelper: value })
                    }
                    if(key === 'beneficiario_id'){
                        this.setState({ beneficiarioHelper: value })
                    }
                    if(key === 'cliente_id'){
                        this.setState({ clienteHelper: value })
                    }
                    if(key === 'programa_id'){
                        this.setState({ programaHelper: value })
                    }
                }
            }

            //Sentry.captureException(erro_msg);

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    alterarValidacaoAtendimento = () => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Alterar Validação?',
            html: `Deseja alterar a validação do atendimento?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, alterar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData();
                formData.append('atendimento_validado', !this.state.atendimento_validado);
                //envia para api
                api({
                    method: "put",
                    url: '/atendimentos/'+this.state.atendimento_id+'/',
                    data: formData,
                })
                .then(response => {
                    const MySwal = withReactContent(Swal)

                    MySwal.fire({
                        title: 'Validação alterada com sucesso!',
                        icon: 'success',
                        html: 'Validação alterada com sucesso',
                        showCloseButton: true,
                    }).then((result) => {
                        location.reload();
                    });

                    
                })
                .catch(error => {
                    let erro_msg = 'Erro ao alterar a validação do atendimento, verifique os campos e tente novamente';            

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    Sentry.captureException(erro_msg);

                    const MySwal = withReactContent(Swal)
                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                    })    
                    
                    this.setState({
                        loading: false,
                    })
                });
            }
        });        
    };

    atualizarAtendimento = () => {
        // Bloqueia o botão para evitar cliques duplicados
        if (this.state.loading) return;
        this.setState({ loading: true });

        const formData = new FormData();
        
        if(this.state.programa_dados.validacao_doenca == 'atendimento') {
            if(!this.state.doenca_id) {
                const MySwal = withReactContent(Swal)

                MySwal.fire({
                    title: 'Atenção!',
                    html: `Por favor, selecione uma opção do campo ${this.state.programa_dados.label_doencas}`,
                    icon: 'error',
                    showCloseButton: true,
                });
                this.setState({ loading: false });
                return; // Interrompe a execução do resto da função
            }
        }

        //campos extras do atendimento
        let cont = 1;
        let cancelar_voltar_etapa = false;
        let list_valores = [];

        Object.entries(this.state.valoresCamposExtra).forEach(([campoId, valor]) => {
            const campo = this.state.atendimento_campos.find(c => c.id === parseInt(campoId, 10));

            let dados = {
                valor: "",
                file_param: "",
                campo_id: campoId,
                repeater: []
            };

            /*if (campo.tipo === 'repeater') {
                if (Array.isArray(valor)) {
                    valor.forEach((repetidorItem, idx) => {
                        let bloco = {};
                        Object.entries(repetidorItem).forEach(([id, val]) => {
                            bloco = {
                                'subcampo_id': id,
                                'valor': val,
                            };
                            dados.repeater.push(bloco);
                        });
                        
                    });
                }
            }*/
            if (campo.tipo === 'repeater' && Array.isArray(valor)) {
                const definicoes = campo.repetidor_list; // lista de defs, cada def.id é o subcampo_id

                valor.forEach(row => {
                    definicoes.forEach(def => {
                    const cell = row[def.id] || { id: null, valor: '' };
                        dados.repeater.push({
                            // somente inclua id se existir
                            ...(cell.id != null ? { id: cell.id } : {}),
                            subcampo_id:   def.id,
                            subcampo_slug: def.slug,
                            subcampo_nome: def.nome,
                            valor:         cell.valor
                        });
                        });
                });
            }
            else if (valor instanceof File) {
                let file_param = `valor_arquivo_${cont}`;
                dados.file_param = file_param;
                formData.append(file_param, valor);
            }

            else if (typeof valor === "boolean") {
                dados.valor = valor;
            }

            else if (typeof valor === "string" && ['outro', 'outros'].includes(valor.toLowerCase()) && this.state.camposOutrosExtra[campoId]) {
                dados.valor = `Outro - ${this.state.camposOutrosExtra[campoId]}`;
            }

            else {
                dados.valor = valor;
            }

            list_valores.push(dados);
            cont++;
        });

        if (list_valores.length > 0) {
            formData.append('valores', JSON.stringify(list_valores));
        }

        //
        if(this.state.programa_status_id) {
            formData.append('programa_status_id', this.state.programa_status_id);
        }

        if(this.state.laboratorio_id) {
            formData.append('laboratorio_id', this.state.laboratorio_id);
        }

        if(this.state.doenca_id) {
            formData.append('doenca_id', this.state.doenca_id);
        }

        if(this.state.atendente_id) {
            formData.append('atendente_id', this.state.atendente_id);
        }
        
        formData.append('doenca_outros', this.state.doenca_outros || '');

        if(this.state.medico_id != this.state.medico_atual_id) {
            formData.append('medico_id', this.state.medico_id);
        }
        
        if(this.state.reativar_atendimento) {
            formData.append('finalizado', false);
            formData.append('cancelado', false);
        }
    
        //envia para api
        api({
            method: "put",
            url: '/atendimentos/'+this.state.atendimento_id+'/',
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)

            MySwal.fire({
                title: 'Atendimento atualizado!',
                icon: 'success',
                html: 'Atendimento atualizado com sucesso',
                showCloseButton: true,
            }).then((result) => {
                location.reload();
            });

            
        })
        .catch(error => {
            let erro_msg = 'Erro ao atualizar o atendimento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }

            Sentry.captureException(erro_msg);

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handlePaste(event) {
        const { name, value } = event.target;
        const valor = event.clipboardData.getData('Text');
        this.setState({ [name]: valor });
    }

    handleChange = (event, fieldName, bool) => {
        

        if (fieldName === "programa_status_id") {
            const { name, value } = event.target;
            // Encontra o status correspondente pelo ID
            const selectedStatus = this.state.programa_dados.dados_status.find(
                status => status.id === parseInt(value, 10) 
            );  
            this.setState({
                [name]: value, // Atualiza o programa_status_id
                programa_status_slug: selectedStatus ? selectedStatus.slug : "", // Atualiza o slug correspondente
            });

        } else if(fieldName == 'beneficiario_id') {
            this.setState({ beneficiario_id: event.value, beneficiario_nome: event.label, is_loading_paciente: true, beneficiario_atendimentos: false, beneficiario_atendimento_aberto_id: '' });

            //Verifica se o paciente já tem atendimentos
            let dados_usuario = getCurrentUser();

            const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
            const medico_id = (dados_usuario['prestador_id']) ? dados_usuario['prestador_id'] : this.state.medico_id;

            const url = (dados_usuario['ambiente_cliente_id']) ? `/atendimentos/?page=1&beneficiario_id=${event.value}&tipo_usuario=${dados_usuario['tipo_usuario']}&cliente_id=${dados_usuario['ambiente_cliente_id']}` : `/atendimentos/?page=1&beneficiario_id=${event.value}&tipo_usuario=${dados_usuario['tipo_usuario']}&cliente_id=${this.state.cliente_id}`;

            api.get(url)
            .then(response => {

                if('results' in response.data && response.data.results.length > 0){

                    //verifica se os atendimentos já existentes estão cancelados
                    const allCancelled = response.data.results.every(resultado => resultado.cancelado === true);

                    if (allCancelled) {
                        this.setState({
                            is_loading_paciente: false,
                            beneficiario_atendimentos: false
                        });
                    } else {

                        let atendimentoAberto = false;

                        if(medico_id) {
                            atendimentoAberto = response.data.results.find(resultado => {
                                return (
                                    resultado.medico_id === medico_id &&
                                    resultado.programa_id === programa_id &&
                                    resultado.finalizado === false &&
                                    resultado.cancelado === false
                                );
                            });
                        } else {
                            atendimentoAberto = response.data.results.find(resultado => {
                                return (
                                    resultado.programa_id === programa_id &&
                                    resultado.finalizado === false &&
                                    resultado.cancelado === false
                                );
                            });
                        }
                        
                        if (atendimentoAberto) {
                            window.location.href = `/atendimentos/edit/${atendimentoAberto.uuid}/`;
                        } else {
                            this.setState({
                                is_loading_paciente: false,
                                beneficiario_atendimentos: true
                            });
                        }
                    }
                } else {
                    this.setState({
                        is_loading_paciente: false,
                        beneficiario_atendimentos: false
                    });
                }
                
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar atendimentos do paciente.';

                if(error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if(error.response.status === 403){
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    is_loading_paciente: false
                });

                //Sentry.captureException(erro_msg);
            });

            //se o usuario for medico consulta os laboratorios relacionados ao usuario
            this.carregaLaboratoriosMedicoRelacao(medico_id)
        }
        else if(fieldName == 'atendente_id') {
            this.setState({ atendente_id: event.value, atendente_nome: event.label });
        }
        else if(fieldName == 'medico_id') {
            this.setState({ medico_id: event.value, medico_nome: event.label }, () => {
                //this.carregaLaboratorioExclusivo();
                //this.carregaLaboratoriosMedicoRelacao(event.value);                
            });
        }
        else if(fieldName === 'doenca_id') {
            if(this.state.atendimento_id) {
                this.setState(prevState => ({
                    doenca_id: event.value, 
                    doenca_nome: event.label,
                    doenca_idade_maxima: event.doenca_idade_maxima,
                    doenca_idade_minima: event.doenca_idade_minima,
                    idade_maxima: event.idade_maxima,
                    idade_minima: event.idade_minima,
                }), () => {
                    this.carregaCamposExtraPrograma();
                    this.aplicarDefinicaoAutomaticaLaboratorio();
                });
            } else {
                this.setState(prevState => ({
                    doenca_id: event.value, 
                    doenca_nome: event.label,
                    doenca_idade_maxima: event.doenca_idade_maxima,
                    doenca_idade_minima: event.doenca_idade_minima,
                    idade_maxima: event.idade_maxima,
                    idade_minima: event.idade_minima,
                    beneficiario_id: "",
                    beneficiario_nome: "",
                    beneficiario_select_key: prevState.beneficiario_select_key + 1
                }), () => {
                    this.carregaCamposExtraPrograma();
                    this.aplicarDefinicaoAutomaticaLaboratorio();
                });
            }
        }
        else if(fieldName == 'laboratorio_id') {
            this.setState({ laboratorio_id: event.value, laboratorio_nome: event.label });
        }
        else if (fieldName == "relato_servico_procedimento_id"){
            this.setState({ 
                relato_servico_procedimento_id: event.value, 
                relato_servico_procedimento_nome: event.label 
            });
        }
        else if (fieldName == "cliente_id") {
            this.setState(prevState => ({
                cliente_id: event.value, 
                cliente_nome: event.label,
                beneficiario_id: "",
                beneficiario_nome: "",
                medico_id: "", 
                medico_nome: "",
                programa_id: "", 
                programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1,
                medico_select_key: prevState.medico_select_key + 1,
                beneficiario_select_key: prevState.beneficiario_select_key + 1
            }));
            //this.setState({ cliente_id: event.value, cliente_nome: event.label });
        }
        else if (fieldName == "programa_id") {
            this.setState(prevState => ({
                programa_id: event.value, 
                programa_nome: event.label,
                programa_uuid: event.uuid,
                beneficiario_id: "",
                beneficiario_nome: "",
                medico_id: "", 
                medico_nome: "",
                medico_select_key: prevState.medico_select_key + 1,
                beneficiario_select_key: prevState.beneficiario_select_key + 1,
            }), () => {
                this.carregaDadosPrograma();
                this.carregaPlanosPrograma();
                this.carregaCamposExtraPrograma();
                this.carregaCamposExtraPaciente();
            });
            /*this.setState({ programa_id: event.value, programa_nome: event.label }, () => {
                this.carregaDadosPrograma();
                this.carregaPlanosPrograma();
            });*/
        }
        else if (fieldName == "plano_id") {
            this.setState({ plano_id: event.value, plano_nome: event.label });
        }       
        else if (fieldName == "etapa_voltar") {
            this.setState({ etapa_voltar: event.value, etapa_voltar_nome: event.label });
        } 
        else {
            const { name, value } = event.target;
            
            if(name == 'data_nascimento') {
                const currentDate = new Date();
                const selectedDate = new Date(value);
                const maxDate = new Date();
                const minDate = new Date();
                minDate.setFullYear(maxDate.getFullYear() - 120);
    
                let dataNascimentoHelper = '';
    
                if (selectedDate > maxDate) {
                    dataNascimentoHelper = 'Data de nascimento não pode ser no futuro.';
                } else if (selectedDate < minDate) {
                    dataNascimentoHelper = 'Data de nascimento inválida.';
                }
    
                this.setState({
                    [name]: value,
                    dataNascimentoHelper
                });
            } else if(name == 'cuidador_data_nascimento') {
                const currentDate = new Date();
                const selectedDate = new Date(value);
                const maxDate = new Date();
                const minDate = new Date();
                minDate.setFullYear(maxDate.getFullYear() - 120);
    
                let cuidadorDataNascimentoHelper = '';
    
                if (selectedDate > maxDate) {
                    cuidadorDataNascimentoHelper = 'Data de nascimento não pode ser no futuro.';
                } else if (selectedDate < minDate) {
                    cuidadorDataNascimentoHelper = 'Data de nascimento inválida.';
                }
    
                this.setState({
                    [name]: value,
                    cuidadorDataNascimentoHelper
                });
            } else {
                this.setState({ [name]: value });
            }

            if(fieldName == 'etapa_atendimento_status'){
                if(value == 'cancelado'){
                    this.setState({ label_outras_acoes: "Cancelar Atendimento" });
                }
                else {
                    this.setState({ label_outras_acoes: "Atualizar Status" });
                }            
            }

            if(fieldName == 'tipo_cancelamento'){
                if(value == 'somente_etapa'){
                    this.setState({ label_outras_acoes: "Cancelar Etapa" });
                }
                if(value == 'definitivo'){
                    this.setState({ label_outras_acoes: "Cancelar Atendimento" });
                }
            }

            if(fieldName == 'cadastro_teste'){
                this.setState({ cadastro_teste: bool });
            }
        }        
    };

    handleChangeEtapaAtual(e) {
        const { name, value } = e.target;
        this.setState(prevState => ({
            etapa_atual: {
                ...prevState.etapa_atual,
                [name]: value
            }
        }));
    }

    removerMonitoriaDosagem = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover dosagem?',
            text: "Tem certeza que deseja remover esta dosagem?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const dosagem = this.state.monitoria_dosagens[index];

                if (dosagem.id) {
                    api({
                        method: 'delete',
                        url: `/atendimentos/aplicacoes/dosagens/${dosagem.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Dosagem da Monitoria removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            monitoria_dosagens: prevState.monitoria_dosagens.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a dosagem da Monitoria, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        monitoria_dosagens: prevState.monitoria_dosagens.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A dosagem da Monitoria foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    salvarMonitoriaDosagem = (index) => {
        const dosagem = this.state.monitoria_dosagens[index];
        const url = dosagem.id ? `/atendimentos/aplicacoes/dosagens/${dosagem.id}/` : '/atendimentos/aplicacoes/dosagens/';
        const metodo = dosagem.id ? 'put' : 'post';
    
        const dadosDosagem = {
            quantidade: dosagem.quantidade,
            aplicacao_id: this.state.monitoria_id,
            dosagem_id: dosagem.dosagem_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosDosagem,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!dosagem.id) {
                this.setState(prevState => {
                    const dosagemAtualizados = [...prevState.monitoria_dosagens];
                    dosagemAtualizados[index].id = response.data.id;
                    return { monitoria_dosagens: dosagemAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (dosagem.id) ? 'Dosagem da Monitoria atualizada com sucesso' : 'Dosagem da Monitoria cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a dosagem da monitoria, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'quantidade') {
                        content += `<br>&bull; Quantidade: ${value}`;
                    }
                    if(key == 'aplicacao_id') {
                        content += `<br>&bull; Id da aplicação: ${value}`;
                    }
                    if(key == 'dosagem_id') {
                        content += `<br>&bull; Id da dosagem: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }

    handleChangeMonitoriaDosagem(e, campo, index) {
        if(campo == 'dosagem_id'){
            console.log(e);
            this.setState(prevState => ({
                monitoria_dosagens: prevState.monitoria_dosagens.map((dosagem, i) => 
                    i === index ? { ...dosagem, [campo]: e.value, label: e.label, dosagem_nome: e.label } : dosagem
                )
            }));
        } else {
            this.setState(prevState => ({
                monitoria_dosagens: prevState.monitoria_dosagens.map((dosagem, i) => 
                    i === index ? { ...dosagem, [campo]: e.target.value } : dosagem
                )
            }));
        }
    }

    handleChangeMonitoria(e, campo, is_realizado=false) {
        if(campo == "monitoria_status_id"){
            this.setState({
                monitoria_status: e.label,
                [campo]: e.value
            })
        } else if (campo == "monitoria_id") {
            this.setState({ 
                [campo]: e,
                is_aplicacao_realizado: is_realizado
            }, () => {
                this.carregarMonitoria();
            });            
        } else if(campo == "monitoria_tipo_id"){
            this.setState({
                [campo]: e.target.value
            })
        } else if(campo == "monitoria_data_prevista" || campo == "monitoria_data_realizacao"){
            this.setState({
                [campo]: e.target.value
            })    
        } else {
            this.setState({
                [campo]: e.target.value
            })
        }
    }

    handleChangeProduto = (e, fieldName) => {
        if(fieldName == 'programa_produto_id'){
            this.setState({ programa_produto_id: e.value, programa_produto_nome: e.label, produto_valor: formatarValor(e.valor) });
        } else {
            const { name, value } = e.target;
            if(fieldName == 'produto_valor'){
                this.setState({ [name]: formatarValor(value) });
            } else {
                this.setState({ [name]: value });
            }
        }        
    }

    onSubmitMonitoria = (e) => {
        e.preventDefault();
        if (!this.state.monitoria_tipo_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Selecione uma via de administração',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.monitoria_data_prevista) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Selecione uma data prevista.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.monitoria_status) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Selecione um status.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if ((this.state.monitoria_status === 'Realizada' || this.state.monitoria_status === 'Realizado') && !this.state.monitoria_data_realizacao) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Selecione uma data de realização.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; 
        }
        if ((this.state.monitoria_status === 'Realizada' || this.state.monitoria_status === 'Realizado') && this.state.monitoria_data_realizacao) {
            const hoje = getDataAtual().split(' ')[0]; // "YYYY-MM-DD"
            
            if (this.state.monitoria_data_realizacao > hoje) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Não é permitido registrar data futura para confirmação de aplicação.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return;
            }
        }

        // Nova validação: impedir data futura na confirmação de realização
        if ((this.state.monitoria_status === 'Realizada' || this.state.monitoria_status === 'Realizado') && this.state.monitoria_data_realizacao) {
            const hoje = getDataAtual().split(' ')[0]; // "YYYY-MM-DD"
            
            if (this.state.monitoria_data_realizacao > hoje) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Não é permitido registrar data futura para confirmação de aplicação.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return;
            }
        }

        if ((this.state.monitoria_status === 'Não Realizada' || this.state.monitoria_status === 'Não Realizado') && !this.state.monitoria_motivo) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Selecione um motivo da não realização',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        const MySwal = withReactContent(Swal)

        this.setState({
            loading: true,
        });

        //vererifica se é edição ou adição
        const url = (this.state.monitoria_id) ? '/atendimentos/aplicacoes/'+this.state.monitoria_id+'/' : '/atendimentos/aplicacoes/'
        const metodo = (this.state.monitoria_id) ? 'put' : 'post'

        let dataAplicacao = {
            atendimento_id: this.state.atendimento_id,
            data_agendada: this.state.monitoria_data_prevista,
            aplicacao_tipo_id: this.state.monitoria_tipo_id
        }

        if(this.state.monitoria_status_id) {
            dataAplicacao['aplicacao_status_id'] = this.state.monitoria_status_id;
        }
        if(this.state.monitoria_motivo) {
            dataAplicacao['motivo'] = this.state.monitoria_motivo;
        }
        if(this.state.monitoria_data_realizacao) {
            dataAplicacao['data_realizacao'] = this.state.monitoria_data_realizacao;
        }

        if(this.state.monitoria_dosagens.length > 0) {
            dataAplicacao['dosagens'] = this.state.monitoria_dosagens;
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: dataAplicacao 
        })
        .then(response => {
            
            const textSwal = (this.state.monitoria_id) ? 'Monitoria atualizada com Sucesso' : 'Monitoria cadastrada com sucesso';

            this.setState({
                loading: false
            });

            // Tudo concluído aqui, agora pode navegar
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                if(this.state.monitoria_id){
                    this.setState({ 
                        monitoria_id: ""
                    }, () => {
                        this.carregarMonitoria();
                        this.handleCloseModalMonitoria();
                    });
                } else {
                    this.carregarMonitoria();
                    this.handleCloseModalMonitoria();
                }
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar monitoria, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;      
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'data_agendada'){
                        erro_msg = value;
                    }
                    if(key === 'data_realizacao'){
                        erro_msg = value;
                    }
                }
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })

            //Sentry.captureException(erro_msg);
        });
        
    }

    carregaClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: (cliente.dados_pessoa.razao_social) ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})` : cliente.dados_pessoa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            //Sentry.captureException('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome,
                uuid: programa.uuid
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            //Sentry.captureException('Erro ao carregar programas:', error);
            return [];
        }
    };

    carregarDoencas = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        try {
            const program_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;
            const response = await api.get(`/programas/doencas/?programa_id=${program_id}`);

            // Mapeando para o formato necessário
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.dados_doenca.id,
                label: doenca.dados_doenca.nome,
                doenca_idade_maxima: doenca.idade_maxima,
                doenca_idade_minima: doenca.idade_minima,
                idade_minima: doenca.idade_minima || 0,
                idade_maxima: doenca.idade_maxima || 0,
            }));
    
            // Adicionando a opção "Outros" para o programa_id 23
            if (this.state.programa_dados.doencas_exibir_opcao_outros) {
                opcoes.push({
                    value: 'outros',
                    label: 'Outros'
                });
            }
    
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };
    
    

    carregaPlanos = async (inputValue) => {
        let dados_usuario = getCurrentUser();
        try {
            const programaId = (dados_usuario['ambiente_programa_id'] > 0) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
            const response = await api.get(`/planos/?nome=${inputValue}&programa_id=${programaId}`);
            const opcoes = response.data.results.map(plano => ({
                value: plano.id,
                label: plano.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar planos:', error);
            //Sentry.captureException('Erro ao carregar planos:', error);
            return [];
        }
    };

    carregarDosagensPrograma = async (inputValue) => {
        let dados_usuario = getCurrentUser();
        try {
            const programaId = (dados_usuario['ambiente_programa_id'] > 0) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
            const response = await api.get(`/programas/dosagens/?programa_id=${programaId}`);
            const opcoes = response.data.results.map(dosagem => ({
                value: dosagem.id,
                label: dosagem.quantidade + ' ' + dosagem.unidade
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar dosagens:', error);
            //Sentry.captureException('Erro ao carregar dosagens:', error);
            return [];
        }
    };


    carregaBeneficiarios = async (inputValue) => {
        let dados_usuario = getCurrentUser();
        let filtrarDoenca = this.state.doenca_id || '';
        try {
            const url = (dados_usuario['ambiente_cliente_id'] && dados_usuario['ambiente_programa_id']) ? `/pessoas/beneficiarios/?nome=${inputValue}&cliente_id=${dados_usuario['ambiente_cliente_id']}&programa_id=${dados_usuario['ambiente_programa_id']}&tipo_usuario=${dados_usuario['tipo_usuario']}&ordem_campo=nome&ordem_tipo=ASC&doenca_id=${filtrarDoenca}` : `/pessoas/beneficiarios/?nome=${inputValue}&cliente_id=${this.state.cliente_id}&programa_id=${this.state.programa_id}&doenca_id=${filtrarDoenca}&ordem_campo=nome&ordem_tipo=ASC`
            const response = await api.get(url);
            const opcoes = response.data.results.map(beneficiario => ({
                value: beneficiario.id,
                label: `${beneficiario.nome} (${formataCPF(beneficiario.cpf)})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar beneficiários:', error);
            //Sentry.captureException('Erro ao carregar beneficiários:', error);
            return [];
        }
    };

    carregaAtendentes = async (inputValue) => {
        const dados_usuario = getCurrentUser();
        const programa_id = this.state.programa_id || dados_usuario['ambiente_programa_id'];
        try {
            const response = await api.get(`/pessoas/operadores/?nome=${inputValue}&programa_id=${programa_id}`);
            const opcoes = response.data.results.map(atendente => ({
                value: atendente.id,
                label: atendente.dados_pessoa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar atendentes:', error);
            //Sentry.captureException('Erro ao carregar atendentes:', error);
            return [];
        }
    };

    carregaMedicos = async (inputValue = "") => {

        let dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;

        try {
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&programa_id=${programa_id}&categoria=medicos|multiprofissionais&is_active=1&tipo_usuario=${dados_usuario.tipo_usuario}`);
            const opcoes = response.data.results.map(medico => ({
                value: medico.id,
                label: medico.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar médicos:', error);
            //Sentry.captureException('Erro ao carregar médicos:', error);
            return [];
        }
    };


    carregaLaboratoriosPrograma = async () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
        this.setState({laboratorios: []});
        try {
            // carregar laboratórios associados ao programa
            const response = await api.get(`/pessoas/prestadores/?programa_id=${programa_id}&categoria=laboratorio_diagnostico`);
            
            // Inicializa uma variável para armazenar laboratórios
            let laboratorios_filtrados = [];
            let encontrou_exclusivo = false;

            // Verifica e filtra os laboratórios
            response.data.results.forEach(laboratorio => {
                const laboratorio_id = laboratorio.prestador_id;

                // Verificação de laboratório exclusivo
                if (laboratorio.exclusivo_vinculados) {
                    if (this.state.laboratorios_medico.includes(laboratorio_id)) {
                        // Se for exclusivo e estiver no laboratorios_medico, só inclui este laboratório e interrompe as outras verificações
                        laboratorios_filtrados = [{
                            id: laboratorio_id,
                            nome: `${laboratorio.dados_prestador.nome_fantasia}`,
                            alerta_atendimento: laboratorio.alerta_atendimento,
                        }];
                        encontrou_exclusivo = true;
                    }
                }
            });

            // Se encontrou laboratório exclusivo, define no estado e para a execução
            if (encontrou_exclusivo) {
                //this.setState({ laboratorios: laboratorios_filtrados });
                await this.filtrarLaboratoriosPorServico(laboratorios_filtrados);
                return;
            }

            // Se não houver laboratórios exclusivos, aplica as outras condições
            let opcoes = response.data.results.filter(laboratorio => {
                // Verifica a condição do alerta e a existência no laboratorios_medico
                // "Sem Alerta" é tratado como equivalente a vazio/nulo
                if (laboratorio.alerta_atendimento && laboratorio.alerta_atendimento !== 'Sem Alerta') {
                    return this.state.laboratorios_medico.includes(laboratorio.id);
                }
                return true; // Inclui caso não tenha alerta_atendimento
            })
            .map(laboratorio => ({
                id: laboratorio.id,
                nome: `${laboratorio.nome_fantasia}`,
                alerta_atendimento: laboratorio.alerta_atendimento,
            }));
            
            //this.setState({ laboratorios: opcoes });
            // Filtrar laboratórios padrão pelo serviço associado à doença selecionada
            await this.filtrarLaboratoriosPorServico(opcoes);
    
        } catch (error) {
            console.error('Erro ao carregar laboratórios ou serviços/procedimentos:', error);
            //Sentry.captureException('Erro ao carregar laboratórios ou serviços/procedimentos:', error);
            return false;
        } 
    };

    /**
     * Verifica se a definição automática de laboratório está ativa para a doença atual
     */
    isDefinicaoAutomaticaLaboratorio = () => {
        const config = this.state.programa_config?.atendimentos?.definicao_automatica_laboratorio;
        if (!config) return false;
        const doencaId = parseInt(this.state.doenca_id);
        return config.doencas && config.doencas.includes(doencaId);
    };

    /**
     * Define automaticamente o laboratório com base na configuração do programa.
     * Regra: se o médico tiver relação com um dos laboratorios_exclusivos, usa esse;
     * senão, usa o laboratorio_default.
     */
    aplicarDefinicaoAutomaticaLaboratorio = async () => {
        const config = this.state.programa_config?.atendimentos?.definicao_automatica_laboratorio;
        if (!config) return;

        const doencaId = parseInt(this.state.doenca_id);
        if (!config.doencas || !config.doencas.includes(doencaId)) return;

        const exclusivos = config.laboratorios_exclusivos || [];
        
        // Busca os laboratórios do médico se ainda não estiverem no state
        let laboratoriosMedico = this.state.laboratorios_medico || [];
        if (laboratoriosMedico.length === 0) {
            const dados_usuario = getCurrentUser();
            const medico_id = this.state.medico_id || (dados_usuario['prestador_categoria'] === 'medicos' ? dados_usuario['prestador_id'] : null);
            if (medico_id) {
                try {
                    const response = await api.get(`/pessoas/prestadores/laboratorios/?medico_id=${medico_id}`);
                    laboratoriosMedico = response.data.results.map(l => l.laboratorio_id);
                } catch (error) {
                    console.error('Erro ao buscar laboratórios do médico:', error);
                }
            }
        }

        // Verifica se o médico tem relação com algum laboratório exclusivo
        const labExclusivo = exclusivos.find(labId => laboratoriosMedico.includes(labId));
        const laboratorioDefinido = labExclusivo || config.laboratorio_default;

        if (laboratorioDefinido) {
            // Busca o nome do laboratório via endpoint de relação médico-laboratório
            let nome = '';

            // Tenta encontrar o nome nos labs do médico (endpoint retorna dados_laboratorio)
            const dados_usuario = getCurrentUser();
            const medico_id = this.state.medico_id || (dados_usuario['prestador_categoria'] === 'medicos' ? dados_usuario['prestador_id'] : null);
            if (medico_id) {
                try {
                    const response = await api.get(`/pessoas/prestadores/laboratorios/?medico_id=${medico_id}`);
                    const lab = response.data.results.find(l => l.laboratorio_id === laboratorioDefinido);
                    if (lab) {
                        nome = lab.dados_laboratorio?.nome_fantasia || lab.dados_laboratorio?.nome || '';
                    }
                } catch (error) {
                    console.error('Erro ao buscar nome do laboratório:', error);
                }
            }

            // Fallback: busca na listagem de prestadores do programa
            if (!nome) {
                try {
                    const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;
                    const response = await api.get(`/pessoas/prestadores/?programa_id=${programa_id}&categoria=laboratorio_diagnostico`);
                    const lab = response.data.results.find(l => l.prestador_id === laboratorioDefinido || l.id === laboratorioDefinido);
                    nome = lab?.dados_prestador?.nome_fantasia || lab?.nome_fantasia || '';
                } catch (error) {
                    console.error('Erro ao buscar nome do laboratório (fallback):', error);
                }
            }

            this.setState({
                laboratorio_id: laboratorioDefinido,
                laboratorio_nome: nome || 'Laboratório definido automaticamente',
                is_creating: true
            });
        }
    };

    /**
     * Filtra laboratórios pelo serviço associado à doença selecionada
     */
    filtrarLaboratoriosPorServico = async (laboratorios) => {
        const dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
        const doenca_id = this.state.doenca_id;

        if (!doenca_id) {
            this.setState({ laboratorios: [] }); // Se não houver doença, zera a lista de laboratórios
            return;
        }

        try {
            // Obter serviço padrão associado à doença
            const servicoResponse = await api.get(`/programas/servicos_procedimentos/?programa=${programa_id}&doenca_id=${doenca_id}`);
            const servicoPadrao = servicoResponse.data.results.find(servico => servico.padrao === true);

            if (!servicoPadrao) {
                this.setState({ laboratorios: [] }); // Se não houver serviço padrão, zera a lista de laboratórios
                return;
            }

            // Armazenar o ID do serviço padrão no estado
            const servico_procedimento_id = servicoPadrao.servico_procedimento_id;
            this.setState({ servico_procedimento_id });

            // Obter os prestadores que oferecem o serviço padrão
            const prestadoresResponse = await api.get(`/pessoas/prestadores/servicos_procedimentos/?servico_procedimento_id=${servico_procedimento_id}&status=1`);
            const prestadoresIds = prestadoresResponse.data.results.map(prestador => prestador.prestador_id);

            // Filtrar laboratórios que prestam o serviço padrão
            const laboratoriosFiltrados = laboratorios.filter(laboratorio => prestadoresIds.includes(laboratorio.id));

            // Atualizar o estado com os laboratórios filtrados
            this.setState({ laboratorios: laboratoriosFiltrados });
        } catch (error) {
            console.error('Erro ao filtrar laboratórios por serviço:', error);
        }
    };

    carregaLaboratoriosMedicoRelacao = async (medico_id) => {        
        try {
            // Primeira tentativa: carregar laboratórios associados ao médico
            const response = await api.get(`/pessoas/prestadores/laboratorios/?medico_id=${medico_id}`);
            let opcoes = response.data.results.map(laboratorio => (laboratorio.laboratorio_id));
    
            this.setState({ laboratorios_medico: opcoes }, () => {
                this.carregaLaboratoriosPrograma();
                this.aplicarDefinicaoAutomaticaLaboratorio();
            });
        } catch (error) {
            console.error('Erro ao carregar laboratórios do médico:', error);
            //Sentry.captureException('Erro ao carregar laboratórios do médico:', error);
        }
    };

    linkCadastroPaciente = () => {
        e.preventDefault();
        this.props.history.push(`/pacientes/edit/${this.state.beneficiario_id}/?cliente_id=${this.state.cliente_id}`);
    }

    handleUpdateKitFlag = () => {
        console.log("--- [AtendimentosEdit] Flag de Kit ativada pelo cadastro do paciente ---");
        
        // Apenas atualiza o estado local para ser enviado no POST posteriormente
        this.setState({ recebe_kit_paciente: true });

        // Se POR ACASO já for um atendimento existente (edição), salvamos imediatamente para garantir
        if (this.state.atendimento_id) {
            api.put(`/atendimentos/${this.state.atendimento_id}/`, {
                recebe_kit_paciente: true
            }).catch(err => console.error("Erro auto-save kit flag:", err));
        }
    };

    handleShowModalTermosPaciente = () => {
        this.setState({ 
            showModalTermosPaciente: true
        }, () => {
            
        });
    };
    
    handleShowModalMonitoria = () => {
        this.setState({ 
            monitoria_id: "",
            monitoria_data_prevista: "",
            monitoria_data_realizacao: "",
            monitoria_motivo: "",
            monitoria_status: "",
            monitoria_status_id: "",
            monitoria_tipo: "",
            monitoria_tipo_id: "",
            monitoria_dosagens: [],
            is_aplicacao_realizado: false,
        }, () => {
            this.setState({showModalMonitoria: true});
        });
        
    }

    handleCloseModalProduto = () => {
        this.setState({ showModalProduto: false });
    };

    handleCloseModalMonitoria = () => {
        this.setState({ showModalMonitoria: false });
    };

    handleCloseModalTermosPaciente = () => {
        this.setState({ showModalTermosPaciente: false });
    };

    handleShowModalServicoAtendimento = (servico) => {
        const valor_formatado = (servico.valor) ? parseFloat(servico.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })  : 0;
        this.setState({ showModalServicoAtendimento: true, servico_modal: servico, valor_servico_edicao: valor_formatado, data_servico_edicao: servico.data });
    };

    handleCloseModalServicoAtendimento = (servico) => {
        this.setState({ showModalServicoAtendimento: false, servico_modal: [], valor_servico_edicao: 0, data_servico_edicao: '' });
    };

    handleCloseModalCamposHistorico = () => {
        this.setState({ showModalCamposHistorico: false });
    };

    abrirModalCamposHistorico = () => {
        //consulta os logs dos campos do atendimento
        this.getLogsAtendimentoCampos()
        
        this.setState({ 
            showModalCamposHistorico: true, 
        });
    };

    limparEstadoModal = () => {
        this.setState({
            agendamento_data: '',
            agendamento_prestador_id: '',
            agendamento_valor: '',
            agendamento_servico_procedimento_id: '',
            agendamento_servico_video_conferencia: '',
            enviarKitAgendamento: null,
            dataEnvioKit: '',
            agendamento_medico_id: '',
            agendamento_servico_terapia: false,
            agendamento_terapia_id: '',
            agendamento_terapia_nome: '',
            anotacoes: '',
            envia_aceite: '',
            local_nome: '',
            local_cep: '',
            local_endereco: '',
            local_numero: '',
            local_complemento: '',
            local_cidade: '',
            local_uf: '',
            agendamento_exige_termo_aceite: false,
            agendamento_termo_pdf_url: "",
            agendamento_termo_assinado_file: null,
            agendamento_termo_assinado_upload: "",
            agendamento_termo_assinado_url: "",
            agendamento_termo_helper: "",
            excluir_termo_assinado: false,
        });

        if (this.fileInputTermoAssinado && this.fileInputTermoAssinado.current) {
            this.fileInputTermoAssinado.current.value = "";
        }
    }

    handleShowModal = () => {
        this.limparEstadoModal();

        const dataAtual = getDataAtual()
                    .replace(' ', 'T')   // Substitui espaço por "T"
                    .slice(0, 16);       // Remove segundos (YYYY-MM-DDTHH:mm)

        this.setState({ 
            showModal: true,
            data_solicitacao: dataAtual
        });
    };

    handleShowModalAcoes = (acao) => {
        this.limparEstadoModal();
        if(acao) {
            this.setState({ 
                programa_acao_id: acao.programa_acao_id,
                programa_acao_nome: acao.dados_programa_acao.nome,
                acao_id: acao.id,
                acao_descricao: acao.descricao,
                acao_observacoes: acao.observacoes,
                acao_realizado: acao.realizado,
                acao_data: acao.data_acao,
                acao_hora: acao.hora_acao,
                showModalAcoes: true
            }, () => {
                
            });
        } else {
            this.setState({ 
                programa_acao_id: '',
                programa_acao_nome: '',
                acao_id: '',
                acao_descricao: '',
                acao_observacoes: '',
                acao_realizado: '',
                acao_data: '',
                acao_hora: '',
                showModalAcoes: true
            });
        }

        const modal = document.querySelector(".modal-overlay-top");
        const backdrop = document.querySelector(".backdrop-overlay-top");

        if (modal) modal.style.zIndex = 1060;
        if (backdrop) backdrop.style.zIndex = 1059;
        
    };

    handleCloseModalAcoes = () => {
        this.limparEstadoModal();
        this.setState({ showModalAcoes: false });
    };

    handleShowModalProduto = (produto) => {
        //this.limparEstadoModal();

        this.setState({ 
            produto_id: produto ? produto.id : '',
            produto_valor: produto ? produto.valor : '',
            programa_produto_id: produto ? produto.produto_id : '',
            programa_produto_nome: produto ? produto.dados_produto.nome : '',
            showModalProduto: true
        }, () => {
            
        });
    };
    
    handleCloseModal = () => {
        this.limparEstadoModal();
        this.setState({ showModal: false });
    };

    agendarServico = (id, label) => {
        this.limparEstadoModal();

        this.setState({ 
            agendamento_servico_procedimento_id: id,
            agendamento_servico_procedimento_nome: label,
            showModalRelatosEdit: false
        }, () => {
            this.setState({ showModal: true });
        });    
    }

    usarGotoLegId = (legId) => {    
        // Se veio do modal de aceite de termo por telefone, preenche o input do SweetAlert
        if (this.state.goto_hist_campo_id === '__aceite_termo_telefone__') {
            this.setState({ showModalConsultaHistoricoLigacoes: false }, () => {
                // Restaura o z-index do SweetAlert para ficar por cima novamente
                const swalContainer = document.querySelector('.swal2-container');
                if (swalContainer) swalContainer.style.zIndex = '';

                const inputSwal = document.getElementById('chamadaId');
                if (inputSwal) {
                    inputSwal.value = legId;
                    // Dispara evento input para que eventuais listeners de máscara atuem
                    inputSwal.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
            return;
        }

        this.setState(prevState => ({
            showModalConsultaHistoricoLigacoes: false,
            valoresCampos: {
                ...prevState.valoresCampos,
                [this.state.goto_hist_campo_id]: legId,
            },
        }));
    }

    carregaServicoProcedimento = async (inputValue) => {
        try {
            const uf = this.state.beneficiario_dados.uf || this.state.uf;
            
            let url = `/programas/servicos_procedimentos/?servico_procedimento=${inputValue}&status=1&programa=${this.state.programa_id}&uf=${uf}`;

            if (this.state.doenca_id) {
                url += `&doenca_id=${this.state.doenca_id}`;
            }

            //const response = await api.get(`/planos/regras/?plano_id=${this.state.plano_id}`);
            const response = await api.get(url);
            // Filtra os serviços/procedimentos antes de mapear
            const opcoesFiltradas = response.data.results.filter(servico => servico.servico_procedimento_id > 0).map(servico => ({
                value: servico.servico_procedimento_id,
                label: servico.dados_servico.nome,
                video_conferencia: servico.dados_servico.servico_video_conferencia,
                servico_terapia: servico.dados_servico.servico_terapia || false,
                limite: servico.quantidade
            }));
            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar serviço/procedimento:', error);
            //Sentry.captureException('Erro ao carregar serviço/procedimento:', error);
            return [];
        }
    };
    
    carregarTerapiasAtendimento = async () => {
        try {
            const response = await api.get(
                `/atendimentos/aplicacoes/?atendimento_id=${this.state.atendimento_id}&limit=100&order=${this.state.monitoria_ordem}&order_by=${this.state.monitoria_ordem_direcao}`
            );
            
            if (response.data && response.data.results) {
                return response.data.results.map(terapia => ({
                    value: terapia.id,
                    label: `#${terapia.id} - ${terapia.dados_aplicacao_tipo?.nome || 'N/A'} - ${formataDataExibicao(terapia.data_agendada)}`
                }));
            }
            return [];
        } catch (error) {
            console.error('Erro ao carregar terapias:', error);
            return [];
        }
    };

    carregaAcoes = async (inputValue) => {
        try {
            const response = await api.get(`/programas/acoes/?programa_id=${this.state.programa_id}&nome=${inputValue}`);
            const opcoesFiltradas = response.data.results.map(acao => ({
                value: acao.id,
                label: acao.nome
            }));
            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar ações:', error);
            return [];
        }
    };

    carregaPrestadoresServico = async (servico_id) => {
        try {
            const response = await api.get(`/pessoas/prestadores/servicos_procedimentos/?servico_procedimento_id=${servico_id}&status=1&is_active=1`);
            
            // Mapeia os resultados filtrados para o formato desejado
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.prestador_id,
                label: prestador.dados_prestador.nome,
                valor_servico: prestador.valor
            }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            //Sentry.captureException('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    carregaPrestadores = async (inputValue) => {
        try {
            const termoBusca = inputValue || '';
            const cnpjBusca = termoBusca.replace(/\D/g, '');
            const buscaSomenteNumerica = termoBusca && cnpjBusca === termoBusca;
            let url = `/pessoas/prestadores/servicos_procedimentos/?servico_procedimento_id=${this.state.agendamento_servico_procedimento_id}&status=1&programa_id=${this.state.programa_id}&is_active=1`;

            if (buscaSomenteNumerica && cnpjBusca) {
                url += `&prestador_cnpj=${cnpjBusca}`;
            } else if (termoBusca) {
                url += `&prestador_nome=${encodeURIComponent(termoBusca)}`;
            }
            
            // Adiciona filtro por UF se configuração estiver ativa
            if (getConfig(this.state.programa_dados?.configuracoes, 'agendamento.filtrar_prestadores_estado', false)) {
                url += `&uf=${this.state.beneficiario_dados.uf}`;
            }
            
            const response = await api.get(url);
            
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.prestador_id,
                label: `${prestador.dados_prestador.nome} (${prestador.dados_prestador.nome_fantasia} - ${prestador.dados_prestador.bairro}, ${prestador.dados_prestador.cidade}/${prestador.dados_prestador.uf})${prestador.dados_prestador.cpf_cnpj ? ` | ${formataCNPJ(prestador.dados_prestador.cpf_cnpj)}` : ''}`,
                valor_servico: prestador.valor
            }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    handleChangeAgendamento = (event, fieldName) => {
        if(fieldName === 'agendamento_servico_procedimento_id') {
           this.setState(
                (prevState) => ({
                    agendamento_servico_procedimento_id: event.value, 
                    agendamento_servico_procedimento_nome: event.label,
                    agendamento_servico_procedimento_limite: event.limit,
                    agendamento_servico_video_conferencia: event.video_conferencia,
                    agendamento_servico_terapia: event.servico_terapia || false,
                    agendamento_prestador_id: "",
                    agendamento_prestador_nome: "",
                    agendamento_valor: 0,
                    servico_agendamento_key: prevState.servico_agendamento_key + 1,
                    agendamento_exige_termo_aceite: false,
                    agendamento_termo_pdf_url: "",
                    agendamento_termo_assinado_url: "",
                    agendamento_termo_assinado_file: null,
                    agendamento_excluir_termo_assinado: false,
                    agendamento_termo_carregando: true, 
                    agendamento_terapia_id: '', // Limpar seleção anterior de terapia
                    agendamento_terapia_nome: '',
                }),
                async () => {
                    try {
                        const { data } = await api.get(`/servicos_procedimentos/${event.value}/`);

                        const solicita_aceite = getConfig(data.configuracoes, "solicita_aceite_agendamento", false);
                        const servico_monitoria = getConfig(data.configuracoes, "servico_monitoria", false);
                        const permitir_alterar_valor = !!data.permite_alterar_valor_agendamento;

                        this.setState({
                            agendamento_exige_termo_aceite: !!data.exige_termo_aceite,
                            agendamento_termo_pdf_url: data.termo_aceite_pdf || "",
                            agendamento_termo_carregando: false,
                            solicitarAceiteRecusa: solicita_aceite,
                            servicoMonitoria: servico_monitoria,
                            permite_alterar_valor_agendamento: permitir_alterar_valor,
                        });
                    } catch (error) {
                        this.setState({
                            agendamento_exige_termo_aceite: false,
                            agendamento_termo_pdf_url: "",
                            agendamento_termo_carregando: false,
                            solicitarAceiteRecusa: false,
                            servicoMonitoria: false,
                            permite_alterar_valor_agendamento: false,
                        });
                    }
                }
            );
        }
        else if(fieldName === 'agendamento_prestador_id') {
            this.setState({
                agendamento_prestador_id: event.value,
                agendamento_prestador_nome: event.label,
                agendamento_valor: event.valor_servico,
            });
        }

        // ======== MÉDICO SOLICITANTE ========
        else if (fieldName === 'agendamento_medico_id') {
            this.setState({
                agendamento_medico_id: event.value,
                agendamento_medico_nome: event.label,
            });
        }
        else if (fieldName === "agendamento_valor" || fieldName === 'valor_servico_edicao') {
            const { name, value } = event.target;
            this.setState({ [name]: formatarValor(value) });
        }
        
        // ======== UPLOAD DO TERMO ASSINADO ========
        else if (fieldName === "termo_aceite_assinado_upload") {
            const file = event.target.files[0];
    
            if (file && file.type !== "application/pdf") {
                Swal.fire({
                    title: "Arquivo inválido",
                    text: "Envie apenas arquivos PDF.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }
    
            this.setState({
                agendamento_termo_assinado_file: file,
                agendamento_excluir_termo_assinado: false,
            });
        }
    
        // ======== EXCLUSÃO DO TERMO ASSINADO ========
        else if (fieldName === "excluir_termo_assinado") {
            this.setState({
                agendamento_excluir_termo_assinado: true,
                agendamento_termo_assinado_url: "",
                agendamento_termo_assinado_file: null,
            });
        }

        // ======== VINCULAR TERAPIA DO HISTÓRICO ========
        else if (fieldName === 'agendamento_terapia_id') {
            this.setState({
                agendamento_terapia_id: event.value,
                agendamento_terapia_nome: event.label,
            });
        }
    
        // ======== CAMPOS GENÉRICOS ========
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangeAcao = (event, fieldName) => {
        if(fieldName == 'programa_acao_id') {
           this.setState(prevState => ({
                programa_acao_id: event.value, 
                programa_acao_nome: event.label,
            }));
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    enviaAgendamento = async (e) => {
        e.preventDefault();

        const dados_usuario = getCurrentUser();

        if (getConfig(this.state.programa_dados?.configuracoes, 'agendamento.tipo_agendamento_obrigatorio', false) && !this.state.agendamento_tipo) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Preenchimento do tipo de agendamento é obrigatório.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.agendamento_servico_procedimento_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhum serviço selecionado. Por favor, selecione um serviço para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return;
        }

        if (!this.state.agendamento_prestador_id && this.state.meeting_tipo_host == 'prestador') {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhum prestador de serviço selecionado. Por favor, selecione um prestador para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return;
        }

        let data_solicitacao = '';
        if (this.state.agendamento_id) {
            if (!this.state.data_solicitacao) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Nenhuma data de solicitação informada. Por favor, informe a data de solicitação do agendamento.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return;
            }
            data_solicitacao = this.state.data_solicitacao;
        } else {
            data_solicitacao = this.state.data_solicitacao || '1900-01-01 00:00';
        }

        let data_agendamento = '';
        if (this.state.agendamento_id) {
            if (!this.state.agendamento_data) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Nenhuma data informada. Por favor, informe uma data do agendamento.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return;
            }
            data_agendamento = this.state.agendamento_data;
        } else {
            data_agendamento = (this.state.agendamento_data) || '1900-01-01 00:00';
        }

        //verifica se tem envio de kit
        /*if (this.state.enviarKitAgendamento === 'sim') {
            if (!this.state.dataEnvioKit) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Por favor, informe uma data prevista de envio do kit',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return;
            }
        }*/


        // Conta quantos agendamentos já existem para o servico_procedimento_id especificado
        /*let agendamentosExistentes = 0;
        if('results' in this.state.agendamentos && this.state.agendamentos.results.length > 0) {
            agendamentosExistentes = this.state.agendamentos.results.filter(agendamento => 
                agendamento.servico_procedimento_id === this.state.agendamento_servico_procedimento_id
            ).length;
        }*/

        const MySwal = withReactContent(Swal);

        this.setState({
            loading: true,
        });

        // Se tiver envio de kit
        let programa_kit_id = '';
        let atendimento_kit_id = '';
        if (!this.state.agendamento_id && this.state.enviarKitAgendamento === 'sim') {
            
            //Busca kit do programa
            let kitAtivo;
            try {
                kitAtivo = await this.obterProgramaKitId(this.state.programa_id);
                programa_kit_id = kitAtivo.id;
            } catch (e) {
                this.setState({ loading: false });
                await Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: e.message || 'Não foi possível localizar um kit ativo para este programa.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return;
            }

            // Validação do termo assinado obrigatório
            if (this.state.agendamento_exige_termo_aceite) {
                const jaTemArquivoNoAgendamento = !!this.state.agendamento_termo_assinado_url;
                const vaiEnviarArquivoAgora = !!this.state.agendamento_termo_assinado_file;
        
                if (!jaTemArquivoNoAgendamento && !vaiEnviarArquivoAgora) {
                    const MySwal = withReactContent(Swal);
                    await MySwal.fire({
                        title: 'Termo de Aceite obrigatório',
                        html: 'Para este serviço, é necessário anexar o PDF do termo assinado.',
                        icon: 'error',
                        showCloseButton: true,
                    });
                    return;
                }
            }

            try {
                /*const payloadEndereco = {
                    nome: 'Endereço Paciente ' + this.state.beneficiario_id,
                    cep: this.state.beneficiario_dados.cep || '',
                    endereco: this.state.beneficiario_dados.endereco || '',
                    numero: this.state.beneficiario_dados.numero || '',
                    complemento: this.state.beneficiario_dados.complemento || '',
                    bairro: this.state.beneficiario_dados.bairro || '',
                    cidade: this.state.beneficiario_dados.cidade || '',
                    uf: this.state.beneficiario_dados.uf || '',
                    beneficiario_id: this.state.beneficiario_id,
                };
                const enderecoResp = await api.post('/enderecos/', payloadEndereco);
                const endereco_id = enderecoResp?.data?.id;*/
                const endereco_id = this.state.endereco_kit_id;

                await api.put(`/atendimentos/${this.state.atendimento_id}/`, {
                    recebe_kit_paciente: true
                });

                const payloadKit = {
                    atendimento_id: this.state.atendimento_id,
                    programa_kit_id: programa_kit_id,
                    descricao: kitAtivo?.titulo || '',
                    endereco_id: endereco_id,
                    data_envio: this.state.agendamento_data?.split('T')[0],
                };

                const atendimentoKitResp = await api.post('/atendimentos/kits/', payloadKit);
                atendimento_kit_id = atendimentoKitResp?.data?.id;

            } catch (e) {
                // falhou algo do fluxo do kit: informa e interrompe, pra não seguir com agendamento "meio-cadastrado"
                this.setState({ loading: false });
                await MySwal.fire({
                    icon: 'error',
                    title: 'Atenção',
                    html: '<p>Não foi registrar o envio de kit para este atendimento. Tente novamente.</p>',
                    showCloseButton: true,
                });
                return;
            }
        }

        //vererifica se é edição ou adição
        const url = (this.state.agendamento_id) ? '/agendamentos/'+this.state.agendamento_id+'/' : '/agendamentos/'
        const metodo = (this.state.agendamento_id) ? 'put' : 'post'

        const valorFormatadoAPI = formatarValorAPI(this.state.agendamento_valor);

        const formData = new FormData();

        formData.append('data_agendamento', data_agendamento);
        formData.append('data_solicitacao', data_solicitacao);
        formData.append('beneficiario_id', this.state.beneficiario_id);
        formData.append('atendimento_id', this.state.atendimento_id);
        formData.append('tipo', this.state.agendamento_tipo || '');
        formData.append('meeting_host', this.state.meeting_tipo_host || '');
        formData.append('valor', valorFormatadoAPI);
        formData.append('anotacoes', this.state.anotacoes || '');
        formData.append('servico_procedimento_id', this.state.agendamento_servico_procedimento_id);
        formData.append('situacao', 'liberado');
        formData.append('programa_id', this.state.programa_id);

        formData.append('local_nome', this.state.local_nome || '');
        formData.append('local_cep', this.state.local_cep || '');
        formData.append('local_endereco', this.state.local_endereco || '');
        formData.append('local_numero', this.state.local_numero || '');
        formData.append('local_complemento', this.state.local_complemento || '');
        formData.append('local_cidade', this.state.local_cidade || '');
        formData.append('local_uf', this.state.local_uf || '');

        if (this.state.solicitarAceiteRecusa) {
            formData.append('envia_aceite', 'true');
            formData.append('status_aceite', 'aguardando');
        } else {
            formData.append('envia_aceite', 'false');
        }

        if(atendimento_kit_id) {
            formData.append('atendimento_kit_id', atendimento_kit_id);
        }

        if (this.state.atendente_id) {
            formData.append('operador_id', this.state.atendente_id);
        } else {
            if(dados_usuario['tipo_usuario'] === 'operador') {
                formData.append('operador_id', dados_usuario['operador_id']);
            }
        }

        if (this.state.agendamento_prestador_id) {
            formData.append('prestador_id', this.state.agendamento_prestador_id);
        }

        if (this.state.agendamento_medico_id) {
            formData.append('prestador_solicitante', this.state.agendamento_medico_id);
        }

        if (this.state.agendamento_termo_assinado_file) {
            formData.append('termo_aceite_assinado', this.state.agendamento_termo_assinado_file);
        }
        if (this.state.excluir_termo_assinado) {
            formData.append('excluir_termo_assinado', true);
        }
        
        if (this.state.justificativa_limite) {
            formData.append('justificativa_limite', true);
        }

        // Adiciona o ID da terapia vinculada se houver
        if(this.state.agendamento_terapia_id){
            formData.append('aplicacao_id', this.state.agendamento_terapia_id);
        }

        api({
            method: metodo,
            url: url,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(response => {
                this.setState({ justificativa_limite: '' });

                const textSwal = (this.state.agendamento_id) ? 'Agendamento atualizado com sucesso' : 'Agendamento cadastrado com sucesso';

                const id_agendamento = (this.state.agendamento_id) ? this.state.agendamento_id : response.data.id;

                if (this.state.agendamento_servico_procedimento_nome === 'Vídeo Chamada' || this.state.agendamento_servico_video_conferencia) {
                    api.post('/meetings/', {
                        agendamento_id: response.data.id,
                        minutos_expiracao: 36000
                    })
                        .then(responseSala => {
                            this.setState({
                                loading: false
                            });

                            MySwal.fire({
                                title: <p>{textSwal}</p>,
                                icon: 'success',
                                showCloseButton: true,
                            }).then((result) => {
                                this.carregarAgendamentos();
                                this.handleCloseModal();
                            });
                        })
                        .catch(errorSala => {
                            this.setState({
                                loading: false,
                            });

                            MySwal.fire({
                                icon: 'warning',
                                title: 'Atenção!',
                                html: '<p>Agendamento criado, porém houve um erro para criar a sala</p>',
                                showCloseButton: true,
                            }).then((result) => {
                                this.setState({
                                    loading: false,
                                });
                                this.carregarAgendamentos();
                                this.handleCloseModal();
                            });
                        });
                } else {
                    this.setState({
                        loading: false,
                    });

                    MySwal.fire({
                        title: <p>{textSwal}</p>,
                        icon: 'success',
                        showCloseButton: true,
                    }).then((result) => {
                        this.carregarAgendamentos();
                        this.handleCloseModal();
                    });
                }
            })
            .catch(error => {
                let erro_msg = 'Erro ao cadastrar agendamento, verifique os campos e tente novamente';

                const { status, data } = error.response;

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if (error.response && error.response.status === 400) {

                    if (data.limite_confirmacao) {
                        this.setState({ loading: false });

                        MySwal.fire({
                            icon: 'warning',
                            title: 'Limite de Atendimentos Atingido',
                            text: data.message,
                            input: 'textarea',
                            inputLabel: 'Justificativa Obrigatória',
                            inputPlaceholder: 'Descreva o motivo para exceder o limite...',
                            inputAttributes: {
                                'aria-label': 'Descreva o motivo para exceder o limite'
                            },
                            showCancelButton: true,
                            confirmButtonText: 'Confirmar e Agendar',
                            cancelButtonText: 'Cancelar',
                            confirmButtonColor: '#0f9e1bff',
                            cancelButtonColor: '#d33',
                            inputValidator: (value) => {
                                if (!value) {
                                    return 'Você precisa escrever uma justificativa!'
                                }
                            }
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.setState({ justificativa_limite: result.value }, () => {
                                    this.enviaAgendamento(e);
                                });
                            } else {
                                this.setState({ justificativa_limite: '' });
                            }
                        });
                        return;
                    }

                    if (data.limite_validacao) {
                        const msgBloqueio = Array.isArray(data.limite_validacao) ? data.limite_validacao.join('<br/>') : data.limite_validacao;

                        return MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: 'Agendamento Bloqueado',
                            html: `<p>${msgBloqueio}</p>`,
                        }).then(() => {
                            this.setState({ loading: false });
                            this.carregarAgendamentos();
                            this.handleCloseModal();
                        });
                    }

                    const todasMensagens = Object.values(data)
                        .flat()
                        .join('<br/>');
                    erro_msg = todasMensagens || erro_msg;
                }

                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Atenção',
                    html: <p>{erro_msg}</p>,
                });

                this.setState({
                    loading: false,
                });

                //Sentry.captureException(erro_msg);
            });
    };

    getDadosMedicoSolicitante = async (id) => {
        if (!id) return;
        try {
            const { data } = await api.get(`/pessoas/prestadores/${id}/`);

            this.setState(prev => ({
                dados_medico_solicitante: data || null,
                agendamento_medico_nome: prev.agendamento_medico_nome || data?.nome || ""
            }));
        } catch {
            try {
                const u = getCurrentUser();
                const programa_id = u?.ambiente_programa_id || this.state.programa_id;
                const resp2 = await api.get(`/pessoas/prestadores/`, {
                    params: { id, programa_id, is_active: 1 }
                });
                const m = resp2?.data?.results?.[0];
            if (m) {
                this.setState(prev => ({
                    dados_medico_solicitante: m,
                    agendamento_medico_nome: prev.agendamento_medico_nome || m?.nome || ""
                }));
            }
            } catch (error) {
                console.error("Erro ao carregar dados do médico solicitante", error);
            }
        }
    };

    enviaAcao = (e) => {
        e.preventDefault();
        const MySwal = withReactContent(Swal)
        if (!this.state.programa_acao_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma ação selecionada. Por favor, selecione uma ação para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.acao_descricao) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma descrição informada. Por favor, informe uma descrição para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.acao_data) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma data informada. Por favor, informe uma data para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.acao_hora) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma hora informada. Por favor, informe uma hora para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        this.setState({
            loading: true,
        });

        //vererifica se é edição ou adição
        const url = (this.state.acao_id) ? '/atendimentos/acoes/'+this.state.acao_id+'/' : '/atendimentos/acoes/'
        const metodo = (this.state.acao_id) ? 'put' : 'post'
        const realizado = (this.state.acao_realizado === "Sim") ? true : false;

        const data = {
            atendimento_id: this.state.atendimento_id,
            etapa_id: this.state.etapa_atual.id,
            programa_acao_id: this.state.programa_acao_id,
            descricao: this.state.acao_descricao,
            //observacoes: this.state.acao_observacoes,
            data_acao: this.state.acao_data,
            hora_acao: this.state.acao_hora,
            realizado: realizado,
            pessoa_id: 1
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: data
        })
        .then(response => {
            
            const textSwal = (this.state.acao_id) ? 'Ação atualizada com sucesso' : 'Ação cadastrada com sucesso';

            this.setState({
                loading: false
            });

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                this.carregarAcoes();
                this.handleCloseModalAcoes();
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar ação, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                }
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })

            //Sentry.captureException(erro_msg);
        });
    };

    enviaProduto = (e) => {
        e.preventDefault();

        if (!this.state.programa_produto_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhum produto selecionado. Por favor, selecione um produto para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.produto_valor) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhum valor informado. Por favor, informe o valor do produto.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }
        

        const MySwal = withReactContent(Swal)

        this.setState({
            loading: true,
        });

        //vererifica se é edição ou adição
        const url = (this.state.produto_id) ? '/atendimentos/produtos/'+this.state.produto_id+'/' : '/atendimentos/produtos/'
        const metodo = (this.state.produto_id) ? 'put' : 'post'

        const valorFormatadoAPI = formatarValorAPI(this.state.produto_valor);
        //retirei o valor do produto
        //envia para api
        api({
            method: metodo,
            url: url,
            data: {
                produto_id: this.state.programa_produto_id,
                atendimento_id: this.state.atendimento_id,
                valor: valorFormatadoAPI
            }
        })
        .then(response => {
            
            const textSwal = (this.state.produto_id) ? 'Produto atualizado com sucesso' : 'Produto cadastrado com sucesso';

            this.setState({
                loading: false
            });

            // Tudo concluído aqui, agora pode navegar
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                this.carregarProdutos();
                this.handleCloseModalProduto();
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar produto, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                }
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    enviaSituacaoAgendamento = async (e) => {
        e.preventDefault();

        if (!this.state.agendamento_selecionado.situacao) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma situacao selecionada. Por favor, selecione uma situação para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        const MySwal = withReactContent(Swal)

        const data_atual = getDataAtual();

        //vererifica se é edição ou adição
        const url = '/agendamentos/'+this.state.agendamento_selecionado.id+'/'
        const metodo = 'put'

        let data_update = {
            data_agendamento: this.state.agendamento_selecionado.data_agendamento,
            beneficiario_id: this.state.beneficiario_id,
            atendimento_id: this.state.atendimento_id,
            tipo: this.state.agendamento_selecionado.tipo,
            //valor: this.state.agendamento_selecionado.valor,
            servico_procedimento_id: this.state.agendamento_selecionado.servico_procedimento_id,
            situacao: this.state.agendamento_selecionado.situacao,
        } 

        if(this.state.agendamento_selecionado.local_nome) {
            data_update['local_nome'] = this.state.agendamento_selecionado.local_nome;
        }
        if(this.state.agendamento_selecionado.local_cep) {
            data_update['local_cep'] = this.state.agendamento_selecionado.local_cep;
        }
        if(this.state.agendamento_selecionado.local_endereco) {
            data_update['local_endereco'] = this.state.agendamento_selecionado.local_endereco;
        }
        if(this.state.agendamento_selecionado.local_numero) {
            data_update['local_numero'] = this.state.agendamento_selecionado.local_numero;
        }
        if(this.state.agendamento_selecionado.local_complemento) {
            data_update['local_complemento'] = this.state.agendamento_selecionado.local_complemento;
        }
        if(this.state.agendamento_selecionado.local_cidade) {
            data_update['local_cidade'] = this.state.agendamento_selecionado.local_cidade;
        }
        if(this.state.agendamento_selecionado.local_uf) {
            data_update['local_uf'] = this.state.agendamento_selecionado.local_uf;
        }

        if(this.state.agendamento_selecionado.prestador_id) {
            data_update['prestador_id'] = this.state.agendamento_selecionado.prestador_id;
        }

        const estavaRecusado = this.state.agendamento_selecionado?.envia_aceite === true
            && this.state.agendamento_selecionado?.status_aceite === 'recusado';

        const prestadorOriginalId = this.state.agendamento_prestador_original_id || null;
        const prestadorAtualId = this.state.agendamento_selecionado?.prestador_id || null;

        const trocouPrestador = estavaRecusado && prestadorAtualId && prestadorAtualId !== prestadorOriginalId;

        // se trocou, reinicia o fluxo de aceite
        if (trocouPrestador) {
            data_update['prestador_id'] = prestadorAtualId;
            data_update['status_aceite'] = 'aguardando';
            data_update['envia_aceite'] = true;
        }

        if(this.state.agendamento_selecionado.situacao == 'finalizado'){
            data_update.adicionar_servico_atendimento = true;
        }

        if(this.state.agendamento_selecionado.situacao == 'liberado' && this.state.agendamento_selecionado.data_liberacao) {
            /*if (!this.state.agendamento_selecionado.data_liberacao) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Por favor informe a data de liberação.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return; // Interrompe a execução do método
            }*/

            data_update['data_liberacao'] = this.state.agendamento_selecionado.data_liberacao
        }

        if (this.state.agendamento_selecionado.situacao === 'cancelado') {
            // se vier lista de motivos, deve ter opção selecionada
            if (this.state.motivosCancelamento.length > 0 && !this.state.motivoSelecionado) {
              Swal.fire('Atenção', 'Selecione o motivo do cancelamento.', 'warning');
              return;
            }
            // se selecionou “outro”, deve descrever
            if (this.state.motivoSelecionado === 'outro' && !this.state.motivoOutro.trim()) {
              Swal.fire('Atenção', 'Descreva o motivo do cancelamento.', 'warning');
              return;
            }

            if (this.state.motivoSelecionado && this.state.motivoSelecionado !== 'outro') {
                data_update['motivo_id'] = this.state.motivoSelecionado;
            } else {
                data_update['motivo_outro'] = this.state.motivoOutro;
            }
            data_update['data_cancelamento'] = data_atual;
        }

        if(this.state.agendamento_selecionado.situacao == 'finalizado') {
            if (!this.state.agendamento_selecionado.data_realizacao) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Por favor informe a data de realização.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return; // Interrompe a execução do método
            }

            data_update['data_realizacao'] = this.state.agendamento_selecionado.data_realizacao
        }

        const original = this.state.agendamento_original_data;
        const atual = this.state.agendamento_selecionado.data_agendamento;

        let dataAlterada = false;
        try {
            const originalTime = original ? new Date(original).getTime() : NaN;
            const atualTime = atual ? new Date(atual).getTime() : NaN;
            if (!isNaN(originalTime) && !isNaN(atualTime)) {
                dataAlterada = originalTime !== atualTime;
            } else {
                dataAlterada = (original !== null && original !== undefined) && (original !== atual);
            }
        } catch (err) {
            dataAlterada = (original !== null && original !== undefined) && (original !== atual);
        }

        if (dataAlterada) {
            this.handleCloseModalAgendamento();

            const ok = await this.processarReagendamento();
            if (!ok) {

                return;
            }
        }

        this.setState({
            loading: true,
        });

        //envia para api
        api({
            method: metodo,
            url: url,
            data: data_update
        })
        .then(response => {
            
            const textSwal = 'Situação do agendamento atualizada com sucesso';

            this.setState({
                loading: false
            });

            // Tudo concluído aqui, agora pode navegar
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                this.handleCloseModalAgendamento();
                this.carregarAgendamentos();
                this.handleCloseModal();
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao atualizar situação, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                }
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
            this.handleCloseModalAgendamento();

            //Sentry.captureException(erro_msg);
        });
    };

    /**
     * Gera HTML para campos dinâmicos baseado na configuração do serviço
     * @param {Array} campos - Array de configuração de campos
     * @returns {string} HTML dos campos
     */
    gerarHtmlCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos) || campos.length === 0) {
            return '';
        }
    
        return campos.map(campo => {
            const obrigatorioMark = campo.obrigatorio ? '<span class="text-danger">*</span>' : '';
            const observacao = campo.observacao ? `<small class="text-muted d-block mt-1">${campo.observacao}</small>` : '';
            
            switch (campo.tipo) {
                case 'file':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="file" 
                                accept="${campo.extensoes || '.pdf,.jpg,.jpeg,.png'}"
                                class="swal2-file form-control" 
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'radio': {
                    const opcoesHtml = (campo.opcoes || []).map((opcao, idx) => {
                        const descricao = campo.descricoes_opcoes?.[opcao] 
                            ? `<small class="text-muted d-block ms-4">${campo.descricoes_opcoes[opcao]}</small>` 
                            : '';
                        return `
                            <div class="form-check">
                                <input 
                                    class="form-check-input" 
                                    type="radio" 
                                    name="swal-campo-${campo.slug}" 
                                    id="swal-campo-${campo.slug}-${idx}" 
                                    value="${opcao}"
                                    data-slug="${campo.slug}"
                                    data-tipo="${campo.tipo}"
                                />
                                <label class="form-check-label" for="swal-campo-${campo.slug}-${idx}">${opcao}</label>
                                ${descricao}
                            </div>
                        `;
                    }).join('');
                    
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label class="text-start d-block mb-2">${campo.label} ${obrigatorioMark}</label>
                            <div class="text-start" data-obrigatorio="${campo.obrigatorio || false}" data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'>
                                ${opcoesHtml}
                            </div>
                            ${observacao}
                        </div>
                    `;
                }
                
                case 'text':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="text" 
                                class="swal2-input" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'textarea':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <textarea 
                                id="swal-campo-${campo.slug}" 
                                class="swal2-textarea" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            ></textarea>
                            ${observacao}
                        </div>
                    `;
                
                default:
                    return '';
            }
        }).join('');
    };
    
    /**
     * Configura event listeners para campos com obrigatoriedade condicional
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    configurarEventosCamposDinamicos = (container, campos) => {
        if (!campos || !Array.isArray(campos)) return;

        // Para cada campo radio, adiciona listener para atualizar obrigatoriedade de outros campos
        campos.forEach(campo => {
            if (campo.tipo === 'radio') {
                const radios = container.querySelectorAll(`input[name="swal-campo-${campo.slug}"]`);
                radios.forEach(radio => {
                    radio.addEventListener('change', () => {
                        this.atualizarObrigatoriedadeCondicional(container, campos);
                    });
                });
            }
        });
    };
    
    /**
     * Atualiza a obrigatoriedade condicional dos campos baseado nos valores selecionados
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    atualizarObrigatoriedadeCondicional = (container, campos) => {
        campos.forEach(campo => {
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = container.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                
                const elementoCampo = container.querySelector(`#swal-campo-${campo.slug}`);
                const containerCampo = container.querySelector(`.campo-dinamico[data-slug="${campo.slug}"]`);
                
                if (elementoCampo && containerCampo) {
                    const isObrigatorio = valores.includes(valorAtual);
                    const labelEl = containerCampo.querySelector('label');
                    
                    // Atualiza o asterisco de obrigatório
                    if (labelEl) {
                        const spanObrig = labelEl.querySelector('.text-danger');
                        if (isObrigatorio && !spanObrig) {
                            labelEl.innerHTML = labelEl.textContent + ' <span class="text-danger">*</span>';
                        } else if (!isObrigatorio && spanObrig) {
                            spanObrig.remove();
                        }
                    }
                    
                    // Armazena o estado de obrigatoriedade atual no elemento
                    elementoCampo.dataset.obrigatorioAtual = isObrigatorio;
                }
            }
        });
    };
    
    /**
     * Coleta os valores de todos os campos dinâmicos
     * @param {Array} campos - Array de configuração de campos
     * @returns {Object} Objeto com slugs como chaves e valores preenchidos
     */
    coletarValoresCamposDinamicos = (campos) => {
        const valores = {};
        const arquivos = {};
        
        if (!campos || !Array.isArray(campos)) {
            return { valores, arquivos };
        }

        campos.forEach(campo => {
            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (fileInput?.files?.length > 0) {
                        arquivos[campo.slug] = fileInput.files[0];
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (radioSelecionado) {
                        valores[campo.slug] = radioSelecionado.value;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (inputEl) {
                        valores[campo.slug] = inputEl.value.trim();
                    }
                    break;
                }
            }
        });

        return { valores, arquivos };
    };
    
    /**
     * Valida os campos dinâmicos obrigatórios
     * @param {Array} campos - Array de configuração de campos
     * @returns {string|null} Mensagem de erro ou null se válido
     */
    validarCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos)) {
            return null;
        }

        for (const campo of campos) {
            let isObrigatorio = campo.obrigatorio === true;
            
            // Verifica obrigatoriedade condicional
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = document.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                isObrigatorio = valores.includes(valorAtual);
            }

            if (!isObrigatorio) continue;

            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!fileInput?.files?.length) {
                        return `Por favor, selecione um arquivo para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (!radioSelecionado) {
                        return `Por favor, selecione uma opção para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!inputEl?.value?.trim()) {
                        return `Por favor, preencha o campo "${campo.label}"`;
                    }
                    break;
                }
            }
        }

        return null;
    };
    

    /**
     * Verifica se o usuário atual pode visualizar um campo baseado em control-show
     * @param {Object} campo - Configuração do campo
     * @returns {boolean} - true se pode visualizar, false caso contrário
     */
    podeVisualizarCampo = (campo) => {
        // Se não tem control-show, mostra para todos
        if (!campo['control-show']) {
            return true;
        }

        const controlShow = campo['control-show'];
        const dados_usuario = getCurrentUser();
        const tipoUsuario = dados_usuario?.tipo_usuario || '';

        // Se tem allow-profiles, mostra APENAS para os perfis listados
        if (controlShow['allow-profiles'] && Array.isArray(controlShow['allow-profiles'])) {
            return controlShow['allow-profiles'].includes(tipoUsuario);
        }

        // Se tem deny-profiles, mostra para todos EXCETO os perfis listados
        if (controlShow['deny-profiles'] && Array.isArray(controlShow['deny-profiles'])) {
            return !controlShow['deny-profiles'].includes(tipoUsuario);
        }

        // Se control-show existe mas não tem configuração válida, mostra para todos
        return true;
    };

    renderDadosConfirmacao = () => {
        const agendamento = this.state.agendamento_selecionado;
        if (!agendamento) return null;

        const configuracoes = agendamento.dados_servico_procedimento?.configuracoes;
        const camposConfig = configuracoes?.modal_confirmacao?.campos;
        
        const dadosConfirmacao = agendamento.dados_confirmacao;
        const arquivoUrl = agendamento.arquivo_confirmacao;
        
        const temDados = dadosConfirmacao || arquivoUrl;
        if (!temDados) return null;

        const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(this.state.programa_dados?.configuracoes);
        const isBloqueadoDadosConfirmacao = isDadosConfirmacaoBloqueadosParaUsuarioAtual(this.state.programa_dados?.configuracoes);

        return (
            <Col sm={12}>
                <hr />
                <h6 className="text-uppercase mb-3">Dados da Confirmação do Serviço</h6>

                {arquivoUrl && (
                    <div className="mb-2">
                        <strong>Arquivo de Confirmação:</strong> <br/>
                        {isBloqueadoVisualizarLaudo ? (
                            <span className="text-muted mt-1 d-inline-block">
                                <FaExclamationTriangle className="me-1 text-warning"/> Visualização bloqueada
                            </span>
                        ) : (
                            <a href={arquivoUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary mt-1">
                                <FaDownload className="me-1"/> Visualizar Arquivo
                            </a>
                        )}
                    </div>
                )}

                {dadosConfirmacao && (
                    isBloqueadoDadosConfirmacao ? (
                        <div className="text-muted small">
                            <FaExclamationTriangle className="me-1 text-warning"/> Respostas bloqueadas para o seu perfil
                        </div>
                    ) : (
                        this.renderDynamicData(dadosConfirmacao, null, camposConfig || [], agendamento)
                    )
                )}
            </Col>
        );
    };

    renderDadosFormularioAprovacao = (agendamento) => {
        if (!agendamento) return null;
        const dadosFormulario = agendamento.dados_formulario_aprovacao;
        
        if (!dadosFormulario) return null;

        return (
            <Col sm={12}>
                <hr />
                <h6 className="text-uppercase mb-3">Dados do Formulário de Aprovação</h6>
                {this.renderDynamicData(dadosFormulario, null, [], agendamento)}
            </Col>
        );
    }

    renderDadosFormularioDinamicoServicos = (agendamento) => {
        if (!agendamento) return null;
        const dadosFormulario = agendamento.dados_formulario_dinamico_servicos;
        
        if (!dadosFormulario) return null;

        const configuracoes = agendamento.dados_servico_procedimento?.configuracoes;
        const camposConfig = configuracoes?.formulario_dinamico_servicos_procedimentos?.campos || [];

        return (
            <Col sm={12}>
                <hr />
                <h6 className="text-uppercase mb-3">Formulário Dinâmico de Serviços</h6>
                {this.renderDynamicData(dadosFormulario, null, camposConfig, agendamento)}
            </Col>
        );
    }

    handleConfirmarServico = async (agendamento) => {
        const useNewModal = getConfig(
            this.state.programa_dados?.configuracoes,
            'show_modal_confirm_service',
            false
        );

        if (useNewModal) {
            this.setState({
                showConfirmarRealizacaoModal: true,
                agendamentoParaConfirmar: agendamento,
            });
            return;
        }

        const aprovaAutomatico = getConfig(
            this.state.programa_dados?.configuracoes,
            'aprova_laudo_automatico',
            false
        );

        const showModalAfterApprove = getConfig(
            this.state.programa_dados?.configuracoes,
            'show_modal_after_aprove_laudo',
            false
        );

        if (aprovaAutomatico && showModalAfterApprove) {
            try {
                const programaId = this.state.programa_dados?.id;
                const formulario = await buscarFormularioEvento(EVENTOS.ON_APPROVE_LAUDO, programaId);
                
                if (formulario) {
                    this.setState({
                        agendamentoParaConfirmarComFormulario: agendamento,
                        formularioEventoDataConfirmacao: formulario,
                    });
                }
            } catch (error) {
                console.error('Erro ao buscar formulário de evento:', error);
            }
        }

        // Continuar com fluxo normal de confirmação
        this.executarConfirmacaoServico(agendamento);
    }

    renderDynamicData = (dataSource, title, camposConfig = [], agendamento = null) => {
        if (!dataSource) return null;

        let itemsToRender = [];

        if (Array.isArray(dataSource)) {
            itemsToRender = dataSource.filter(item => {
                if (!camposConfig || camposConfig.length === 0) return true;
                const config = camposConfig.find(c => c.slug === item.slug);
                return config ? this.podeVisualizarCampo(config) : true;
            }).map(item => ({
                label: item.label || item.slug,
                value: item.value,
                type: item.type
            }));
        } 
        else if (typeof dataSource === 'object') {
            const valuesObj = dataSource.valores || dataSource;
            
            if (Array.isArray(valuesObj)) {
                itemsToRender = valuesObj.map(item => ({
                    label: item.label || item.slug,
                    value: item.value,
                    type: item.type
                }));
            } else {
                Object.entries(valuesObj).forEach(([slug, valor]) => {
                    if (valor === null || valor === undefined || valor === '' || typeof valor === 'object') return;

                    const config = camposConfig.find(c => c.slug === slug);
                    
                    let label = slug;
                    if (config) {
                        if (!this.podeVisualizarCampo(config)) return;
                        label = config.label;
                    } else {
                        label = slug.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
                    }

                    itemsToRender.push({
                        label: label,
                        value: valor,
                        type: config?.tipo || 'text'
                    });
                });
            }
        }

       if (itemsToRender.length === 0) return null;

        return (
            <div className="mb-2">
                {title && <div className="fw-bold mb-1 border-bottom pb-1">{title}</div>}
                {itemsToRender.map((item, idx) => {
                    let displayValue = item.value;

                    const isDateType = item.type === 'date' || item.type === 'datetime';
                    const looksLikeDate = typeof item.value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(item.value);
                    
                    if ((isDateType || looksLikeDate) && item.value) {
                        displayValue = moment(item.value).format('DD/MM/YYYY');
                    } else if (item.value === "true" || item.value === true) {
                        displayValue = "Sim";
                    } else if (item.value === "false" || item.value === false) {
                        displayValue = "Não";
                    }

                    if (typeof displayValue === 'string' && (displayValue.startsWith('http') || displayValue.startsWith('/media'))) {
                        return (
                            <div key={idx} className="mb-1">
                                <strong>{item.label}:</strong>{' '}
                                <a href={displayValue} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-light py-0 px-2 ms-1 border" style={{fontSize: '0.85rem'}}>
                                    <FaEye className="me-1"/> Ver Arquivo/Link
                                </a>
                            </div>
                        );
                    }

                    if (typeof displayValue === 'object' && displayValue !== null) {
                        try {
                           displayValue = JSON.stringify(displayValue);
                        } catch (e) {
                           displayValue = String(displayValue);
                        }
                    }

                    return (
                        <div key={idx} className="mb-1">
                            <strong>{item.label}:</strong> <span className="ms-1 text-muted">{displayValue}</span>
                        </div>
                    );
                })}
            </div>
        );
    };

    executarConfirmacaoServico = (agendamento) => {

        const MySwal = withReactContent(Swal);
        const dataRealizacaoPadrao = moment().tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm');
        const nomeProfPadrao = this.state.agendamento_selecionado?.prestador_nome
            || this.state.agendamento_selecionado?.dados_prestador?.nome
            || '';

        let configuracoes = this.state.programa_dados?.configuracoes;
        if (typeof configuracoes === 'string') {
            try { configuracoes = JSON.parse(configuracoes); } catch (e) { configuracoes = {}; }
        }
        configuracoes = configuracoes || {};

        const configExames = configuracoes['Exames_Component'] || {};
        const exigeLaudo = configExames['exige_laudo_exame']?.includes('obrigatorio');
        const ocultarCampoLaudo = getConfig(this.state.programa_dados?.configuracoes, "Exames_Component.ocultar_laudo_confirmacao", false);

        const isLogista = agendamento?.dados_servico_procedimento?.servico_logistica === true;
        const ocultarSolicitacaoExames = !!agendamento?.dados_servico_procedimento?.ocultar_solicitacao_exames;
        const permiteAlterarValor = !!agendamento?.dados_servico_procedimento?.permite_alterar_valor_agendamento;
        const isMonitoria = agendamento?.dados_servico_procedimento?.servico_dados_monitoramento === true 
            || (agendamento?.dados_servico_procedimento?.nome || '').startsWith('Monitoria');


        const configuracoesServico = agendamento?.dados_servico_procedimento?.configuracoes;
        const camposDinamicos = configuracoesServico?.modal_confirmacao?.campos || [];
        const temCamposDinamicos = camposDinamicos.length > 0;

        const htmlCamposDinamicos = temCamposDinamicos
            ? `<div class="campos-dinamicos-container mt-3 pt-3 border-top">${this.gerarHtmlCamposDinamicos(camposDinamicos)}</div>`
            : '';

        // === MONTA HTML DO MODAL ===
        let htmlContent = `
            <div class="text-start container-confirma-servico" style="max-height: 65vh; overflow-y: auto; overflow-x: hidden; padding-right: 10px;">
                <p class="text-start">Deseja confirmar a realização de <strong>${agendamento.dados_servico_procedimento.nome}</strong>?</p>

                <label for="swal-input-data" class="text-start form-label">Data de Realização do Serviço <span class="text-danger">*</span></label>
                <input id="swal-input-data" type="datetime-local"
                    value="${dataRealizacaoPadrao}"
                    min="${moment().subtract(30, 'days').format('YYYY-MM-DDTHH:mm')}"
                    max="${moment().format('YYYY-MM-DDTHH:mm')}"
                    class="form-control mb-3" />
        `;

        if (!isLogista && !permiteAlterarValor && 1 != 1) {
            htmlContent += `
                <label for="swal-input-profissional" class="text-start form-label mt-3">Nome do profissional <span class="text-danger">*</span></label>
                <input id="swal-input-profissional" type="text"
                    value="${nomeProfPadrao}"
                    placeholder="Digite o nome do profissional"
                    class="form-control mb-3" />
            `;
        }

        if (isLogista || permiteAlterarValor) {
            const valorInicial = permiteAlterarValor && agendamento.valor ? formatarValorLocal(agendamento.valor).replace('R$', '').trim() : ''; 
            htmlContent += `
                <label for="swal-input-valor" class="text-start form-label mt-3">Valor do serviço <span class="text-danger">*</span></label>
                <input id="swal-input-valor" type="text"
                    inputmode="decimal" autocomplete="off"
                    placeholder="0,00"
                    value="${valorInicial}"
                    class="form-control mb-3" />
            `;
        }

        if (isMonitoria) {
            htmlContent += `
                <label for="swal-input-arquivo-monitoria" class="text-start mt-3">Arquivo de Monitoramento <span class="text-danger">*</span></label>
                <input id="swal-input-arquivo-monitoria" type="file"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                    class="form-control form-control-sm" style="display: block; width: 100%; margin-top: 0.5rem; font-size: 0.875rem;" />
            `;
        }

        if(!ocultarCampoLaudo && !ocultarSolicitacaoExames) {
            if (exigeLaudo) {
                htmlContent += `
                    <label for="swal-input-arquivo" class="text-start form-label">Laudo do Exame <span class="text-danger">*</span></label>
                    <input id="swal-input-arquivo" type="file" class="form-control mb-3" accept=".pdf, .jpg, .jpeg, .png" />
                `;
            } else {
                htmlContent += `
                    <label for="swal-input-arquivo" class="text-start form-label">Laudo do Exame (Opcional)</label>
                    <input id="swal-input-arquivo" type="file" class="form-control mb-3" accept=".pdf, .jpg, .jpeg, .png" />
                `;
            }
        }
        

        htmlContent += htmlCamposDinamicos;

        htmlContent += `
                <label for="swal-textarea-anotacoes" class="text-start form-label mt-3">Anotações do Serviço (opcional)</label>
                <textarea id="swal-textarea-anotacoes" class="form-control" rows="3"></textarea>
            </div>
        `;

        MySwal.fire({
            title: 'Confirmar Realização',
            icon: 'warning',
            html: htmlContent,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar!',
            cancelButtonText: 'Cancelar',
            width: temCamposDinamicos ? '800px' : '650px',

            didOpen: (el) => {
                if (exigeLaudo) {
                    const confirmBtn = Swal.getConfirmButton();
                    const fileInput = document.getElementById('swal-input-arquivo');

                    confirmBtn.disabled = true;

                    fileInput.addEventListener('change', () => {
                        if (fileInput.files.length > 0) {
                            confirmBtn.disabled = false;
                        } else {
                            confirmBtn.disabled = true;
                        }
                    });
                }

                if (isLogista || permiteAlterarValor) {
                    const inputValor = el.querySelector('#swal-input-valor');
                    if (inputValor) {
                        const maskMoeda = (valor) => {
                            let v = valor.replace(/\D/g, '');
                            if (!v) return '';
                            v = v.slice(0, 15); 
                            const number = parseFloat(v) / 100;
                            return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        };

                        inputValor.addEventListener('input', (e) => {
                            e.target.value = maskMoeda(e.target.value);
                            if (document.activeElement === e.target) {
                                e.target.setSelectionRange(e.target.value.length, e.target.value.length);
                            }
                        });

                        inputValor.addEventListener('paste', (e) => {
                            e.preventDefault();
                            const text = (e.clipboardData || window.clipboardData).getData('text');
                            inputValor.value = maskMoeda(text);
                        });
                    }
                }

                if (temCamposDinamicos) {
                    this.configurarEventosCamposDinamicos(el, camposDinamicos);
                }
            },

            preConfirm: () => {
                const data = document.getElementById('swal-input-data')?.value || '';
                const elProf = document.getElementById('swal-input-profissional');
                const nome_profissional = (elProf ? elProf.value : '').trim();
                const anotacoes = document.getElementById('swal-textarea-anotacoes')?.value || '';

                if (!data) {
                    Swal.showValidationMessage('Por favor, selecione uma data de realização');
                    return false;
                }

                if (!nome_profissional && !isLogista && 1 != 1) {
                    Swal.showValidationMessage('Por favor, informe o nome do profissional');
                    return false;
                }

                let valorFormatadoBR = null;
                let valorNumero = null;

                if (isLogista || permiteAlterarValor) {
                    const elValor = document.getElementById('swal-input-valor');
                    const rawValor = (elValor?.value || '').trim();
                    if (!rawValor) {
                        Swal.showValidationMessage('Por favor, informe o valor do serviço');
                        return false;
                    }
                        
                    const somenteNumeroEVirgula = rawValor.replace(/[^\d,]/g, '');
                    const comPonto = somenteNumeroEVirgula.replace(',', '.');
                    // remove pontos de milhar se houver (o regex acima ja removeu pontos, mas assumindo input pt-BR: 1.000,00 -> 1000,00 -> "1000,00" -> replace , por . -> 1000.00)
                    // Mas toLocaleString usa ponto como milhar. O replace acima [^\d,] remove pontos de milhar.

                    const num = parseFloat(comPonto);
                    if (Number.isNaN(num) || num <= 0) {
                        Swal.showValidationMessage('O valor do serviço deve ser um número válido maior que zero');
                        return false;
                    }

                    valorFormatadoBR = rawValor;
                    valorNumero = Number(num.toFixed(2));
                }

                let arquivoMonitoria = null;
                if (isMonitoria) {
                    const elArquivo = document.getElementById('swal-input-arquivo-monitoria');
                    if (elArquivo && elArquivo.files && elArquivo.files.length > 0) {
                        arquivoMonitoria = elArquivo.files[0];
                    } else {
                        Swal.showValidationMessage('Por favor, selecione o arquivo de monitoramento');
                        return false;
                    }
                }

                let arquivoLaudo = null;
                const fileInput = document.getElementById('swal-input-arquivo');
                if (fileInput && fileInput.files.length > 0) {
                    arquivoLaudo = fileInput.files[0];
                }
    
                if (exigeLaudo && !arquivoLaudo) {
                    Swal.showValidationMessage('É obrigatório anexar o laudo do exame para confirmar.');
                    return false;
                }
    
                if (temCamposDinamicos) {
                    const erroValidacao = this.validarCamposDinamicos(camposDinamicos);
                    if (erroValidacao) {
                        Swal.showValidationMessage(erroValidacao);
                        return false;
                    }
                }
    
                const dadosDinamicos = temCamposDinamicos
                    ? this.coletarValoresCamposDinamicos(camposDinamicos)
                    : { valores: {}, arquivos: {} };

                return {
                    data,
                    nome_profissional,
                    anotacoes,
                    arquivoLaudo,
                    isLogista,
                    isMonitoria,
                    valorNumero,
                    valorFormatadoBR,
                    dadosConfirmacao: dadosDinamicos.valores,
                    arquivosConfirmacao: dadosDinamicos.arquivos,
                    arquivoMonitoria
                };
            }
        }).then((result) => {
            if (result.isConfirmed) {

                // Exibe loading durante todo o processo
                MySwal.fire({
                    title: 'Confirmando serviço...',
                    text: 'Aguarde enquanto processamos a confirmação.',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                this.setState({ loading: true });

                const dataRealizacao = moment(result.value.data).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss');
                const dataEnvioKit = moment(result.value.data).tz('America/Sao_Paulo').format('YYYY-MM-DD');
                const {
                    anotacoes,
                    nome_profissional,
                    arquivoLaudo,
                    isLogista,
                    isMonitoria,
                    valorNumero,
                    dadosConfirmacao,
                    arquivosConfirmacao,
                    arquivoMonitoria
                } = result.value;

                const payload = {
                    data_agendamento: this.state.agendamento_selecionado?.data_agendamento || agendamento.data_agendamento,
                    data_realizacao: dataRealizacao,
                    servico_procedimento_id: this.state.agendamento_selecionado?.servico_procedimento_id || agendamento.servico_procedimento_id,
                    situacao: 'finalizado',
                };

                if(this.state.agendamento_selecionado?.prestador_id || agendamento.prestador_id) {
                    payload.prestaor_id = this.state.agendamento_selecionado?.prestador_id || agendamento.prestador_id;
                    payload.adicionar_servico_atendimento = true;
                }

                if (anotacoes && anotacoes.trim() !== '') {
                    payload.anotacoes = anotacoes;
                }

                if (isLogista) {
                    payload.valor = valorNumero;
                }

                if (nome_profissional) {
                    payload.nome_profissional = nome_profissional;
                }

                if (temCamposDinamicos && Object.keys(dadosConfirmacao).length > 0) {
                    payload.dados_confirmacao = dadosConfirmacao;
                }

                const temArquivosDinamicos = Object.keys(arquivosConfirmacao).length > 0;

                let requestPromise;

                if (temArquivosDinamicos) {
                    const formData = new FormData();

                    Object.entries(payload).forEach(([key, value]) => {
                        if (value !== null && value !== undefined) {
                            if (typeof value === 'object' && !(value instanceof File)) {
                                formData.append(key, JSON.stringify(value));
                            } else {
                                formData.append(key, value);
                            }
                        }
                    });

                    Object.entries(arquivosConfirmacao).forEach(([slug, arquivo]) => {
                        formData.append(`arquivo_${slug}`, arquivo);
                    });

                    const arquivosKeys = Object.keys(arquivosConfirmacao);
                    if (arquivosKeys.length > 0) {
                        formData.append('arquivo_confirmacao', arquivosConfirmacao[arquivosKeys[0]]);
                    }

                    requestPromise = api.put(`/agendamentos/${agendamento.id}/`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                } else {
                    requestPromise = api.put(`/agendamentos/${agendamento.id}/`, payload);
                }

                requestPromise
                    .then(() => {
                        if (arquivoLaudo) {
                            const formDataArquivo = new FormData();
                            const agora = moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");

                            formDataArquivo.append('arquivo', arquivoLaudo);
                            formDataArquivo.append('nome', `Laudo - ${agendamento.dados_servico_procedimento.nome}`);
                            formDataArquivo.append('agendamento_id', agendamento.id);
                            formDataArquivo.append('data', agora);
                            formDataArquivo.append('tipo', 'laudo');
                            formDataArquivo.append('pessoa_id', 1);
                            
                            // Verificar se tem aprovação automática
                            const aprovaAutomatico = getConfig(
                                this.state.programa_dados?.configuracoes,
                                'aprova_laudo_automatico',
                                false
                            );
                            
                            const statusAprovacao = aprovaAutomatico ? 'true' : '';
                            formDataArquivo.append('aprovado', statusAprovacao);

                            if (this.state.dadosFormularioAprovacaoColetados) {
                                formDataArquivo.append('dados_formulario_aprovacao', JSON.stringify(this.state.dadosFormularioAprovacaoColetados));
                            }

                            return api.post('/agendamentos/arquivos/', formDataArquivo, {
                                headers: { 'Content-Type': 'multipart/form-data' }
                            });
                        }
                        return Promise.resolve();
                    })
                    .then(() => {
                        if (agendamento.atendimento_kit_id) {
                            const payloadKit = {
                                data_envio_realizado: dataEnvioKit,
                                status: 'enviado',
                            };
                            return api.put(`/atendimentos/kits/${agendamento.atendimento_kit_id}/`, payloadKit);
                        }
                        return Promise.resolve();
                    })
                    .then(() => {
                        // Se for monitoria, envia o arquivo
                        if (isMonitoria && arquivoMonitoria) {
                            const formDataArquivo = new FormData();
                            formDataArquivo.append('monitoramento_pdf', arquivoMonitoria);
                            formDataArquivo.append('titulo', 'VNS Therapy');
                            formDataArquivo.append('modelo_dados_monitoramento', 'vns_therapy');
                            formDataArquivo.append('servico_dados_monitoramento', true);
                            formDataArquivo.append('atendimento_id', this.state.atendimento_id);
                            formDataArquivo.append('tipo', 'etapa');
                            formDataArquivo.append('etapa_id', this.state.etapa_id);

                            return api.post('/atendimentos/relatos/', formDataArquivo, {
                                headers: { 'Content-Type': 'multipart/form-data' }
                            });
                        }
                        return Promise.resolve();
                    })
                    .then(() => {
                        const formDataRelato = new FormData();

                        formDataRelato.append('data', dataRealizacao);
                        formDataRelato.append('etapa_id', this.state.etapa_atual.id);
                        formDataRelato.append('atendimento_id', this.state.atendimento_id);
                        formDataRelato.append('tipo', 'etapa');
                        formDataRelato.append('titulo', `Realização de ${agendamento.dados_servico_procedimento.nome}`);
                        formDataRelato.append('servico_procedimento_id', agendamento.servico_procedimento_id);
                        formDataRelato.append('ignorar_cadastro_servico', true);
                        formDataRelato.append('agendamento_id', agendamento.id);  // Branch 2

                        return api.post('/atendimentos/relatos/', formDataRelato);
                    })
                    .then(() => {
                        this.setState({ loading: false });
                        
                        const temFormulario = this.state.formularioEventoDataConfirmacao && this.state.agendamentoParaConfirmarComFormulario;
                        
                        if (temFormulario) {
                            this.setState({
                                showFormularioEventoModalConfirmacao: true,
                            });
                        } else {
                            MySwal.fire({
                                title: 'Sucesso!',
                                text: 'Realização de serviço confirmado com sucesso.',
                                icon: 'success',
                                confirmButtonColor: '#3085d6',
                            });
                        }

                        this.carregarAgendamentos(); 

                        if (this.state.showModalArquivos) {
                            this.carregaArquivosAgendamento(agendamento.id);
                        }
                    })
                    .catch((error) => {
                        this.setState({ loading: false });
                        console.error(error);
                        const errorMessage =
                            error.response && error.response.data
                                ? error.response.data.message || JSON.stringify(error.response.data) || 'Erro ao processar a solicitação.'
                                : 'Erro ao confirmar o serviço.';

                        MySwal.fire({
                            title: 'Erro!',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                        });
                    });
            }
        });
    }

    /**
     * Abre o modal de formulário dinâmico para serviços
     */
    handleEnviaCadastroFormularioDinamico = (agendamento) => {
        const temRespostas = agendamento.dados_formulario_dinamico_servicos && Object.keys(agendamento.dados_formulario_dinamico_servicos).length > 0;
        this.setState({
            showModalPersonalizadoServicos: true,
            agendamentoFormularioDinamico: agendamento,
            formularioDinamicoReadOnly: !!temRespostas,
        });
    };

    /**
     * Verifica se deve mostrar o botão de formulário dinâmico para o agendamento
     */
    deveMostrarBotaoFormularioDinamico = (agendamento) => {
        const configFormulario = agendamento?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        if (!configFormulario) return false;
        
        const showOnEtapa = configFormulario.show_on_etapa;
        const etapaAtualNome = this.state.etapa_atual?.nome;
        
        // Se não tem restrição de etapa, mostra sempre
        if (!showOnEtapa || !Array.isArray(showOnEtapa)) return true;
        
        // Verifica se a etapa atual está na lista de etapas permitidas
        return showOnEtapa.includes(etapaAtualNome);
    };

    /**
     * Retorna o título do botão de formulário dinâmico
     */
    getTituloBotaoFormularioDinamico = (agendamento) => {
        const temRespostas = agendamento.dados_formulario_dinamico_servicos && Object.keys(agendamento.dados_formulario_dinamico_servicos).length > 0;
        if (temRespostas) return 'Ver Respostas';

        const configFormulario = agendamento?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        return configFormulario?.titulo_botao || 'Formulário';
    };
    
   handleAceiteAgendamento = async (agendamento, aceite) => {
        const isAceite = !!aceite;
        const acao = aceite ? "Aceitar" : "Recusar";
        
        const swalConfig = {
            title: `${acao} agendamento?`,
            text: `Tem certeza que deseja ${acao.toLowerCase()} o agendamento #${agendamento.id}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: acao,
            cancelButtonText: "Cancelar",
            buttonsStyling: true,
            confirmButtonColor: isAceite ? "#28a745" : "#dc3545",
            cancelButtonColor: "#6c757d",
        };

        // Campo de motivo apenas na recusa
        if (!isAceite) {
            swalConfig.input = "textarea";
            swalConfig.inputPlaceholder = "Motivo da Recusa";
            swalConfig.inputValue = "";
            swalConfig.inputAttributes = { rows: 3 };
        }

        const { isConfirmed, value: observacao } = await Swal.fire(swalConfig);

        if (!isConfirmed) return;

        try {
            await api.post("/agendamentos/aceite/", {
                agendamento_id: agendamento.id,
                aceite: !!aceite,
                observacao: observacao || "",
            });

            await Swal.fire({
                icon: "success",
                title: `Agendamento ${aceite ? "aceito" : "recusado"} com sucesso!`,
                timer: 1500,
                showConfirmButton: false,
            });

            if (this.carregarAgendamentos) await this.carregarAgendamentos();
            else if (this.loadAgendamentos) await this.loadAgendamentos();
        } catch (e) {
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Erro ao processar",
                text:
                    e?.response?.data?.detail ||
                    e?.response?.data?.message ||
                    "Não foi possível concluir a operação.",
            });
        }
    };

    handleShowModalDescricao = () => {
        this.setState({ showModalDescricao: true });
    };
    
    handleCloseModalDescricao = () => {
        this.setState({ showModalDescricao: false });
    };

    handleShowModalAgendamento = (agendamento) => {
        const dataOriginal = agendamento?.data_agendamento || null;
        const medicoId = agendamento?.prestador_solicitante || null;
        this.setState({ 
            showModalAgendamento: true, 
            agendamento_selecionado: agendamento, 
            agendamento_original_data: dataOriginal, 
            reagendamentos: [], 
            agendamento_prestador_original_id: agendamento?.prestador_id || null, 
            agendamento_medico_id: medicoId, 
            agendamento_medico_nome: agendamento?.prestador_solicitante_nome || "",
            motivoSelecionado: agendamento?.motivo_id || '',
            motivoOutro: agendamento?.motivo_outro || '',
        },
            () => {
                this.getDadosMedicoSolicitante(medicoId);
                this.fetchReagendamentos( agendamento.atendimento_id, agendamento.servico_procedimento_id);
            }
        );
    };
    
    handleCloseModalAgendamento = () => {
        this.setState({ 
            showModalAgendamento: false, 
            agendamento_selecionado: [],  
            agendamento_original_data: null, 
            reagendamentos: [],
            motivoSelecionado: '',
            motivoOutro: '',
        });
    };

    handleShowModalVisualizarAgendamento = (agendamento) => {
        const medicoId = agendamento?.prestador_solicitante || null;
        this.setState({showModalAgendamento: true, agendamento_selecionado: agendamento, agendamento_prestador_original_id: agendamento?.prestador_id || null, agendamento_medico_id: medicoId, agendamento_medico_nome: agendamento?.prestador_solicitante_nome || "", }, () => {
            this.getDadosMedicoSolicitante(medicoId);
        });
    };

    handleCloseModalVisualizarAgendamento = () => {
        this.setState({ showModalVisualizarAgendamento: false, agendamento_selecionado: [] });
    };


    handleShowHistoricoAgendamentos = async (agendamento) => {
        this.setState({
            showHistoricoAgendamentosModal: true,
            historicoAgendamentosLoading: true,
            historicoAgendamentosErro: '',
            historicoAgendamentosRows: [],
            historicoAgendamentosAgendamentoId: agendamento.id,
            historicoAgendamentosPrestadoresMap: {},
        });

        try {
            const { data } = await api.get('/agendamentos/aceite/', {
                params: { agendamento_id: agendamento.id },
            });

            const payload =
                Array.isArray(data) ? data :
                Array.isArray(data?.results) ? data.results :
                Array.isArray(data?.data) ? data.data :
                (data ? [data] : []);

            const rows = payload.map(x => ({
                prestador_id: x.prestador_id ?? x.prestador?.id ?? null,
                aceite: !!x.aceite,
                data_criacao: x.data_criacao ?? x.data_aceite ?? x.created_at ?? null,
                observacao: x.observacao
            }));

            const map = {};
                if (agendamento.prestador_id && agendamento.dados_prestador?.nome) {
                map[agendamento.prestador_id] = {
                    nome: agendamento.dados_prestador.nome,
                    nome_fantasia: agendamento.dados_prestador.nome_fantasia || null,
                };
            }

            const uniqueIds = [...new Set(rows.map(r => r.prestador_id).filter(Boolean))];
            const toFetch = uniqueIds.filter(id => !map[id]);

            if (toFetch.length > 0) {
                const responses = await Promise.all(
                    toFetch.map(id => api.get(`/prestadores/${id}/`).catch(() => null))
            );

            responses.forEach((resp, i) => {
                const id = toFetch[i];
                if (resp?.data) {
                    map[id] = {
                        nome: resp.data.nome || `#${id}`,
                        nome_fantasia: resp.data.nome_fantasia || null,
                    };
                }
            });
            }

            this.setState({
            historicoAgendamentosRows: rows,
            historicoAgendamentosPrestadoresMap: map,
            historicoAgendamentosLoading: false,
            });
        } catch (e) {
            this.setState({
            historicoAgendamentosLoading: false,
            historicoAgendamentosErro:
                e?.response?.data?.detail || e?.message || 'Erro ao carregar histórico.',
            });
        }
    };

    handleCloseHistoricoAgendamentos = () => {
        this.setState({
            showHistoricoAgendamentosModal: false,
            historicoAgendamentosRows: [],
            historicoAgendamentosLoading: false,
            historicoAgendamentosErro: '',
            historicoAgendamentosAgendamentoId: null,
        });
    };

    // DESPESAS 
    handleShowDespesasAgendamentos = async (agendamento) => {
        if (!this.getProgramaConfig('agendamento.despesas', true)) {
            return;
        }
        this.setState({
            showDespesasAgendamentosModal: true,
            despesasAgendamentosLoading: true,
            despesasAgendamentosErro: '',
            despesasAgendamentosRows: [],
            despesasAgendamentosAgendamentoId: agendamento.id,
            despesasAgendamentosShowForm: false,
            despesasAgendamentosForm: { descricao: '', valor: '', data: '', despesa_categoria_id: '', categoria_outros: '', comprovanteFile: null},
            informar_km: false,
            endereco_origem: '',
            endereco_destino: '',
            km_total: '',
            motivo: '',
        });

        try {
            const [catResp, listResp] = await Promise.all([api.get('/agendamentos/despesas/categorias'), api.get('/agendamentos/despesas/', { params: { agendamento_id: agendamento.id } }),]);

            const categorias = Array.isArray(catResp.data)
            ? catResp.data
            : (Array.isArray(catResp.data?.results) ? catResp.data.results : []);

            const payload = listResp.data;
            const rows = Array.isArray(payload)
            ? payload
            : (Array.isArray(payload?.results) ? payload.results : (payload ? [payload] : []));

            this.setState({
                despesasAgendamentosCategorias: categorias,
                despesasAgendamentosRows: rows,
                despesasAgendamentosLoading: false,
            });
        } catch (e) {
            this.setState({
                despesasAgendamentosLoading: false,
                despesasAgendamentosErro:
                e?.response?.data?.detail || e?.message || 'Erro ao carregar despesas.',
            });
        }
    };

    handleCloseDespesasAgendamentos = () => {
        this.setState({
            showDespesasAgendamentosModal: false,
            despesasAgendamentosLoading: false,
            despesasAgendamentosErro: '',
            despesasAgendamentosRows: [],
            despesasAgendamentosAgendamentoId: null,
            despesasAgendamentosCategorias: [],
            despesasAgendamentosShowForm: false,
            despesasAgendamentosForm: { descricao: '', valor: '', data: '', despesa_categoria_id: '', categoria_outros: '', comprovanteFile: null},
        });
    };

    handleChangeDespesasAgendamentosForm = (e) => {
        const { name, value, files, type } = e.target;

        if (name === 'comprovante') {
            this.setState(s => ({
                despesasAgendamentosForm: { ...s.despesasAgendamentosForm, comprovanteFile: files?.[0] || null }
            }));
        } else {
            this.setState(s => ({
                despesasAgendamentosForm: { ...s.despesasAgendamentosForm, [name]: type === 'number' ? Number(value) : value }
            }));
        }
    };

    carregaCategoriasDespesas = async (inputValue) => {
        try {
            const resp = await api.get('/agendamentos/despesas/categorias', {
                params: { titulo: inputValue || '', search: inputValue || '' }
            });
            const lista = Array.isArray(resp.data) ? resp.data : (resp.data?.results || []);
            const mapped = lista.map(cat => ({
                value: String(cat.id),
                label: cat.titulo,
                slug: cat.slug || ''
            }));
            // acrescenta "Outros" no final
            return [...mapped, { value: '__outros__', label: 'Outros', slug: 'outros' }];
        } catch (err) {
            console.error('Erro ao carregar categorias de despesas:', err);
            return [{ value: '__outros__', label: 'Outros', slug: 'outros' }];
        }
    };


    handleChangeDespesasAgendamentosCategoria = (opt) => {
        const id = opt?.value || '';
        const nome = opt?.label || '';

        this.setState(s => ({
            despesasAgendamentosForm: {
            ...s.despesasAgendamentosForm,
            despesa_categoria_id: id,
            despesa_categoria_nome: nome,       
            // se não for “Outros”, zera o texto
            categoria_outros: nome.toLowerCase() === 'outros' ? s.despesasAgendamentosForm.categoria_outros : '',
            },
        }));
    };

    handleSubmitDespesaAgendamentos = async (e) => {
        e?.preventDefault?.();

        const f = this.state.despesasAgendamentosForm;
        const agendamentoId = this.state.despesasAgendamentosAgendamentoId;

        const catIsOutros =
            (f.despesa_categoria_slug || '').toLowerCase() === 'outros' ||
            (f.despesa_categoria_nome || '').toLowerCase() === 'outros' ||
            String(f.despesa_categoria_id) === '__outros__';

        Swal.fire({
            title: 'Enviando...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            const formData = new FormData();
            formData.append('descricao', f.descricao || '');
            formData.append('agendamento_id', agendamentoId);

            const valorApi = typeof formatarValorAPI === 'function'
            ? formatarValorAPI(f.valor)
            : String(f.valor || '').replace(/\./g, '').replace(',', '.');

            if (valorApi) formData.append('valor', valorApi);
            if (f.data) formData.append('data', f.data);
            if (f.comprovanteFile) formData.append('comprovante', f.comprovanteFile);

            if (catIsOutros) {
            formData.append('categoria_outros', f.categoria_outros || '');
            } else if (f.despesa_categoria_id) {
            formData.append('despesa_categoria_id', f.despesa_categoria_id);
            }

            if (f.informar_km) {
                if (f.endereco_origem) 
                    formData.append('endereco_origem', f.endereco_origem);
                if (f.endereco_destino) 
                    formData.append('endereco_destino', f.endereco_destino);
                if (f.motivo) 
                    formData.append('motivo', f.motivo);

                const kmTotal = String(f.km_total || '').replace(/\./g, '').replace(',', '.');

                if (kmTotal) 
                    formData.append('km_total', kmTotal);
            }

            await api.post('/agendamentos/despesas/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            });

            Swal.close(); // fecha o loading
            await Swal.fire({
            icon: 'success',
            title: 'Despesa cadastrada com sucesso!',
            timer: 1400,
            showConfirmButton: false,
            });

            // Recarrega a listagem
            this.setState({ despesasAgendamentosLoading: true });
            const listResp = await api.get('/agendamentos/despesas/', {
            params: { agendamento_id: agendamentoId },
            });
            const payload = listResp.data;
            const rows = Array.isArray(payload)
            ? payload
            : (Array.isArray(payload?.results) ? payload.results : (payload ? [payload] : []));

            this.setState({
            despesasAgendamentosRows: rows,
            despesasAgendamentosLoading: false,
            despesasAgendamentosShowForm: false,
            despesasAgendamentosForm: {
                descricao: '',
                valor: '',
                data: '',
                despesa_categoria_id: '',
                despesa_categoria_nome: '',
                despesa_categoria_slug: '',
                categoria_outros: '',
                comprovanteFile: null,
            },
            });

            // Atualiza o valor do agendamento somando a despesa adicionada
            const valorDespesaNum = Number(valorApi) || 0;
            if (valorDespesaNum > 0) {
                await this.atualizarValorAgendamentoComDespesa(agendamentoId, valorDespesaNum, 'adicionar');
            }

        } catch (err) {
            Swal.close(); 
            Swal.fire({
            icon: 'error',
            title: 'Erro ao cadastrar despesa',
            text: err?.response?.data?.detail || err?.response?.data?.message || err?.message || 'Verifique os campos e tente novamente.',
            });
        }
    };

    // Método para atualizar o valor do agendamento somando ou subtraindo uma despesa
    atualizarValorAgendamentoComDespesa = async (agendamentoId, valorDespesa, operacao = 'adicionar') => {
        try {
            // Busca o agendamento atual para pegar o valor
            const agendamentoResp = await api.get(`/agendamentos/${agendamentoId}/`);
            const agendamentoAtual = agendamentoResp.data;
            
            // Pega o valor atual do agendamento
            const valorAtual = Number(String(agendamentoAtual.valor || 0).replace(/[^\d.-]+/g, '').replace(',', '.')) || 0;
            
            // Calcula o novo valor baseado na operação
            let novoValor;
            if (operacao === 'adicionar') {
                novoValor = valorAtual + valorDespesa;
            } else {
                novoValor = valorAtual - valorDespesa;
            }
            
            // Garante que o valor não fique negativo
            if (novoValor < 0) novoValor = 0;

            // Atualiza o agendamento via API
            await api.put(`/agendamentos/${agendamentoId}/`, {
                valor: novoValor
            });

            // Atualiza a lista de agendamentos no state para refletir o novo valor
            this.carregaAgendamentos();

        } catch (err) {
            console.error('Erro ao atualizar valor do agendamento:', err);
            // Não exibe erro ao usuário pois a despesa já foi salva
        }
    };

    // Método para excluir uma despesa
    handleExcluirDespesa = async (despesaId) => {
        const agendamentoId = this.state.despesasAgendamentosAgendamentoId;
        
        // Encontra a despesa para pegar o valor antes de excluir
        const despesaParaExcluir = this.state.despesasAgendamentosRows.find(d => d.id === despesaId);
        const valorDespesa = despesaParaExcluir 
            ? Number(String(despesaParaExcluir.valor).replace(/[^\d.-]+/g, '').replace(',', '.')) || 0
            : 0;

        const result = await Swal.fire({
            title: 'Confirmar exclusão',
            text: 'Deseja realmente excluir esta despesa?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        Swal.fire({
            title: 'Excluindo...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            await api.delete(`/agendamentos/despesas/${despesaId}/`);

            Swal.close();
            await Swal.fire({
                icon: 'success',
                title: 'Despesa excluída com sucesso!',
                timer: 1400,
                showConfirmButton: false,
            });

            // Recarrega a listagem
            this.setState({ despesasAgendamentosLoading: true });
            const listResp = await api.get('/agendamentos/despesas/', {
                params: { agendamento_id: agendamentoId },
            });
            const payload = listResp.data;
            const rows = Array.isArray(payload)
                ? payload
                : (Array.isArray(payload?.results) ? payload.results : (payload ? [payload] : []));

            this.setState({
                despesasAgendamentosRows: rows,
                despesasAgendamentosLoading: false,
            });

            // Atualiza o valor do agendamento subtraindo a despesa excluída
            if (valorDespesa > 0) {
                await this.atualizarValorAgendamentoComDespesa(agendamentoId, valorDespesa, 'remover');
            }

        } catch (err) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Erro ao excluir despesa',
                text: err?.response?.data?.detail || err?.response?.data?.message || err?.message || 'Tente novamente.',
            });
        }
    };

    fetchReagendamentos = (atendimento_id, servico_procedimento_id) => {
        if (!atendimento_id || !servico_procedimento_id) return;

        api({ method: 'get', url: '/agendamentos/reagendamentos/', params: { atendimento_id, servico_procedimento_id }})
        .then(resp => {
            const data = Array.isArray(resp.data) ? resp.data : (resp.data?.results || []);
            this.setState({ reagendamentos: data });
        })
        .catch(err => {
            console.warn('Erro ao carregar reagendamentos:', err);
        });
    };

    processarReagendamento = async () => {
        const MySwal = withReactContent(Swal);

        const originalRaw = this.state.agendamento_original_data;
        const atualRaw = this.state.agendamento_selecionado.data_agendamento;

        const atendimentoId = this.state.agendamento_selecionado?.atendimento_id || this.state.atendimento_id;
        const servicoProcedimentoId = this.state.agendamento_selecionado?.servico_procedimento_id || this.state.servico_procedimento_id;

        if (!atendimentoId || !servicoProcedimentoId) {
            await MySwal.fire('Atenção', 'Não foi possível registrar reagendamento: faltam informações do agendamento (serviço/atendimento). Verifique os dados.', 'error');
            return false;
        }

        // Primeiro: perguntar o tipo de alteração
        const tipoAlteracao = await MySwal.fire({
            title: 'Tipo de alteração',
            text: 'Essa alteração de data é uma correção ou um reagendamento?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Reagendamento',
            cancelButtonText: 'Correção',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#6c757d',
            allowOutsideClick: false,
            reverseButtons: true
        });

        // Se fechou o modal (clicou no X)
        if (tipoAlteracao.isDismissed && tipoAlteracao.dismiss === Swal.DismissReason.close) {
            return false;
        }

        // Se for CORREÇÃO (clicou em "Correção" / cancelButton)
        if (tipoAlteracao.isDismissed && tipoAlteracao.dismiss === Swal.DismissReason.cancel) {
            // Apenas retorna true para permitir a atualização normal do agendamento
            return true;
        }

        // Se for REAGENDAMENTO (clicou em "Reagendamento" / confirmButton)
        if (tipoAlteracao.isConfirmed) {
            const result = await MySwal.fire({
                title: 'Justificativa do reagendamento',
                input: 'textarea',
                inputPlaceholder: 'Descreva o motivo do reagendamento...',
                showCancelButton: true,
                confirmButtonText: 'Enviar',
                cancelButtonText: 'Cancelar',
                customClass: {
                    title: 'swal2-title-strong',
                },
                didOpen: () => {
                    const textarea = Swal.getInput();
                    if (textarea) {
                        textarea.style.fontSize = '14px';
                    }
                },
                inputValidator: (value) => {
                    if (!value || !value.trim()) return 'A justificativa é obrigatória.';
                    return null;
                },
                allowOutsideClick: false
            });

            if (!result || !result.value) return false;

            const justificativa = result.value.trim();

            // Função para formatar data sem conversão de fuso
            const formatarDataSemFuso = (dataStr) => {
                if (!dataStr) return null;

                if (typeof dataStr === 'string' && !dataStr.endsWith('Z')) {
                    return dataStr;
                }

                const d = new Date(dataStr);
                const ano = d.getFullYear();
                const mes = String(d.getMonth() + 1).padStart(2, '0');
                const dia = String(d.getDate()).padStart(2, '0');
                const hora = String(d.getHours()).padStart(2, '0');
                const min = String(d.getMinutes()).padStart(2, '0');
                const seg = String(d.getSeconds()).padStart(2, '0');

                return `${ano}-${mes}-${dia}T${hora}:${min}:${seg}`;
            };

            const payload = {
                data_original: formatarDataSemFuso(originalRaw),
                data_reagendada: formatarDataSemFuso(atualRaw),
                atendimento_id: atendimentoId,
                servico_procedimento_id: servicoProcedimentoId,
                justificativa: justificativa
            };

            try {
                await api({
                    method: 'post',
                    url: '/agendamentos/reagendamentos/',
                    data: payload
                });

                this.fetchReagendamentos(atendimentoId, servicoProcedimentoId);
                this.setState({ agendamento_original_data: atualRaw });

                return true;
            } catch (err) {
                const msg = (err?.response?.data) ? JSON.stringify(err.response.data) : 'Erro ao registrar reagendamento. Tente novamente.';
                await MySwal.fire('Atenção', `Erro ao registrar reagendamento: ${msg}`, 'error');
                return false;
            }
        }

        return false;
    };

    handleChangeAgendamentoEdit = (eventOrValue, fieldName) => {
        // Verifica se é um evento (tem target) ou valor direto (do IMaskInput onAccept)
        const value = eventOrValue?.target ? eventOrValue.target.value : eventOrValue;
    
        this.setState(prevState => ({
            agendamento_selecionado: {
                ...prevState.agendamento_selecionado,
                [fieldName]: value
            }
        }));
    };

    handleChangeAgendamentoEditTerapia = (event) => {
        this.setState(prevState => ({
            agendamento_selecionado: {
                ...prevState.agendamento_selecionado,
                aplicacao_id: event.value
            }
        }));
    };

    buscarCep = async (cepNum) => {
        try {
            const { data } = await axios.get(`https://viacep.com.br/ws/${cepNum}/json/`);
            if (!data.erro) {
            this.setState(prev => ({
                agendamento_selecionado: {
                ...prev.agendamento_selecionado,
                // só sobrescreve se vier algo do ViaCEP
                local_endereco: data.logradouro || prev.agendamento_selecionado.local_endereco,
                local_bairro:   data.bairro     || prev.agendamento_selecionado.local_bairro,
                local_cidade:   data.localidade || prev.agendamento_selecionado.local_cidade,
                local_uf:       data.uf         || prev.agendamento_selecionado.local_uf
                },
                // se você usa helpers de validação:
                cepHelper: ''
            }));
            } else {
            this.setState({ cepHelper: 'CEP não encontrado.' });
            }
        } catch (err) {
            console.error('Erro na requisição ViaCEP:', err);
            this.setState({ cepHelper: 'Erro ao consultar CEP.' });
        }
    };

    carregaArquivosAgendamento = (agendamento_id) => {
        if (agendamento_id) {
            api.get(`/agendamentos/arquivos/?agendamento_id=${agendamento_id}`)
                .then(response => {
                    const arquivosCarregados = response.data.results.map(dados => ({
                        id: dados.id,
                        nome: dados.nome,
                        arquivo: dados.arquivo,
                        agendamento_id: dados.agendamento_id,
                        data: dados.data,
                        aprovado: dados.aprovado,
                        tipo: dados.tipo,
                        motivo_recusa: dados.motivo_recusa,
                        cadastrado_por_id: dados.cadastrado_por_id
                    }));
                    this.setState({ arquivos: arquivosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar arquivos:', error);
                    
                    let erro_msg = 'Erro ao carregar arquivos do agendamento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    consultarHistoricoLigacoes = (e) => {
        e.preventDefault();

        const { goto_hist_data_inicio, goto_hist_data_final, goto_hist_num_telefone } = this.state;

        if (!goto_hist_data_inicio || !goto_hist_data_final) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Por favor, informe um a data de início e a data final',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return;
        }        

        let params = `?data_inicio=${goto_hist_data_inicio.replaceAll("T", " ")}:00&data_fim=${goto_hist_data_final.replaceAll("T", " ")}:00&sincronizar=true`;

        if(goto_hist_num_telefone){
            params += `&num_telefone=${goto_hist_num_telefone}`;
        }
        
        this.setState({
            loading: true
        });

        api({
            method: 'GET',
            url: '/gotoconnect/historico_ligacoes/'+params,
        }).then(response => {
            this.setState({
                loading: false,
                lista_historico_ligacoes: response.data.results
            })
        })
        .catch(error => {
            let erro_msg = "Não foi possível consultar o histórico";            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;     
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'monitoramento_pdf'){
                        erro_msg += "<br /><br />" + value;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'warning',
                showCloseButton: true,
                title: 'Atenção!',
                html: erro_msg,
            })    
            
            this.setState({
                loading: false,
            })
        });
    }

    saveArquivo = (e) => {
    e.preventDefault();

    const formData = new FormData();
    const MySwal = withReactContent(Swal);
    const { arquivo_upload } = this.state;

    if (!this.state.arquivo_nome) {
        Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Por favor, informe um nome para o arquivo',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
        });
        return;
    }

    if (!this.state.arquivo_tipo && this.state.tipo_arquivo_agendamento != 'monitoramento') {
        Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Por favor, selecione um tipo do arquivo',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
        });
        return;
    }

    this.setState({ loading: true });

    if (!this.state.arquivo_id && this.state.tipo_arquivo_agendamento != 'monitoramento') {
        if (!arquivo_upload) {
        this.setState({ loading: false });
        MySwal.fire({
            icon: 'error',
            showCloseButton: true,
            title: "Atenção",
            html: "Forneça um arquivo para enviar"
        });
        return false;
        }
    }

    let url = '';
    let metodo = '';
    const agendamento_id = this.state.agendamento_selecionado.id;

    const isCorrecaoRecusa =
        this.state.arquivo_id &&
        this.state.arquivo_aprovado === false &&
        this.state.arquivo_upload;

    if (this.state.tipo_arquivo_agendamento === 'monitoramento') {
        url = '/atendimentos/relatos/';
        metodo = 'POST';

        formData.append('monitoramento_pdf', this.state.arquivo_upload);
        formData.append('titulo', 'VNS Therapy');
        formData.append('modelo_dados_monitoramento', 'vns_therapy');
        formData.append('servico_dados_monitoramento', true);
        formData.append('atendimento_id', this.state.atendimento_id);
        formData.append('tipo', 'etapa');
        formData.append('etapa_id', this.state.etapa_id);
    } else {
        if (!this.state.arquivo_id || isCorrecaoRecusa) {
        url = '/agendamentos/arquivos/';
        metodo = 'post';

        const nomeFinal = isCorrecaoRecusa
            ? `${this.state.arquivo_nome} (Correção)`
            : this.state.arquivo_nome;

        const agora = moment().tz("America/Sao_Paulo");
        const dataHoraAtualFormatada = agora.format("YYYY-MM-DD HH:mm:ss");

        formData.append('arquivo', this.state.arquivo_upload);
        formData.append('nome', nomeFinal);
        formData.append('agendamento_id', agendamento_id);
        formData.append('data', dataHoraAtualFormatada);
        formData.append('tipo', this.state.arquivo_tipo);
        formData.append('pessoa_id', 1);

        formData.append('aprovado', this.state.arquivo_aprovado);
        } else {
        url = `/agendamentos/arquivos/${this.state.arquivo_id}/`;
        metodo = 'put';

        formData.append('nome', this.state.arquivo_nome);
        formData.append('tipo', this.state.arquivo_tipo);

        formData.append('aprovado', this.state.arquivo_aprovado);

        if (this.state.arquivo_upload) {
            formData.append('arquivo', this.state.arquivo_upload);
        }
        }
    }

    api({ method: metodo, url: url, data: formData })
        .then(response => {
        let text_msg = '';

        if (this.state.tipo_arquivo_agendamento == 'monitoramento') {
            text_msg = 'Arquivo de monitoramento enviado com sucesso';
        } else {
            if (isCorrecaoRecusa) {
            text_msg = 'Correção enviada com sucesso';
            } else if (metodo === 'post') {
            text_msg = 'Arquivo enviado com sucesso';
            } else {
            text_msg = 'Dados do arquivo atualizados com sucesso';
            }
        }

        MySwal.fire({
            title: 'Sucesso',
            icon: 'success',
            html: text_msg,
            showCloseButton: true,
        });

        if (this.state.tipo_arquivo_agendamento != 'monitoramento') {
            this.carregaArquivosAgendamento(agendamento_id);
            this.carregarAgendamentos();
        } else {
            this.carregarAgendamentos();
        }

        if (isCorrecaoRecusa) {
            this.carregarAgendamentos();
        }

        this.handleCloseModalArquivosEdit();
        this.setState({ loading: false });
        })
        .catch(error => {
        let erro_msg = "Não foi possível enviar o arquivo";

        if (error.response && error.response.status === 500) {
            erro_msg = 'Servidor indisponível no momento';
        } else if (error.response && error.response.data && error.response.data.detail) {
            erro_msg = error.response.data.detail;
        } else if (error.response && error.response.status === 400) {
            const campos = error.response.data;
            for (let key in campos) {
            var value = campos[key];
            if (key === 'monitoramento_pdf') {
                erro_msg += "<br /><br />" + value;
            }
            }
        }

        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'warning',
            showCloseButton: true,
            title: 'Atenção!',
            html: erro_msg,
        });

        this.setState({ loading: false });
        })
        .finally(() => {
        this.setState({ isSaving: false });
        });
    };


    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo_enviado = e.target.files[0];
            
            this.setState({ arquivo_upload: arquivo_enviado });
        }
    };

    excluirArquivo = (idArquivo) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir arquivo?',
            text: "Tem certeza que deseja excluir este arquivo? Você não poderá reverter isso!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
    
                api.delete(`/agendamentos/arquivos/${idArquivo}/`)
                    .then(response => {
                        MySwal.fire(
                            'Excluído!',
                            'O arquivo foi excluído com sucesso.',
                            'success'
                        );
                        this.setState(prevState => ({
                            arquivos: prevState.arquivos.filter(arquivo => arquivo.id !== idArquivo),
                            loading: false
                        }));
                    })
                    .catch(error => {

                        MySwal.fire(
                            'Erro!',
                            'Houve um erro ao tentar excluir o arquivo. Por favor, tente novamente.',
                            'error'
                        );
                        this.setState({ loading: false });
                    });
            }
        });
    }

    handleShowModalArquivos = (agendamento) => {
        this.carregaArquivosAgendamento(agendamento.id);
        this.setState({ showModalArquivos: true, agendamento_selecionado: agendamento });
    };

    handleShowModalArquivoMonitoramento = (agendamento) => {
        this.setState({ showModalArquivosEdit: true, tipo_arquivo_agendamento: 'monitoramento', agendamento_selecionado: agendamento, arquivo_nome: 'Arquivo de Monitoramento' });
    };
    
    handleCloseModalArquivos = () => {
        this.setState({ showModalArquivos: false });
    };

    handleShowModalArquivosEdit = (agendamento) => {
        this.handleCloseModalArquivos();
        this.setState({ showModalArquivosEdit: true, agendamento_selecionado: agendamento });
    };
    
    handleCloseModalArquivosEdit = () => {
        if(this.state.tipo_arquivo_agendamento == 'monitoramento'){
            this.setState({ showModalArquivosEdit: false, arquivo_id: '', arquivo_nome: '', arquivo_tipo: '', arquivo_atual: '', arquivo_aprovado: '', tipo_arquivo_agendamento: '' });
        }
        else{
            this.setState({ showModalArquivosEdit: false, arquivo_id: '', arquivo_nome: '', arquivo_tipo: '', arquivo_atual: '', arquivo_aprovado: '' });
            this.handleShowModalArquivos(this.state.agendamento_selecionado);
        }
    };

    handleShowModalAnotacoes = (agendamento) => {
        this.setState({ showModalAnotacoes: true, agendamento_selecionado: agendamento });
    };

    handleCloseModalAnotacoes = () => {
        this.setState({ showModalAnotacoes: false, agendamento_selecionado: {} });
    };

    editarArquivo = (arquivo) => {
        this.setState({
            arquivo_id: arquivo.id,
            arquivo_nome: arquivo.nome,
            arquivo_tipo: arquivo.tipo,
            arquivo_aprovado: arquivo.aprovado
        }, () => {
            this.handleShowModalArquivosEdit(this.state.agendamento_selecionado)
        })
    }

    renderAlertasMascaraPaciente = () => {
        const { pacientes_campos, extra_valores_beneficiario_list, dados_usuario } = this.state;
        const camposComMascara = [];

        // Verifica pacientes_campos
        if (pacientes_campos && pacientes_campos.length > 0) {
            pacientes_campos.forEach(campo => {
                if (campo.mascara) {
                    camposComMascara.push({
                        id: campo.id,
                        nome: campo.nome,
                        mascara: campo.mascara,
                        slug: campo.slug,
                        tipo: 'paciente_campo'
                    });
                }
            });
        }

        const tipoUsuario = dados_usuario?.tipo_usuario || '';
        const prestadorCategoria = dados_usuario?.prestador_categoria || '';
        const alertas = [];

        camposComMascara.forEach(campo => {
            // Suporta novo formato: [valor_campo=null.then(mensagemalerta=XXX)|can_view=YYY]
            // e formato legado sem brackets
            const regexBracketed = /\[valor_campo=null\.then\(mensagemalerta=(.+?)\)([^\]]*)\]/i;
            const regexLegacy = /valor_campo=null\.then\(mensagemalerta=(.+?)\)/i;

            let mensagemDeAlerta = null;
            let directiveStr = '';

            const matchBracketed = campo.mascara.match(regexBracketed);
            if (matchBracketed) {
                mensagemDeAlerta = matchBracketed[1];
                directiveStr = matchBracketed[2] || ''; // tudo depois do ) e dentro do ]
            } else {
                const matchLegacy = campo.mascara.match(regexLegacy);
                if (matchLegacy) {
                    mensagemDeAlerta = matchLegacy[1];
                    directiveStr = campo.mascara; // pode haver can_view fora dos brackets (legado)
                }
            }

            if (mensagemDeAlerta) {
                // Verifica can_view dentro do bloco ou na máscara geral (legado)
                const regexCanView = /can_view=\[([^\]]+)\]|can_view=(\w+)/i;
                const canViewMatch = directiveStr.match(regexCanView);
                if (canViewMatch) {
                    const perfilListStr = canViewMatch[1] || canViewMatch[2];
                    const perfisPermitidos = perfilListStr.split(',').map(p => p.trim());
                    const podeVer = perfisPermitidos.includes(tipoUsuario) || perfisPermitidos.includes(prestadorCategoria);
                    if (!podeVer) return;
                }

                let valorCampo = null;

                if (extra_valores_beneficiario_list) {
                    const extraValor = extra_valores_beneficiario_list.find(ev => ev.campo_slug === campo.slug);
                    valorCampo = extraValor ? extraValor.valor : null;
                }

                // Se o valor estiver vazio ou nulo, incluímos o alerta
                if (valorCampo === null || valorCampo === undefined || valorCampo.toString().trim() === '') {
                    alertas.push(mensagemDeAlerta);
                }
            }
        });

        if (alertas.length > 0) {
            return (
                <div className="mb-3">
                    {alertas.map((msg, index) => (
                        <Alert key={index} variant="danger" className="d-flex align-items-center">
                            <FaExclamationTriangle className="me-2" size={20} />
                            <div>{msg}</div>
                        </Alert>
                    ))}
                </div>
            );
        }
        return null;
    };

    handleShowModalRelatosEdit = (tipo='registro-etapa') => {
        this.setState({ 
            etapa_relato: this.state.etapa_atual,     
            modal_relato_tipo: tipo,
            etapa_atendimento_status: tipo === 'cancelar-etapa' ? 'cancelado' : ''         
        }, () => {
            const { tituloExibicao, descricaoExibicao } = this.getTituloDescricaoEtapa(
                this.state.etapa_relato,
                this.state.doenca_id
            );
            this.setState({
                opcaoModalRelato: 'cadastrar_etapa',
                showModalRelatosEdit: true, 
                loading: true, 
                loadingCamposFormulario: true,
                camposFormulario: [],
                etapa_titulo_exibicao: tituloExibicao,
                etapa_descricao_exibicao: descricaoExibicao,    
            });

            // Aqui fazemos a chamada para a API para buscar os campos do formulário
            api.get(`/formularios/campos/?formulario_id=${this.state.formulario_id}&status=1&limit=500`)
            .then(response => {
                // Atualizamos o estado com os campos recebidos
                this.setState({ camposFormulario: response.data.results, loadingCamposFormulario: false });
            })
            .catch(error => {
                console.error('Erro ao carregar campos do formulário:', error);
                Sentry.captureException('Erro ao carregar campos do formulário:', error);
            });

            //consultar os servicos relacionados a etapa
            this.setState({ servicos_etapa: [], relato_servico_procedimento_id: '', relato_servico_procedimento_nome: '' });
            if(this.state.etapa_atual.servicos_relacionados) {
                api.get(`/programas/etapas/servicos/?etapa_id=${this.state.etapa_relato.id}&prestador_id=${this.state.laboratorio_id}`)
                .then(response => {
                    // Atualizamos o estado com os campos recebidos
                    this.setState({ servicos_etapa: response.data.results, loading: false });
                })
                .catch(error => {
                    console.error('Erro ao carregar serviços da etapa:', error);
                    Sentry.captureException('Erro ao carregar serviços da etapa:', error);
    
                    this.setState({ loading: false });
                });
            } else {
                this.setState({ loading: false });
            }
        });        
    };

    handleRegerarTermo = async () => {
        Swal.fire({
            title: 'Regerar Termo?',
            text: "Tem certeza que deseja regerar o termo?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#eb4961',
            confirmButtonText: 'Sim, regerar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.post(`/atendimentos/regerar_termos/`, {
                    atendimento_id: this.state.atendimento_id,
                    tipo: "programa"
                })
                .then(response => {
                    Swal.fire({
                        title: 'Sucesso!',
                        text: 'Termo regerado com sucesso.',
                        icon: 'success'
                    });
                })
                .catch(error => {
                    console.error('Erro ao regerar termo:', error);
                    Sentry.captureException('Erro ao regerar termo:', error);

                    Swal.fire({
                        title: 'Erro!',
                        text: 'Erro ao regerar termo.',
                        icon: 'error'
                    });
                });
            }
        });
    }

    handleRegerarTermoLaboratorio = async () => {
        const result = await Swal.fire({
            title: 'Gerar termo novamente?',
            text: "Tem certeza que deseja gerar o termo novamente?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#eb4961',
            confirmButtonText: 'Sim, gerar novamente!',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        this.setState({ regerandoTermoLaboratorio: true });

        try {
            await api.post(`/atendimentos/regerar_termos/`, {
                atendimento_id: this.state.atendimento_id,
                tipo: "laboratorio"
            });
            window.location.reload();
        } catch (error) {
            console.error('Erro ao regerar termo do laboratório:', error);
            Sentry.captureException('Erro ao regerar termo do laboratório:', error);

            const mensagem = error?.response?.data?.detail
                || error?.response?.data?.message
                || (typeof error?.response?.data === 'string' ? error.response.data : '')
                || error?.message
                || 'Erro ao gerar termo novamente.';

            this.setState({ regerandoTermoLaboratorio: false });

            Swal.fire({
                title: 'Erro!',
                text: mensagem,
                icon: 'error'
            });
        }
    }

    carregaLaboratorios = async (inputValue = "") => {
        //if(this.state.programa_dados.id){
            try {
                const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.programa_dados.id}&nome=${inputValue}&categoria=laboratorio_diagnostico`);
                const opcoes = response.data.results.map(laboratorio => ({
                    value: laboratorio.id,
                    label: laboratorio.nome
                }));
                return opcoes;
            } catch (error) {
                console.error('Erro ao carregar laboratórios:', error);
                return [];
            }
        //}
    };

    carregaMultiProfissional = async (inputValue = "") => {
        //if(this.state.programa_dados.id){
            try {
                const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.programa_dados.id}&nome=${inputValue}&categoria=multiprofissionais`);
                const opcoes = response.data.results.map(profissional => ({
                    value: profissional.id,
                    label: profissional.nome
                }));
                return opcoes;
            } catch (error) {
                console.error('Erro ao carregar laboratórios:', error);
                return [];
            }
        //}
    };
    
    handleShowModalRelatosAdicionar = (etapa) => {
        this.setState({
            etapa_relato: etapa,
            modal_relato_tipo: 'registro-etapa'
        }, () => {
            const { tituloExibicao, descricaoExibicao } = this.getTituloDescricaoEtapa(
                this.state.etapa_relato,
                this.state.doenca_id
            );
            this.setState({
                opcaoModalRelato: 'novo_relato',
                showModalRelatosEdit: true, 
                loading: true, 
                camposFormulario: [],  
                etapa_titulo_exibicao: tituloExibicao,
                etapa_descricao_exibicao: descricaoExibicao,                
            });

            api.get(`/formularios/campos/?formulario_id=${etapa.formulario_id}&status=1&limit=500`)
            .then(response => {
                this.setState({ camposFormulario: response.data.results });
            })
            .catch(error => {
                console.error('Erro ao carregar campos do formulário:', error);
                Sentry.captureException('Erro ao carregar campos do formulário:', error);
            });

            this.setState({ servicos_etapa: [], relato_servico_procedimento_id: '', relato_servico_procedimento_nome: '' });
            if(etapa.servicos_relacionados) {
            api.get(`/programas/etapas/servicos/?etapa_id=${this.state.etapa_relato.id}&prestador_id=${this.state.laboratorio_id}`)
                .then(response => {
                    this.setState({ servicos_etapa: response.data.results, loading: false });
                })
                .catch(error => {
                    console.error('Erro ao carregar serviços da etapa:', error);
                    Sentry.captureException('Erro ao carregar serviços da etapa:', error);

                    this.setState({ loading: false });
                });
            } else {
                this.setState({ loading: false });
            }
        });        
    };
    
    handleCloseModalRelatosEdit = () => {
        this._submittingRelato = false;
        this.setState({ showModalRelatosEdit: false, valoresCampos: {} });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        
        // Guard contra duplo submit (usa flag de instância pois setState é assíncrono)
        if (this._submittingRelato || this.state.loading) return;

        let etapa_termo = (this.state.etapa_atual.etapa_termo && !this.state.optin_data) ? true : false;
        const campoOdcAmostra = this.state.camposFormulario.find(c => c.slug === CAMPO_SLUG_ODC_AMOSTRA_ACEITA);
        const valorOdcAmostra = campoOdcAmostra ? this.state.valoresCampos[campoOdcAmostra.id] : null;
        const isRecoleta = valorOdcAmostra && valorOdcAmostra.toString().toLowerCase() === 'recoleta';

        if(this.state.opcaoModalRelato == 'novo_relato' || etapa_termo || isRecoleta){
            this.continuarEnvioFormularioRelato();
        }
        else {
            this.enviarFormularioRelato();
        }              
    };

    enviarFormularioRelato = () => {
        Swal.fire({
            title: 'Finalizar etapa?',
            text: "Deseja finalizar esta etapa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#eb4961',
            confirmButtonText: 'Sim, finalizar!',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ finalizar_etapa: true }, () => {
                    this.continuarEnvioFormularioRelato();
                });                
            } else {
                this.setState({ finalizar_etapa: false });
            }
        });
    };
    
    continuarEnvioFormularioRelato = () => {
    
        // Guard contra duplo submit
        if (this._submittingRelato) return;
        this._submittingRelato = true;
        this.setState({loading: true});

        // Verifica se a etapa requer campos do paciente preenchidos
        const erroValidacao = this.validaCamposPacienteEtapa();
        
        if (erroValidacao) {
            this._submittingRelato = false;
            this.setState({ loading: false });
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: erroValidacao,
            });
            return;
        }
        
        // Verifica se a etapa requer campos do atendimento preenchidos
        const erroValidacaoAtendimento = this.validaCamposAtendimentoEtapa();
        
        if (erroValidacaoAtendimento) {
            this._submittingRelato = false;
            this.setState({ loading: false });
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: erroValidacaoAtendimento,
            });
            return;
        }
        
        // Primeiro, salvar o relato
        const dataHoraAtualFormatada = getDataAtual();
        const { etapa_relato, atendimento_id, valoresCampos, camposFormulario, camposOutro } = this.state;

        let formData = new FormData();
        formData.append('data', dataHoraAtualFormatada);
        formData.append('etapa_id', etapa_relato.id);
        formData.append('atendimento_id', atendimento_id);
        formData.append('tipo', 'etapa');

        //servico
        if(this.state.relato_servico_procedimento_id){
            formData.append('servico_procedimento_id', this.state.relato_servico_procedimento_id);
        }

        if(this.state.relato_tipo_paciente){
            formData.append('tipo_paciente', this.state.relato_tipo_paciente);
        }

        //valores do relato
        let cont = 1;
        let cancelar_voltar_etapa = false;
        let list_valores = []

        Object.entries(valoresCampos).forEach(([campoId, valor]) => {
            const campo = camposFormulario.find(c => c.id === parseInt(campoId));

            if (campo && (campo.tipo === "voltar_etapa" || campo.tipo === "cancela_atendimento") && valor === true) {
                cancelar_voltar_etapa = true;
            }

            let dados = {
                "valor": "",
                "file_param": "",
                "formulario_campo_id": campoId,
                "repeater": []
            }

            if (valor instanceof File) {
                let file_param = `valor_arquivo_${cont}`

                dados["file_param"] = file_param

                formData.append(file_param, valor);
            }
            else if (valor instanceof Boolean) {
                dados["valor"] = valor ? true : false
            }
            else if (typeof valor === 'string' && ['outro', 'outros'].includes(valor.trim().toLowerCase()) && camposOutro && camposOutro[campoId]) {
                dados["valor"] = `Outro - ${camposOutro[campoId]}`;
            }
            else {
                dados["valor"] = valor
            }

            list_valores.push(dados)

            cont++;
        });

        if(list_valores.length > 0){
            formData.append('valores', JSON.stringify(list_valores))
        }

        if (cancelar_voltar_etapa) {
            this.setState({ opcaoModalRelato: 'altera_etapa' });
        }

        const tipo_recorrencia = this.state.finalizar_recorrencia ? 'encerrar' : this.state.etapa_relato.tipo_recorrencia

        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

        // Verificar se existe uma próxima etapa
        const proximaEtapa = indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1 
        ? this.state.etapas_atendimento[indiceEtapaAtual + 1] 
        : null;
        
        let atendimento_finalizado = false;

        if(!proximaEtapa && this.state.finalizar_etapa === true) {
            atendimento_finalizado = true;
        }

        if(tipo_recorrencia) {
            if(tipo_recorrencia !== 'encerrar') {
                atendimento_finalizado = false;
            }
        }

        //Verifica se etapa tem envio de mensagem no término da etapa
        if(this.state.opcaoModalRelato == 'cadastrar_etapa' && this.state.etapa_relato.midias_contato && this.state.etapa_relato.momento_envio == 'termino' && (this.state.etapa_relato.tipo_envio == 'automatico' || this.state.etapa_relato.tipo_envio == 'ambos')) {
            formData.append('mensageria_etapa', JSON.stringify({"etapa_id": this.state.etapa_relato.id}))
        }
        

        //verifica se etapa tem envio de mensagem no término da etapa
        let mensagem_inicial_enviada = false;
        
        //finaliza o atendimento
        if(this.state.opcaoModalRelato == 'cadastrar_etapa' && atendimento_finalizado) {

            let payload_atendimento = {
                finalizado: true,
            }

            if(this.state.etapa_atual.status_finalizacao_etapa_id) {
                payload_atendimento['programa_status_id'] = this.state.etapa_atual.status_finalizacao_etapa_id;
            }

            formData.append('atendimento_updt', JSON.stringify(payload_atendimento));

            //Salva status da etapa como concluído
            if(this.state.etapa_atendimento_id) {
                formData.append('atendimento_etapa_updt', JSON.stringify({
                    "etapa_atendimento_id": this.state.etapa_atendimento_id,
                    "etapa_id": this.state.etapa_relato.id,
                    "status": 'concluido',
                    "tipo_recorrencia": tipo_recorrencia
                }))
            }            
        }
        else if (this.state.opcaoModalRelato == 'cadastrar_etapa' && this.state.finalizar_etapa === true && atendimento_finalizado === false) {
            //Salva status da etapa como concluído
            if(this.state.etapa_atendimento_id) {
                let etapaUpdt = {
                    etapa_id: this.state.etapa_relato.id,
                    etapa_atendimento_id: this.state.etapa_atendimento_id,
                    status: 'concluido',
                    tipo_recorrencia: tipo_recorrencia,
                };

                // só adiciona se existir próxima etapa
                if (proximaEtapa) {
                    etapaUpdt.proxima_etapa_id = proximaEtapa.id;
                }

                formData.append('atendimento_etapa_updt', JSON.stringify(etapaUpdt));

                //Verifica se a próxima etapa tem envio de mensagem no início da etapa
                if(proximaEtapa && proximaEtapa.midias_contato && proximaEtapa.momento_envio == 'inicio' && (proximaEtapa.tipo_envio == 'automatico' || proximaEtapa.tipo_envio == 'ambos')) {
                    formData.append('mensageria_etapa', JSON.stringify({"etapa_id": proximaEtapa.id}));
                    mensagem_inicial_enviada = true;
                }           
                     
            }
            
            //verifica se etapa atual altera status do atendimento ao ser finalizado
            if(this.state.etapa_atual.status_finalizacao_etapa_id) {
                formData.append('atendimento_updt', JSON.stringify({"programa_status_id": this.state.etapa_atual.status_finalizacao_etapa_id}))
            }
        } else {
            //verifica se etapa atual altera status do atendimento ao ser finalizado
            if(this.state.etapa_atual.status_finalizacao_etapa_id) {
                //formData.append('atendimento_updt', JSON.stringify({"programa_status_id": this.state.etapa_atual.status_finalizacao_etapa_id}))
            }
        }      
        
        //exibe loading visual para o usuário
        Swal.fire({
            title: 'Registrando etapa...',
            text: 'Aguarde enquanto os dados são enviados.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        //envia a requisição
        api.post('/atendimentos/relatos/', formData)
        .then(response => {
            this._submittingRelato = false;
            if(this.state.opcaoModalRelato == 'cadastrar_etapa' && atendimento_finalizado) {
                //sucesso
                this.setState({loading:false})
                Swal.fire({
                    title: this.state.etapa_relato.titulo_sucesso_finalizacao || 'Sucesso!',
                    text: this.state.etapa_relato.mensagem_sucesso_finalizacao === 'aviso_solicitacao_exame'
                        ? 'Caso o paciente não atenda aos critérios de elegibilidade, um profissional do programa entrará em contato.'
                        : (this.state.etapa_relato.mensagem_sucesso_finalizacao || 'Etapa concluída com sucesso.'),
                    icon: 'success'
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            } 
            else if (this.state.opcaoModalRelato == 'cadastrar_etapa' && this.state.finalizar_etapa === true && atendimento_finalizado === false) {

                //Verifica se deve mandar mensageria pra etapa inicial
                if(!mensagem_inicial_enviada && proximaEtapa && proximaEtapa.midias_contato && proximaEtapa.momento_envio == 'inicio' && (proximaEtapa.tipo_envio == 'automatico' || proximaEtapa.tipo_envio == 'ambos')) {
                    
                    const dadosMensageria = {
                        etapa_id: proximaEtapa.id,
                        atendimento_id: this.state.atendimento_id
                    }

                    api({
                        method: 'post',
                        url: '/mensageria/etapa/',
                        data: dadosMensageria
                    })
                    .then(responseMensageriaEtapa => {
                        
                    })
                    .catch(error => {
                        console.log("Mensagem da etapa não enviada", error);
                    });
                }

                //sucesso
                this.setState({loading:false})
                Swal.fire({
                    title: this.state.etapa_relato.titulo_sucesso_finalizacao || 'Sucesso!',
                    text: this.state.etapa_relato.mensagem_sucesso_finalizacao === 'aviso_solicitacao_exame'
                        ? 'Caso o paciente não atenda aos critérios de elegibilidade, um profissional do programa entrará em contato.'
                        : (this.state.etapa_relato.mensagem_sucesso_finalizacao || 'Etapa concluída com sucesso.'),
                    icon: 'success'
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            }
            else {
                this.setState({loading:false})
                Swal.fire({
                    title: this.state.etapa_relato.configuracoes?.titulo_sucesso_ocorrencia || 'Sucesso!',
                    text: this.state.etapa_relato.configuracoes?.mensagem_sucesso_ocorrencia || 'Ocorrência cadastrada com sucesso.',
                    icon: 'success'
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        this.handleCloseModalRelatosEdit(); // Chamada para fechar o modal
    
                        //refresh na pagina
                        if(this.state.opcaoModalRelato == 'novo_relato'){
                            // Chamada à API para carregar relatos da etapa
                            api.get(`/atendimentos/relatos/?etapa_id=${etapa_relato.id}&atendimento_id=${this.state.atendimento_id}&limit=500`).then(response => {
                                this.setState(prevState => ({
                                    relatosPorEtapa: {
                                        ...prevState.relatosPorEtapa,
                                        [etapa_relato.id]: { carregando: false, dados: response.data.results }
                                    }
                                }));
                            });
                        } else {
                            if(this.state.opcaoModalRelato == 'altera_etapa') {
                                window.location.reload();
                            }
                        }
                    }
                });
            }
        })
        .catch(error => {
            this._submittingRelato = false;
            this.setState({loading:false})
            console.error('Erro ao salvar o relato:', error);
            Swal.fire('Erro!', 'Não foi possível salvar o relato.', 'error');
            //Sentry.captureException('Erro ao salvar o relato:', error);
        });
    };

    handleLaboratorioVinculadoChange = (e, laboratorioId, laboratorioNome) => {
        const isChecked = e.target.checked
        let obj = this.state.laboratorios.find(o => o.id === laboratorioId);        

        //verifica se tem alerta ("Sem Alerta" é tratado como equivalente a vazio/nulo)
        if(obj.alerta_atendimento && obj.alerta_atendimento !== 'Sem Alerta' && isChecked){
            Swal.fire({
                icon: 'info',
                showCloseButton: true,
                title: 'Atenção',
                html: obj.alerta_atendimento
            })
        }

        this.setState({
            laboratorio_id: laboratorioId,
            laboratorio_nome: laboratorioNome,
            is_creating: true
        });
    }

    handleChangeAtendimentoPaciente = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState({ 
                cliente_id: event.value, 
                cliente_nome: event.label,
                programa_id: '',  // Limpa o ID do programa selecionado
                programa_nome: '',  // Limpa o nome do programa selecionado
            });
        } 
        else if (fieldName == 'programa_id') {
            this.setState({ 
                programa_id: event.value, 
                programa_nome: event.label,
            });
        } 
        else if(fieldName == 'plano_id') {
            this.setState({ plano_id: event.value, plano_nome: event.label });
        } 
        else {
            const { name, value } = event.target;

            if(name == 'data_nascimento') {
                const currentDate = new Date();
                const selectedDate = new Date(value);
                const maxDate = new Date();
                const minDate = new Date();
                minDate.setFullYear(maxDate.getFullYear() - 120);
    
                let dataNascimentoHelper = '';
    
                if (selectedDate > maxDate) {
                    dataNascimentoHelper = 'Data de nascimento não pode ser no futuro.';
                } else if (selectedDate < minDate) {
                    dataNascimentoHelper = 'Data de nascimento inválida.';
                }
    
                this.setState({
                    [name]: value,
                    dataNascimentoHelper
                });
            } else if(name == 'cuidador_data_nascimento') {
                const currentDate = new Date();
                const selectedDate = new Date(value);
                const maxDate = new Date();
                const minDate = new Date();
                minDate.setFullYear(maxDate.getFullYear() - 120);
    
                let cuidadorDataNascimentoHelper = '';
    
                if (selectedDate > maxDate) {
                    cuidadorDataNascimentoHelper = 'Data de nascimento não pode ser no futuro.';
                } else if (selectedDate < minDate) {
                    cuidadorDataNascimentoHelper = 'Data de nascimento inválida.';
                }
    
                this.setState({
                    [name]: value,
                    cuidadorDataNascimentoHelper
                });
            } else {
                this.setState({ [name]: value });
            }

            
        }
    };

    carregarClientes = async (inputValue) => {
        if (inputValue.length < 3) return [];
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: cliente.dados_pessoa.nome_fantasia ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})` : cliente.dados_pessoa.nome
            }));
            //this.setState({ opcoesClientes: opcoes });

            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregarProgramasCliente = async (inputValue, cliente_id) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas do cliente:', error);
            return [];
        }
    };

    carregarProdutosPrograma = async (inputValue) => {
        if (this.state.showModalBotao) {
            const dados_usuario = getCurrentUser();
            const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;
            try {
                const response = await api.get(`/programas/produtos/?produto=${inputValue}&programa=${programa_id}&status=1`);
                
                // Extrair nomes únicos
                const nomesUnicos = Array.from(
                    new Set(
                        response.data.results.map(produto => produto.dados_produto.nome.split(' - ')[0]) // Pega apenas o nome antes do " - "
                    )
                );
    
                // Mapear para o formato esperado
                const opcoes = nomesUnicos.map(nome => ({
                    value: nome,
                    label: nome
                }));
    
                return opcoes;
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
                return [];
            }
        }
    };

    handleChangeCampoAsync = (id, valor) => {
        const novoValor = valor && valor.value ? valor.value : valor; // Verifica se é um objeto e pega o `value`, ou usa o valor diretamente
    
        this.setState(prevState => ({
            valoresCampos: {
                ...prevState.valoresCampos,
                [id]: novoValor,
            },
        }));
    };

    handleChangeCampo = (id, value) => {
        // Verifica se o valor é um evento (para campos de arquivo, por exemplo)
        const isEvent = value && value.target;

        let finalValue = value;

        // Se for um evento e um campo de arquivo, captura o arquivo; caso contrário, usa o valor diretamente
        if (isEvent && value.target.type === "file") {
            finalValue = value.target.files[0]; // Pode ser undefined se nenhum arquivo for selecionado
        }
        else if(isEvent && (value.target.type === "checkbox" || value.target.type === "radio")){
            finalValue = value.target.checked
        } 
        else if (isEvent) {
            finalValue = value.target.value;
        }
        
        this.setState(prevState => {
            const novosCamposOutro = { ...prevState.camposOutro };

            // só checa "Outro" para campos de texto/select (não file/checkbox/radio)
            const shouldCheckOutro = !isEvent || (
                isEvent &&
                value.target.type !== "file" &&
                value.target.type !== "checkbox" &&
                value.target.type !== "radio"
            );
    
            if (shouldCheckOutro) {
                // normaliza finalValue para uma lista de tokens (suporta múltiplo como "a, b, Outro")
                let tokens = [];
                if (Array.isArray(finalValue)) {
                    tokens = finalValue;
                } else if (typeof finalValue === "string") {
                    tokens = finalValue.split(",");
                } else if (finalValue == null) {
                    tokens = [];
                } else {
                    tokens = [String(finalValue)];
                }

                const selecionouOutro = tokens
                    .map(t => (t ?? "").toString().trim().toLowerCase())
                    .some(t => ['outro', 'outros'].includes(t));

                if (selecionouOutro) {
                    if (!(id in novosCamposOutro)) novosCamposOutro[id] = "";
                } else {
                    delete novosCamposOutro[id];
                }
            }

            return {
                valoresCampos: {
                    ...prevState.valoresCampos,
                    [id]: finalValue,
                },
                camposOutro: novosCamposOutro,
            };
        });
    };

    handleChangeCampoCheckSim = (id, value) => {
        let finalValue = value.target.checked ? 'sim' : 'nao';
        
        this.setState(prevState => {
            return {
                valoresCampos: {
                    ...prevState.valoresCampos,
                    [id]: finalValue,
                },
            };
        });
    };

    abrirModalHistoricoLigacoes = (id) => {
        this.setState({
            showModalConsultaHistoricoLigacoes: true,
            goto_hist_campo_id: id,
        });
    };

    handleCloseModalconsultarHistoricoLigacoes = () => {
        // Se estava aberto a partir do SweetAlert de aceite, restaura o z-index
        if (this.state.goto_hist_campo_id === '__aceite_termo_telefone__') {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) swalContainer.style.zIndex = '';
        }

        this.setState({ 
            showModalConsultaHistoricoLigacoes: false,
        });
    };

    handleChangeOutro = (id, valor) => {
        this.setState(prevState => ({
            camposOutro: {
                ...prevState.camposOutro,
                [id]: valor,
            },
        }));
    };

    handleChangeCheckbox = () => {
        const { finalizar_recorrencia } = this.state;

        this.setState({
            finalizar_recorrencia: !finalizar_recorrencia,
        });
    };

    handleChangeCampoAtendExtra = (id, value, marcado = null) => {
        // Verifica se o valor é um evento (para campos de arquivo, por exemplo)
        const isEvent = value && value.target;

        let finalValue = value;

        if (marcado !== null) {
            this.setState(prevState => {
                const valoresAnteriores = prevState.valoresCamposExtra[id]
                    ? prevState.valoresCamposExtra[id].split(',')
                    : [];
    
                let novosValores;
                if (marcado) {
                    // Adiciona o valor se ainda não estiver presente
                    novosValores = [...new Set([...valoresAnteriores, value])];
                } else {
                    // Remove o valor
                    novosValores = valoresAnteriores.filter((v) => v !== value);
                }
    
                return {
                    valoresCamposExtra: {
                        ...prevState.valoresCamposExtra,
                        [id]: novosValores.join(','),
                    },
                };
            });
            return;
        }

        // Se for um evento e um campo de arquivo, captura o arquivo; caso contrário, usa o valor diretamente
        if (isEvent && value.target.type === "file") {
            finalValue = value.target.files[0]; // Pode ser undefined se nenhum arquivo for selecionado
        }
        else if(isEvent && (value.target.type === "checkbox" || value.target.type === "radio")){
            finalValue = value.target.checked
        } 
        else if (isEvent) {
            finalValue = value.target.value;
        }

        // Atualiza o estado
        /*this.setState(prevState => ({
            valoresCamposExtra: {
                ...prevState.valoresCamposExtra,
                [id]: finalValue,
            },
        }));*/

        this.setState(prevState => {
            const novosCamposOutroExtra = { ...prevState.camposOutrosExtra };
    
            if (!isEvent || (isEvent && value.target.type != "file" && value.target.type != "checkbox" && value.target.type != "radio")) {
                if (['outro', 'outros'].includes(finalValue.toLowerCase())) {
                    // Se "Outro/Outros" foi selecionado, adicione ao estado
                    novosCamposOutroExtra[id] = '';
                } else {
                    // Caso contrário, remova do estado
                    delete novosCamposOutroExtra[id];
                }
            }

            return {
                valoresCamposExtra: {
                    ...prevState.valoresCamposExtra,
                    [id]: finalValue,
                },
                camposOutrosExtra: novosCamposOutroExtra,
            };
        });
    };

    handleChangeOutroExtra = (id, valor) => {
        this.setState(prevState => ({
            camposOutrosExtra: {
                ...prevState.camposOutrosExtra,
                [id]: valor,
            },
        }));
    };
    
        handleChangeCampoPacienteExtra = (id, value) => {
        const isEvent = value && value.target;
        let finalValue = value;
    
        if (isEvent) {
            const target = value.target;
    
            if (target.type === "file") {
                finalValue = target.files[0];
            }
    
            //Checkbox
            else if (target.type === "checkbox") {
                const valoresAnteriores = this.state.valoresCamposExtraPaciente?.[id]
                    ? this.state.valoresCamposExtraPaciente[id].split(',')
                    : [];
    
                const valorAtual = target.value;
    
                let novosValores;
                if (target.checked) {
                    // Adiciona valor se ainda não existe
                    novosValores = [...valoresAnteriores, valorAtual].filter((v, i, arr) => arr.indexOf(v) === i);
                } else {
                    // Remove valor
                    novosValores = valoresAnteriores.filter(v => v !== valorAtual);
                }
    
                finalValue = novosValores.join(',');
            }
    
            else if (target.type === "radio") {
                finalValue = target.value;
            }
    
            else {
                finalValue = target.value;
            }
        }
    
        // Atualiza o estado
        this.setState(prevState => ({
            valoresCamposExtraPaciente: {
                ...prevState.valoresCamposExtraPaciente,
                [id]: finalValue,
            },
        }));
    };
    
    handleSelecaoFinalizaEtapa = (campoId, valor) => {
        this.setState(prevState => ({
            selecaoFinalizaEtapa: {
                ...prevState.selecaoFinalizaEtapa,
                [campoId]: valor
            }
        }));
    }

    obterValorCampo = (idCampo) => {
        return this.state.valoresCampos[idCampo];
    };

    handleShowModalPaciente = () => {
        //console.log("Novo paciente")
        const dados_programa = {
            programa_id: this.state.programa_id,
            programa_nome: this.state.programa_nome,
            programa_uuid: this.state.programa_uuid,
            exige_cpf_atendimento: this.state.programa_dados.exige_cpf_atendimento
        }
        const dados_cliente = {
            cliente_id: this.state.cliente_id,
            cliente_nome: this.state.cliente_nome
        }
        this.setState({ showModalPaciente: true, dados_programa: dados_programa, dados_cliente: dados_cliente });
    };

    handleShowModalMedico = () => {
        const dados_programa = {
            programa_id: this.state.programa_id,
            programa_nome: this.state.programa_nome,
            programa_uuid: this.state.programa_uuid
        }
        const dados_cliente = {
            cliente_id: this.state.cliente_id,
            cliente_nome: this.state.cliente_nome
        }
        this.setState({ showModalMedico: true, dados_programa: dados_programa, dados_cliente: dados_cliente });
    };

    handleCloseModalMedico = () => {
        this.setState({ showModalMedico: false });
    };

    handleCloseModalPaciente = () => {
        this.setState({ 
            showModalPaciente: false,
            cpf: '',
            nome: "",
            data_nascimento: "",
            email: "",
            telefone: "",
            endereco_telefone: "",
            celular: "",
            genero: "NI",
            cep: '',
            nome_local: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
            tipo_cuidador: '',
            cuidador_nome: '',
            cuidador_cpf: '',
            cuidador_data_nascimento: '',
            cuidador_endereco: '',
            cuidador_celular: '',
            cuidador_telefone: '',
            cuidador_email: '',
        });
    };

    handleShowModalAtendimentoPaciente = () => {
        this.setState({
            showModalAtendimentoPaciente: true
        });
    };
    
    
    handleCloseModalAtendimentoPaciente = () => {
        this.setState({ 
            showModalAtendimentoPaciente: false,
        });
    };
    
    enviaAtendimentoPaciente = (e) => {
        e.preventDefault();

        let dados_usuario = getCurrentUser();

        const MySwal = withReactContent(Swal);

        if(this.state.programa_dados.doenca_principal_id && this.state.programa_dados.doenca_principal_id > 0 && this.state.programa_dados.validacao_doenca == 'paciente' && this.state.programa_dados.exige_confirmacao_diagnostico && this.state.confirmacao_diagnostico === false) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário confirmar o diagnóstico do paciente para prosseguir</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        }

        //Valida idade do paciente
        const idade = this.calcularIdade(this.state.data_nascimento);
        // Validação com base em idade mínima e máxima, caso estejam configuradas
        if (this.state.idade_minima > 0 || this.state.idade_maxima > 0) {
            if (
                (this.state.idade_minima > 0 && idade < this.state.idade_minima) ||
                (this.state.idade_maxima > 0 && idade > this.state.idade_maxima)
            ) {
                const mensagem = `O programa permite cadastro de pacientes ${
                    this.state.idade_minima > 0 ? `a partir de ${this.state.idade_minima} anos` : ''
                } ${
                    this.state.idade_maxima > 0
                        ? `${this.state.idade_minima > 0 ? 'e' : ''} até ${this.state.idade_maxima} anos`
                        : ''
                }.`;
        
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>{mensagem}</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }
        } else {
            if (this.state.programa_dados.id && this.state.programa_dados.permite_menor_idade === false && idade < 18) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>O programa não permite cadastro de pacientes menores de 18 anos</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }
        }

        if(!this.state.genero) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>Gênero é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        }

        if(!this.state.cpf_nao_informado && !this.state.cpf) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>O CPF é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,  
            });
            return; // Interrompe a execução do resto da função
        }

        //Valida cuidador
        const vinculoCuidador = (!this.state.vinculo_cuidador) ? false : this.state.vinculo_cuidador;

        if(idade < 18 && !vinculoCuidador) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>O vínculo de cuidador é obrigatório para pacientes menores de 18 anos</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        if(vinculoCuidador) {

            if(!this.state.tipo_cuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário selecionar o tipo de cuidador</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }

            if(!this.state.cuidador_nome) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar o nome do cuidador</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }

            if(!this.state.cuidador_cpf) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar o CPF do cuidador</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }
        
            if(this.state.cuidador_data_nascimento) {
                const idadeCuidador = this.calcularIdade(this.state.cuidador_data_nascimento);
                if (idadeCuidador < 18) {
                    MySwal.fire({
                        title: 'Atenção!',
                        html: <p>O cuidador não pode ser menor de 18 anos</p>,
                        icon: 'error',
                        showCloseButton: true,
                    });
                    return; // Interrompe a execução do resto da função
                }
            }
        }

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: '',
            cpfHelper: '',
            emailHelper: '',
            telefoneHelper: '',
            enderecoTelefoneHelper: '',
            celularHelper: '',
        });

        //vererifica se é edição ou adição
        const url = (this.state.paciente_id) ? '/pessoas/beneficiarios/'+this.state.paciente_id+'/?cliente_id=' + this.state.cliente_id : '/pessoas/beneficiarios/'
        const metodo = (this.state.paciente_id) ? 'put' : 'post'
        
        formData.append('nome', this.state.nome);
        if(!this.state.cpf_nao_informado) {
            formData.append('cpf', this.state.cpf || '');
        } else {
            formData.append('cpf', '');
        }
        formData.append('data_nascimento', this.state.data_nascimento);
        formData.append('genero', this.state.genero);
        formData.append('email', this.state.email || '');
        formData.append('telefone', this.state.telefone);
        formData.append('endereco_telefone', this.state.endereco_telefone);
        formData.append('celular', this.state.celular);
        formData.append('cep', this.state.cep);
        formData.append('endereco', this.state.endereco);
        formData.append('numero', this.state.numero);
        formData.append('complemento', this.state.complemento);
        formData.append('bairro', this.state.bairro);
        formData.append('cidade', this.state.cidade);
        formData.append('uf', this.state.uf);
        formData.append('plano_saude', this.state.plano_saude);
        formData.append('numero_carteirinha', this.state.numero_carteirinha);

        if(this.state.nome_local) {
            formData.append('nome_local', this.state.nome_local);
        }

        const cliente_id  = dados_usuario['ambiente_cliente_id'] || this.state.cliente_id;
        const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;

        
        formData.append('cliente_id', cliente_id);
        formData.append('programa_id', programa_id);    
        
        //formData.append('plano_id', this.state.plano_id);

        //cuidador
        formData.append('vinculo_cuidador', vinculoCuidador);
        if(vinculoCuidador) {
            formData.append('tipo_cuidador', this.state.tipo_cuidador);
            formData.append('cuidador_nome', this.state.cuidador_nome);
            formData.append('cuidador_cpf', this.state.cuidador_cpf);

            if(this.state.cuidador_data_nascimento) {
                formData.append('cuidador_data_nascimento', this.state.cuidador_data_nascimento);
            }
            
            if(this.state.cuidador_endereco) {
                formData.append('cuidador_endereco', this.state.cuidador_endereco);
            }

            if(this.state.cuidador_celular) {
                formData.append('cuidador_celular', this.state.cuidador_celular);
            }

            if(this.state.cuidador_telefone) {
                formData.append('cuidador_telefone', this.state.cuidador_telefone);
            }

            if(this.state.cuidador_email) {
                formData.append('cuidador_email', this.state.cuidador_email);
            }
        }

        //campos extras do atendimento
        let cont = 1;
        Object.entries(this.state.valoresCamposExtraPaciente).forEach(([campoId, valor]) => {
            if (valor instanceof File) {
                formData.append(`extra_valor_arquivo_${cont}`, valor);
            } 
            else if (typeof valor === 'boolean') {
                formData.append(`extra_valor_valor_${cont}`, valor ? 'true' : 'false');
            }
            else {
                formData.append(`extra_valor_valor_${cont}`, valor);
            }

            formData.append(`extra_valor_campo_id_${cont}`, campoId);
            cont++;
        });
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.paciente_id) ? 'Paciente atualizado com sucesso' : 'Paciente cadastrado com sucesso';

            if(this.state.paciente_id){
                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        if(this.state.paciente_id) {
                            window.location.reload();
                        }
                    }
                });
            }
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.paciente_id){
                this.props.router.navigate("/atendimentos");
            }
        })
        .catch(error => {
            let erro_msg = "Erro ao cadastrar paciente:<br />";              

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento, tente novamente dentro de alguns minutos';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        erro_msg += "<br />Nome: " + value;
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'data_nascimento'){
                        erro_msg += "<br />Data de Nascimento: " + value;
                        this.setState({ dataNascimentoHelper: value })
                    }
                    if(key === 'cpf'){
                        erro_msg += "<br />CPF: " + value;
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        erro_msg += "<br />CPF: " + value;
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'email'){
                        erro_msg += "<br />E-mail: " + value;
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'telefone'){
                        erro_msg += "<br />Telefone: " + value;
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'endereco_telefone'){
                        erro_msg += "<br />Telefone de Contato: " + value;
                        this.setState({ enderecoTelefoneHelper: value })
                    }
                    if(key === 'celular'){
                        erro_msg += "<br />Celular: " + value;
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'cep'){
                        erro_msg += "<br />CEP: " + value;
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'endereco'){
                        erro_msg += "<br />Endereço: " + value;
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'nome_local'){
                        erro_msg += "<br />Local de Coleta: " + value;
                        this.setState({ nomeLocalHelper: value })
                    }
                    if(key === 'numero'){
                        erro_msg += "<br />Número: " + value;
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        erro_msg += "<br />Complemento: " + value;
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        erro_msg += "<br />Bairro: " + value;
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cidade'){
                        erro_msg += "<br />Cidade: " + value;
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'uf'){
                        erro_msg += "<br />Estado: " + value;
                        this.setState({ ufHelper: value })
                    }
                    if(key === 'tipo_cuidador'){
                        erro_msg += "<br />Parentesco do Cuidador: " + value;
                    }
                    if(key === 'cuidador_nome'){
                        erro_msg += "<br />Nome do Cuidador: " + value;
                    }
                    if(key === 'cuidador_cpf'){
                        erro_msg += "<br />CPF do Cuidador: " + value;
                    }
                    if(key === 'cuidador_data_nascimento'){
                        erro_msg += "<br />Data de Nascimento do Cuidador: " + value;
                    }
                    if(key === 'cuidador_endereco'){
                        erro_msg += "<br />Endereço do Cuidador: " + value;
                    }
                    if(key === 'cuidador_celular'){
                        erro_msg += "<br />Celular do Cuidador: " + value;
                    }
                    if(key === 'cuidador_telefone'){
                        erro_msg += "<br />Telefone do Cuidador: " + value;
                    }
                    if(key === 'cuidador_email'){
                        erro_msg += "<br />E-mail do Cuidador: " + value;
                    }
                    
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            })   
            
            this.setState({
                loading: false,
            })
        });
    };

    enviaPaciente = (e) => {
        e.preventDefault();

        let dados_usuario = getCurrentUser();

        const MySwal = withReactContent(Swal);

        let hipotese_diagnostica_id = 0;

        if(this.state.programa_dados.doenca_principal_id && this.state.programa_dados.validacao_doenca == 'paciente' && this.state.programa_dados.doenca_principal_id > 0 && this.state.programa_dados.exige_confirmacao_diagnostico && this.state.confirmacao_diagnostico === false) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>É necessário confirmar o diagnóstico do paciente para prosseguir</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        } else {
            if(this.state.programa_dados.validacao_doenca == 'atendimento') {
                hipotese_diagnostica_id = this.state.doenca_id;
            } else {
                hipotese_diagnostica_id = this.state.programa_dados.doenca_principal_id;
            }
        }
        
        if(this.state.programa_dados.exige_cpf_atendimento && !this.state.cpf) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>CPF é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        }

        //Valida idade do paciente
        const idade = this.calcularIdade(this.state.data_nascimento);
        if (this.state.idade_minima > 0 || this.state.idade_maxima > 0) {
            if (
                (this.state.idade_minima > 0 && idade < this.state.idade_minima) ||
                (this.state.idade_maxima > 0 && idade > this.state.idade_maxima)
            ) {
                const mensagem = `O programa permite cadastro de pacientes ${
                    this.state.idade_minima > 0 ? `a partir de ${this.state.idade_minima} anos` : ''
                } ${
                    this.state.idade_maxima > 0
                        ? `${this.state.idade_minima > 0 ? 'e' : ''} até ${this.state.idade_maxima} anos`
                        : ''
                }.`;
        
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>{mensagem}</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }
        } else {
            if (this.state.programa_dados.id && this.state.programa_dados.permite_menor_idade === false && idade < 18) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>O programa não permite cadastro de pacientes menores de 18 anos</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }
        }

        if(!this.state.genero) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>Gênero é obrigatório</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return; // Interrompe a execução do resto da função
        }

        //Valida cuidador
        const vinculoCuidador = (!this.state.vinculo_cuidador) ? false : this.state.vinculo_cuidador;

        if(idade < 18 && !vinculoCuidador) {
            MySwal.fire({
                title: 'Atenção!',
                html: <p>O vínculo de cuidador é obrigatório para pacientes menores de 18 anos</p>,
                icon: 'error',
                showCloseButton: true,
            });
            return;
        }

        if(vinculoCuidador) {

            if(!this.state.tipo_cuidador) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário selecionar o tipo de cuidador</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }

            if(!this.state.cuidador_nome) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar o nome do cuidador</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }

            if(!this.state.cuidador_cpf) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar o CPF do cuidador</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }

            /*if(!this.state.cuidador_data_nascimento) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>É necessário informar a data de nascimento do cuidador</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }*/

            const idadeCuidador = this.calcularIdade(this.state.cuidador_data_nascimento);
            if (idadeCuidador < 18) {
                MySwal.fire({
                    title: 'Atenção!',
                    html: <p>O cuidador não pode ser menor de 18 anos</p>,
                    icon: 'error',
                    showCloseButton: true,
                });
                return; // Interrompe a execução do resto da função
            }
        }

        const formData = new FormData();
        

        this.setState({
            loading: true
        });

        const url = '/pessoas/beneficiarios/'
        const metodo = 'post'

        formData.append('nome', this.state.nome);
        if(!this.state.cpf_nao_informado) {
            formData.append('cpf', this.state.cpf);
        } else {
            formData.append('cpf', '');
        }
        formData.append('data_nascimento', this.state.data_nascimento);
        formData.append('genero', this.state.genero);
        formData.append('email', this.state.email);
        formData.append('telefone', this.state.telefone);
        formData.append('endereco_telefone', this.state.endereco_telefone);
        formData.append('celular', this.state.celular);
        formData.append('cep', this.state.cep);
        formData.append('endereco', this.state.endereco);
        formData.append('numero', this.state.numero);
        formData.append('complemento', this.state.complemento);
        formData.append('bairro', this.state.bairro);
        formData.append('cidade', this.state.cidade);
        formData.append('uf', this.state.uf);

        if(this.state.nome_local) {
            formData.append('nome_local', this.state.nome_local);
        }

        if(dados_usuario['ambiente_cliente_id'] > 0) {
            formData.append('cliente_id', dados_usuario['ambiente_cliente_id']);
        } else {
            formData.append('cliente_id', this.state.cliente_id);
        }

        if(dados_usuario['ambiente_programa_id'] > 0) {
            formData.append('programa_id', dados_usuario['ambiente_programa_id']);
        } else {
            formData.append('programa_id', this.state.programa_id);
        }

        //Cuidador
        formData.append('vinculo_cuidador', vinculoCuidador);
        if(vinculoCuidador) {
            formData.append('tipo_cuidador', this.state.tipo_cuidador);
            formData.append('cuidador_nome', this.state.cuidador_nome);
            formData.append('cuidador_cpf', this.state.cuidador_cpf);
            formData.append('cuidador_data_nascimento', this.state.cuidador_data_nascimento);

            if(this.state.cuidador_endereco) {
                formData.append('cuidador_endereco', this.state.cuidador_endereco);
            }

            if(this.state.cuidador_celular) {
                formData.append('cuidador_celular', this.state.cuidador_celular);
            }

            if(this.state.cuidador_telefone) {
                formData.append('cuidador_telefone', this.state.cuidador_telefone);
            }

            if(this.state.cuidador_email) {
                formData.append('cuidador_email', this.state.cuidador_email);
            }
        }

        //campos extras do atendimento
        let cont = 1;
        Object.entries(this.state.valoresCamposExtraPaciente).forEach(([campoId, valor]) => {
            if (valor instanceof File) {
                formData.append(`extra_valor_arquivo_${cont}`, valor);
            } 
            else if (valor instanceof Boolean) {
                formData.append(`extra_valor_valor_${cont}`, valor ? true : false);
            }
            else {
                formData.append(`extra_valor_valor_${cont}`, valor);
            }

            formData.append(`extra_valor_campo_id_${cont}`, campoId);
            cont++;
        });
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(response => {
            
            const paciente_id = response.data.id;

            //Salva Hipótese Diagnóstica do Paciente
            if(hipotese_diagnostica_id > 0) {
                const dadosDoenca = {
                    beneficiario_id: paciente_id,
                    doenca_id: hipotese_diagnostica_id,
                    tipo_doenca: 'doenca_alvo'
                };

                api({
                    method: 'post',
                    url: '/pessoas/beneficiarios/doencas/',
                    data: dadosDoenca,
                })
                .then(responseDoenca => {
                    console.log("Hipótese diagnóstica atrelada ao paciente")
                })
                .catch(error => {
                    console.log("Erro ao atrelar hipótese diagnóstica ao paciente")
                    //Sentry.captureException("Erro ao atrelar hipótese diagnóstica ao paciente");
                });
            }

            //Relaciona o médico ao paciente
            const medicoId = (dados_usuario['prestador_id'] > 0 && (dados_usuario['prestador_categoria'] == 'medicos' || dados_usuario['prestador_categoria'] == 'multiprofissionais')) ? dados_usuario['prestador_id'] : this.state.medico_id;

            if(medicoId) {
                const dadosMedico = {
                    beneficiario_id: paciente_id,
                    prestador_id: medicoId,
                };
                api({
                    method: 'post',
                    url: '/pessoas/beneficiarios/medicos/',
                    data: dadosMedico,
                })
                .then(responseMedico => {
                    const MySwal = withReactContent(Swal)
                    const textSwal = 'Paciente cadastrado com sucesso';
        
                    MySwal.fire({
                        title: <p>{textSwal}</p>,
                        icon: 'success',
                        showCloseButton: true,
                    })
                    
                    this.setState({
                        loading: false,
                        beneficiario_id: paciente_id,
                        beneficiario_nome: this.state.nome 
                    })

                    //consulta os laboratorios relacionados ao usuario
                    this.carregaLaboratoriosMedicoRelacao(medicoId)
                    
                    //Fecha Modal
                    this.handleCloseModalPaciente();        
                })
                .catch(errorMedico => {
                    let erro_msg = 'Paciente cadastrado, porém não foi possível vincular o médico ao paciente. Por favor, contate a administração da plataforma.';   
                    let content = '';         
        
                    if(errorMedico.response && errorMedico.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento';
                    }
                    
                    const MySwal = withReactContent(Swal)
                    MySwal.fire({
                        icon: 'error',
                        showCloseButton: true,
                        title: <p>{erro_msg}</p>,
                        html: content,
                    })

                    this.setState({
                        loading: false,
                    })

                    //Sentry.captureException(erro_msg);
                });
            } else {
                const MySwal = withReactContent(Swal)
                const textSwal = 'Paciente cadastrado com sucesso';
    
                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })
                
                this.setState({
                    loading: false,
                    beneficiario_id: paciente_id,
                    beneficiario_nome: this.state.nome 
                })
                
                //Fecha Modal
                this.handleCloseModalPaciente();
            } 
        })
        .catch(error => {
            let erro_msg = "Erro ao cadastrar paciente:<br />";            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento, atualize a página e tente novamente dentro de alguns isntantes';
            }
            else {
                const campos = error.response.data;                
                
                console.log("Erro cadastrar paciente");
                //console.log(campos);

                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    //console.log(key + " = " + value);

                    if(key === 'nome'){
                        erro_msg += "<br />Nome: " + value;
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'data_nascimento'){
                        erro_msg += "<br />Data de Nascimento: " + value;
                        this.setState({ dataNascimentoHelper: value })
                    }
                    if(key === 'email'){
                        erro_msg += "<br />E-mail: " + value;
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'cpf'){
                        erro_msg += "<br />CPF: " + value;
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        erro_msg += "<br />CPF: " + value;
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'telefone'){
                        erro_msg += "<br />Telefone: " + value;
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'endereco_telefone'){
                        erro_msg += "<br />Telefone de contato: " + value;
                        this.setState({ enderecoTelefoneHelper: value })
                    }
                    if(key === 'celular'){
                        erro_msg += "<br />Celular: " + value;
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'cep'){
                        erro_msg += "<br />CEP: " + value;
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'endereco'){
                        erro_msg += "<br />Endereço: " + value;
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'nome_local'){
                        erro_msg += "<br />Local de Coleta: " + value;
                        this.setState({ nomeLocalHelper: value })
                    }
                    if(key === 'numero'){
                        erro_msg += "<br />Número: " + value;
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        erro_msg += "<br />Complemento: " + value;
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        erro_msg += "<br />Bairro: " + value;
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cidade'){
                        erro_msg += "<br />Cidade: " + value;
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'uf'){
                        erro_msg += "<br />Estado: " + value;
                        this.setState({ ufHelper: value })
                    }
                    if(key === 'genero'){
                        erro_msg += "<br />Gênero: " + value;
                    }
                    if(key === 'tipo_cuidador'){
                        erro_msg += "<br />Parentesco do Cuidador: " + value;
                    }
                    if(key === 'cuidador_nome'){
                        erro_msg += "<br />Nome do Cuidador: " + value;
                    }
                    if(key === 'cuidador_cpf'){
                        erro_msg += "<br />CPF do Cuidador: " + value;
                    }
                    if(key === 'cuidador_data_nascimento'){
                        erro_msg += "<br />Data de Nascimento do Cuidador: " + value;
                    }
                    if(key === 'cuidador_endereco'){
                        erro_msg += "<br />Endereço do Cuidador: " + value;
                    }
                    if(key === 'cuidador_celular'){
                        erro_msg += "<br />Celular do Cuidador: " + value;
                    }
                    if(key === 'cuidador_telefone'){
                        erro_msg += "<br />Telefone do Cuidador: " + value;
                    }
                    if(key === 'cuidador_email'){
                        erro_msg += "<br />E-mail do Cuidador: " + value;
                    }
                }
            }

            
            this.setState({
                loading: false,
            })

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            }) 

            //Sentry.captureException(erro_msg);
        });
    };

    // Função para calcular idade
    calcularIdade = 
    (dataNascimento) => {
        let nascimento;

        if (typeof dataNascimento === 'string') {
            const dataOnly = dataNascimento.split('T')[0];

            if (dataOnly.includes('/')) {
                const [dia, mes, ano] = dataOnly.split('/');
                nascimento = new Date(+ano, +mes - 1, +dia);
            } else if (dataOnly.includes('-')) {
                const [ano, mes, dia] = dataOnly.split('-');
                nascimento = new Date(+ano, +mes - 1, +dia);
            } else {
                nascimento = new Date(dataNascimento);
            }
        } else {
            // já é Date ou timestamp
            nascimento = new Date(dataNascimento);
        }

        const hoje = new Date();
        let idade = hoje.getFullYear() - nascimento.getFullYear();
        const m = hoje.getMonth() - nascimento.getMonth();

        if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
            idade--;
        }
        return idade;
    }

    handleToggleSolicitarAceiteRecusa = (e) => {
        this.setState({ solicitarAceiteRecusa: e.target.checked });
    };

    handleCheckboxEndereco = (e) => {
        const checked = e.target.checked;
        this.setState({ informarLocalRealizacao: checked });

        if (!checked) {
            this.setState({
                local_nome: '',
                local_cep: '',
                local_endereco: '',
                local_numero: '',
                local_complemento: '',
                local_cidade: '',
                local_uf: '',
            });
        }
    };

    onChangeCep(e) {
        const cep = e.target.value;
        this.setState({ cep: cep });
        this.setState({ local_cep: cep });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            endereco: res.data.logradouro,
                            complemento: res.data.complemento,
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf,
                            local_endereco: res.data.logradouro,
                            local_cidade: res.data.localidade,
                            local_uf: res.data.uf
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                        console.log("CEP não encontrado.");
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                    //Sentry.captureException("Erro na requisição:", error);
                });
        }
    }

    onChangeEndereco(e) {
        this.setState({ local_endereco: e.target.value });
    }
        
    onChangeNumero(e) {
        this.setState({ local_numero: e.target.value });
    }
    
    onChangeComplemento(e) {
        this.setState({ local_complemento: e.target.value });
    }
    
    onChangeNome(e) {
        this.setState({ local_nome: e.target.value });
    }
    
    onChangeCidade(e) {
        this.setState({ local_cidade: e.target.value });
    }
    
    onChangeUF(e) {
        this.setState({ local_uf: e.target.value });
        console.log("U Alterado = ");
        console.log(this.state.local_uf);
    }

    handlePasteCep(e) {
        const cep = e.clipboardData.getData('Text');
        this.setState({ cep: cep });

        //if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
        axios.get(`https://viacep.com.br/ws/${cep}/json/`)
            .then(res => {
                if (!res.data.erro) {
                    this.setState({
                        endereco: res.data.logradouro,
                        complemento: res.data.complemento,
                        bairro: res.data.bairro,
                        cidade: res.data.localidade,
                        uf: res.data.uf
                    });
                } else {
                    // Tratar o caso de CEP não encontrado
                    console.log("CEP não encontrado.");
                }
            })
            .catch(error => {
                // Tratar erro na requisição
                console.error("Erro na requisição:", error);
            });
        //}
    }

    substituiVariaveis(texto) {
        const { beneficiario_nome, atendimento_id, uuid, medico_nome } = this.state;
        const url_sistema = window.location.hostname;
        return texto
            .replace('{nome_paciente}', beneficiario_nome)
            .replace('{nome_medico}', medico_nome)
            .replace('{link_atendimento}', `https://aditus.vercel.app/atendimentos/edit/${uuid}/`)
            .replace('{link_termo_programa}', `https://aditus.vercel.app/termos/aceite/${uuid}/`);
    }

    atualizarStatusEtapa = (e) => {
       
        this.setState({
            loading: true
        });

        const url = '/atendimentos/etapas/' + this.state.etapa_atendimento_id + '/';
        const metodo = 'put'

        const dadosStatus = {
            atendimento_id: this.state.atendimento_id,
            etapa_id: this.state.etapa_atual.id,
            status: this.state.etapa_atendimento_status,
        }
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: dadosStatus
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = 'Status da etapa atualizado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    window.location.reload();
                }
            });
            
            this.setState({
                loading: false
            })
        })
        .catch(error => {
            let erro_msg = "Houve um erro ao atualizar o status da etapa\n\n";            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                erro_msg += campos;
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                showCloseButton: true,
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })

            //Sentry.captureException(erro_msg);
        });
    };

    cancelarAtendimento= (e) => {
        

        if(!this.state.tipo_cancelamento) {
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção!',
                showCloseButton: true,
                html: "Selecione o tipo de cancelamento",
            })

            return false;
        }

        if(this.state.tipo_cancelamento == 'somente_etapa' && !this.state.etapa_voltar) {
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção!',
                showCloseButton: true,
                html: "Selecione uma etapa para voltar o atendimento",
            })

            return false;
        }

        if(!this.state.motivo_cancelamento) {
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção!',
                showCloseButton: true,
                html: "Informe o motivo do cancelamento",
            })

            return false;
        }

        

        const dados = {
            atendimento_id: this.state.atendimento_id,
            motivo_cancelamento: this.state.motivo_cancelamento,
        }

        if(this.state.etapa_voltar){
            dados['etapa_id_voltar'] = this.state.etapa_voltar
        }

        this.setState({
            loading: true
        });
        
        //envia para api
        api({
            method: 'POST',
            url: `/atendimentos/cancelar/${this.state.tipo_cancelamento}/`,
            data: dados
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = this.state.tipo_cancelamento == 'somente_etapa' ? 'Etapa do atendimento cancelada com sucesso' : 'Atendimento cancelado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    window.location.reload();
                }
            });
            
            this.setState({
                loading: false
            })
        })
        .catch(error => {
            let erro_msg = "Houve um erro ao cancelar o atendimento\n\n";            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                erro_msg += campos;
            }

            Sentry.captureException(erro_msg);

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                showCloseButton: true,
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    enviarMensagem = (e) => {
       
        this.setState({
            loading: true
        });

        const url = '/mensageria/etapa/'
        const metodo = 'post'

        const dadosMensageria = {
            atendimento_id: this.state.atendimento_id,
            etapa_id: this.state.etapa_atual.id,
            mensagem: this.substituiVariaveis(this.state.etapa_atual.conteudo_mensagem)
        }
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: dadosMensageria
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = 'Mensagem enviada com suscesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false
            })
        })
        .catch(error => {
            let erro_msg = "Houve um erro ao enviar mensagem\n\n";            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                erro_msg += campos;
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                showCloseButton: true,
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })

            //Sentry.captureException(erro_msg);
        });
    };

    //Reenvia os termos para apciente
    handleReenviarTermo = (event) => {
        //console.log(this.state.etapa_atual);

        event.preventDefault();
        Swal.fire({
            title: 'Deseja realmente enviar o termo para o paciente?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, enviar',
            cancelButtonText: 'Não, cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                this.setState({
                    loading: true,
                })

                //Pega a etapa do termo
                const indiceEtapaTermo = this.state.etapas_atendimento.findIndex(etapa => etapa.etapa_termo === true);

                const etapaTermo = this.state.etapas_atendimento[indiceEtapaTermo];

                const dadosMensageria = {
                    atendimento_id: this.state.atendimento_id,
                    etapa_id: etapaTermo.id,
                };
    
                // Envia para API
                api({
                    method: 'post',
                    url: '/mensageria/etapa/',
                    data: dadosMensageria
                })
                .then(responseMensageriaEtapa => {
                    this.setState({
                        loading: false,
                    })
                    console.log("Mensagem da etapa enviada");
                    Swal.fire('Sucesso', 'Termo enviado com sucesso!', 'success');
                })
                .catch(error => {
                    this.setState({
                        loading: false,
                    })
                    console.log("Mensagem da etapa não enviada", error);

                    Swal.fire('Erro', 'Falha ao enviar o termo. Tente novamente.', 'error');
                    //Sentry.captureException("Mensagem da etapa não enviada");
                });
            }
        });
    }


    //Reenvia os termos do laboratório
    handleReenviarTermoLaboratorio = (event) => {
        event.preventDefault();
        Swal.fire({
            title: 'Como deseja prosseguir?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Reenviar Termo Atual',
            denyButtonText: 'Gerar Novo Termo e Enviar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#252f4a',
            denyButtonColor: '#3cc172',
            cancelButtonColor: '#aaa',
        }).then((result) => {
            if (result.isConfirmed || result.isDenied) {

                this.setState({
                    loading: true,
                })
    
                const dados = {
                    atendimento_id: this.state.atendimento_id
                };
    
                // Adiciona regerar_termo: true se o botão de 'Gerar novo termo' foi clicado
                if (result.isDenied) {
                    dados.regerar_termo = true;
                }
    
                // Envia para API
                api({
                    method: 'post',
                    url: '/atendimentos/assinatura/',
                    data: dados
                })
                .then(response => {
                    console.log("Termo enviado");
                    Swal.fire('Sucesso', 'Termo enviado com sucesso!', 'success');
                    this.setState({
                        loading: false,
                    })
                })
                .catch(error => {
                    console.log("Termo não enviado");

                    Swal.fire('Erro', 'Falha ao enviar o termo. Tente novamente.', 'error');
                    //Sentry.captureException("Termo não enviado", error);
                    this.setState({
                        loading: true,
                    })
                });
            }
        });
    }
    

    consultaLinhasGoto(goToAccessToken) {
        this.setState({ loading: true });

        //chamar a api atendimentos/call/linhas/ para listar as linhas do atendente
        api.post('/atendimentos/call/linhas/', {
            "token_goto": goToAccessToken,
        })
        .then(response => {
            const items = response.data.items;

            this.setState({ 
                goToLinhasAtendente: items,
                goToErroMensagem: "",
                loading: false,
                goToLinhaLigar: items[0].id,
            });                
        })
        .catch(error => {
            console.log("Erro ao listar linhas do atendente");

            if('data' in error.response){
                const dados = error.response.data;

                if('api_goto' in dados){
                    if(dados.api_goto == 'sem_autorizacao'){
                        //remove o token
                        localStorage.removeItem("tokenG");                        

                        this.setState({ 
                            goToLinhasAtendente: [], 
                            goToAccessToken: "",
                            loading: false 
                        });        

                        this.handleLigacaoPaciente()
                    }
                    else if(dados.api_goto == 'limite_excedido'){
                        this.setState({ goToErroMensagem: "Foi excedido o limite de ligação, tente novamente mais tarde ", loading: false });        
                    }
                }
            }
            else {
                this.setState({ goToErroMensagem: "Não foi possível listar as linhas para a ligação", loading: false });
            }
            //Sentry.captureException("Erro ao listar linhas do atendente", error);
        });
    }

    handleLigacaoPaciente = () => {
        this.setState({goToLigacaoRealizada: false})

        if(!this.state.goToClient_id){
            return;
        }        

        //redireciona para pagina de login do logmein
        if(!this.state.goToAccessToken){
            const redirect_uri = `${import.meta.env.VITE_URL_COMPLETA}goto_postback/`
            const logmeinUrl = 'https://authentication.logmeininc.com/oauth/authorize?response_type=token&client_id='+this.state.goToClient_id+'&redirect_uri='+redirect_uri

            window.open(logmeinUrl, '_blank').focus();      
        }
    };    

    handleShowModalBotao = (botao) => {
        //executa uma funcao caso esteja cadastrado
        if(botao.callback_funcao){
            executeFunctionByName(botao.callback_funcao, this);
        }

        const prev = this.state.botao_atual || {};
        const keyPrev = prev.formulario_id ?? prev.id ?? prev.titulo;
        const keyNext = botao.formulario_id ?? botao.id ?? botao.titulo;
        const mesmoBotao = keyPrev && keyPrev === keyNext;

        this.setState({
            botao_atual: botao,
            showModalBotao: true,
            camposFormulario: [],
            camposMaxLengthOverrides: {},
            valoresCampos: mesmoBotao ? (this.state.valoresCampos || {}) : {}, 
            camposOutro:   mesmoBotao ? (this.state.camposOutro || {})   : {},
            loading: true,
        });

        // Aqui fazemos a chamada para a API para buscar os campos do formulário
        api.get(`/formularios/campos/?formulario_id=${botao.formulario_id}&status=1&limit=500`)
            .then(async (response) => {
                const camposArray = response.data.results;
                
                const novosValores = { ...(this.state.valoresCampos || {}) };

                const campoRef = camposArray.find(c => c.slug === CAMPO_SLUG_REPORT_REFERENCE);
                if (campoRef) {
                    const programaId = this.state.programa_id;
                    const atendimentoId = this.state.atendimento_id;
                    const anoAtual = new Date().getFullYear();

                    if (programaId && atendimentoId) {
                        try {
                            const respRelatos = await api.get(`/atendimentos/relatos/?farmacovigilancia=1&programa_id=${programaId}&limit=1`);
                            const lista = respRelatos.data.results || [];
                            const ultimoId = lista.length > 0 ? lista[0].id : 0;
                            const proximoId = (ultimoId || 0) + 1;

                            const refGerada = `${atendimentoId}-${proximoId}-${anoAtual}`;
                            novosValores[campoRef.id] = refGerada;

                            console.log(
                                `Pré-preenchendo campo ID ${campoRef.id} com o valor gerado automaticamente: ${refGerada}`
                            );
                        } catch (errRelatos) {
                            console.error('Erro ao buscar último relato de farmacovigilância:', errRelatos);
                        }
                    }
                }

                let camposMaxLengthOverrides = {};
                try {
                    if (
                        botao?.dados_formulario?.farmacovigilancia &&
                        this.state.programa_dados?.farmacovigilancia_pdf_modelo &&
                        this.state.programa_dados?.farmacovigilancia_modelo
                    ) {
                        const templateUrl = `/farmaco/${this.state.programa_dados.farmacovigilancia_modelo}_farmacovigilancia.pdf`;
                        camposMaxLengthOverrides = await this.buildFarmacoMaxLengthOverrides(camposArray, templateUrl);
                    }
                } catch (error) {
                    console.warn('Falha ao montar limites de campos para farmacovigilância', error);
                }

                this.setState({ 
                    tempReportRef: null,
                    camposFormulario: camposArray,
                    valoresCampos: novosValores,
                    camposMaxLengthOverrides,
                    loading: false,
                });
            })
            .catch(error => {
                console.error('Erro ao carregar campos do formulário:', error);

                this.setState({ loading: false });
            });
    };
    
    handleCloseModalBotao = () => {
        this.setState({
            showModalBotao: false,
            camposMaxLengthOverrides: {},
            /*botao_atual: {},
            camposFormulario: [],
            valoresCampos: {}*/
        });
    };

    ligarParaPaciente = (campo_id) => {
        this.setState({ loading: true, goToLoaderLigacao: true });

        api.post('/atendimentos/call/ligar/', {
            "token_goto": this.state.goToAccessToken,
            "numero_telefone": this.state.beneficiario_celular,
            "linha_id": this.state.goToLinhaLigar
        })
        .then(response => {
            const item = response.data;

            this.setState(prevState => ({
                valoresCampos: {
                    ...prevState.valoresCampos,
                    [campo_id]: item.initiatorId,
                },
            }));

            this.setState({ 
                goToLigacaoRealizada: true,       
                loading: false,         
            });           
            
            setTimeout(() => {
                this.setState({ 
                    loading: false,
                    goToLoaderLigacao: false
                }); 
            }, "5000");
        })
        .catch(error => {
            console.log("Erro ao ligar para paciente");

            this.setState({ goToErroMensagem: "Não foi possível iniciar a ligação", loading: false, goToLoaderLigacao: false });
            //Sentry.captureException("Erro ao ligar para paciente");
        });
    };

    renderModalBotao = () => {
        const {
            camposFormulario,
            valoresCampos,
            camposOutro,
            opcaoModalRelato,
            loading,
            goToClient_id,
            loadingGoto,
            goToErroMensagem,
            goToAccessToken,
            goToLinhasAtendente,
            goToLinhaLigar,
            goToLoaderLigacao,
            goToLigacaoRealizada,
            beneficiario_celular,
            showModal
        } = this.state;
        
        const dados_usuario = getCurrentUser();

        // Config para o gotoConnect
        const gotoConfig = {
            goToClientId: goToClient_id,
            loadingGoto,
            goToErroMensagem,
            goToAccessToken,
            goToLinhasAtendente,
            goToLinhaLigar,
            onChangeLinha: e => this.handleChange(e, 'goToLinhaLigar'),
            ligarParaPaciente: this.ligarParaPaciente,
            loadingLigacao: goToLoaderLigacao,
            goToLigacaoRealizada,
            beneficiario_celular
        };

        //Medicamento/produto
        let produto_nome = '';
        if (this.state.programa_dados.habilitar_gestao_produtos && ('results' in this.state.produtos && this.state.produtos.results.length > 0)) {
            produto_nome = this.state.produtos.results[0].dados_produto.nome;
        }

        return (
            <Modal show={this.state.showModalBotao} size="lg" onHide={this.handleCloseModalBotao}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.botao_atual.titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.state.botao_atual.descricao}</p>
                    {this.state.camposFormulario.length > 0 && (
                    <Form onSubmit={this.handleSubmitModalAtendimento}>
                        <FormularioRender
                            campos={camposFormulario}
                            valoresCampos={valoresCampos}
                            camposOutro={camposOutro}
                            maxLengthOverrides={this.state.camposMaxLengthOverrides}
                            onChangeCampo={this.handleChangeCampo}
                            onChangeCampoAsync={this.handleChangeCampoAsync}
                            onChangeCampoCheckSim={this.handleChangeCampoCheckSim}
                            onChangeOutro={this.handleChangeOutro}
                            dadosUsuario={dados_usuario}
                            opcaoModalRelato={opcaoModalRelato}
                            tiposSessoesCampos={tiposSessoesCampos}
                            carregarProdutosPrograma={this.carregarProdutosPrograma}
                            gotoConfig={gotoConfig}

                            dados_beneficiario={this.state.dados_beneficiario}
                            dadosMedico={this.state.dados_medico}
                            camposExtraCadastrados={this.state.camposExtraCadastrados}
                            programaDados={this.state.programa_dados}
                            produtosOpcoes={this.state.produtosOpcoes}

                            produtoNome={produto_nome}
                            abrirModalHistoricoLigacoes={this.abrirModalHistoricoLigacoes}
                        />
                        <Row>
                            <Col sm={6}>
                                <Button variant="success" size="sm" type="submit" disabled={this.state.loading}>{this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'SALVAR INFORMAÇÕES'}</Button>
                            </Col>
                            {this.state.botao_atual.exibir_botao_monitoria && (
                            <Col sm={6} className="text-end">
                                <Button variant="secondary" size="sm" type="submit" disabled={this.state.loading} onClick={() => this.handleShowModalMonitoria()}>{this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar nova aplicação'}</Button>
                            </Col>
                            )}
                        </Row>
                    </Form>
                    )}
                    {(dados_usuario['tipo_usuario'] == '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == 'operador') && (
                        <>
                            <Row>
                                <Col sm={12}>
                                    <hr />
                                </Col>
                            </Row>
                            <Row className="align-items-end">
                                <Col sm={12}>
                                    <h6 className="mt-4"><strong>Outras Ações</strong></h6>
                                </Col>
                                <Col sm={12}>
                                    <Button type="button" variant="secondary" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalAcoes()}>
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Lembrete de Ação'}                                       
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={this.handleCloseModalBotao}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    
    //Envio do formulário de botão de atendimento (Etapa Flutuante)
    handleSubmitModalAtendimento = (e) => {
        e.preventDefault(); // Isso evita a recarga da página
        this.enviarFormularioBotaoAtendimento();
    };

    renderizaCamposFormulario = () => {
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {}
        for(let i = 0; i < this.state.camposFormulario.length; i++) {
            let item = this.state.camposFormulario[i];
            const sessao = item.sessao || '0_sem_sessao'

            if(!(sessao in objCampos)){
                objCampos[sessao] = [];    
            }

            objCampos[sessao].push(item)
        }

        return (
            Object.keys(objCampos).map((nome_sessao) => (
                <div className="row-list" key={nome_sessao}>
                    {nome_sessao && <h6><strong>{tiposSessoesCampos[nome_sessao] ? tiposSessoesCampos[nome_sessao] : (nome_sessao === '0_sem_sessao' ? '' : nome_sessao)}</strong></h6>}           
                    
                    <Row>
                        {objCampos[nome_sessao].map((campo) => (
                        <React.Fragment key={campo.id}>
                            {campo.tipo === 'texto' || campo.tipo === 'area_texto' || campo.tipo === 'data' || campo.tipo === 'selecao' || campo.tipo === 'radio' || campo.tipo === 'checkbox' ? (
                                <>
                                    <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className={campo.tipo === 'checkbox' ? 'mb-1' : 'mb-3'}>
                                        <Form.Group>
                                            {campo.tipo !== 'checkbox' && <Form.Label>{campo.nome}</Form.Label> }                                            
                                            {
                                            (campo.mascara === 'produtos_programa') ? (
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarProdutosPrograma}
                                                    required={campo.obrigatorio}
                                                    defaultOptions
                                                    placeholder="Buscar produto..."
                                                    noOptionsMessage={() => "Nenhum produto encontrado"}
                                                    onChange={(option) => this.handleChangeCampoAsync(campo.id, option)}
                                                    value={this.state.valoresCampos[campo.id] ? { value: this.state.valoresCampos[campo.id], label: this.state.valoresCampos[campo.id] } : null}
                                                />
                                            )
                                            :
                                            (campo.tipo === 'selecao') ? (
                                                <Form.Control as="select" required={campo.obrigatorio} onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}>
                                                    <option value="">Selecione...</option>
                                                    {campo.opcoes.split('\n').map((opcao, idx) => {
                                                        const [valor, label] = opcao.split(':');
                                                        return <option key={idx} value={valor}>{label}</option>;
                                                    })}
                                                </Form.Control>
                                                ) 
                                            : 
                                                (campo.tipo === 'texto' || campo.tipo === 'data') ? (
                                                    <Form.Control
                                                        type={campo.tipo === 'data' ? 'date' : 'text'}
                                                        value={this.state.valoresCampos[campo.id] || ''}
                                                        required={campo.obrigatorio}
                                                        onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                    />
                                                )
                                                :
                                                    (campo.tipo === 'radio') ? 
                                                    (
                                                        <div>
                                                            {campo.opcoes.split('\n').map((opcao, indexO) => {
                                                                const [valorRadio, labelRadio] = opcao.split(':'); // Divide a opção pelo ':'
                                                                const radioSelecionado = valorRadio === this.state.valoresCampos[campo.id];
                                                                
                                                                return (
                                                                    <Form.Check 
                                                                        inline 
                                                                        type="radio" 
                                                                        name={`radio_${campo.id}`}
                                                                        label={labelRadio} 
                                                                        key={`radio_${campo.id}_opcao_${indexO}`} 
                                                                        id={`radio_${campo.id}_opcao_${indexO}`}
                                                                        value={valorRadio} 
                                                                        onClick={() => {
                                                                            if (radioSelecionado) {
                                                                                this.handleChangeCampo(campo.id, '');
                                                                            }
                                                                        }}
                                                                        onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                                        checked={radioSelecionado} 
                                                                    />                                                                                                                        
                                                                );
                                                            })}
                                                        </div>
                                                    )
                                                    :
                                                        (campo.tipo === 'checkbox') ? 
                                                        (
                                                            <div>
                                                                <Form.Check 
                                                                    type="checkbox" 
                                                                    name={campo.tipo} 
                                                                    id={`check_${campo.slug}`}
                                                                    label={campo.nome}                                                             
                                                                    value="sim" 
                                                                    checked={this.state.valoresCampos[campo.id] == 'sim' ? true : false} 
                                                                    onChange={(e) => this.handleChangeCampoCheckSim(campo.id, e)} 
                                                                />
                                                            </div>
                                                        )
                                                        :
                                                        (
                                                            <Form.Control
                                                                as={campo.tipo === 'area_texto' ? 'textarea' : 'text'}
                                                                value={this.state.valoresCampos[campo.id] || ''}
                                                                required={campo.obrigatorio}
                                                                className={campo.tipo === 'area_texto' ? 'custom-textarea2' : ''}
                                                                onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                            />
                                                        )
                                            }
                                            {campo.descricao && <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text>}
                                        </Form.Group>
                                    </Col>
                                    {campo.tipo !== 'checkbox' && ['outro', 'outros'].includes(this.state.valoresCampos[campo.id]?.toLowerCase()) && (
                                    <Col sm={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Descreva</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.camposOutro[campo.id] || ''}
                                                onChange={(e) => this.handleChangeOutro(campo.id, e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    )}
                                </>
                            ) : null}
                            {campo.tipo == 'informacao' && (
                                <Col sm={12} className="mb-0">
                                    <div dangerouslySetInnerHTML={{ __html: campo.descricao }} />
                                </Col>
                            )}
                            {campo.tipo === 'gotoconnect' && (
                                <Col sm={12} className="mb-3">
                                    {
                                    this.state.goToClient_id
                                    ?
                                        this.state.loading
                                        ?
                                            <h4 className="text-center mt-3"><FaClock /> Carregando...</h4>
                                        :
                                            this.state.goToErroMensagem
                                            ?
                                                <h4 className="text-center mt-3"><FaExclamationTriangle /> {this.state.goToErroMensagem}</h4>
                                            :
                                                this.state.goToAccessToken 
                                                ?
                                                    this.state.goToLinhasAtendente.length > 0
                                                    &&
                                                    <div>
                                                        <Row>
                                                            <Col sm={6} xs={12} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Linhas disponíveis</Form.Label>
                                                                    <Form.Control name="goToLinhaLigar" as="select" onChange={this.handleChange} value={this.state.goToLinhaLigar}>
                                                                        {this.state.goToLinhasAtendente.map((linha, idx) => {
                                                                            return <option key={idx} value={linha.id}>{linha.name} (Número: {linha.number})</option>;
                                                                        })}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={6} xs={12} className="mb-3">
                                                                <Button variant="success" size="sm" type="button" className="mt-4" disabled={this.state.goToLoaderLigacao} onClick={() => this.ligarParaPaciente(campo.id)}>
                                                                    {this.state.goToLoaderLigacao ? <span className="spinner-border spinner-border-sm"></span> : <><FaPhone className="me-2" /> Ligar para {this.state.beneficiario_celular}</>}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        {
                                                        this.state.goToLigacaoRealizada &&
                                                        <Alert variant="success"><FaCheckCircle className="me-2" /><strong>Ligação iniciada! Acesse app.goto.com para prosseguir com a ligação.</strong></Alert>
                                                        }
                                                    </div>
                                                :
                                                <h4 className="text-center mt-3"><FaClock />Aguardando login na Goto Connect...</h4>
                                    :
                                    <h4 className="text-center mt-3"><FaExclamation /> O seu cliente não possui uma integração com o Goto Connect.</h4>
                                    }
                                </Col>
                            )}
                            {campo.tipo === 'arquivo' && (
                                <Col sm={6} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>{campo.nome}</Form.Label>
                                        <Form.Control 
                                            type="file" 
                                            required={campo.obrigatorio}
                                            onChange={(e) => this.handleChangeCampo(campo.id, e)}
                                        />
                                        {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                                    </Form.Group>
                                </Col>
                            )}
                        </React.Fragment>
                        ))}
                    </Row>
                </div>
            ))        
        );
    }

    gerarPdfFarmaco = async (templateUrl, valoresCampos, camposOutro) => {
        // 1) baixa o template
        const resp = await fetch(templateUrl, { cache: 'no-store' });
        if (!resp.ok) throw new Error(`Falha ao baixar o PDF (HTTP ${resp.status})`);

        const ct = resp.headers.get('content-type') || '';
        if (!ct.includes('pdf')) {
            const preview = (await resp.clone().text()).slice(0, 200);
            console.warn('Conteúdo NÃO é PDF:', ct, preview);
            throw new Error('O arquivo retornado não é PDF');
        }

        const arrayBuf = await resp.arrayBuffer();
        const pdfDoc = await PDFDocument.load(arrayBuf);
        const form = pdfDoc.getForm();
        const MESES_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const formatarDataPdfCondicional = (valorStr, campoConfig) => {
            const mascara = campoConfig?.mascara || "";
            const tipo = campoConfig?.tipo || "";

            if (tipo !== 'data' && tipo !== 'date') {
                return valorStr;
            }

            let dataObj;
            try {
                dataObj = new Date(valorStr + 'T12:00:00Z');
                if (isNaN(dataObj.getTime())) throw new Error('Data inválida');
            } catch (e) {
                return valorStr;
            }

            // 3. Verifica se a máscara especial 'format-mmm-en' está presente
            if (mascara.includes('format-mmm-en')) {
                // Formata como MMM/dd/yy (ex: Jan/10/25)
                const mesEn = MESES_EN[dataObj.getUTCMonth()];
                const dia = dataObj.getUTCDate();
                const ano = dataObj.getUTCFullYear().toString().slice(-2);
                return `${mesEn}/${dia.toString().padStart(2, '0')}/${ano}`;
            } else {
                const dia = dataObj.getUTCDate();
                const mes = dataObj.getUTCMonth() + 1;
                const ano = dataObj.getUTCFullYear();
                return `${dia.toString().padStart(2, '0')}/${mes.toString().padStart(2, '0')}/${ano}`;
            }
        };

        const helv = await pdfDoc.embedFont(StandardFonts.Helvetica);

        // 2) montar o pdfFieldMap a partir do que você tem em estado
        //    ajuste o nome desta fonte conforme seu state: campos_formulario, camposFormulario, etc.
        const campos = this.state.campos_formulario || this.state.camposFormulario || [];
        const pdfFieldMap = [];

        for (const campo of campos) {
            let raw = campo?.campos_pdf;
            if (!raw) continue;

            // normaliza para array de itens de mapeamento
            let entries = [];
            if (Array.isArray(raw)) {
                entries = raw;
            } else if (typeof raw === 'string') {
                try {
                    const parsed = JSON.parse(raw);
                    entries = Array.isArray(parsed) ? parsed : [parsed];
                } catch (e) {
                    console.warn('campos_pdf string inválido p/ campo', campo?.id, e);
                    continue;
                }
            } else if (typeof raw === 'object') {
                entries = [raw]; // <<=== 🍰 seu caso atual
            }

            // normaliza cada item no formato que seu preenchimento usa
            for (const item of entries) {
                const tRaw = (item.type || item.pdf_field_type || '').toString().toLowerCase();
                let tipo = 'text';
                if (tRaw === 'checkbox_group') tipo = 'checkbox_group';
                else if (tRaw === 'radio_group') tipo = 'radio_group';
                else if (tRaw.includes('radio')) tipo = 'radio';
                else if (tRaw === 'date_parts') tipo = 'date_parts';
                else if (tRaw === 'number_4digits') tipo = 'number_4digits';
                else if (tRaw.includes('checkbox')) tipo = 'checkbox';

                const meta = {
                    campoId: campo.id,
                    pdf_field_type: tipo,
                    pdf_field_name: item.name || item.pdf_field_name || null,
                    pdf_group_name: item.group || item.pdf_group_name || null,
                    pdf_unit_group: item.unit_group || item.pdf_unit_group || null,
                    options_map: item.options_map || null,
                    value_separator: item.value_separator ?? ', ',
                    exclusive: item.exclusive ?? null,
                    map_by: (item.map_by || 'value').toLowerCase(),
                    checked_value: item.checked_value ?? item.value ?? item.when ?? item.match ?? null,
                    defaultValue: item.defaultValue ?? item.default ?? item.fallback ?? null,
                    transform: item.transform || null,
                    fontSize: item.fontSize ?? null,
                    fontStrategy: item.fontStrategy ?? null,
                };

                if (tipo === 'date_parts') {
                    meta.targets = item.targets || null;     // { dd, mm, yyyy }
                    meta.fontSize = item.fontSize ?? null;
                    meta.fontStrategy = item.fontStrategy ?? null;
                    meta.useMonthAbbr = item.useMonthAbbr ?? false;
                }

                if (tipo === 'number_4digits') {
                    meta.targets = item.targets || null;      // { d1, d2, d3, d4 }
                    meta.acceptComma = item.acceptComma ?? true;
                    meta.pad = item.pad ?? '';
                    meta.decimalDefault = item.decimalDefault ?? '0'; 
                }

                if (tipo === 'checkbox_group') {
                    meta.options_map = item.options_map || {};        // { value -> pdfFieldName }
                    meta.value_separator = item.value_separator ?? ', ';
                    meta.exclusive = item.exclusive ?? null;          // valor exclusivo (ex.: "none")
                    meta.map_by = (item.map_by || 'value').toLowerCase(); // "value" | "label"
                }

                if (tipo === 'radio_group') {
                    meta.options_map = item.options_map || {};
                    meta.map_by = (item.map_by || 'value').toLowerCase(); // "value" | "label"
                }

                pdfFieldMap.push(meta);
            }
        }

        // 3) helpers usados no preenchimento (exemplos)
        const setChoiceIfExists = (form, name, value) => {
            if (!name) return false;
            const text = value != null ? String(value) : '';
            try {
                form.getDropdown(name).select(text);
                return true;
            } catch {}
            try {
                form.getOptionList(name).select(text);
                return true;
            } catch {}
            return false;
        };
        const setTextOriginalSize = (form, name, value) => {
            if (!name) return;
            try {
                const f = form.getTextField(name);
                f.setText(value != null ? String(value) : '');
                // não chama setFontSize, nem updateAppearances
            } catch {
                setChoiceIfExists(form, name, value);
            }
        };
        const setTextIfExists = (form, name, value, font, fontSize = 9) => {
            if (!name) return;
            try {
                const f = form.getTextField(name);
                f.setText(value != null ? String(value) : '');
                f.setFontSize(fontSize);
                // ponto-chave: regen por CAMPO com a fonte embutida
                f.updateAppearances(font);
            } catch (err) {
                if (setChoiceIfExists(form, name, value)) return;
                console.warn('Campo de texto não encontrado:', name, err);
            }
        };
        // Rastreia se algum campo "custom" forçado foi escrito — usado para
        // desligar NeedAppearances apenas quando necessário.
        let anyCustomWritten = false;

        // Helper agressivo: usado SOMENTE quando fontStrategy === 'custom'.
        // Reescreve o /DA do widget, seta tamanho, regenera aparência.
        const setTextCustomForced = (form, name, value, font, fontSize) => {
            if (!name) return;
            try {
                const f = form.getTextField(name);
                f.setText(value != null ? String(value) : '');
                f.setFontSize(fontSize);
                try {
                    f.acroField.dict.set(
                        PDFName.of('DA'),
                        PDFString.of(`/Helv ${fontSize} Tf 0 g`)
                    );
                } catch {}
                f.updateAppearances(font);
                anyCustomWritten = true;
            } catch (err) {
                if (setChoiceIfExists(form, name, value)) return;
                console.warn('Campo de texto (custom) não encontrado:', name, err);
            }
        };

        // Mede quantas linhas o texto ocupa numa caixa com determinada largura e tamanho de fonte.
        const measureLinesAtSize = (text, font, size, maxWidth) => {
            const paragraphs = String(text ?? '').split(/\r?\n/);
            const spaceW = font.widthOfTextAtSize(' ', size);
            let totalLines = 0;

            for (const para of paragraphs) {
                if (!para) { totalLines += 1; continue; }
                const words = para.split(/\s+/).filter(Boolean);
                let lineWidth = 0;
                let lines = 1;

                for (const word of words) {
                    const w = font.widthOfTextAtSize(word, size);
                    if (lineWidth === 0) {
                        lineWidth = w;
                    } else if (lineWidth + spaceW + w <= maxWidth) {
                        lineWidth += spaceW + w;
                    } else {
                        lines += 1;
                        lineWidth = w;
                    }
                }
                totalLines += lines;
            }
            return totalLines;
        };

        // Encontra o maior tamanho <= maxSize que faz o texto caber no retângulo do campo.
        const fitFontSize = (field, text, font, maxSize, minSize = 4) => {
            try {
                const widget = field?.acroField?.getWidgets?.()[0];
                const rect = widget?.getRectangle?.();
                if (!rect?.width || !rect?.height) return maxSize;

                const padding = 4;
                const usableWidth = Math.max(10, rect.width - padding * 2);
                const usableHeight = Math.max(10, rect.height - padding * 2);

                for (let size = maxSize; size >= minSize; size -= 0.5) {
                    const lines = measureLinesAtSize(text, font, size, usableWidth);
                    const lineHeight = size * 1.2;
                    if (lines * lineHeight <= usableHeight) return size;
                }
                return minSize;
            } catch {
                return maxSize;
            }
        };

        // Auto-shrink: aplica fontSize como TAMANHO MÁXIMO e reduz conforme necessário
        // para o texto caber na caixa. Usado para campos Summary quando fontSize é informado.
        const setTextAutoShrink = (form, name, value, font, maxSize) => {
            if (!name) return;
            try {
                const f = form.getTextField(name);
                const text = value != null ? String(value) : '';
                const size = text ? fitFontSize(f, text, font, maxSize) : maxSize;
                f.setText(text);
                f.setFontSize(size);
                f.updateAppearances(font);
            } catch (err) {
                if (setChoiceIfExists(form, name, value)) return;
                console.warn('Campo de texto (auto-shrink) não encontrado:', name, err);
            }
        };

        // Helper centralizado: decide entre tamanho do template ou fontSize customizado
        // Regras:
        //  - fontStrategy === 'custom'   → aplica fontSize via setTextCustomForced (DA manual)
        //  - fontStrategy === 'template' → sempre usa tamanho original do template
        //  - campo Summary + fontSize    → auto-shrink com teto = fontSize
        //  - sem fontSize                → template
        //  - demais casos                → fontSize fixo (caminho leve)
        const writeText = (name, value, meta) => {
            if (!name) return;
            const fs = meta?.fontSize ?? null;
            const strategy = (meta?.fontStrategy || '').toLowerCase();
            const isSummary = this.isSummaryPdfFieldName(name);

            if (strategy === 'custom' && fs) {
                setTextCustomForced(form, name, value, helv, fs);
                return;
            }

            if (strategy === 'template' || !fs) {
                setTextOriginalSize(form, name, value);
                return;
            }

            if (isSummary) {
                setTextAutoShrink(form, name, value, helv, fs);
                return;
            }

            setTextIfExists(form, name, value, helv, fs);
        };
        const setCheckbox = (form, name, on) => {
            if (!name) return;
            try {
            const f = form.getCheckBox(name);
            on ? f.check() : f.uncheck();
            } catch {}
        };
        const selectRadio = (form, groupName, val) => {
            if (!groupName) return;
            try {
            const g = form.getRadioGroup(groupName);
            g.select(val != null ? String(val) : '');
            } catch {}
        };
        const toDDMMMYYYY = (val) => {
            if (!val) return '';
            const d = new Date(val);
            if (isNaN(d)) return '';
            const dd = String(d.getDate()).padStart(2, '0');
            const mmm = d.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // JAN, FEB...
            const yyyy = d.getFullYear();
            return `${dd}-${mmm}-${yyyy}`;
        };
        const splitDateToParts = (val) => {
            if (!val) return { dd: '', mmm: '', yyyy: '' };
            const d = new Date(val);
            if (isNaN(d)) return { dd: '', mmm: '', yyyy: '' };
            return {
            dd: String(d.getDate()).padStart(2, '0'),
            mmm: d.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
            yyyy: String(d.getFullYear())
            };
        };
        const applyTransforms = (v, transform) => {
            // opcional: se você definiu transforms no JSON (ex.: uppercase, trim, etc.)
            if (!transform) return v;
            let out = v;
            const tlist = Array.isArray(transform) ? transform : String(transform).split('|');
            for (const t of tlist) {
            const tt = String(t).trim().toLowerCase();
            if (tt === 'trim') out = (out ?? '').toString().trim();
            else if (tt === 'upper') out = (out ?? '').toString().toUpperCase();
            else if (tt === 'lower') out = (out ?? '').toString().toLowerCase();
            }
            return out;
        };
        const MONTH_ABBR = [
            "Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"
        ];
        const splitDateToPartsCustom = (val, useMonthAbbr = false) => {
            if (!val) return { dd: '', mm: '', yyyy: '' };

            // Preferir parsing “puro” de YYYY-MM-DD
            const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(val).trim());
            if (m) {
                const [, yyyy, mmStr, dd] = m;
                const mm = parseInt(mmStr, 10);

                return {
                    dd,
                    mm: useMonthAbbr ? MONTH_ABBR[mm - 1] : mmStr,
                    yyyy
                };
            }

            // fallback
            const d = new Date(val);
            if (isNaN(d)) return { dd: '', mm: '', yyyy: '' };

            const monthIndex = d.getMonth();

            return {
                dd: String(d.getDate()).padStart(2, '0'),
                mm: useMonthAbbr 
                    ? MONTH_ABBR[monthIndex] 
                    : String(monthIndex + 1).padStart(2, '0'),
                yyyy: String(d.getFullYear())
            };
        };
        const splitNumberTo4Digits = (
            val,
            { acceptComma = true, pad = '', decimalDefault = '0' } = {}
        ) => {
            if (val == null || val === '') return { d1: pad, d2: pad, d3: pad, d4: decimalDefault };

            let s = String(val).trim();
            if (acceptComma) s = s.replace(',', '.');
            s = s.replace(/[^\d.]/g, '');

            const [intRaw = '', decRaw = ''] = s.split('.');
            // remove zeros à esquerda, mantendo um único zero se necessário
            const intDigits = intRaw.replace(/^0+(?=\d)/, '') || (intRaw ? '0' : '');

            const u1 = intDigits.slice(-1) || '';     // unidades
            const u2 = intDigits.slice(-2, -1) || ''; // dezenas
            const u3 = intDigits.slice(-3, -2) || ''; // centenas
            const dec1 = decRaw.length ? decRaw.slice(0, 1) : decimalDefault; // 👈 aqui

            const fill = x => (x === '' ? pad : x);
            return { d1: fill(u3), d2: fill(u2), d3: fill(u1), d4: dec1 };
        };
        const normalizeComparable = (value) => String(value ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase();
        const isNullishPdfValue = (value) => {
            if (value === null || value === undefined) return true;
            if (typeof value !== 'string') return false;
            return ['', 'none', 'null', 'undefined', 'nan'].includes(normalizeComparable(value));
        };
        const sanitizePdfValue = (value) => isNullishPdfValue(value) ? '' : value;
        const parseCampoOptions = (campo) => String(campo?.opcoes || '')
            .split('\n')
            .map(line => {
                const separatorIndex = line.indexOf(':');
                if (separatorIndex < 0) return null;
                return {
                    value: line.slice(0, separatorIndex).trim(),
                    label: line.slice(separatorIndex + 1).trim(),
                };
            })
            .filter(Boolean);
        const getCampoOptionAliases = (campo, value) => {
            const aliases = [];
            if (!isNullishPdfValue(value)) aliases.push(String(value));

            const normalizedValue = normalizeComparable(value);
            if (!normalizedValue) return aliases;

            for (const option of parseCampoOptions(campo)) {
                if (
                    normalizeComparable(option.value) === normalizedValue ||
                    normalizeComparable(option.label) === normalizedValue
                ) {
                    aliases.push(option.value, option.label);
                }
            }

            return aliases.filter(v => !isNullishPdfValue(v));
        };
        const getDefaultPdfValue = (campo, meta) => {
            if (meta?.defaultValue !== null && meta?.defaultValue !== undefined) {
                return meta.defaultValue;
            }
            if (/\bprefill\[pais-brasil\]/.test(campo?.mascara || '')) {
                return 'Brasil';
            }
            return '';
        };
        const resolvePdfValue = (value, campo, meta) => {
            let resolved = sanitizePdfValue(value);

            if (isNullishPdfValue(resolved)) {
                resolved = getDefaultPdfValue(campo, meta);
            }

            if ((meta?.map_by || '').toLowerCase() === 'label' && !isNullishPdfValue(resolved)) {
                const normalized = normalizeComparable(resolved);
                const option = parseCampoOptions(campo).find(opt => normalizeComparable(opt.value) === normalized);
                if (option?.label) {
                    resolved = option.label;
                }
            }

            return sanitizePdfValue(resolved);
        };
        const selectedTokens = (raw, separator = ', ') => {
            if (Array.isArray(raw)) return raw.filter(v => !isNullishPdfValue(v));
            if (isNullishPdfValue(raw)) return [];
            if (typeof raw !== 'string') return [raw];

            const sep = separator || ',';
            const pieces = raw.includes(sep)
                ? raw.split(sep)
                : raw.split(/\s*,\s*/);

            return pieces.map(v => v.trim()).filter(v => !isNullishPdfValue(v));
        };
        const valueMatches = (selectedValue, expectedValue, campo, separator = ', ') => {
            const expectedAliases = getCampoOptionAliases(campo, expectedValue).map(normalizeComparable);
            const expectedSet = new Set(expectedAliases.length ? expectedAliases : [normalizeComparable(expectedValue)]);

            return selectedTokens(selectedValue, separator).some(selected => (
                getCampoOptionAliases(campo, selected)
                    .map(normalizeComparable)
                    .some(alias => expectedSet.has(alias))
            ));
        };
        const applyOptionsMapAsCheckboxes = (map, selectedValue, campo, separator = ', ', exclusive = null) => {
            const exclusiveOn = exclusive && valueMatches(selectedValue, exclusive, campo, separator);

            for (const [valueKey, pdfName] of Object.entries(map || {})) {
                const on = exclusiveOn
                    ? valueMatches(valueKey, exclusive, campo, separator)
                    : valueMatches(selectedValue, valueKey, campo, separator);
                setCheckbox(form, pdfName, on);
            }
        };
        const toBool = (x) => {
            if (Array.isArray(x)) return x.some(toBool);
            if (typeof x === 'string') {
                return ['1', 'true', 'sim', 'on', 'yes', 'y', 's'].includes(normalizeComparable(x));
            }
            return !!x;
        };

        for (const meta of pdfFieldMap) {
            const { campoId, pdf_field_name, pdf_field_type, pdf_group_name, pdf_unit_group, transform } = meta || {};
            if (!campoId || !pdf_field_type) continue;

            const campoConfig = campos.find(c => c.id === campoId);
            let valor = valoresCampos[campoId];

            // “Outro”
            if (typeof valor === 'string' && ['outro', 'outros'].includes(valor.toLowerCase()) && camposOutro && camposOutro[campoId]) {
                valor = `Outro - ${String(camposOutro[campoId]).trim()}`;
            }

            valor = resolvePdfValue(valor, campoConfig, meta);
            valor = applyTransforms(valor, transform);

            try {
                switch (pdf_field_type) {
                    case 'text': {
                        if (pdf_field_name) {
                            const valorFinal = formatarDataPdfCondicional(valor, campoConfig);
                            writeText(pdf_field_name, valorFinal, meta);
                        }
                        break;
                    }
                    case 'checkbox': {
                        if (pdf_field_name) {
                            const hasCheckedValue = meta.checked_value !== null && meta.checked_value !== undefined;
                            const on = hasCheckedValue
                                ? valueMatches(valor, meta.checked_value, campoConfig, meta.value_separator)
                                : toBool(valor);
                            setCheckbox(form, pdf_field_name, on);
                        }
                        break;
                    }
                    case 'radio': {
                        if (meta.options_map && Object.keys(meta.options_map).length) {
                            applyOptionsMapAsCheckboxes(meta.options_map, valor, campoConfig, meta.value_separator, meta.exclusive);
                        } else if (pdf_group_name) {
                            selectRadio(form, pdf_group_name, valor);
                        } else if (pdf_field_name) {
                            setCheckbox(form, pdf_field_name, toBool(valor));
                        }
                        break;
                    }
                    case 'unit_flag': {
                        const units = Array.isArray(pdf_unit_group) && pdf_unit_group.length ? pdf_unit_group : [pdf_field_name];
                        for (const u of units) {
                        setCheckbox(form, u, normalizeComparable(u) === normalizeComparable(valor));
                        }
                        break;
                    }
                    case 'date_parts': {
                        const parts = splitDateToPartsCustom(valor, meta.useMonthAbbr);

                        if (meta.targets?.full_date) {
                            writeText(meta.targets.full_date, `${parts.dd}/${parts.mm}/${parts.yyyy}`, meta);
                        } else {
                            writeText(meta.targets?.dd, parts.dd, meta);
                            writeText(meta.targets?.mm, parts.mm, meta);
                            writeText(meta.targets?.yyyy, parts.yyyy, meta);
                        }
                        break;
                    }
                    case 'number_4digits': {
                        const parts = splitNumberTo4Digits(valor, {
                            acceptComma: meta.acceptComma,
                            pad: meta.pad,
                            decimalDefault: meta.decimalDefault,
                        });

                        writeText(meta.targets?.d1, parts.d1, meta);
                        writeText(meta.targets?.d2, parts.d2, meta);
                        writeText(meta.targets?.d3, parts.d3, meta);
                        writeText(meta.targets?.d4, parts.d4, meta);
                        break;
                    }
                    case 'checkbox_group': {
                        // 1) pegue as seleções do usuário
                        const raw = valor ?? '';
                        let selected = [];
                        if (Array.isArray(raw)) {
                            selected = raw;
                        } else if (typeof raw === 'string') {
                            selected = raw.split(meta.value_separator).map(s => s.trim()).filter(Boolean);
                        } else if (raw) {
                            selected = [String(raw)];
                        }

                        // 2) se mapear por label, converta label -> value usando as opções do campo (se precisar)
                        //    (Opcional: se você guarda apenas "valor", pode ignorar isso)
                        if (meta.map_by === 'label') {
                            // tenta montar um dicionário label->valor a partir de campo.opcoes ("v:Label")
                            const optLines = (campos.find(c => c.id === campoId)?.opcoes || '').split('\n');
                            const labelToValue = {};
                            for (const line of optLines) {
                            const [v, l] = line.split(':');
                            if (l) labelToValue[l.trim()] = (v || '').trim();
                            }
                            selected = selected.map(s => labelToValue[s] || s);
                        }

                        // 3) normaliza p/ comparação case-insensitive
                        const selSet = new Set(
                            selected
                                .flatMap(s => getCampoOptionAliases(campoConfig, s))
                                .map(normalizeComparable)
                        );

                        // 4) se houver opção exclusiva marcada (ex.: "none"), liga só ela
                        const exclusiveKey = meta.exclusive ? normalizeComparable(meta.exclusive) : null;
                        const exclusiveOn = exclusiveKey && selSet.has(exclusiveKey);

                        // 5) percorre o options_map: marca/desmarca cada checkbox no PDF
                        for (const [valueKey, pdfName] of Object.entries(meta.options_map || {})) {
                            const k = normalizeComparable(valueKey);
                            const on = exclusiveOn ? (k === exclusiveKey) : selSet.has(k);
                            setCheckbox(form, pdfName, on);
                        }

                        break;
                    }
                    case 'radio_group': {
                        const selected = isNullishPdfValue(valor) ? null : String(valor).trim();
                        if (!selected) break;

                        for (const [valueKey, pdfName] of Object.entries(meta.options_map || {})) {
                            const match = valueMatches(selected, valueKey, campoConfig, meta.value_separator);
                            setCheckbox(form, pdfName, match); // marca só o que bate, desmarca os outros
                        }
                        break;
                    }
                }
            } catch (e) {
                console.warn('Falha ao aplicar campo PDF', meta, e);
            }
        }

        // Se algum campo custom forçou fontSize, garante que o viewer não regenere
        // as aparências (usaria o DA original do template e ignoraria nosso tamanho).
        if (anyCustomWritten) {
            try {
                form.acroForm.dict.set(PDFName.of('NeedAppearances'), PDFBool.False);
            } catch {}
        }

        try { form.flatten(); } catch {}

        const filledBytes = await pdfDoc.save();
        return new Blob([filledBytes], { type: 'application/pdf' });
    };

    
    enviarFormularioBotaoAtendimento = async () => {
        // Primeiro, salvar o relato
        this.setState({loading:true})        

        const dataHoraAtualFormatada = getDataAtual();
        const { etapa_atual, atendimento_id, valoresCampos, camposOutro, programa_dados } = this.state;

        const invalidMaxLen = this.validateCamposMaxLength(
            valoresCampos,
            camposOutro,
            this.state.camposMaxLengthOverrides
        );

        if (invalidMaxLen) {
            this.setState({ loading: false });
            Swal.fire(
                'Atenção!',
                `O campo "${invalidMaxLen.campoNome}" aceita no máximo ${invalidMaxLen.maxLen} caracteres. Valor atual: ${invalidMaxLen.atual}.`,
                'warning'
            );
            return;
        }

        let formData = new FormData();
        formData.append('data', dataHoraAtualFormatada);
        formData.append('etapa_id', etapa_atual.id);
        formData.append('atendimento_id', atendimento_id);
        formData.append('tipo', 'atendimento');
        formData.append('titulo', this.state.botao_atual.titulo);
        formData.append('formulario_id', this.state.botao_atual.formulario_id);

        if(this.state.relato_tipo_paciente){
            formData.append('tipo_paciente', this.state.relato_tipo_paciente);      
        }
          
        //verifica se o botão atual é de um formulário de farmacovigilância
        if(this.state.botao_atual && this.state.botao_atual.dados_formulario.farmacovigilancia) {
            formData.append('farmacovigilancia', true);
        }

        let list_valores = []
        let cont = 1;
        Object.entries(valoresCampos).forEach(([campoId, valorBruto]) => {
            let valor = valorBruto; 

            const dados = {
                valor: "",
                file_param: "",
                formulario_campo_id: campoId,
                repeater: []
            };

            // 1) Se veio um event (ex.: input file passado direto)
            const isEvent = valor && typeof valor === 'object' && 'target' in valor;
            if (isEvent) {
                const { target } = valor;
                if (target.type === 'file' && target.files && target.files.length > 0) {
                valor = target.files[0];
                } else {
                valor = target.value; // fallback pra outros inputs
                }
            }

            // 2) Arquivo
            if (valor instanceof File) {
                const file_param = `valor_arquivo_${cont}`;
                dados.file_param = file_param;
                formData.append(file_param, valor);
            }
            // 3) Array (ex.: múltipla seleção)
            else if (Array.isArray(valor)) {
                dados.valor = valor.map(v => (v ?? '').toString().trim()).filter(Boolean).join(', ');
            }
            // 4) Boolean (primitivo)
            else if (typeof valor === 'boolean') {
                dados.valor = valor; 
            }
            // 5) null/undefined
            else if (valor === null || valor === undefined) {
                dados.valor = '';
            }
            // 6) Número
            else if (typeof valor === 'number') {
                dados.valor = String(valor);
            }
            // 7) String
            else if (typeof valor === 'string') {
                let vStr = valor;

                // “Outro” + texto complementar
                if (['outro', 'outros'].includes(vStr.trim().toLowerCase()) && camposOutro && camposOutro[campoId]) {
                vStr = `Outro - ${camposOutro[campoId]}`;
                }

                dados.valor = vStr;
            }
            // 8) Objeto genérico (ex.: JSON de campo_pdf ou algo estruturado)
            else if (typeof valor === 'object') {
                dados.valor = JSON.stringify(valor);
            }

            list_valores.push(dados);
            cont++;
        });

        if(list_valores.length > 0){
            formData.append('valores', JSON.stringify(list_valores))
        }

        //gera o pdf de farmaco com base em um modelo
        if (programa_dados.farmacovigilancia_pdf_modelo) {
            const nome_modelo = programa_dados.farmacovigilancia_modelo;

            let templateUrl = `/farmaco/${nome_modelo}_farmacovigilancia.pdf`;

            try {
                const pdfBlob = await this.gerarPdfFarmaco(templateUrl, valoresCampos, camposOutro);

                // Alguns browsers não têm File(), então usamos Blob e passamos filename no terceiro arg de append
                formData.append('farmacovigilancia_pdf', pdfBlob, "farmacovigilancia.pdf");
            } 
            catch (e) {
                Swal.fire('Erro!', 'Falha ao gerar PDF de farmacovigilância.', 'error');
                console.error('Falha ao gerar PDF de farmacovigilância', e);
                return
            }
        }

        api.post('/atendimentos/relatos/', formData)
        .then(response => {
            const relatoId = response.data.id;
            
            this.setState({loading:false})
            Swal.fire({
                title: 'Sucesso!',
                text: 'Atendimento salvo com sucesso.',
                icon: 'success'
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    this.handleCloseModalBotao(); // Chamada para fechar o modal
                    window.location.reload();
                }
            });
        })
        .catch(error => {
            this.setState({loading:false})
            console.error('Erro ao salvar o relato de atendimento:', error);

            Swal.fire('Erro!', 'Não foi possível salvar o atendimento.', 'error');
            //Sentry.captureException('Erro ao salvar o relato de atendimento:', error);
        });
    };

    getServicosAtendimento = (num_page = 1) => {
        this.setState({ servicos_atendimento_loading: true });
        api.get(`/atendimentos/servicos/?atendimento_id=${this.state.atendimento_id}&limit=${this.state.servicos_atendimento_limite}&page=${num_page}`)
        .then(response => {
            this.setState({ 
                servicos_atendimento: response.data.results,
                servicos_atendimento_data: response.data,
                servicos_atendimento_loading: false,
            });
        })

        .catch(error => {
            console.error('Erro ao carregar serviços do atendimento:', error);
            Sentry.captureException('Erro ao carregar serviços do atendimento:', error);
            this.setState({ servicos_atendimento_loading: false });
        });
    }
    
    // Carrega todos os serviços do atendimento (sem paginação) para uso em verificações
    // como .some() na aba de Agendamentos (botão de gerar serviço relacionado / faturar)
    getServicosAtendimentoAll = () => {
        api.get(`/atendimentos/servicos/?atendimento_id=${this.state.atendimento_id}&limit=500`)
        .then(response => {
            this.setState({ 
                servicos_atendimento_all: response.data.results,
            });
        })
        .catch(error => {
            console.error('Erro ao carregar todos os serviços do atendimento:', error);
        });
    }

    getLogsAtendimento = (num_page=1) => {
        api.get(`/logs/?atendimento_id=${this.state.atendimento_id}&limit=${this.state.logs_limite}&page=${num_page}`)
        .then(response => {
            this.setState({ 
                logs_atendimento: response.data,
                loading: false,
            });
        })
        .catch(error => {
            console.error('Erro ao carregar logs do atendimento:', error);
            Sentry.captureException('Erro ao carregar logs do atendimento:', error);                                
        });
    }

    getLogsAtendimentoCampos = () => {
        api.get(`/atendimentos/campos/historico/?atendimento_id=${this.state.atendimento_id}`)
        .then(response => {
            this.setState({ 
                logs_atendimento_campos: response.data,
            });
        })
        .catch(error => {
            console.error('Erro ao carregar logs do atendimento:', error);
            Sentry.captureException('Erro ao carregar logs do atendimento:', error);                                
        });
    }

    handleSelectTabs = (key) => {
        this.setState({ tab_key: key })

        if(key == 'servicosRelacionados'){
            //consulta os serviços do atendimento
            this.setState({ servicos_atendimento_page_numb: 1 }, () => {
                this.getServicosAtendimento(1);
            });
        } 
        else if(key == 'logsAtendimento'){
            //consulta os logs do atendimento
            this.getLogsAtendimento()
        }
        else if(key == 'agendamentoServicos'){
            //consulta os agendamentos
            this.setState({ agendamentos_page_numb: 1 }, () => {
                this.carregarAgendamentos(1);
            });
        } 
        else if(key == 'kitsPrograma') {
            this.buscarEnderecos();
            this.buscarKitsAgendados();
        } 
                    
    }

    handleMarcarAcaoProximaComoRealizada = async () => {
        const acao = this.state.proxima_acao;
        if (!acao?.id) {
            Swal.fire('Atenção', 'Nenhuma ação encontrada.', 'warning');
            return;
        }

        const confirm = await Swal.fire({
            title: 'Confirmar?',
            text: 'Deseja marcar esta ação como realizada?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, marcar',
            cancelButtonText: 'Cancelar'
        });

        if (!confirm.isConfirmed) return;

        this.setState({ loading: true });

        try {
            const getResp = await api.get(`/atendimentos/acoes/${acao.id}/`);
            const atual = getResp.data;

            const payload = {
            atendimento_id: atual.atendimento_id ?? this.state.atendimento_id,
            etapa_id: (atual.etapa_id ?? atual.etapa?.id ?? this.state.etapa_atual?.id) || null,
            programa_acao_id: atual.programa_acao_id ?? atual.programa_acao?.id ?? this.state.programa_acao_id,
            descricao: atual.descricao ?? this.state.acao_descricao ?? '',
            data_acao: atual.data_acao ?? this.state.acao_data,
            hora_acao: atual.hora_acao ?? this.state.acao_hora,
            realizado: true,
            pessoa_id: atual.pessoa_id ?? 1
            };

            await api.put(`/atendimentos/acoes/${acao.id}/`, payload);

            await Swal.fire('Sucesso', 'Ação marcada como realizada.', 'success');

            this.setState({ proxima_acao: null });
            if (typeof this.carregarAcoes === 'function') this.carregarAcoes();

            window.location.reload();

        } catch (error) {
            console.error('Erro ao marcar ação:', error);
            if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data); 
            const serverMsg = typeof error.response.data === 'string'
                ? error.response.data
                : JSON.stringify(error.response.data);
            Swal.fire('Erro', `Não foi possível atualizar a ação. Detalhes: ${serverMsg}`, 'error');
            } else {
            Swal.fire('Erro', 'Não foi possível atualizar a ação.', 'error');
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    handleAceiteTermoTelefone = (event) => {
            
        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

        const proximaEtapa = indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1 
        ? this.state.etapas_atendimento[indiceEtapaAtual + 1] 
        : null;

        const MySwal = withReactContent(Swal);

        // ---------- helpers de formatação (espelhados do FormularioRender) ----------
        const formatHip = (raw = "") => {
            const only = String(raw).replace(/\D+/g, "").slice(0, 10);
            if (only.length <= 8) return only;
            return `${only.slice(0,8)}-${only.slice(8)}`;
        };

        const formatGoto = (raw = "") => {
            const hex = String(raw).toLowerCase().replace(/[^0-9a-f]+/g, "").slice(0, 32);
            const g1 = hex.slice(0, 8);
            const g2 = hex.slice(8, 12);
            const g3 = hex.slice(12, 16);
            const g4 = hex.slice(16, 20);
            const g5 = hex.slice(20, 32);
            return [g1, g2, g3, g4, g5].filter(Boolean).join("-");
        };

        const HIP_RE  = /^\d{8}-\d{2}$/;
        const UUID_RE = /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/;
        // ---------- fim helpers ----------

        MySwal.fire({
            title: 'Aceite de Termo por Telefone',
            width: 480,
            html: `
                <p>Tem certeza que deseja confirmar o aceite do termo por telefone?</p>
                <div style="text-align:left; margin-bottom:12px;">
                    <label for="canalAceite" style="font-weight:600; font-size:14px;">Canal de contato:</label>
                    <select id="canalAceite" class="form-select form-select-sm" style="margin-top:4px;">
                        <option value="">Selecione...</option>
                        <option value="whatsapp">Whatsapp</option>
                        <option value="telefone">Telefone</option>
                    </select>
                </div>
                <div id="chamadaIdContainer" style="display:none; text-align:left; margin-bottom:12px;">
                    <label for="chamadaId" style="font-weight:600; font-size:14px;">ID da chamada:</label>
                    <div style="display:flex; gap:6px; align-items:center; margin-top:4px;">
                        <input id="chamadaId" class="form-control form-control-sm" style="flex:1;" placeholder="" autocomplete="off">
                        <button type="button" id="btnConsultarLigacoes" class="btn btn-secondary btn-sm" style="display:none; white-space:nowrap;">Consultar</button>
                    </div>
                    <small id="chamadaIdHint" style="color:#888; display:block; margin-top:2px;"></small>
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',
            didOpen: () => {
                const selectCanal = document.getElementById('canalAceite');
                const container = document.getElementById('chamadaIdContainer');
                const inputId = document.getElementById('chamadaId');
                const btnConsultar = document.getElementById('btnConsultarLigacoes');
                const hint = document.getElementById('chamadaIdHint');

                selectCanal.addEventListener('change', () => {
                    const val = selectCanal.value;
                    if (val) {
                        container.style.display = 'block';
                        inputId.value = '';
                    } else {
                        container.style.display = 'none';
                        inputId.value = '';
                    }

                    if (val === 'whatsapp') {
                        inputId.placeholder = '00000000-00';
                        inputId.maxLength = 11;
                        inputId.inputMode = 'numeric';
                        hint.textContent = 'Formato: 00000000-00 (protocolo Hi Platform)';
                        btnConsultar.style.display = 'none';
                    } else if (val === 'telefone') {
                        inputId.placeholder = '00000000-0000-0000-0000-000000000000';
                        inputId.maxLength = 36;
                        inputId.inputMode = 'text';
                        hint.textContent = 'Formato: UUID (LEG ID do GoToConnect)';
                        btnConsultar.style.display = 'inline-block';
                    }
                });

                // Máscara ao digitar
                inputId.addEventListener('input', () => {
                    const canal = selectCanal.value;
                    if (canal === 'whatsapp') {
                        inputId.value = formatHip(inputId.value);
                    } else if (canal === 'telefone') {
                        inputId.value = formatGoto(inputId.value);
                    }
                });

                // Máscara ao colar
                inputId.addEventListener('paste', (e) => {
                    const text = e.clipboardData?.getData('text') ?? '';
                    e.preventDefault();
                    const canal = selectCanal.value;
                    if (canal === 'whatsapp') {
                        inputId.value = formatHip(text);
                    } else if (canal === 'telefone') {
                        inputId.value = formatGoto(text);
                    }
                });

                // Botão Consultar abre o modal de histórico de ligações
                // Esconde temporariamente o SweetAlert para o modal Bootstrap ficar por cima
                btnConsultar.addEventListener('click', () => {
                    const swalContainer = document.querySelector('.swal2-container');
                    if (swalContainer) swalContainer.style.zIndex = '1040';

                    this.setState({
                        showModalConsultaHistoricoLigacoes: true,
                        goto_hist_campo_id: '__aceite_termo_telefone__',
                    });
                });
            },
            preConfirm: () => {
                const canal = document.getElementById('canalAceite').value;
                const chamadaId = document.getElementById('chamadaId').value.trim();

                if (!canal) {
                    Swal.showValidationMessage('Por favor, selecione o canal de contato.');
                    return false;
                }
                if (!chamadaId) {
                    Swal.showValidationMessage('Por favor, informe a ID da chamada.');
                    return false;
                }

                // Validação de formato
                if (canal === 'whatsapp' && !HIP_RE.test(chamadaId)) {
                    Swal.showValidationMessage('Formato inválido. Use: 00000000-00');
                    return false;
                }
                if (canal === 'telefone' && !UUID_RE.test(chamadaId)) {
                    Swal.showValidationMessage('Formato inválido. Use o formato UUID (ex: 00000000-0000-0000-0000-000000000000)');
                    return false;
                }

                return { canal, chamadaId };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({loading:true})
                const { canal, chamadaId } = result.value;

                const dataAtual = getDataAtual();

                const payload = {
                    'atualiza_comprovante': true,
                    'optin_telefone': true,
                    'optin_data': dataAtual,
                    'optin_telefone_chamada_id': chamadaId,
                    'optin_telefone_canal': canal,
                }
                
                if(proximaEtapa) {
                    payload['proxima_etapa_id'] = proximaEtapa.id;
                }
        
                api.put(`/atendimentos/${this.state.atendimento_id}/`, payload, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    Swal.fire({
                        title: 'Sucesso',
                        html: 'Termo aceito por telefone com sucesso',
                        icon: 'success',
                        showCloseButton: true,
                    }).then((result) => {
                        if (result.isConfirmed || result.dismiss) {
                            window.location.reload();
                        }
                    });
                })
                .catch(error => {
                    this.setState({loading:false})

                    Swal.fire('Atenção!', 'Ocorreu um erro ao aceitar o termo', 'error');
                    //Sentry.captureException('Ocorreu um erro ao enviar o termo assinado', error);
                });
            }
        });
    }

    clickFileInputTermoAssinado = (item_id) => {
        this.setState({uploadTermoAssinadoId: item_id})

        this.fileInputTermoAssinado.current.click()
    }

    handleChangeTermoAssinado = (event) => {
        const file = event.target.files[0];

        if (file && file.type === 'application/pdf') {
            this.setState({loading:true})

            const dataAtual = getDataAtual()
            const formData = new FormData();
            
            formData.append('termo_pdf_assinado', file);            
            formData.append('data_assinatura', dataAtual);
    
            api.put(`/atendimentos/atualizacao_termos/${this.state.uploadTermoAssinadoId}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                Swal.fire({
                    title: 'Sucesso',
                    html: 'Termo assinado enviado com sucesso',
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            })
            .catch(error => {
                this.setState({loading:false})

                Swal.fire('Atenção!', 'Ocorreu um erro ao enviar o termo assinado', 'error');
                //Sentry.captureException('Ocorreu um erro ao enviar o termo assinado', error);
            });
        } else {
            Swal.fire('Atenção!', 'Por favor, selecione um arquivo PDF', 'error');
        }
    }

    handleChangeComprovante = (event) => {
        const file = event.target.files[0];

        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

        const proximaEtapa = indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1 
        ? this.state.etapas_atendimento[indiceEtapaAtual + 1] 
        : null;

        if (file && file.type === 'application/pdf') {
            this.setState({loading:true})
            const formData = new FormData();

            const dataAtual = getDataAtual()
            
            formData.append('termo_paciente_pdf_comprovante', file);
            formData.append('atualiza_comprovante', true);
            formData.append('optin_data', dataAtual);
            if(proximaEtapa) {
                formData.append('proxima_etapa_id', proximaEtapa.id);
            }
    
            api.put(`/atendimentos/${this.state.atendimento_id}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                Swal.fire({
                    title: 'Sucesso',
                    html: 'Termo assinado enviado com sucesso',
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            })
            .catch(error => {
                this.setState({loading:false})

                Swal.fire('Atenção!', 'Ocorreu um erro ao enviar o termo assinado', 'error');
                //Sentry.captureException('Ocorreu um erro ao enviar o termo assinado', error);
            });
        } else {
            Swal.fire('Atenção!', 'Por favor, selecione um arquivo PDF', 'error');
        }
    }

    adicionarMonitoriaDosagem = () => {
        this.setState(prevState => ({
            monitoria_dosagens: [...prevState.monitoria_dosagens, {dosagem_id: '', quantidade: ''}],
        }));
    };


    handleChangeComprovanteLaboratorio = (event) => {
        const file = event.target.files[0];

        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

        const proximaEtapa = indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1 
        ? this.state.etapas_atendimento[indiceEtapaAtual + 1] 
        : null;

        if (file && file.type === 'application/pdf') {
            this.setState({loading:true})
            const formData = new FormData();

            const dataAtual = getDataAtual();

            formData.append('termo_prestador_pdf_comprovante', file);
            formData.append('atualiza_comprovante', true);
            formData.append('optin_data_laboratorio', dataAtual);
            if(proximaEtapa) {
                formData.append('proxima_etapa_id', proximaEtapa.id);
            }
    
            api.put(`/atendimentos/${this.state.atendimento_id}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                Swal.fire({
                    title: 'Sucesso',
                    html: 'Termo assinado enviado com sucesso',
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        window.location.reload();
                    }
                });
            })
            .catch(error => {
                this.setState({loading:false})

                Swal.fire('Atenção!', 'Ocorreu um erro ao enviar o termo assinado', 'error');
                ////Sentry.captureException('Ocorreu um erro ao enviar o termo assinado', error);
            });
        } else {
            Swal.fire('Atenção!', 'Por favor, selecione um arquivo PDF', 'error');
        }
    }

    // Método para alternar a visibilidade dos detalhes de cada relato
    toggleDetalhesRelato = (relatoId) => {
        this.setState(prevState => ({
            exibirDetalhesRelato: {
                ...prevState.exibirDetalhesRelato,
                [relatoId]: !prevState.exibirDetalhesRelato[relatoId]
            }
        }));
    }

    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };
    /*Funções relacionadas a aba de dosagens */
    handleCloseModalDosagem = () => {
        this.setState({ showModalDosagem: false });
    };

    handleShowModalDosagem = (dosagem) => {
        //this.limparEstadoModal();

        this.setState({ 
            dosagem_id: dosagem ? dosagem.id : '',
            dosagem_nome: dosagem ? dosagem.nome : '',
            dosagem_frequencia: dosagem ? dosagem.frequencia : '',
            dosagem_dosagem: dosagem ? dosagem.dosagem : '',
            dosagem_produto_id: dosagem ? dosagem.produto_id : '',
            dosagem_produto_nome: dosagem ? dosagem.dados_produto.nome : '',
            dosagem_apresentacao_id: dosagem ? dosagem.apresentacao_id : '',
            dosagem_apresentacao_descricao: dosagem ? dosagem.dados_apresentacao.descricao : '',
            dosagem_quantidade: dosagem ? dosagem.quantidade : '',
            dosagem_dosagem: dosagem ? dosagem.dosagem : '',
            showModalDosagem: true
        }, () => {
            
        });
    };
    
    handleChangeDosagem = (e, fieldName) => {
        if(fieldName == 'dosagem_produto_id'){
            this.setState({ dosagem_produto_id: e.value, dosagem_produto_nome: e.label });
        } else if (fieldName == 'dosagem_apresentacao_id'){
            this.setState({ dosagem_apresentacao_id: e.value, dosagem_apresentacao_descricao: e.label });
        } else {
            const { name, value } = e.target;
            this.setState({ [name]: value });
        }        
    }

    deletarDosagem = (item_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir dosagem?',
            text: "Tem certeza que deseja excluir esta dosagem do produto?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
    
                api.delete(`/atendimentos/produtos/dosagens/${item_id}/`)
                .then(response => {
                    MySwal.fire(
                        'Excluído!',
                        'A dosagem foi excluída com sucesso.',
                        'success'
                    );
                    this.setState({ loading: false });
                    //consulta os produtos do atendimento
                    this.carregarDosagens();
                })
                .catch(error => {
                    Sentry.captureException('Houve um erro ao tentar excluir a dosagem do produto. Por favor, tente novamente.', error);

                    MySwal.fire(
                        'Erro!',
                        'Houve um erro ao tentar excluir a dosagem do produto. Por favor, tente novamente.',
                        'error'
                    );
                    this.setState({ loading: false });
                });
            }
        });
    }

    carregarDosagens = () => {
        let dados_usuario = getCurrentUser();
        if (this.state.atendimento_id && hasPerm('view_agendamentos')) {
            const url = `/atendimentos/produtos/dosagens/?atendimento_id=${this.state.atendimento_id}`
            api.get(url)
                .then(response => {
                    this.setState({ dosagens: response.data });
                })
                .catch(error => {
                    console.error('Erro ao carregar dosagens:', error);
                    //Sentry.captureException('Erro ao carregar dosagens:', error);
                    
                    let erro_msg = 'Erro ao carregar dosagens, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                });
        }
    };

    enviaDosagem = (e) => {
        e.preventDefault();

        if (!this.state.dosagem_produto_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhum produto selecionado. Por favor, selecione um produto para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.dosagem_apresentacao_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma apresentação informada. Por favor, informe a apresentação da dosagem.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.dosagem_quantidade) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma quantidade informada. Por favor, informe a quantidade da dosagem.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.dosagem_frequencia) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma frequência informada. Por favor, informe a frequência da dosagem.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        const MySwal = withReactContent(Swal)

        this.setState({
            loading: true,
        });

        //vererifica se é edição ou adição
        const url = (this.state.dosagem_id) ? '/atendimentos/produtos/dosagens/'+this.state.dosagem_id+'/' : '/atendimentos/produtos/dosagens/'
        const metodo = (this.state.dosagem_id) ? 'put' : 'post'

        //retirei o valor do produto
        //envia para api
        api({
            method: metodo,
            url: url,
            data: {
                produto_id: this.state.dosagem_produto_id,
                atendimento_id: this.state.atendimento_id,
                frequencia: this.state.dosagem_frequencia,
                quantidade: this.state.dosagem_quantidade,
                apresentacao_id: this.state.dosagem_apresentacao_id,
                dosagem: this.state.dosagem_dosagem
            }
        })
        .then(response => {
            
            const textSwal = (this.state.dosagem_id) ? 'Dosagem atualizada com sucesso' : 'Dosagem cadastrada com sucesso';

            this.setState({
                loading: false,
                showModalDosagem: false
            });

            // Tudo concluído aqui, agora pode navegar
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                this.carregarDosagens();
                this.handleCloseModalDosagem();
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar dosagem, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                }
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    /*Funções relacionadas a aba de dosagens */
    handleCloseModalCompra = () => {
        this.setState({ showModalCompra: false });
    };

    handleShowModalCompra = (compra) => {
        //this.limparEstadoModal();

        this.setState({ 
            compra_id: compra ? compra.id : '',
            compra_data_compra: compra ? compra.data_compra : '',
            compra_data_proxima_compra: compra ? compra.data_proxima_compra : '',
            compra_farmacia_id: compra ? compra.farmacia_id : '',
            compra_farmacia_nome: compra ? compra.dados_farmacia.nome : '',
            compra_produto_id: compra ? compra.produto_id : '',
            compra_produto_nome: compra ? compra.dados_produto.nome : '',
            compra_etapa_id: compra ? compra.etapa_id : '',
            compra_etapa_nome: compra ? compra.dados_etapa.nome : '',
            showModalCompra: true
        }, () => {
            
        });
    };
    
    handleChangeCompra = (e, fieldName) => {
        if(fieldName == 'compra_produto_id'){
            this.setState({ compra_produto_id: e.value, compra_produto_nome: e.label });
        } else if(fieldName == 'compra_farmacia_id'){
            this.setState({ compra_farmacia_id: e.value, compra_farmacia_nome: e.label });
        } else if(fieldName == 'compra_etapa_id'){
            this.setState({ compra_etapa_id: e.value, compra_etapa_nome: e.label });
        } else {
            const { name, value } = e.target;
            this.setState({ [name]: value });
        }        
    }

    deletarCompra = (item_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir compra?',
            text: "Tem certeza que deseja excluir esta compra do produto?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
    
                api.delete(`/atendimentos/compras/${item_id}/`)
                .then(response => {
                    MySwal.fire(
                        'Excluído!',
                        'A compra foi excluída com sucesso.',
                        'success'
                    );
                    this.setState({ loading: false });
                    //consulta os produtos do atendimento
                    this.carregarProdutos();
                })
                .catch(error => {
                    Sentry.captureException('Houve um erro ao tentar excluir a compra do produto. Por favor, tente novamente.', error);

                    MySwal.fire(
                        'Erro!',
                        'Houve um erro ao tentar excluir a compra do produto. Por favor, tente novamente.',
                        'error'
                    );
                    this.setState({ loading: false });
                });
            }
        });
    }

    carregarCompras = () => {
        let dados_usuario = getCurrentUser();
        if (this.state.atendimento_id && hasPerm('view_agendamentos')) {
            const url = `/atendimentos/compras/?atendimento_id=${this.state.atendimento_id}`
            api.get(url)
                .then(response => {
                    this.setState({ compras: response.data });
                })
                .catch(error => {
                    console.error('Erro ao carregar compras:', error);
                    //Sentry.captureException('Erro ao carregar compras:', error);
                    
                    let erro_msg = 'Erro ao carregar compras, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                });
        }
    };

    enviaCompra = (e) => {
        e.preventDefault();

        if (!this.state.compra_produto_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhum produto selecionado. Por favor, selecione um produto para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.compra_farmacia_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma farmácia selecionada. Por favor, selecione uma farmácia para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.compra_etapa_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma etapa selecionada. Por favor, selecione uma etapa para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        const MySwal = withReactContent(Swal)

        this.setState({
            loading: true,
        });

        //vererifica se é edição ou adição
        const url = (this.state.compra_id) ? '/atendimentos/compras/'+this.state.compra_id+'/' : '/atendimentos/compras/'
        const metodo = (this.state.compra_id) ? 'put' : 'post'

        //retirei o valor do produto
        //envia para api
        api({
            method: metodo,
            url: url,
            data: {
                produto_id: this.state.compra_produto_id,
                atendimento_id: this.state.atendimento_id,
                farmacia_id: this.state.compra_farmacia_id,
                etapa_id: this.state.compra_etapa_id,
                data_compra: this.state.compra_data_compra,
                data_proxima_compra: this.state.compra_data_proxima_compra
            }
        })
        .then(response => {
            
            const textSwal = (this.state.compra_id) ? 'Compra atualizada com sucesso' : 'Compra cadastrada com sucesso';

            this.setState({
                loading: false
            });

            // Tudo concluído aqui, agora pode navegar
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                this.carregarCompras();
                this.handleCloseModalCompra();
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar compra, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                }
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    carregarEtapasPrograma = async (inputValue) => {
        try {
            const response = await api.get(`/programas/etapas/?programa_id=${this.state.programa_id}&nome=${inputValue}&status=1`);
            const opcoes = response.data.results.map(etapa => ({
                value: etapa.id,
                label: etapa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar etapas:', error);
            return [];
        }
    }

    carregarFarmacias = async (inputValue) => {
        try {
            const response = await api.get(`/farmacias/?nome=${inputValue}`);
            const opcoes = response.data.results.map(farmacia => ({
                value: farmacia.id,
                label: farmacia.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar farmácias:', error);
            return [];
        }
    }

    renderizaCamposHistoricoBKP = (campos) => {
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {}
        for(let i = 0; i < campos.length; i++) {
            let item = campos[i];
            const secao = item.formulario_campo__sessao || '0_sem_sessao'

            if(!(secao in objCampos)){
                objCampos[secao] = [];    
            }

            objCampos[secao].push(item)
        }

        return (
            Object.keys(objCampos).map((nome_secao) => (
                <div className="row-list pb-0 mb-2" key={nome_secao}>
                    {nome_secao && <h6><strong>{tiposSessoesCampos[nome_secao] ? tiposSessoesCampos[nome_secao] : (nome_secao === '0_sem_sessao' ? '' : nome_secao)}</strong></h6>}            
                    <Row>
                        {objCampos[nome_secao].map((campo) => (
                        <React.Fragment key={campo.id}>
                            <div key={campo.id} className="col-12 col-sm-6">
                                {campo.arquivo ? (
                                    <>
                                        <Button variant="light" className="btn-sm mb-3" href={campo.arquivo} target="_blank">
                                            <FaEye /> Ver {campo.formulario_campo__nome}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <strong>{campo.formulario_campo__nome}:</strong>
                                        {campo.valor.match(/^\d{4}-\d{2}-\d{2}$/) ? (
                                            <p>{formataDataExibicao(campo.valor)}</p>
                                        ) : (
                                            <div style={{ whiteSpace: "pre-wrap" }}>
                                                <p>
                                                {campo.valor === "true"
                                                    ? "Sim"
                                                    : campo.valor === "false"
                                                    ? "Não"
                                                    : campo.valor}
                                                </p>
                                            </div>
                                        )}                                                                             
                                    </>
                                )}
                            </div>
                        </React.Fragment>
                        ))}
                    </Row>
                </div>
            ))        
        );
    }

    renderizaCamposHistorico = (campos) => {
        const dados_usuario = getCurrentUser();
        // agrupa por sessão
        const objCampos = {};
        campos.forEach(item => {
            const secao = item.formulario_campo__sessao || '0_sem_sessao';
            if (!objCampos[secao]) objCampos[secao] = [];
            objCampos[secao].push(item);
        });

        return Object.entries(objCampos).map(([nome_secao, lista]) => {
            return (
            <div className="row-list pb-0 mb-2" key={nome_secao}>
                {nome_secao !== '0_sem_sessao' && (
                <h6>
                    <strong>
                    {tiposSessoesCampos[nome_secao] || nome_secao}
                    </strong>
                </h6>
                )}
                <Row>
                {lista.map(campo => {
                    const isEditing = !!this.state.editingCampoValues[campo.id];
                    const editedValue = this.state.campoEditadoValores[campo.id] ?? campo.valor;

                    return (
                    <Col xs={12} sm={6} key={campo.id} className="mb-3">
                        {campo.arquivo ? (
                        <Button
                            variant="light"
                            size="sm"
                            className="mb-3"
                            href={campo.arquivo}
                            target="_blank"
                        >
                            <FaEye className="me-1" /> Ver {campo.formulario_campo__nome}
                        </Button>
                        ) : (
                        <React.Fragment>
                            {/* título + lápis */}
                            <div className="d-flex align-items-center mb-1">
                            <strong className="me-2">
                                {campo.formulario_campo__nome}:
                            </strong>
                            {(dados_usuario.tipo_usuario === '' || dados_usuario.tipo_usuario === 'gestor') && (
                                <FaPencilAlt
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                    this.toggleEditCampo(campo.id, campo.valor)
                                    }
                                />
                            )}
                            </div>

                            {isEditing ? (
                            // modo edição: input + check
                            <div className="d-flex">
                                <Form.Control
                                type="text"
                                value={editedValue}
                                onChange={e =>
                                    this.handleCampoValueChange(campo.id, e.target.value)
                                }
                                className="me-2"
                                />
                                <Button
                                    size="sm"
                                    variant="success"
                                    disabled={!!this.state.updatingCampoValues[campo.id]}
                                    onClick={() => this.saveCampoValor(campo)}
                                >
                                    {this.state.updatingCampoValues[campo.id] ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : (
                                        <FaCheck />
                                    )}
                                </Button>
                            </div>
                            ) : (
                            // modo leitura: exibe valor
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                {campo.valor.match(/^\d{4}-\d{2}-\d{2}$/) ? (
                                <p>{formataDataExibicao(campo.valor)}</p>
                                ) : (
                                <p>
                                    {campo.valor === 'true'
                                    ? 'Sim'
                                    : campo.valor === 'false'
                                    ? 'Não'
                                    : campo.valor}
                                </p>
                                )}
                            </div>
                            )}
                        </React.Fragment>
                        )}
                    </Col>
                    );
                })}
                </Row>
            </div>
            );
        });
        };

    handleAlterarMedico = (value) => {
        this.setState({ alterar_medico: key })
    }

    handleEnviarWhatsapp = () => {
        const { atendimento_id, etapa_atual, templateEscolhido } = this.state;
    
        if (!templateEscolhido) {
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Selecione um template antes de enviar a mensagem.",
            });
            return;
        }
    
        Swal.fire({
            title: "Enviar Whatsapp?",
            html: `Deseja realmente enviar a mensagem de WhatsApp?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, enviar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
    
                api.post("/mensageria/etapa/", {
                    atendimento_id,
                    etapa_id: etapa_atual.id,
                    template_whatsapp: templateEscolhido,
                })
                    .then(() => {
                        this.setState({ loading: false, templateEscolhido: "", showModalTemplateWhatsapp: false });
                        Swal.fire({
                            icon: "success",
                            title: "Enviado!",
                            text: "Mensagem enviada com sucesso.",
                        });
                    })
                    .catch((error) => {
                        console.error("Erro ao enviar mensagem WhatsApp:", error);
                        this.setState({ loading: false });
                        Swal.fire({
                            icon: "error",
                            title: "Erro",
                            text: "Ocorreu um erro ao enviar a mensagem. Tente novamente.",
                        });
                    });
            }
        });
    };

    handleShowHistorico = (campoId, campoNome) => {
        const { atendimento_id } = this.state;
    
        // Chama o endpoint para buscar o histórico
        api.get(`/atendimentos/campos/historico/?atendimento_id=${atendimento_id}&campo_id=${campoId}`)
            .then((response) => {
                this.setState({
                    historicoCampos: response.data,
                    nomeCampoHistorico: campoNome,
                    showModalHistorico: true,
                });
            })
            .catch((error) => {
                console.error("Erro ao carregar histórico:", error);
                Swal.fire({
                    icon: "error",
                    title: "Erro",
                    text: "Não foi possível carregar o histórico.",
                });
            });
    };
    
    handleCloseHistorico = () => {
        this.setState({ showModalHistorico: false, historicoCampos: [] });
    };

    handleShowModalTemplateWhatsapp = () => {
        this.setState({
            showModalTemplateWhatsapp: true
        });
    };

    handleCloseModalTemplateWhatsapp = () => {
        this.setState({
            showModalTemplateWhatsapp: false
        });
    };

    renderModalTemplateWhatsapp = () => {
        const dados_usuario = getCurrentUser();

        return (
            <Modal show={this.state.showModalTemplateWhatsapp} size="lg" onHide={this.handleCloseModalTemplateWhatsapp}>
                <Modal.Header closeButton>
                    <Modal.Title>Enviar Template Whatsapp</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="align-items-center mt-3">
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label><strong>Selecione abaixo o template que deseja enviar</strong></Form.Label>
                                <Form.Control
                                    as="select"
                                    value={this.state.templateEscolhido || ""}
                                    onChange={(e) =>
                                        this.setState({ templateEscolhido: e.target.value })
                                    }
                                >
                                    <option value="">Escolha o template</option>
                                    {this.state.templates_whatsapp.map((template) => (
                                        <option
                                            key={template.id}
                                            value={template.template}
                                        >
                                            {template.titulo}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col sm={12} className="mt-2">
                            <Button
                                type="button"
                                variant="success"
                                className="btn-sm"
                                disabled={!this.state.templateEscolhido || this.state.loading}
                                onClick={() => this.handleEnviarWhatsapp()}
                            >
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    "Enviar"
                                )}
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={this.handleCloseModalTemplateWhatsapp}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handleReativarAtendimento = () => {
        const { atendimento_id } = this.state;
    
        Swal.fire({
            title: "Reativar Atendimento?",
            text: "Você tem certeza que deseja reativar este atendimento?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, reativar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                // Exibe um loading enquanto realiza a requisição
                Swal.fire({
                    title: "Reativando...",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                //Pega o status da etapa anterior
                const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

                const etapaAnterior = indiceEtapaAtual >= 1 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1 
                    ? this.state.etapas_atendimento[indiceEtapaAtual - 1] 
                    : null;

                let payload = {
                    cancelado: false,
                    finalizado: false,
                    optout_reativar: true
                    //optout_motivo_id: ''
                }

                if(etapaAnterior) {
                    if(etapaAnterior.status_finalizacao_etapa_id){
                        const status_etapa_id = etapaAnterior.status_finalizacao_etapa_id;

                        payload['programa_status_id'] = status_etapa_id;
                    }
                } else {
                    // Usa o primeiro status do programa_dados.dados_status
                    const primeiroStatus = this.state.programa_dados.dados_status?.[0];
                    if (primeiroStatus) {
                        payload["programa_status_id"] = primeiroStatus.id;
                    }
                }
    
                // Envia a requisição PUT para atualizar o atendimento
                api.put(`/atendimentos/${atendimento_id}/`, payload)
                .then(() => {
                    // Fecha o loading e exibe o alerta de sucesso
                    Swal.fire({
                        icon: "success",
                        title: "Sucesso",
                        text: "O atendimento foi reativado com sucesso.",
                    }).then(() => {
                        // Recarrega a página
                        window.location.reload();
                    });
                })
                .catch((error) => {
                    console.error("Erro ao reativar atendimento:", error);
                    // Fecha o loading e exibe o alerta de erro
                    Swal.fire({
                        icon: "error",
                        title: "Erro",
                        text: "Não foi possível reativar o atendimento. Tente novamente.",
                    });
                });
            }
        });
    };

    handleReativarAtendimentoFinalizado = async () => {
        const { atendimento_id } = this.state;

        Swal.fire({
            title: "Reativar Atendimento?",
            text: "Você tem certeza que deseja reativar este atendimento e iniciar novo ciclo?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, reativar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {

                // Loading
                Swal.fire({
                    title: "Reativando...",
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });

                try {

                    // -------------------------------------
                    // 1) Atualiza o atendimento
                    // -------------------------------------
                    let payload = {
                        cancelado: false,
                        finalizado: false
                    };

                    await api.put(`/atendimentos/${atendimento_id}/`, payload);

                    // -------------------------------------
                    // 2) Salva o relato de reativação
                    // -------------------------------------
                    await this.relatoReativacaoAtendimento();

                    // -------------------------------------
                    // 3) Sucesso → Fecha loading, mostra alerta e recarrega
                    // -------------------------------------
                    Swal.fire({
                        icon: "success",
                        title: "Sucesso",
                        text: "O atendimento foi reativado com sucesso.",
                    }).then(() => {
                        window.location.reload();
                    });

                } catch (error) {
                    console.error("Erro ao reativar atendimento:", error);

                    Swal.fire({
                        icon: "error",
                        title: "Erro",
                        text: "Não foi possível reativar o atendimento. Tente novamente.",
                    });
                }
            }
        });
    };

    relatoReativacaoAtendimento = () => {
        return new Promise((resolve, reject) => {

            const dataHoraAtualFormatada = getDataAtual();
            const { etapa_atual, atendimento_id } = this.state;

            let formData = new FormData();
            formData.append('data', dataHoraAtualFormatada);
            formData.append('etapa_id', etapa_atual.id);
            formData.append('atendimento_id', atendimento_id);
            formData.append('tipo', 'etapa');

            const tipo_recorrencia = etapa_atual.tipo_recorrencia;

            const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

            // próxima etapa (caso futuramente precise)
            const proximaEtapa = indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1
                ? this.state.etapas_atendimento[indiceEtapaAtual + 1]
                : null;

            if (this.state.etapa_atendimento_id) {
                let etapaUpdt = {
                    etapa_id: etapa_atual.id,
                    etapa_atendimento_id: this.state.etapa_atendimento_id,
                    status: 'concluido',
                    tipo_recorrencia: tipo_recorrencia,
                };

                formData.append('atendimento_etapa_updt', JSON.stringify(etapaUpdt));
            }

            // Requisição
            api.post('/atendimentos/relatos/', formData)
                .then(response => {
                    this.setState({ loading: false });
                    resolve(response);  // <-- importante
                })
                .catch(error => {
                    this.setState({ loading: false });
                    console.error('Erro ao salvar o relato:', error);
                    Swal.fire('Erro!', 'Não foi possível salvar o relato.', 'error');
                    reject(error); // <-- importante
                });
        });
    };
    
    handleCopy = (link) => {
        navigator.clipboard.writeText(link)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'Link copiado!',
                    text: 'O link foi copiado para a área de transferência.',
                    timer: 2000,
                    showConfirmButton: false
                });
            })
            .catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: 'Não foi possível copiar o link.',
                });
            });
    };

    handleShowModalPrestador = async (prestadorId = null, agendamento = null, servico = null) => {
        if(prestadorId) {
            try {
                const response = await api.get(`/pessoas/prestadores/${prestadorId}`);
                this.setState({
                    prestadorDados: response.data,
                    prestadorAgendamento: agendamento,
                    prestadorServico: servico,
                    showModalPrestador: true
                });
            } catch (error) {
                console.error('Erro ao carregar prestador:', error);
                // aqui pode usar Sentry.captureException, toast, etc
            }
        } else {
            this.setState({
                prestadorDados: {},
                prestadorAgendamento: agendamento,
                prestadorServico: servico,
                showModalPrestador: true
            });
        }
        
    }

    handleCloseModalPrestador = () => {
        this.setState({
            showModalPrestador: false,
            prestadorDados: {},
            prestadorAgendamento: null,
            prestadorServico: null,
            loadingAlterarPrestador: false
        });
    }
    
    // Função para alterar o prestador diretamente na listagem de agendamentos
    handleAlterarPrestadorAgendamento = async (agendamentoId, agendamento, novoPrestador) => {
        const MySwal = withReactContent(Swal);

        // Monta mensagem de confirmação
        let mensagemConfirmacao = `Deseja realmente alterar o prestador para <strong>${novoPrestador.label}</strong>?`;
        if (agendamento?.exame_solicitado) {
            mensagemConfirmacao += `<br /><br /><small class="text-muted">O laboratório do exame solicitado também será atualizado.</small>`;
        }
        
        // Confirmar a alteração
        const confirmResult = await MySwal.fire({
            icon: 'question',
            title: 'Alterar Prestador',
            html: mensagemConfirmacao,
            showCancelButton: true,
            confirmButtonText: 'Sim, alterar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
        });

        if (!confirmResult.isConfirmed) {
            // Usuário cancelou, resetar o state
            this.setState({ alterandoPrestadorAgendamentoId: null });
            return;
        }

        // Mostrar loading
        this.setState({ loadingAlterarPrestador: true });

        try {
            // 1. Atualizar o agendamento
            await api.put(`/agendamentos/${agendamentoId}/`, {
                prestador_id: novoPrestador.value
            });

            // 2. Se tiver exame solicitado, atualizar o laboratório
            if (agendamento?.exame_solicitado) {
                await api.put(`/exames/solicitados/${agendamento.exame_solicitado}/`, {
                    laboratorio_id: novoPrestador.value
                });
            }

            await MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'Prestador alterado com sucesso.',
                timer: 2000,
                showConfirmButton: false
            });

            // Fechar modal se estiver aberto e atualizar listagem
            this.setState({ 
                showModalPrestador: false,
                alterandoPrestadorAgendamentoId: null,
                loadingAlterarPrestador: false
            });

            // Recarregar agendamentos
            this.carregarAgendamentos();

        } catch (error) {
            console.error('Erro ao alterar prestador:', error);
            
            let errorMsg = 'Erro ao alterar o prestador. Tente novamente.';
            if (error.response?.data?.detail) {
                errorMsg = error.response.data.detail;
            } else if (error.response?.status === 500) {
                errorMsg = 'Servidor indisponível no momento.';
            }

            await MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: errorMsg
            });

            this.setState({ 
                loadingAlterarPrestador: false,
                alterandoPrestadorAgendamentoId: null
            });
        }
    }
    
    // Função para alterar o prestador de um serviço (aba Serviços Relacionados)
    handleAlterarPrestadorServico = async (servico, novoPrestador) => {
        const MySwal = withReactContent(Swal);
        
        // Buscar dados do agendamento se existir
        let agendamento = null;
        if (servico.agendamento_id) {
            agendamento = this.state.agendamentos?.find(a => a.id === servico.agendamento_id);
        }
        
        // Monta mensagem de confirmação
        let mensagemConfirmacao = `Deseja realmente alterar o prestador para <strong>${novoPrestador.label}</strong>?`;
        if (servico.agendamento_id) {
            mensagemConfirmacao += `<br /><br /><small class="text-muted">O agendamento #${servico.agendamento_id} relacionado também será atualizado.</small>`;
        }
        if (agendamento?.exame_solicitado) {
            mensagemConfirmacao += `<br /><small class="text-muted">O laboratório do exame solicitado também será atualizado.</small>`;
        }
        
        // Confirmar a alteração
        const confirmResult = await MySwal.fire({
            icon: 'question',
            title: 'Alterar Prestador do Serviço',
            html: mensagemConfirmacao,
            showCancelButton: true,
            confirmButtonText: 'Sim, alterar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
        });

        if (!confirmResult.isConfirmed) {
            return;
        }

        // Mostrar loading
        this.setState({ loadingAlterarPrestador: true });

        try {
            // 1. Atualizar o serviço
            await api.put(`/atendimentos/servicos/${servico.id}/`, {
                prestador_id: novoPrestador.value
            });

            // 2. Se tiver agendamento relacionado, atualizar também
            if (servico.agendamento_id) {
                await api.put(`/agendamentos/${servico.agendamento_id}/`, {
                    prestador_id: novoPrestador.value,
                    adicionar_servico_atendimento: false
                });
            }

            // 3. Se o agendamento tiver exame solicitado, atualizar o laboratório
            if (agendamento?.exame_solicitado) {
                await api.put(`/exames/solicitados/${agendamento.exame_solicitado}/`, {
                    laboratorio_id: novoPrestador.value
                });
            }

            await MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: servico.agendamento_id 
                    ? 'Prestador do serviço e do agendamento alterados com sucesso.'
                    : 'Prestador do serviço alterado com sucesso.',
                timer: 2000,
                showConfirmButton: false
            });

            // Fechar modal e atualizar listagens
            this.setState({ 
                showModalPrestador: false,
                prestadorServico: null,
                loadingAlterarPrestador: false
            });

            // Recarregar serviços e agendamentos
            this.getServicosAtendimento();
            this.getServicosAtendimentoAll();
            if (servico.agendamento_id) {
                this.carregarAgendamentos();
            }

        } catch (error) {
            console.error('Erro ao alterar prestador do serviço:', error);
            
            let errorMsg = 'Erro ao alterar o prestador. Tente novamente.';
            if (error.response?.data?.detail) {
                errorMsg = error.response.data.detail;
            } else if (error.response?.status === 500) {
                errorMsg = 'Servidor indisponível no momento.';
            }

            await MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: errorMsg
            });

            this.setState({ loadingAlterarPrestador: false });
        }
    }

    fetchMotivosCancelamento = async () => {
        const dados_usuario = getCurrentUser();
        const programa_id = this.state.programa_id || dados_usuario.ambiente_programa_id;
        try {
          const resp = await api.get(`/agendamentos/motivos_cancelamento/?programa_id=${programa_id}`);
          this.setState({ motivosCancelamento: resp.data.results || [] });
        } catch (err) {
          console.error('Erro ao buscar motivos de cancelamento', err);
          this.setState({ motivosCancelamento: [] });
        }
    }

    handleSituacaoChange = async (e) => {
        const situacao = e.target.value;
        // atualiza o agendamento selecionado
        this.handleChangeAgendamentoEdit(e, 'situacao');
      
        if (situacao === 'cancelado') {
          await this.fetchMotivosCancelamento();
        } else {
          // limpa tudo se não estiver mais em cancelado
          this.setState({ motivosCancelamento: [], motivoSelecionado: '', motivoOutro: '' });
        }
    }

    handleMotivoChange = (e) => {
        this.setState({ motivoSelecionado: e.target.value, motivoOutro: '' });
    }

    handleMotivoOutroChange = (e) => {
        this.setState({ motivoOutro: e.target.value });
    }
    
    // Função para atualizar o status do atendimento
    async updateRecebeKitPaciente(recebeKit) {
        // Validação solicitada: Não permitir desativar o kit se estiver atualmente na etapa configurada para kit
        if (!recebeKit) {
            let isKitStage = false;
            if (this.state.etapa_atual?.configuracoes) {
                try {
                    const config = typeof this.state.etapa_atual.configuracoes === 'string' 
                        ? JSON.parse(this.state.etapa_atual.configuracoes) 
                        : this.state.etapa_atual.configuracoes;
                    if (config.etapa_kit === true) {
                        isKitStage = true;
                    }
                } catch (e) {
                    console.error("Erro ao validar etapa_kit do updateRecebeKitPaciente", e);
                }
            }

            if (isKitStage) {
                const MySwal = withReactContent(Swal);
                MySwal.fire(
                    'Atenção!',
                    'Para cancelar a necessidade de envio de kit, cancele primeiro a etapa atual.',
                    'warning'
                );
                return;
            }
        }

        this.setState({
            loading: true,
            recebe_kit_paciente: recebeKit
        }, () => this.atualizarEtapasFiltradas());

        const url = '/atendimentos/' + this.state.atendimento_id + '/';
        const metodo = 'put';
        const dadosKit = {
            recebe_kit_paciente: recebeKit
        };

        api({
            method: metodo,
            url: url,
            data: dadosKit
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            // Define a mensagem conforme o valor selecionado
            const textSwal = recebeKit 
                ? 'Ok, a aba Kits do Programa será habilitada!' 
                : 'A aba Kits do Programa foi desativada';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    window.location.reload();
                }
            });

            this.setState({
                loading: false
            });
        })
        .catch(error => {
            let erro_msg = "Houve um erro ao atualizar o kit\n\n";

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }
            else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                erro_msg += campos;
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                showCloseButton: true,
                html: <p>{erro_msg}</p>,
            });

            this.setState({
                loading: false,
            });
        });
    }

    // Função para mostrar o modal de adicionar kit
    handleShowModalKit = async () => {
        const { programa_id } = this.state;

        this.setState({
            showModalKit: true,
            kitsProgramaLoading: true,
            kitsProgramaOptions: [],
            kitSelecionadoId: '',
        });

        try {
            const resp = await api.get('/programas/kits/', { params: { programa_id } });
            const options = Array.isArray(resp.data?.results) ? resp.data.results : [];

            this.setState({
                kitsProgramaOptions: options,
                kitsProgramaLoading: false,
                // se quiser pré-selecionar caso haja apenas um:
                kitSelecionadoId: options.length === 1 ? String(options[0].id) : '',
            });
        } catch (err) {
            console.error('Erro ao buscar kits do programa:', err);
            this.setState({ kitsProgramaLoading: false });
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                html: <p>Não foi possível carregar os kits do programa.</p>,
                showCloseButton: true,
            });
        }
    };

    handleChangeKitSelecionado = (e) => {
        this.setState({ kitSelecionadoId: e.target.value });
    };

    // Função para fechar o modal de adicionar kit
    handleCloseModalKit = () => {
        this.setState({ showModalKit: false, showNovoEndereco: false });
    };

    // Função para buscar os endereços do beneficiário
    buscarEnderecos = () => {
        const beneficiario_endereco = this.state.beneficiario_id;
        api.get(`enderecos/?beneficiario_id=${beneficiario_endereco}`)
            .then(response => {
                console.log('Retorno da API Endereços:');
                console.log(response);
                const enderecos = response.data.results || [];
                this.setState({ enderecos });
            })
            .catch(error => {
                console.error(error);
                this.setState({ enderecos: [] });
            });
    };

    onChangeCepNovoEndereco = (e) => {
        const rawValue = e.target.value;
        const cep = rawValue.replace(/\D/g, '');
        
        if (this.state.usingEnderecoAtual) {
            // Atualiza o CEP no beneficiario_dados
            this.setState(prevState => ({
                beneficiario_dados: {
                    ...prevState.beneficiario_dados,
                    cep: cep
                }
            }));
        } else {
            // Atualiza o CEP no novoEndereco
            this.setState(prevState => ({
                novoEndereco: {
                    ...prevState.novoEndereco,
                    cep: cep
                }
            }));
        }
        
        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(response => response.json())
                .then(data => {
                    if (!data.erro) {
                        if (this.state.usingEnderecoAtual) {
                            this.setState(prevState => ({
                                beneficiario_dados: {
                                    ...prevState.beneficiario_dados,
                                    endereco: data.logradouro,
                                    bairro: data.bairro,
                                    cidade: data.localidade,
                                    uf: data.uf
                                }
                            }));
                        } else {
                            this.setState(prevState => ({
                                novoEndereco: {
                                    ...prevState.novoEndereco,
                                    endereco: data.logradouro,
                                    bairro: data.bairro,
                                    cidade: data.localidade,
                                    uf: data.uf
                                }
                            }));
                        }
                    }
                });
        }
        this.handleChangeNovoEndereco(e);
    }

    handleChangeNovoEndereco = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            novoEndereco: {
                ...prevState.novoEndereco,
                [name]: value,
            },
        }));
    };

    handlePasteCepNovoEndereco = (e) => {
        const cep = e.clipboardData.getData('Text').replace(/\D/g, '');
        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(response => response.json())
                .then(data => {
                    if (!data.erro) {
                        this.setState(prevState => ({
                            novoEndereco: {
                                ...prevState.novoEndereco,
                                endereco: data.logradouro,
                                bairro: data.bairro,
                                cidade: data.localidade,
                                uf: data.uf
                            }
                        }));
                    }
                });
        }
        this.handleChangeNovoEndereco(e);
    }

    buscarKitsAgendados = async () => {
        const { atendimento_id } = this.state;
        try {
            const response = await api.get(`/atendimentos/kits/`, { params: { atendimento_id } });
            this.setState({ kitsEnviados: response.data.results });
        } catch (error) {
            console.error('Erro ao buscar kits agendados:', error);
        }
    };

    handleUsarEnderecoAtual = () => {
        this.setState({
            usingEnderecoAtual: true,
            novoEndereco: {
                nome: 'Endereço Atual',
                cep: this.state.beneficiario_dados.cep,
                endereco: this.state.beneficiario_dados.endereco,
                numero: this.state.beneficiario_dados.numero,
                complemento: this.state.beneficiario_dados.complemento,
                bairro: this.state.beneficiario_dados.bairro,
                cidade: this.state.beneficiario_dados.cidade,
                uf: this.state.beneficiario_dados.uf,
                endereco_principal: true,
            },
            tituloModalNovoEndereco: 'Atualizando Endereço Atual',
            showModalNovoEndereco: true,
        });
    };
    
    handleShowModalNovoEndereco = () => {
        this.setState({
            showModalNovoEndereco: true,
            novoEndereco: {
                nome: '',
                cep: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: '',
                endereco_principal: false,
            },
            usingEnderecoAtual: false,
            tituloModalNovoEndereco: 'Adicionar Novo Endereço',
        });
    };

    handleCloseModalNovoEndereco = () => {
        this.setState({ showModalNovoEndereco: false });
    };

    handleSubmitNovoEndereco = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        
        const { novoEndereco, beneficiario_id } = this.state;
        
        // Verifica se todos os campos obrigatórios estão preenchidos
        if (!novoEndereco.nome || !novoEndereco.cep || !novoEndereco.endereco || !novoEndereco.numero || !novoEndereco.bairro || !novoEndereco.cidade || !novoEndereco.uf) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                html: '<p>Por favor, preencha todos os campos obrigatórios.</p>',
                showCloseButton: true,
            });
            this.setState({ loading: false });
            return;
        }

        console.log('Novo Endereço:', novoEndereco);
        console.log('Beneficiário ID:', beneficiario_id);
        
        const data = {
            ...novoEndereco,
            complemento: novoEndereco.complemento || "", 
            endereco_principal: novoEndereco.endereco_principal || false,
            beneficiario_id,
        };

        console.log('Dados do novo endereço:', data);
        
        api({
            method: 'post',
            url: '/enderecos/',
            data: data
        })
        .then(response => {
            const enderecoCriado = response.data;
            this.setState((prevState) => ({
                enderecos: [...prevState.enderecos, enderecoCriado],
                showModalNovoEndereco: false,
                novoEndereco: {
                    nome: '',
                    cep: '',
                    endereco: '',
                    numero: '',
                    complemento: '',
                    bairro: '',
                    cidade: '',
                    uf: '',
                    endereco_principal: false,
                },
                loading: false,
            }));
        
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: 'Sucesso!',
                html: '<p>Endereço adicionado com sucesso!</p>',
                icon: 'success',
                showCloseButton: true,
            });
        })
        .catch(error => {
            this.handleError(error, 'Erro ao adicionar o novo endereço.');
        });
    };

    handleError = (error, defaultMessage) => {
        let erro_msg = defaultMessage;
    
        if (error.response && error.response.status === 500) {
            erro_msg = 'Servidor indisponível no momento.';
        } else if (error.response && error.response.status === 400) {
            const campos = error.response.data;
            erro_msg = campos.detail || JSON.stringify(campos, null, 2);
        }
    
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'error',
            title: 'Atenção!',
            html: `<p>${erro_msg}</p>`,
            showCloseButton: true,
        });
    
        this.setState({ loading: false });
    };

    handleSelectEndereco = (endereco_id) => {
        this.setState({ enderecoSelecionado: endereco_id });
    };

    // Função para enviar os dados do kit
    handleSubmitKit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });

        const { atendimento_id, data_envio, enderecoSelecionado, programa_id, descricao } = this.state;

        // Buscar o programa_kit_id do endpoint /programas/kits/
        try {
            const response = await api.get('/programas/kits/', { params: { programa_id } });
            const kits = Array.isArray(response.data.results) ? response.data.results : [];
            const kitAtivo = kits.find(kit => kit.status === true);

            if (!kitAtivo) {
                throw new Error('Nenhum kit ativo encontrado para o programa.');
            }

            const programa_kit_id = kitAtivo.id;

            const url = '/atendimentos/kits/';
            const dadosKit = {
                atendimento_id,
                programa_kit_id,
                descricao,
                data_envio,
                endereco_id: enderecoSelecionado
            };

            api({
                method: 'post',
                url: url,
                data: dadosKit
            })
            .then(response => {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    title: <p>Kit cadastrado com sucesso!</p>,
                    icon: 'success',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss) {
                        //recarrega a lista de kits
                        this.buscarKitsAgendados();
                    }
                });
                this.setState({ loading: false, showModalKit: false });
            })
            .catch(error => {
                let erro_msg = "Houve um erro ao enviar o kit: \n\n";

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response && error.response.status === 400) {
                    console.log('error.response', error.response);
                    const campos = error.response.data;
                    if (campos.detail) {
                        erro_msg += campos.detail;
                    } else {
                        erro_msg += JSON.stringify(campos, null, 2);
                    }
                }

                this.handleCloseModalNovoEndereco();

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    showCloseButton: true,
                    html: <p>{erro_msg}</p>,
                });

                this.setState({ loading: false });
            });
        } catch (error) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                showCloseButton: true,
                html: <p>{error.message}</p>,
            });

            this.setState({ loading: false });
        }
    };

    // Função para visualizar o endereço do kit
    handleViewEndereco = async (enderecoId) => {
        try {
            const response = await api.get(`/enderecos/${enderecoId}/`);
            const endereco = response.data;
            this.setState({
                enderecoVisualizado: endereco,
                showModalEndereco: true,
            });
        } catch (error) {
            console.error('Erro ao buscar endereço:', error);
        }
    };

    compactaEndereco = (e) => {
        if (!e) return '';
        const pedacos = [
            e.nome,
            [e.endereco, e.numero].filter(Boolean).join(', '),
            e.complemento,
            e.bairro,
            [e.cidade, e.uf].filter(Boolean).join(' - '),
            e.cep
        ].filter(Boolean);
        return pedacos.join(' • ');
    };

    // Função para fechar o modal do endereço
    handleCloseModalEndereco = () => {
        this.setState({ showModalEndereco: false, enderecoVisualizado: null });
    };

    // Função para excluir um kit
    handleDeleteKit = (kitId) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir kit?',
            text: "Tem certeza que deseja excluir este kit do atendimento?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });

                api.delete(`/atendimentos/kits/${kitId}/`)
                .then(response => {
                    MySwal.fire(
                        'Excluído!',
                        'O kit foi excluído com sucesso.',
                        'success'
                    );

                    this.setState({ loading: false });

                    //recarrega a lista de kits
                    this.buscarKitsAgendados();
                })
                .catch(error => {
                    Sentry.captureException('Houve um erro ao tentar excluir o kit do atendimento. Por favor, tente novamente.', error);

                    MySwal.fire(
                        'Erro!',
                        'Houve um erro ao tentar excluir o kit do atendimento. Por favor, tente novamente.',
                        'error'
                    );
                    this.setState({ loading: false });
                });
            }
        });
    }
    
    handleOpenEditKit = async (kit) => {
        try {
            this.setState({ editKitLoading: true });

            // Busca o endereço para exibição compacta
            let endereco_compacto = '';
            if (kit.endereco_id) {
                const resp = await api.get(`/enderecos/${kit.endereco_id}/`);
                endereco_compacto = this.compactaEndereco(resp.data);
            }

            // Preenche o formulário de edição
            this.setState({
            showModalEditKit: true,
            editKitLoading: false,
            editKit: {
                id: kit.id,
                descricao: kit.descricao || kit.dados_kit?.titulo || '',
                data_envio: kit.data_envio && kit.data_envio !== '1900-01-01' ? kit.data_envio : '',
                status: kit.status ?? '',
                data_envio_realizado: kit.data_envio_realizado || '',
                endereco_id: kit.endereco_id || null,
                endereco_compacto,
                dados_kit: kit.dados_kit,
            }
            });
        } catch (error) {
            console.error('Erro ao abrir editor de kit:', error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                showCloseButton: true,
                html: <p>Não foi possível carregar os dados do endereço.</p>,
            });
            this.setState({ editKitLoading: false });
        }
    };

    handleUpdateKit = async (e) => {
        e.preventDefault();

        const { editKit } = this.state;
        const { id, descricao, data_envio, status, data_envio_realizado } = editKit;

        // Validação: se realizado, exigir data_envio_realizado
        const statusRealizado = String(status).toLowerCase() === 'realizado' || String(status) === '3'; 
        // ^ ajuste esse '3' se "realizado" for um código específico; mantenha se já usar string.

        if (statusRealizado && !data_envio_realizado) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
            icon: 'warning',
            title: 'Campo obrigatório',
            text: 'Informe a data do envio realizado.',
            showCloseButton: true,
            });
            return;
        }

        this.setState({ editKitLoading: true });

        try {
            // Monte somente os campos que podem ser editados
            const payload = {
                descricao,
                data_envio: data_envio || null, // envie null se quiser limpar
                status
            };

            if(data_envio_realizado) {
                payload['data_envio_realizado'] = data_envio_realizado;
            }

            await api.put(`/atendimentos/kits/${id}/`, payload);

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>Kit atualizado com sucesso!</p>,
                icon: 'success',
                showCloseButton: true,
            });

            // Recarrega a lista
            await this.buscarKitsAgendados();

            this.setState({
                showModalEditKit: false,
                editKitLoading: false,
            });

        } catch (error) {
            console.error('Erro ao atualizar kit:', error);

            let erro_msg = "Não foi possível atualizar o kit.";
            if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                erro_msg = campos.detail ? campos.detail : JSON.stringify(campos, null, 2);
            } else if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                html: {erro_msg},
                showCloseButton: true,
            });

            this.setState({ editKitLoading: false });
        }
    };

    handleEditKitChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            editKit: { ...prev.editKit, [name]: value }
        }));
    };

    handleEditKitStatusChange = (e) => {
        const status = e.target.value;
        this.setState((prev) => {
            const statusRealizado = String(status).toLowerCase() === 'realizado' || String(status) === '3';
            return {
            editKit: {
                ...prev.editKit,
                status,
                // Se não for realizado, zera a data_realizado para evitar sujeira
                data_envio_realizado: statusRealizado ? prev.editKit.data_envio_realizado : ''
            }
            };
        });
    };

    handleCloseModalEditKit = () => {
        this.setState({ showModalEditKit: false });
    };
    
    handleExcluirTermoLaudo = (area_solicitacao, relato_valor_id = "") => {
        // Verificar se já existe uma solicitação de exclusão em andamento
        api.get(`/autorizacoes/?atendimento_id=${this.state.atendimento_id}&area_solicitacao=${area_solicitacao}&status_solicitacao=novo&relato_valor_id=${relato_valor_id}`)
        .then(response => {
            if (response.data.count > 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Solicitação em Andamento',
                    text: 'Já existe uma solicitação de exclusão de arquivo em andamento para esta área.'
                });
                return false;
            } else {
                Swal.fire({
                    title: 'Excluir Arquivo',
                    html: `
                        <div>
                            <label for="motivo_solicitacao" class="form-label">Motivo da Exclusão</label>
                            <textarea id="motivo_solicitacao" class="form-control" rows="3" placeholder="Informe o motivo da exclusão do arquivo"></textarea>
                            
                            <label for="arquivo_novo" class="form-label mt-3">Novo Arquivo</label>
                            <input type="file" id="arquivo_novo" class="form-control" accept=".pdf,.jpg,.jpeg,.png"/>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonText: 'Solicitar Exclusão',
                    cancelButtonText: 'Cancelar',
                    preConfirm: () => {
                        const motivo_solicitacao = document.getElementById('motivo_solicitacao').value;
                        const arquivo_novo = document.getElementById('arquivo_novo').files[0];
                        
                        if (!motivo_solicitacao) {
                            Swal.showValidationMessage('Por favor, informe o motivo da exclusão');
                            return false;
                        }

                        if (!arquivo_novo) {
                            if (relato_valor_id == "") {
                                Swal.showValidationMessage('Por favor, selecione um novo arquivo para substituição');
                                return false;
                            }
                        }
                        
                        return { motivo_solicitacao, arquivo_novo };
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        const { motivo_solicitacao, arquivo_novo } = result.value;
                        
                        const formData = new FormData();
                        formData.append('atendimento_id', this.state.atendimento_id);
                        formData.append('motivo_solicitacao', motivo_solicitacao);
                        formData.append('area_solicitacao', area_solicitacao);
                        formData.append('relato_valor_id', relato_valor_id);
                        formData.append('tipo_solicitacao', 'exclusao');
                        if (arquivo_novo) {
                            formData.append('arquivo_novo', arquivo_novo);
                        }
                        
                        api.post(`/autorizacoes/`, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        .then((response) => {
                            Swal.fire({
                                icon: 'success', 
                                title: 'Solicitação Enviada',
                                text: 'A solicitação de exclusão do arquivo original foi enviada com sucesso. O ID da solicitação é: ' + response.data.id
                            }).then(() => {
                                // Atualizar o estado para remover o termo
                                this.setState({
                                    [`${tipo_termo}`]: null,
                                    optin_data: null,
                                    optin_termo_conteudo: null
                                });
                            });
                        })
                        .catch((error) => {
                            console.error('Erro ao excluir termo:', error);
                            Swal.fire({
                                icon: 'error',
                                title: 'Erro',
                                text: 'Não foi possível solicitar a exclusão do arquivo. Tente novamente.'
                            });
                        });
                    }
                });
            }
        })
        .catch(error => {
            console.error('Erro ao verificar solicitações existentes:', error);
        });
    }
    
    logsOnClickPagina(num_page) {
        this.setState({
            loading: true,
            logs_page_numb: num_page
        });
        
        this.getLogsAtendimento(num_page)
    }

    handleAtualizarMedico = async (dados_medico) => {
        await this.carregaMedicos();
        this.setState({
            medico_id: dados_medico.medico_id,
            medico_nome: dados_medico.medico_nome,
            showModalMedico: false,
            disabledInputMedico: true
        });
    }

    carregaDadosBeneficiario = async (beneficiario_id) => {
        const resp = await api.get(`/pessoas/beneficiarios/${beneficiario_id}/`);
        this.setState({
            beneficiario_dados: resp.data
        });
    }

    handleAtualizarEdicaoPaciente = async (dados_paciente) => {
        await this.carregaBeneficiarios();
        await this.carregaDadosBeneficiario(dados_paciente.beneficiario_id);
        this.setState({
            beneficiario_id: dados_paciente.beneficiario_id,
            beneficiario_nome: dados_paciente.beneficiario_nome,
            showModalAtendimentoPaciente: false
        }, () => {
            window.location.reload();
        }); 
    }

    handleAtualizarPaciente = async (dados_paciente) => {
        const dados_usuario = getCurrentUser();

        await this.carregaBeneficiarios();
        this.setState({
            beneficiario_id: dados_paciente.beneficiario_id,
            beneficiario_nome: dados_paciente.beneficiario_nome,
            showModalPaciente: false,
            disabledInputBeneficiario: true,
            beneficiario_atendimento_aberto_id: ''
        }, () => {
            const medico_id = (dados_usuario['prestador_id']) ? dados_usuario['prestador_id'] : this.state.medico_id;
            this.carregaLaboratoriosMedicoRelacao(medico_id);
        });

    }

    handleExcluirAtendimento = () => {
        Swal.fire({
            title: 'Excluir Atendimento',
            text: 'Tem certeza que deseja excluir o atendimento?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/atendimentos/${this.state.atendimento_id}/`)
                .then((response) => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Atendimento excluído com sucesso',
                        text: 'O atendimento foi excluído com sucesso.'
                    }).then(() => {
                        window.location.href = '/atendimentos';
                    });
                })
                .catch((error) => {
                    console.error('Erro ao excluir atendimento:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro ao excluir atendimento',
                        text: 'Ocorreu um erro ao excluir o atendimento. Tente novamente.'
                    });
                });
            }
        });
    }

    // alterna o modo edição de um valor específico
    toggleEditCampo = (valorId, currentValue) => {
        this.setState(prev => ({
            editingCampoValues: {
                ...prev.editingCampoValues,
                [valorId]: !prev.editingCampoValues[valorId]
            },
            campoEditadoValores: {
            ...prev.campoEditadoValores,
            // se passou a entrar em edição, já pré‑carrega o valor atual
            [valorId]: prev.editingCampoValues[valorId]
                ? prev.campoEditadoValores[valorId]
                : currentValue
            }
        }));
    };

    // atualiza o texto enquanto digita
    handleCampoValueChange = (valorId, novoValor) => {
        this.setState(prev => ({
            campoEditadoValores: {
                ...prev.campoEditadoValores,
                [valorId]: novoValor
            }
        }));
    };

    // envia o PUT e, em sucesso, atualiza o estado e sai do modo edição
    saveCampoValor = (campo) => {
        const novoValor = this.state.campoEditadoValores[campo.id];

        // marca como “enviando”
        this.setState(prev => ({
            updatingCampoValues: {
                ...prev.updatingCampoValues,
                [campo.id]: true
            }
        }));

        
        api.put(
            `/atendimentos/relatos/valores/${campo.id}/`,
            {
                valor: novoValor,
                formulario_campo_id: campo.formulario_campo__id,
                relato_id: campo.relato_id
            }
        ).then(() => {
            this.setState(prev => {
                // clona o objeto de relatos por etapa
                const novosRelatosAtendimento = { ...prev.relatos_atendimento };

                // para cada etapa (chave = etapaId)
                Object.entries(novosRelatosAtendimento).forEach(([etapaId, relatosList]) => {
                    novosRelatosAtendimento[etapaId] = relatosList.map(rel => ({
                    ...rel,
                    valores_list: rel.valores_list.map(v => 
                        v.id === campo.id
                        ? { ...v, valor: novoValor }
                        : v
                    )
                    }));
                });

                return {
                    relatos_atendimento: novosRelatosAtendimento,
                    editingCampoValues: {
                        ...prev.editingCampoValues,
                        [campo.id]: false
                    }
                };
            });

            // SweetAlert de sucesso
            Swal.fire({
                icon: 'success',
                title: 'Salvo',
                text: 'Valor atualizado com sucesso'
            });

        })
        .catch(err => {
            console.error(err);
            // SweetAlert de erro
            Swal.fire({
                icon: 'error',
                title: 'Falha',
                text: 'Não foi possível salvar a alteração'
            });
        })
        .finally(() => {
            // tira o loading do botão
            this.setState(prev => ({
                updatingCampoValues: {
                    ...prev.updatingCampoValues,
                    [campo.id]: false
                }
            }));
        });
    };

    loadHistoricoTermos = async () => {
        const { atendimento_id, optin_data, termo_paciente_pdf_comprovante } = this.state;

        if (!atendimento_id) {
            this.setState({
            historicoAceites: [],
            historicoError: 'Atendimento não identificado.',
            historicoPendente: null,
            });
            return;
        }

        this.setState({
            historicoLoading: true,
            historicoError: '',
            historicoAceites: [],
            historicoPendente: null,
        });

        try {
            const res = await api.get(`/atendimentos/atualizacao_termos/?atendimento_id=${atendimento_id}`);
            let rows = (res.data?.results || []).slice(); // mantém a ordem do backend

            //rows = rows.reverse();

            // Fallback: se não houver histórico mas existe um aceite atual com comprovante
            if (rows.length === 0 && optin_data && termo_paciente_pdf_comprovante) {
            rows = [{
                id: 'optin-inicial',
                termo_versao: null,
                data_assinatura: optin_data,
                termo_pdf_assinado: termo_paciente_pdf_comprovante,
            }];
            }

            const ultimo = rows[rows.length - 1] || null;
            const pendente = ultimo && (!ultimo.data_assinatura);

            this.setState({
            historicoAceites: rows,
            historicoPendente: pendente ? ultimo : null, // ← se o último não foi assinado, é “nova versão pendente”
            historicoLoading: false,
            });
        } catch (e) {
            this.setState({
            historicoLoading: false,
            historicoError: 'Não foi possível carregar o histórico. Tente novamente.',
            });
        }
    };

    handleOpenHistoricoTermos = async () => {
        this.setState({ showHistoricoModal: true });
        await this.loadHistoricoTermos();
    };

    handleCloseHistoricoTermos = () => {
        this.setState({ showHistoricoModal: false });
    };

    // Retorna o ID do kit ativo do programa ou lança erro
    obterProgramaKitId = async (programa_id) => {
        if (!programa_id) throw new Error('programa_id é obrigatório');

        const resp = await api.get('/programas/kits/', {
            params: { programa_id: programa_id, status: 1, limit: 1 }
        });

        const lista = Array.isArray(resp.data?.results)
            ? resp.data.results
            : (Array.isArray(resp.data) ? resp.data : []);

        if (!lista.length) throw new Error('Nenhum kit ativo encontrado para o programa.');

        return lista[0];
    }

    handleConfirmarEnvioKit = (atendimento_kit_id, agendamento) => {
        const MySwal = withReactContent(Swal);
        const dataEnvioPadrao = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
    
        MySwal.fire({
            title: 'Confirmar envio do kit',
            icon: 'warning',
            html: `
                <div class="text-start container-confirma-servico">
                <p class="text-start">Deseja confirmar o envio do kit de <strong>${agendamento.dados_servico_procedimento.nome}</strong>?</p>

                <label for="swal-input-data" class="text-start">Data de Envio do kit</label>
                <input id="swal-input-data" type="date"
                    value="${dataEnvioPadrao}"
                    min="${moment().subtract(30, 'days').format('YYYY-MM-DD')}"
                    max="${moment().format('YYYY-MM-DD')}"
                    class="swal2-input swal-input-data" />
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar!',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const data = document.getElementById('swal-input-data').value;

                if (!data) {
                    Swal.showValidationMessage('Por favor, selecione uma data de envio');
                    return false;
                }

                return { data };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const dataEnvio = moment(result.value).tz('America/Sao_Paulo').format('YYYY-MM-DD');

                const payload = {
                    data_envio_realizado: dataEnvio,
                    status: 'enviado',
                } 
    
                api
                    .put(`/atendimentos/kits/${atendimento_kit_id}/`, payload)
                    .then(() => {
                        MySwal.fire({
                            title: 'Sucesso!',
                            text: 'Envio de kit confirmado com sucesso.',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        });
                        this.carregarAgendamentos(); 
                    })
                    .catch((error) => {
                        const errorMessage =
                            error.response && error.response.data
                                ? error.response.data.message || 'Erro ao confirmar o envio de kit.'
                                : 'Erro ao confirmar o envio de kit.';
                        MySwal.fire({
                            title: 'Erro!',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                        });
                    });
            }
        });
    };

    fetchProdutosPrograma = async () => {
        try {
            const dados_usuario = getCurrentUser();
            const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;

            const resp = await api.get(`/programas/produtos/?programa=${programa_id}&status=1`);

            const nomesUnicos = Array.from(new Set(
            (resp.data?.results || []).map(p => (p.dados_produto?.nome || '').split(' - ')[0]).filter(Boolean)
            ));

            const opcoes = nomesUnicos.map(nome => ({ value: nome, label: nome }));

            this.setState({ produtosOpcoes: opcoes });
        } catch (e) {
            console.error('Erro ao carregar produtos:', e);
            this.setState({ produtosOpcoes: [] });
        }
    };

    mergePreferNonEmpty = (base = {}, extra = {}) => {
        const out = { ...base };
        Object.entries(extra).forEach(([k, v]) => {
            const isEmpty =
                v === null ||
                v === undefined ||
                (typeof v === 'string' && v.trim() === '');
            if (!isEmpty) out[k] = v; // só substitui se veio algo “não vazio”
        });
        return out;
    };

    getDadosMedico = async () => {
        const { medico_id, dados_medico } = this.state;
        if (!medico_id) return;

        try {
            const { data } = await api.get(`/pessoas/prestadores/${medico_id}/`);
            const normalizado = data || {};

            this.setState(prev => ({
                dados_medico: this.mergePreferNonEmpty(prev.dados_medico, normalizado),
            }));
        } catch (e) {
            console.error('Erro carregar os dados do médico', e);
        }
    };

    getDadosBeneficiario = async () => {
        const { beneficiario_id, cliente_id, dados_beneficiario } = this.state;
        if (!beneficiario_id) return;

        try {
            const { data } = await api.get(`/pessoas/beneficiarios/${beneficiario_id}/?cliente_id=${cliente_id}`);
            const normalizado = data || {};

            this.setState(prev => ({
                dados_beneficiario: this.mergePreferNonEmpty(prev.dados_beneficiario, normalizado),
            }));
        } catch (e) {
            console.error('Erro carregar os dados do médico', e);
        }
    };
    
    carregaPrestadoresComServico = (servicoId) => async (inputValue) => {
        try {
            const resp = await api.get(
                `/pessoas/prestadores/servicos_procedimentos/?nome=${inputValue || ''}` +
                `&servico_procedimento_id=${servicoId}` +
                `&status=1&programa_id=${this.state.programa_id}&is_active=1`
            );
            return (resp.data.results || []).map((prestador) => ({
                value: prestador.prestador_id,
                label: `${prestador.dados_prestador.nome} (${prestador.dados_prestador.nome_fantasia} - ${prestador.dados_prestador.bairro}, ${prestador.dados_prestador.cidade}/${prestador.dados_prestador.uf} | CNPJ: ${formataCNPJ(prestador.dados_prestador.cpf_cnpj)})`,
                valor_servico: prestador.valor,
            }));
        } catch (e) {
            console.error('Erro ao carregar prestadores:', e);
            return [];
        }
    };

    // Função para buscar prestadores com CNPJ (usada na alteração de prestador)
    carregaPrestadoresAlteracaoFetch = async (servicoId, inputValue) => {
        try {
            // Remove caracteres não numéricos para verificar se é CNPJ
            const apenasNumeros = (inputValue || '').replace(/\D/g, '');
            
            // Verifica se parece ser um CNPJ (somente números, entre 1 e 14 dígitos)
            const isCnpj = apenasNumeros.length > 0 && apenasNumeros.length <= 14 && /^\d+$/.test(apenasNumeros);
            
            let url = `/pessoas/prestadores/?servico_id=${servicoId}&status=1&programa_id=${this.state.programa_id}&is_active=1`;
            
            // Adiciona o parâmetro correto baseado no tipo de busca
            if (isCnpj) {
                url += `&cpf_cnpj=${apenasNumeros}`;
            } else if (inputValue) {
                url += `&nome=${inputValue}`;
            }
            
            // Adiciona filtro por UF se configuração estiver ativa
            if (getConfig(this.state.programa_dados?.configuracoes, 'agendamento.filtrar_prestadores_estado', false)) {
                url += `&uf=${this.state.beneficiario_dados.uf}`;
            }
            
            const response = await api.get(url);
            
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.id,
                label: `${prestador.nome} (${prestador.nome_fantasia} - ${prestador.bairro}, ${prestador.cidade}/${prestador.uf} - CNPJ: ${formataCNPJ(prestador.cpf_cnpj)})`
            }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    // Wrapper com debounce para carregaPrestadoresAlteracao (400ms de delay)
    carregaPrestadoresAlteracao = (servicoId) => {
        let timeoutId = null;
        
        return (inputValue) => {
            return new Promise((resolve) => {
                // Cancela o timeout anterior se existir
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                
                // Se não digitou nada, carrega as opções padrão imediatamente
                if (!inputValue || inputValue.length < 2) {
                    this.carregaPrestadoresAlteracaoFetch(servicoId, inputValue || '').then(resolve);
                    return;
                }
                
                // Aguarda 400ms antes de fazer a requisição
                timeoutId = setTimeout(() => {
                    this.carregaPrestadoresAlteracaoFetch(servicoId, inputValue).then(resolve);
                }, 500);
            });
        };
    };

    // 2) atualiza prestador no agendamento_selecionado (id + nome para refletir na UI)
    handleChangePrestadorSelecionado = (option) => {
        this.setState((prev) => ({
            agendamento_selecionado: {
            ...prev.agendamento_selecionado,
            prestador_id: option?.value || null,
            dados_prestador: option
                ? { ...(prev.agendamento_selecionado?.dados_prestador || {}), nome: option.label }
                : prev.agendamento_selecionado?.dados_prestador || null,
            },
        }));
    };

    handleReenviarTermoHistorico = async () => {
        const { atendimento_id } = this.state;
        if (!atendimento_id) return;

        const resp = await Swal.fire({
            icon: 'question',
            title: 'Reenviar termo?',
            text: 'Tem certeza que deseja reenviar o termo para o paciente?',
            showCancelButton: true,
            confirmButtonText: 'Sim, reenviar',
            cancelButtonText: 'Cancelar'
        });

        if (!resp.isConfirmed) return;

        try {
            await api.post('/atendimentos/reenviar_termo/', { atendimento_id });
            await Swal.fire({ icon: 'success', title: 'Termo reenviado com sucesso!' });
            await this.loadHistoricoTermos(); // recarrega para refletir
        } catch (e) {
            await Swal.fire({
            icon: 'error',
            title: 'Falha ao reenviar termo',
            text: e?.response?.data?.detail || 'Tente novamente.'
            });
        }
    };

    getRelatosFlutuantesDaInstancia = (etapaId, instance = 0) => {
        const grupos = this.state.etapas_status_grouped || {};
        const ocorrencias = grupos[etapaId] || [];
        const todos = this.state.relatos_atendimento[etapaId] || [];

        // Sem ocorrências mapeadas: devolve todos (fallback)
        if (!ocorrencias.length) return todos;

        const atual = ocorrencias[instance] || ocorrencias[ocorrencias.length - 1];
        const proxima = ocorrencias[instance + 1] || null;

        // Para o ciclo 0, abre o início da janela em -Infinity para também capturar
        // relatos órfãos de ocorrências anteriores que foram apagadas (ex.: cancelamento
        // de etapa com volta para etapa anterior remove os registros de status posteriores,
        // mas mantém os relatos vinculados ao etapa_id).
        const tStart = instance === 0
            ? -Infinity
            : (atual?.data_cadastro ? new Date(atual.data_cadastro).getTime() : -Infinity);
        const tEnd = proxima?.data_cadastro ? new Date(proxima.data_cadastro).getTime() : Infinity;

        return todos.filter(r => {
            // assumindo que r.data é a data do relato (mesmo campo usado no seu render)
            const t = new Date(r.data).getTime();
            return t >= tStart && t < tEnd;
        });
    };

    getTituloDescricaoEtapa = (etapa, doencaId) => {
        // Defaults
        let tituloExibicao = etapa?.nome || '';
        let descricaoExibicao = etapa?.descricao || '';

        if (!etapa) return { tituloExibicao, descricaoExibicao };

        // Pode vir string JSON do backend
        let cfg = etapa.configuracoes;
        if (cfg && typeof cfg === 'string') {
            try { cfg = JSON.parse(cfg); } catch (e) { cfg = null; }
        }

        if (!cfg) return { tituloExibicao, descricaoExibicao };

        // Formato 1: mapas simples
        const titMap = cfg.titulo_por_doenca || cfg.titulos_por_doenca;
        const desMap = cfg.descricao_por_doenca || cfg.descricoes_por_doenca;
        if (doencaId != null) {
            if (titMap && titMap[String(doencaId)]) {
                tituloExibicao = titMap[String(doencaId)];
            }
            if (desMap && desMap[String(doencaId)]) {
                descricaoExibicao = desMap[String(doencaId)];
            }
        }

        // Formato 2: regras com arrays de ids
        if (cfg.regras_por_doenca && Array.isArray(cfg.regras_por_doenca) && doencaId != null) {
            for (const regra of cfg.regras_por_doenca) {
                const ids = regra?.ids || [];
                if (ids.map(String).includes(String(doencaId))) {
                    if (regra.titulo) tituloExibicao = regra.titulo;
                    if (regra.descricao) descricaoExibicao = regra.descricao;
                    break; // primeira que casar já resolve
                }
            }
        }

        return { tituloExibicao, descricaoExibicao };
    };

    //Exclusão de relato
    handleExcluirRelato = async (relato, etapaId) => {
        const MySwal = withReactContent(Swal);

        const confirm = await MySwal.fire({
        title: "Excluir relato?",
        html: `
            <div>
                <p>Tem certeza que deseja excluir este relato?</p>
                <p class="mb-0"><strong>Atenção:</strong> esta ação é <span class="text-danger">irreversível</span>.</p>
            </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, excluir",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        focusCancel: true
        });

        if (!confirm.isConfirmed) return;

        try {
            // loading
            MySwal.fire({
                title: "Excluindo...",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            await api.delete(`/atendimentos/relatos/${relato.id}/`);

            // Atualiza o state removendo o relato desta etapa
            this.setState((prev) => {
                const relatosPorEtapa = { ...prev.relatosPorEtapa };
                const bloco = relatosPorEtapa[etapaId] ? { ...relatosPorEtapa[etapaId] } : null;

                if (bloco && Array.isArray(bloco.dados)) {
                    bloco.dados = bloco.dados.filter((r) => r.id !== relato.id);
                    relatosPorEtapa[etapaId] = bloco;
                }
                return { relatosPorEtapa };
            });

            Swal.close();

            await MySwal.fire({
                icon: "success",
                title: "Relato excluído",
                text: "O relato foi removido com sucesso."
            });
        } catch (err) {
            const msg =
                err?.response?.data?.detail ||
                err?.response?.data?.message ||
                "Não foi possível excluir o relato. Tente novamente.";
            await MySwal.fire({
                icon: "error",
                title: "Falha ao excluir",
                text: msg
            });
        }
    };

    //Excluir relato flutuante
    handleExcluirRelatoFlutuante = async (relato, etapaId) => {
        const MySwal = withReactContent(Swal);

        const confirm = await MySwal.fire({
            title: "Excluir relato?",
            html: `
            <div class="text-start">
                <p>Tem certeza que deseja excluir este relato?</p>
                <p class="mb-0"><strong>Atenção:</strong> esta ação é <span class="text-danger">irreversível</span>.</p>
            </div>
            `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, excluir",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
            focusCancel: true
        });

        if (!confirm.isConfirmed) return;

        try {
            // Mostra loading
            MySwal.fire({
                title: "Excluindo...",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            await api.delete(`/atendimentos/relatos/${relato.id}/`);

            // Atualiza apenas o array dentro do relatos_atendimento
            this.setState((prev) => {
                const novosRelatos = { ...prev.relatos_atendimento };
                if (Array.isArray(novosRelatos[etapaId])) {
                    novosRelatos[etapaId] = novosRelatos[etapaId].filter(r => r.id !== relato.id);
                }
                return { relatos_atendimento: novosRelatos };
            });

            Swal.close();

            await MySwal.fire({
                icon: "success",
                title: "Relato excluído",
                text: "O relato foi removido com sucesso."
            });
        } catch (err) {
            Swal.close();
            const msg =
                err?.response?.data?.detail ||
                err?.response?.data?.message ||
                "Não foi possível excluir o relato. Tente novamente.";

            await MySwal.fire({
                icon: "error",
                title: "Falha ao excluir",
                text: msg
            });
        }
    };

    // Normaliza strings para comparação robusta (case/acentos/espaços)
    normalize = (s) => (s ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();

    /**
     * Monta um mapa { slug: valorAtual } considerando:
     * - valor salvo (this.state.camposExtraCadastrados)
     * - overrides em edição (this.state.valoresCamposExtra[campo.id])
     */
    getValoresPorSlug = () => {
        const valorPorSlug = {};

        for (const item of this.state.atendimento_campos || []) {
            // valor "base" vindo dos registros já salvos
            let valorBase = '';
            for (const v of (this.state.camposExtraCadastrados || [])) {
            if (v.campo_slug === item.slug) {
                valorBase = v.valor;
                break;
            }
            }

            // override do usuário em edição (se houver)
            const override = this.state.valoresCamposExtra?.[item.id];
            const valorAtual = (override !== undefined && override !== null) ? override : (item.valor ?? valorBase ?? '');

            valorPorSlug[item.slug] = valorAtual;
        }

        return valorPorSlug;
    };

    /**
     * Interpreta máscaras condicionais do tipo:
     *   show-on[slug=ValorA|ValorB]
     * Suporta múltiplos valores (separados por "|").
     * Funciona também para campos múltiplos (checkbox com valores "a,b,c").
     */
    matchShowOnMask = (campo, valorPorSlug) => {
        const mask = campo?.mascara || '';
        if (!mask.startsWith('show-on[') || !mask.endsWith(']')) return true;

        const inner = mask.slice(8, -1); // conteúdo entre colchetes
        
        // Verifica operadores de comparação numérica: <=, >=, <, >, !=
        // Ordem importa: verificar <= e >= antes de < e >
        const operadores = ['<=', '>=', '!=', '<', '>'];
        let operadorEncontrado = null;
        let opIdx = -1;

        for (const op of operadores) {
            const idx = inner.indexOf(op);
            if (idx !== -1) {
                operadorEncontrado = op;
                opIdx = idx;
                break;
            }
        }

        // Se encontrou operador de comparação numérica
        if (operadorEncontrado && operadorEncontrado !== '!=') {
            const depSlug = inner.slice(0, opIdx).trim();
            const valorComparar = parseFloat(inner.slice(opIdx + operadorEncontrado.length).trim());

            if (!depSlug || isNaN(valorComparar)) return true;

            const valorAtual = parseFloat(valorPorSlug[depSlug] ?? '');
            
            // Se o valor atual não for numérico, não exibe o campo
            if (isNaN(valorAtual)) return false;

            switch (operadorEncontrado) {
                case '<':  return valorAtual < valorComparar;
                case '>':  return valorAtual > valorComparar;
                case '<=': return valorAtual <= valorComparar;
                case '>=': return valorAtual >= valorComparar;
                default:   return true;
            }
        }

        // Operador != (diferente)
        if (operadorEncontrado === '!=') {
            const depSlug = inner.slice(0, opIdx).trim();
            const rawVals = inner.slice(opIdx + 2).trim();

            if (!depSlug || !rawVals) return true;

            const proibidos = rawVals.split('|').map(this.normalize);
            const atual = (valorPorSlug[depSlug] ?? '').toString();
            const atuais = atual.split(',').map(this.normalize);

            // Verdadeiro se NENHUM dos valores atuais estiver na lista de proibidos
            return !atuais.some(v => proibidos.includes(v));
        }

        // Fallback: operador de igualdade (=)
        const eqIdx = inner.indexOf('=');
        if (eqIdx === -1) return true;

        const depSlug = inner.slice(0, eqIdx).trim();
        const rawVals = inner.slice(eqIdx + 1).trim();

        if (!depSlug || !rawVals) return true;

        const allowed = rawVals.split('|').map(this.normalize);
        const atual = (valorPorSlug[depSlug] ?? '').toString();

        // Se o campo dependente for multi (checkbox), virá "a,b,c"
        const atuais = atual.split(',').map(this.normalize);

        // Verdadeiro se QUALQUER um dos valores atuais bater com allowed
        return atuais.some(v => allowed.includes(v));
    };

    // Parseia as configurações da etapa (JSON)
    getEtapaConfiguracoes = (etapa) => {
        if (!etapa?.configuracoes) return null;
        
        let cfg = etapa.configuracoes;
        if (typeof cfg === 'string') {
            try {
                cfg = JSON.parse(cfg);
            } catch (e) {
                return null;
            }
        }
        return cfg;
    };

    // Verifica se um campo do paciente (por slug) está preenchido
    verificaCampoPacientePreenchido = (slug) => {
        const lista = this.state.extra_valores_beneficiario_list || [];
        const campo = lista.find(item => item.campo_slug === slug);
        
        if (!campo) return false;
        
        const valor = (campo.valor ?? '').toString().trim();
        return valor.length > 0;
    };

    // Valida os campos obrigatórios da etapa e retorna a mensagem de erro (ou null se tudo ok)
    validaCamposPacienteEtapa = () => {
        const etapaConfig = this.getEtapaConfiguracoes(this.state.etapa_relato);
        
        if (!etapaConfig?.requer_campos_paciente) return null;
        
        const camposRequeridos = etapaConfig.requer_campos_paciente;
        
        // Pode ser um array ou objeto único (para retrocompatibilidade)
        const lista = Array.isArray(camposRequeridos) ? camposRequeridos : [camposRequeridos];
        
        for (const campo of lista) {
            const preenchido = this.verificaCampoPacientePreenchido(campo.slug);
            
            if (!preenchido) {
                return campo.mensagem || `O campo ${campo.slug} precisa estar preenchido.`;
            }
        }
        
        return null; // Todos os campos estão preenchidos
    };

    // Verifica se um campo do atendimento (por slug) está preenchido
    verificaCampoAtendimentoPreenchido = (slug) => {
        const campos = this.state.atendimento_campos || [];
        const valoresExtra = this.state.valoresCamposExtra || {};

        // Encontra o campo pelo slug
        const campo = campos.find(item => item.slug === slug);

        if (!campo) return false;

        // Verifica primeiro no valoresCamposExtra (valores editados), depois no campo.valor (valor salvo)
        const valor = valoresExtra.hasOwnProperty(campo.id)
            ? valoresExtra[campo.id]
            : (campo.valor ?? '');

        const valorString = (valor ?? '').toString().trim();
        return valorString.length > 0;
    };

    // Valida os campos obrigatórios do atendimento configurados na etapa
    validaCamposAtendimentoEtapa = () => {
        const etapaConfig = this.getEtapaConfiguracoes(this.state.etapa_relato);

        if (!etapaConfig?.requer_campos_atendimento) return null;

        const camposRequeridos = etapaConfig.requer_campos_atendimento;

        // Pode ser um array ou objeto único (para retrocompatibilidade)
        const lista = Array.isArray(camposRequeridos) ? camposRequeridos : [camposRequeridos];

        for (const campo of lista) {
            const preenchido = this.verificaCampoAtendimentoPreenchido(campo.slug);

            if (!preenchido) {
                return campo.mensagem || `O campo '${campo.slug}' do atendimento precisa estar preenchido.`;
            }
        }

        return null; // Todos os campos estão preenchidos
    };

    handleChangeFinalizarRecorrencia = (e) => {
        const isChecked = e.target.checked;
        
        // Só pede confirmação ao marcar, não ao desmarcar
        if (isChecked) {
            Swal.fire({
                title: 'Confirmar encerramento',
                text: 'Deseja realmente interromper a recorrência?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3cc172',
                cancelButtonColor: '#eb4961',
                confirmButtonText: 'Sim, encerrar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setState({ finalizar_recorrencia: true });
                }
                // Se cancelar, não faz nada (mantém desmarcado)
            });
        } else {
            // Desmarcar não precisa de confirmação
            this.setState({ finalizar_recorrencia: false });
        }
    };

    handleUpdateKitFlag = () => {
        console.log("--- [AtendimentosEdit] Flag de Kit ativada pelo cadastro do paciente ---");
        
        // Apenas atualiza o estado local para ser enviado no POST posteriormente
        this.setState({ recebe_kit_paciente: true });

        // Se POR ACASO já for um atendimento existente (edição), salvamos imediatamente para garantir
        if (this.state.atendimento_id) {
            api.put(`/atendimentos/${this.state.atendimento_id}/`, {
                recebe_kit_paciente: true
            }).catch(err => console.error("Erro auto-save kit flag:", err));
        }
    };

    carregarEnderecoExtra = () => {
        const { beneficiario_id } = this.state;
        
        if (beneficiario_id) {
            api.get(`/enderecos/?beneficiario_id=${beneficiario_id}&limit=1`)
                .then(response => {
                    const lista = response.data.results || response.data;
                    
                    if (lista && lista.length > 0) {
                        const end = lista[0]; 
                        
                        this.setState({
                            novoEndereco: {
                                cep: end.cep || '',
                                endereco: end.endereco || '',
                                numero: end.numero || '',
                                complemento: end.complemento || '',
                                bairro: end.bairro || '',
                                cidade: end.cidade || '',
                                uf: end.uf || '',
                            },
                            endereco_kit_id: end.id
                        });
                    }
                })
                .catch(error => {
                    console.error('Erro ao carregar endereço de entrega do kit:', error);
                });
        }
    };

    // Função para renderizar campos extras do paciente no card (Modo Leitura)
    renderDetalhesExtrasPaciente = () => {
        const { pacientes_campos, extra_valores_beneficiario_list, doenca_id } = this.state;
        
        if (!pacientes_campos || pacientes_campos.length === 0) return null;

        const slugsIgnorados = [
            'veracidade-dos-dados-fornecidos',
            'conformidade-e-direitos-do-paciente'
        ];

        const valoresAtuaisMap = {};
        extra_valores_beneficiario_list.forEach(item => {
            valoresAtuaisMap[item.campo_slug] = item.valor;
        });

        return pacientes_campos.map((campo) => {
            if (slugsIgnorados.includes(campo.slug)) {
                return null;
            }

            if (campo.doencas_list && campo.doencas_list.length > 0) {
                if (doenca_id) {
                    const pertenceDoenca = campo.doencas_list.some(d => d.doenca_id === parseInt(doenca_id));
                    if (!pertenceDoenca) return null;
                }
            }

            if (campo.mascara && campo.mascara.includes('show-on[')) {
                const match = campo.mascara.match(/show-on\[([^=]+)=([^\]]+)\]/);
                if (match) {
                    const [ , slugDependencia, valorDependencia ] = match;
                    const valorAtualDependencia = valoresAtuaisMap[slugDependencia];
                    
                    if (valorAtualDependencia !== valorDependencia) {
                        return null;
                    }
                }
            }

            const valorSalvoObj = extra_valores_beneficiario_list.find(v => v.campo_slug === campo.slug);
            let valorExibicao = valorSalvoObj ? valorSalvoObj.valor : null;

            if (!valorExibicao || valorExibicao === '') {
                valorExibicao = 'Não informado';
            } else {
                if ((campo.tipo === 'radio' || campo.tipo === 'selecao' || campo.tipo === 'checkbox') && campo.opcoes) {
                    const opcoesArray = campo.opcoes.split('\n');
                    let labelEncontrada = null;

                    const opcaoCorrespondente = opcoesArray.find(opt => {
                        const [val, label] = opt.split(':');
                        return val.trim() === String(valorExibicao).trim();
                    });

                    if (opcaoCorrespondente) {
                        const [ , label] = opcaoCorrespondente.split(':');
                        valorExibicao = label;
                    }
                }

                const valorLower = String(valorExibicao).toLowerCase();
                if (['true', 'on', '1'].includes(valorLower)) {
                    valorExibicao = 'SIM';
                } else if (['false', 'off', '0'].includes(valorLower)) {
                    valorExibicao = 'NÃO';
                }
            }

            return (
                <p className="mb-1" key={campo.id}>
                    <small className="text-uppercase">{campo.nome}:</small>{' '}
                    <strong>{valorExibicao}</strong>
                </p>
            );
        });
    }

    concluirEtapaAtualSemCampos = async (avancarEtapa = true, forceSkip = false) => {
        this.setState({ loading: true });

        // Se não for para avançar a etapa (ex: exames extras), apenas recarrega a página
        if (!avancarEtapa) {
            Swal.fire({
                title: 'Sucesso!',
                text: 'Solicitação realizada com sucesso.',
                icon: 'success'
            }).then(() => {
                window.location.reload();
            });
            return;
        }

        try {
            const { etapa_relato, etapas_atendimento, etapa_id, etapa_atendimento_id, atendimento_id, etapa_atual } = this.state;
            
            // Encontra índice e próxima etapa
            const idx = etapas_atendimento.findIndex(e => e.id === etapa_id);
            const proximaEtapa = (idx >= 0 && idx < etapas_atendimento.length - 1)
                ? etapas_atendimento[idx + 1]
                : null;
                
            // Vai finalizar o atendimento se NÃO houver próxima etapa
            const atendimento_finalizado = false;

            // Monta o payload mínimo (sem campos personalizados)
            const formData = new FormData();
            formData.append('data', getDataAtual());           // você já tem esse helper
            formData.append('etapa_id', etapa_id);
            formData.append('atendimento_id', atendimento_id);
            formData.append('tipo', 'etapa');

            // Regra: concluir etapa atual e, se houver, apontar a próxima
            if (etapa_atendimento_id && (this.state.etapa_nome === 'Solicitação de Exames' || this.state.etapa_nome  === 'Pedido do Teste de Responsividade'|| forceSkip)) {
                const updtEtapa = {
                    etapa_atendimento_id,
                    etapa_id: etapa_id,
                    status: 'concluido',
                    ...(proximaEtapa && !atendimento_finalizado ? { proxima_etapa_id: proximaEtapa.id } : {})
                };

                formData.append('atendimento_etapa_updt', JSON.stringify(updtEtapa));
            }

            // Se a etapa atual define mudança de status do atendimento ao concluir
            if (etapa_atual?.status_finalizacao_etapa_id && (this.state.etapa_nome  === 'Solicitação de Exames' || this.state.etapa_nome  === 'Pedido do Teste de Responsividade' || forceSkip)) {
                formData.append('atendimento_updt', JSON.stringify({
                    ...(atendimento_finalizado ? { finalizado: true } : {}),
                    programa_status_id: etapa_atual.status_finalizacao_etapa_id,
                }));
            } else if (atendimento_finalizado) {
                // Se não tem status específico mas é a última, ao menos marca finalizado
                formData.append('atendimento_updt', JSON.stringify({ finalizado: true }));
            }

            // Mensageria no início da próxima etapa (se aplicável)
            let enviouMensagemInicio = false;
            
            // COMENTADO PARA EVITAR TIMEOUT (504) - A mensageria será enviada na chamada separada abaixo
            /*
            if (proximaEtapa?.midias_contato && proximaEtapa.momento_envio === 'inicio'
                && (proximaEtapa.tipo_envio === 'automatico' || proximaEtapa.tipo_envio === 'ambos')) {
            formData.append('mensageria_etapa', JSON.stringify({ etapa_id: proximaEtapa.id }));
            enviouMensagemInicio = true;
            }
            */

            // Chama o mesmo endpoint de relatos, porém sem “valores”
            await api.post('/atendimentos/relatos/', formData);

            // Caso você prefira mandar a mensageria em chamada separada quando não foi inline:
            if (!enviouMensagemInicio && proximaEtapa?.midias_contato && proximaEtapa.momento_envio === 'inicio'
                && (proximaEtapa.tipo_envio === 'automatico' || proximaEtapa.tipo_envio === 'ambos')) {
                try {
                    await api.post('/mensageria/etapa/', {
                    etapa_id: proximaEtapa.id,
                    atendimento_id
                    });
                } catch (e) {
                    console.log('Mensagem da etapa não enviada', e);
                }
            }

            // Feedback e refresh (segue seu padrão atual)
            this.setState({ loading: false });
            Swal.fire({
                title: etapa_atual?.titulo_sucesso_finalizacao || 'Sucesso!',
                text: etapa_atual?.mensagem_sucesso_finalizacao === 'aviso_solicitacao_exame'
                    ? 'Caso o paciente não atenda aos critérios de elegibilidade, um profissional do programa entrará em contato.'
                    : (etapa_atual?.mensagem_sucesso_finalizacao || 'Etapa concluída com sucesso.'),
                icon: 'success'
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    window.location.reload();
                }
            });

        } catch (err) {
            this.setState({ loading: false });
            console.error('Erro ao concluir etapa sem campos:', err);
            Swal.fire('Erro!', 'Não foi possível concluir a etapa.', 'error');
        }
    };

    handleOpenDropdown = (e, agendamentoId) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const menuHeight = 300; // altura estimada do menu
        const menuWidth = 220; // largura estimada do menu
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        
        let top, left, openDirection;
        
        // Decide se abre pra cima ou pra baixo
        if (spaceBelow < menuHeight && spaceAbove > spaceBelow) {
            // Abre pra cima
            openDirection = 'up';
            top = rect.top + window.scrollY;
        } else {
            // Abre pra baixo
            openDirection = 'down';
            top = rect.bottom + window.scrollY;
        }
        
        // Ajusta posição horizontal - se não cabe na direita, alinha pela direita do botão
        left = rect.left + window.scrollX;
        if (left + menuWidth > window.innerWidth) {
            // Alinha o menu pela direita do botão
            left = rect.right + window.scrollX - menuWidth;
        }
        
        this.setState({
            dropdownAberto: agendamentoId,
            dropdownPosition: {
                top: top,
                left: left,
                openDirection: openDirection,
                buttonBottom: rect.bottom + window.scrollY
            }
        });
    }

    handleCloseDropdown = () => {
        this.setState({ dropdownAberto: null });
    }
    
    renderDropdownAgendamento = (agendamento, dados_usuario, habilitarAceiteRecusa, habilitarDespesasAgendamento) => {
        const isOpen = this.state.dropdownAberto === agendamento.id;
        
        // Verifica se pode exibir o botão de confirmar realização
        const podeConfirmarRealizacao = agendamento.situacao !== "finalizado" 
            && agendamento.situacao !== "cancelado"
            && agendamento.situacao !== "arquivo_pendente"
            && (agendamento.status_aceite === "aceito" || !agendamento.envia_aceite);
                
        return (
            <>
                {podeConfirmarRealizacao && (
                    <Button 
                        variant="success" 
                        size="sm"
                        className="me-1"
                        onClick={() => this.handleConfirmarServico(agendamento)}
                        title="Confirmar Realização do Serviço"
                    >
                        <FaCheck /> Confirmar Realização
                    </Button>
                )}
                <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={(e) => this.handleOpenDropdown(e, agendamento.id)}
                    aria-expanded={isOpen}
                >
                    Opções
                </Button>
                
                {isOpen && ReactDOM.createPortal(
                    <>
                        {/* Overlay invisível para fechar ao clicar fora */}
                        <div 
                            style={{ 
                                position: 'fixed', 
                                top: 0, 
                                left: 0, 
                                right: 0, 
                                bottom: 0, 
                                zIndex: 1040 
                            }}
                            onClick={this.handleCloseDropdown}
                        />
                        <div 
                            className="dropdown-menu show"
                            style={{
                                position: 'absolute',
                                top: this.state.dropdownPosition.openDirection === 'up' 
                                    ? 'auto' 
                                    : this.state.dropdownPosition.top,
                                bottom: this.state.dropdownPosition.openDirection === 'up'
                                    ? `calc(100vh - ${this.state.dropdownPosition.top}px + 4px)`
                                    : 'auto',
                                left: this.state.dropdownPosition.left,
                                zIndex: 1050,
                                minWidth: '220px',
                                maxWidth: '280px'
                            }}
                        >
                            {/* Editar Agendamento */}
                            {(agendamento.situacao !== "finalizado" && agendamento.situacao !== "cancelado" && dados_usuario["tipo_usuario"] !== "prestador") && (
                                <>
                                    <button 
                                        className="dropdown-item" 
                                        onClick={() => { this.handleShowModalAgendamento(agendamento); this.handleCloseDropdown(); }}
                                    >
                                        <FaEdit className="me-2" /> Editar Agendamento
                                    </button>
                                    <div className="dropdown-divider"></div>
                                </>
                            )}
                            
                            {/* Visualizar (quando finalizado) */}
                            {(agendamento.situacao === "finalizado" && dados_usuario["tipo_usuario"] !== "prestador") && (
                                <>
                                    <button 
                                        className="dropdown-item" 
                                        onClick={() => { this.handleShowModalVisualizarAgendamento(agendamento); this.handleCloseDropdown(); }}
                                    >
                                        <FaFile className="me-2" /> Visualizar
                                    </button>
                                    
                                    {/* Permitir Faturar $ (para agendamentos finalizados sem serviço relacionado) */}
                                    {((['', 'gestor', 'operador'].includes(dados_usuario['tipo_usuario'])) || dados_usuario['is_superuser']) && 
                                     !this.state.servicos_atendimento_all.some(s => s.agendamento_id == agendamento.id) && (
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => { this.gerarServicoRelacionadoAgendamento(agendamento); this.handleCloseDropdown(); }}
                                            title="Permitir Faturar $"
                                        >
                                            $
                                        </button>
                                    )}
                                </>
                            )}
                            
                            {/* Arquivos, Monitoramento, Anotações */}
                            {agendamento.situacao !== "cancelado" && ((agendamento.envia_aceite === true && agendamento.status_aceite === "aceito") || !agendamento.envia_aceite) && (
                                <>
                                    <button 
                                        className="dropdown-item" 
                                        onClick={() => { this.handleShowModalArquivos(agendamento); this.handleCloseDropdown(); }}
                                    >
                                        <FaFile className="me-2" /> Arquivos
                                    </button>
                                    
                                    {((agendamento?.dados_servico_procedimento?.servico_dados_monitoramento || (agendamento?.dados_servico_procedimento?.nome || '').startsWith("Monitoria")) && agendamento.status_aceite === "aceito" && agendamento.situacao !== "finalizado" && agendamento.situacao !== "cancelado") && (
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => { this.handleShowModalArquivoMonitoramento(agendamento); this.handleCloseDropdown(); }}
                                        >
                                            <FaUpload className="me-2" /> Enviar Arquivo de Monitoramento
                                        </button>
                                    )}
                                    
                                    <button 
                                        className="dropdown-item" 
                                        onClick={() => { this.handleShowModalAnotacoes(agendamento); this.handleCloseDropdown(); }}
                                    >
                                        <FaNotesMedical className="me-2" /> Anotações
                                    </button>
                                    <div className="dropdown-divider"></div>
                                </>
                            )}
                            
                            {/* Aceite/Recusa */}
                            {agendamento.situacao !== "cancelado" && agendamento.envia_aceite === true && (
                                <>
                                    {habilitarAceiteRecusa && agendamento.envia_aceite === true && agendamento.status_aceite === 'aguardando' && (
                                            <button 
                                                className="dropdown-item" 
                                                onClick={() => { this.handleAceiteAgendamento(agendamento, true); this.handleCloseDropdown(); }}
                                            >
                                                <FaCheck className="me-2" /> Aceitar Agendamento
                                            </button>
                                    )}

                                    {habilitarAceiteRecusa && !["finalizado", "cancelado"].includes(agendamento.situacao) && agendamento.status_aceite !== 'recusado' && (
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => { this.handleAceiteAgendamento(agendamento, false); this.handleCloseDropdown(); }}
                                        >
                                            <FaTimes className="me-2" /> Recusar Agendamento
                                        </button>
                                    )}
                                    
                                    {(['', 'gestor', 'operador'].includes(dados_usuario['tipo_usuario']) || dados_usuario['is_superuser']) && (
                                        <button 
                                            className="dropdown-item" 
                                            onClick={() => { this.handleShowHistoricoAgendamentos(agendamento); this.handleCloseDropdown(); }}
                                        >
                                            <FaHistory className="me-2" /> Histórico aceites/recusas
                                        </button>
                                    )}
                                    <div className="dropdown-divider"></div>
                                </>
                            )}
                            
                            {/* Despesas */}
                            {habilitarDespesasAgendamento && agendamento.situacao !== "cancelado" && ((agendamento.envia_aceite === true && agendamento.status_aceite === "aceito") || !agendamento.envia_aceite) && (
                                <button 
                                    className="dropdown-item" 
                                    onClick={() => { this.handleShowDespesasAgendamentos(agendamento); this.handleCloseDropdown(); }}
                                >
                                    <FaReceipt className="me-2" /> Despesas
                                </button>
                            )}
                            
                            {/* Confirmar Realização */}
                            {((agendamento.situacao !== "finalizado" && agendamento.situacao !== "cancelado" && (agendamento.status_aceite === "aceito" || !agendamento.envia_aceite))) && (
                                <>
                                    <div className="dropdown-divider"></div>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => { this.handleConfirmarServico(agendamento); this.handleCloseDropdown(); }}
                                    >
                                        <FaCheck className="me-2" /> Confirmar Realização do Serviço
                                    </button>
                                </>
                            )}

                            {/* Excluir Agendamento (somente cancelados, com permissão) */}
                            {agendamento.situacao === 'cancelado' && hasPerm('delete_agendamentos') && (
                                <>
                                    <div className="dropdown-divider"></div>
                                    <button
                                        className="dropdown-item text-danger"
                                        onClick={() => { this.handleExcluirAgendamento(agendamento.id); this.handleCloseDropdown(); }}
                                    >
                                        <FaTrash className="me-2" /> Excluir Agendamento
                                    </button>
                                </>
                            )}
                        </div>
                    </>,
                    document.body
                )}
            </>
        );
    }

    render(){
        const {
            camposFormulario,
            valoresCampos,
            camposOutro,
            opcaoModalRelato,
            loading,
            goToClient_id,
            loadingGoto,
            goToErroMensagem,
            goToAccessToken,
            goToLinhasAtendente,
            goToLinhaLigar,
            goToLoaderLigacao,
            goToLigacaoRealizada,
            beneficiario_celular,
            showModal
        } = this.state;

        // Config para o gotoConnect
        const gotoConfig = {
            goToClientId: goToClient_id,
            loadingGoto,
            goToErroMensagem,
            goToAccessToken,
            goToLinhasAtendente,
            goToLinhaLigar,
            onChangeLinha: e => this.handleChange(e, 'goToLinhaLigar'),
            ligarParaPaciente: this.ligarParaPaciente,
            loadingLigacao: goToLoaderLigacao,
            goToLigacaoRealizada,
            beneficiario_celular
        };
        
        let dados_usuario = getCurrentUser();

        // Encontrar o índice da etapa atual no array de etapas
        const indiceEtapaAtual = this.state.etapas_atendimento.findIndex(etapa => etapa.id === this.state.etapa_id);

        // Verificar se existe uma próxima etapa
        const proximaEtapa = indiceEtapaAtual >= 0 && indiceEtapaAtual < this.state.etapas_atendimento.length - 1 
            ? this.state.etapas_atendimento[indiceEtapaAtual + 1] 
            : null;

        // Calcular a porcentagem de progresso
        let porcentagemProgresso = 5
        if(indiceEtapaAtual > 0) {
            porcentagemProgresso = (indiceEtapaAtual) / this.state.etapas_atendimento.length * 100;
        }
        if(this.state.finalizado && indiceEtapaAtual === (this.state.etapas_atendimento.length - 1)) {
            porcentagemProgresso = 100;
        }

        let etapasOcultasCount = 0;
        
        const temFinalizaEtapa = this.state.camposFormulario.some(campo => campo.tipo === 'finaliza_etapa');

        const currentDate = new Date().toISOString().split('T')[0];
        const minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 120);
        const minDateString = minDate.toISOString().split('T')[0];

        const ocultar_etapa_atual = (this.state.etapa_atual.ocultar_etapa) ? this.state.etapa_atual.ocultar_etapa.split(',') : [];

        const desabilitar_edicao = (this.state.finalizado || this.state.cancelado || (dados_usuario['tipo_usuario'] != '' && dados_usuario['tipo_usuario'] != 'operador' && dados_usuario['tipo_usuario'] != 'gestor')) ? true : false;

        const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;

        const idade_paciente = (this.state.beneficiario_id && this.state.beneficiario_dados.data_nascimento) ? this.calcularIdade(this.state.beneficiario_dados.data_nascimento) : 0;
        
        const { enderecos, showModalNovoEndereco, novoEndereco, beneficiario_dados } = this.state;

        const showMedicoSolicitante = this.getProgramaConfig('agendamento.medico_solicitante', false);
        const showObservacoes = this.getProgramaConfig('agendamento.observacoes', false);
        const showLocalProcedimento = this.getProgramaConfig('agendamento.local_procedimento', false);
        const habilitarDespesasAgendamento = this.getProgramaConfig('agendamento.despesas', false);
        const habilitarAceiteRecusa = this.getProgramaConfig('agendamento.aceite_recusa', false);
        
        const statusListaDefault = ["solicitado", "liberado", "em_analise", "finalizado", "cancelado"];
        const statusListaConfig = this.getProgramaConfig('agendamento.status_lista', statusListaDefault);
        const situacaoAtual = this.state.agendamento_selecionado?.situacao;
        
        let allowedStatusOptions = Array.isArray(statusListaConfig) 
            ? statusListaConfig.filter(statusKey => situacoesAgendamento[statusKey])
            : statusListaDefault;

        if (situacaoAtual && !allowedStatusOptions.includes(situacaoAtual)) {
            allowedStatusOptions.push(situacaoAtual);
        }
        
        // Pegar o objeto do status atual do atendimento
        let statusAtual = {};
        if(this.state.programa_dados.dados_status) {
            statusAtual = this.state.programa_dados.dados_status.find(
                status => status.id === this.state.programa_status_id
            );  
        }

        // Atualiza o estado apenas se necessário, evitando loop infinito
        this.state.etapas_atendimento.forEach((etapa) => {
            if (etapa.ocultar_etapa && etapa.ocultar_etapa !== '') {
                const ocultar_etapa = etapa.ocultar_etapa.split(',');
    
                if (ocultar_etapa.includes(dados_usuario['tipo_usuario']) ||
                    (dados_usuario['tipo_usuario'] === 'prestador' && verificarOcultarEtapa(ocultar_etapa, dados_usuario['prestador_categoria']))) {
                    etapasOcultasCount += 1;
                }
            }
        });


        //Medicamento/produto
        let produto_nome = '';
        if (this.state.programa_dados.habilitar_gestao_produtos && ('results' in this.state.produtos && this.state.produtos.results.length > 0)) {
            produto_nome = this.state.produtos.results[0].dados_produto.nome;
        }     

        const termos_indice_etapa_exibir = getConfig(this.state.programa_dados?.configuracoes, 'termos_paciente_atendimento.indice_etapa_exibir_termos', 0);
        const termos_ocultar_impressao_medico = getConfig(this.state.programa_dados?.configuracoes, 'termos_paciente_atendimento.medico_ocultar_impressao', false);

        let termos_exibir_impressao_medico = true;
        if(dados_usuario?.prestador_categoria === 'medicos' && termos_ocultar_impressao_medico) {
            termos_exibir_impressao_medico = false;
        }

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={12} lg={12}>
                        {this.state.programa_id && this.state.atendimento_id && (
                            <h5 className="text-white"><strong>{this.state.cliente_nome} | {this.state.programa_nome}</strong></h5>
                        )}
                        <h4 className="page-title mb-1">
                            {this.state.atendimento_id ? (
                                <>
                                    {this.state.is_perfil_medico
                                        ? 'Dados do Atendimento'
                                        : this.state.titulo_pagina}
                                    {this.state.atendimento_id &&
                                        ` | #${this.state.atendimento_id}${this.state.beneficiario_nome ? ` | ${this.state.beneficiario_nome}` : ''}`}

                                    {this.state.cadastro_teste && (
                                        <Badge className="bg-warning ms-3 text-dark">
                                            ATENDIMENTO DE TESTE
                                        </Badge>
                                    )}
                                </>
                            ) : (
                                <>
                                    {this.state.is_perfil_medico
                                        ? 'Novo Cadastro'
                                        : this.state.titulo_pagina}
                                </>
                            )}
                        </h4>
                        {/* Exibição de "Criado por" temporariamente oculta */}
                    </Col>
                </Row>
                <Tabs 
                    activeKey={this.state.tab_key}
                    onSelect={this.handleSelectTabs}
                    mountOnEnter
                    defaultActiveKey="dadosAtendimento" 
                    id="tabs-agendamento" 
                    className={`aditus-tabs ${this.state.is_perfil_medico && !this.state.atendimento_id ? 'hide-medico-tab' : ''}`}>
                    <Tab eventKey="dadosAtendimento" title="Dados do Atendimento">
                        {this.state.atendimento_id && (
                            <>
                                <Card className="cardDestaque mt-2 mb-4">
                                    {this.state.cancelado ? (
                                        <Card.Body>     
                                            <Row>
                                                <Col sm={12} lg={12}>
                                                    <h4><strong>Jornada de Atendimento ao Paciente</strong> {!this.state.finalizado && <FaQuestionCircle onClick={this.handleShowModalDescricao} />}</h4>
                                                
                                                    <Alert className="alert-warning">
                                                        <p className="mb-0">Este atendimento foi cancelado</p>
                                                        {this.state.optout_data && (
                                                            <>
                                                                <hr />
                                                                <p className="mt-2 mb-1">O paciente optou por encerrar a participação no programa em <strong>{formataDataHoraExibicao(this.state.optout_data)}</strong>.</p>
                                                                {this.state.optout_motivo_id ? (
                                                                    <p className="mb-0">Motivo: <strong>{this.state.optout_motivo_titulo}</strong></p> 
                                                                ) : (
                                                                    <p className="mb-0">Motivo: <strong>{this.state.optout_motivo_outros}</strong></p> 
                                                                )}
                                                            </>
                                                        )}
                                                        {/*this.state.programa_dados.permite_reativar_atendimento && (
                                                            <Button
                                                                variant="warning"
                                                                size="sm"
                                                                className="mt-3"
                                                                onClick={this.handleReativarAtendimento}
                                                            >
                                                                Reativar
                                                            </Button>
                                                        )*/}
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    ) : (
                                        <Card.Body>                    
                                            <Row>
                                                <Col sm={6} lg={6}>
                                                    <h4><strong>Jornada de Atendimento ao Paciente</strong> {!this.state.finalizado && <FaQuestionCircle onClick={this.handleShowModalDescricao} />}</h4>
                                                </Col>
                                                <Col sm={6} lg={6} className="text-sm-end">
                                                    <p>Etapa <strong>{(indiceEtapaAtual + 1)}</strong> de <strong>{this.state.etapas_atendimento.length}</strong></p>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    <div className="mb-2 atendimento-etapa-info">
                                                        {this.state.finalizado ? (
                                                            <div>
                                                                {indiceEtapaAtual === (this.state.etapas_atendimento.length - 1) ? (
                                                                    <p className="mb-0">A jornada de atendimento ao paciente foi concluída.</p>
                                                                ) : (
                                                                    <p className="mb-0">A jornada de atendimento ao paciente foi interrompida.</p>
                                                                )}
                                                                
                                                                {this.state.programa_dados.permite_reativar_atendimento && dados_usuario.tipo_usuario !== 'prestador' && (
                                                                    <>
                                                                        {indiceEtapaAtual < (this.state.etapas_atendimento.length - 1) ? (
                                                                            <Button
                                                                                variant="warning"
                                                                                size="sm"
                                                                                className="mt-3"
                                                                                onClick={this.handleReativarAtendimento}
                                                                            >
                                                                                Reativar
                                                                            </Button>
                                                                        ) : (
                                                                            <Button
                                                                                variant="warning"
                                                                                size="sm"
                                                                                className="mt-3"
                                                                                onClick={this.handleReativarAtendimentoFinalizado}
                                                                            >
                                                                                Iniciar novo ciclo
                                                                            </Button>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <>
                                                                {(indiceEtapaAtual + 1) === this.state.etapas_atendimento.length ? (
                                                                    <span>Você está na etapa <strong> {this.state.etapa_nome}</strong>.</span>
                                                                ) : (
                                                                    <span>Você está na etapa <strong> {this.state.etapa_nome}</strong>.</span>
                                                                )}
                                                                {proximaEtapa && (
                                                                    <span> Próxima etapa: <strong>{proximaEtapa.nome}</strong></span>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col sm={12}>
                                                    <ProgressBar now={porcentagemProgresso} label={`${porcentagemProgresso.toFixed(0)}%`} />
                                                </Col>
                                            </Row>
                                            {this.state.programa_dados.dados_status && statusAtual && statusAtual.tipo === 'pause_atendimento' ? (
                                                <Row className="align-items-center">
                                                    <Col sm={10}>
                                                        <p className="m-0 atendimento-etapa-info">{statusAtual.descricao}</p>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row className="align-items-center">
                                                    {this.state.finalizado === false && (dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] == '' || (dados_usuario['gestor_id'] > 0 && this.state.permite_editar) || (dados_usuario['prestador_id'] > 0 && dados_usuario['prestador_categoria'] == this.state.etapa_atual.responsavel_etapa && !verificarOcultarEtapa(ocultar_etapa_atual, dados_usuario['prestador_categoria']))) && (
                                                    <Col sm={6} className="text-start" style={{marginBottom: '10px'}}>
                                                            {(this.state.etapa_nome  === 'Solicitação de Exames' || this.state.etapa_nome  === 'Pedido do Teste de Responsividade' || this.verificarExamesExtrasPendentes() || this.state.etapa_atual?.configuracoes?.etapa_solicitar_exame === true) && dados_usuario['prestador_categoria'] === 'medicos' ? (
                                                                <Button
                                                                    variant="secondary"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            tab_key: 'exames',
                                                                            autoSolicitarExames: true
                                                                        });
                                                                    }}
                                                                >
                                                                    Pedido de {getConfig(this.state.programa_dados?.configuracoes, "exames.nomenclatura", 'Exames')}
                                                                </Button>
                                                            ) : (
                                                                <>
                                                                <Button variant="secondary" className="mb-3 mb-sm-0" size="sm" onClick={() => this.handleShowModalRelatosEdit()}>
                                                                    <FaCheckDouble className="me-2" /> {this.state.etapa_atual?.configuracoes?.label_botao || 'Registrar Etapa'}
                                                                </Button>
                                                                {(dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['tipo_usuario'] == '') && this.state.etapa_atual?.id && (
                                                                <Button variant="outline-secondary" className="mb-3 mb-sm-0" size="sm" onClick={() => this.setState({ showModalRelatosEtapaAtual: true })}>
                                                                    <FaEye className="me-2" /> Ver Relatos da Etapa
                                                                </Button>
                                                                )}
                                                                {!this.state.programa_dados.ocultar_outras_acoes && (dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['tipo_usuario'] == '') && (
                                                                <Button variant="outline-danger" className="mb-3 mb-sm-0" size="sm" onClick={() => this.handleShowModalRelatosEdit('cancelar-etapa')}>
                                                                    Cancelar Etapa
                                                                </Button>
                                                                )}
                                                                </> 
                                                            )}
                                                    </Col>
                                                    )}
                                                    {/*!this.state.programa_dados.termo_paciente_pdf && !this.state.optin_data && (
                                                        <Col sm={12} className="text-start" style={{marginTop: '10px'}}>
                                                                <Button variant="secondary" className="mb-3 mb-sm-0" size="sm" onClick={() => this.handleRegerarTermo()}>
                                                                    <FaEdit /> Regerar Termo
                                                                </Button> 
                                                        </Col>
                                                    )*/}
                                                    {this.state.formulario_pesquisa_id && (
                                                        <>
                                                            {this.state.formulario_pesquisa_respondida ? (
                                                                <Col sm={12} className="text-start ">
                                                                    <Col sm={2} className="text-start">
                                                                        <Alert variant="success">
                                                                            <FaCheckCircle /> Pesquisa já respondida
                                                                        </Alert>
                                                                    </Col>
                                                                </Col>
                                                            ) : (
                                                            <Col sm={12} className="text-start" style={{marginBottom: '10px'}}>
                                                                <Button variant="primary" className="mb-3 mb-sm-0" size="sm" href={`/pesquisa/${this.state.uuid}`} target="_blank">
                                                                    <FaCheckDouble /> Acessar Pesquisa
                                                                </Button>
                                                            </Col>
                                                            )}
                                                        </>
                                                    )}
                                                </Row>
                                            )}
                                            
                                        </Card.Body>
                                    )}
                                </Card>

                                {/* Renderização dos botões */}
                                <Row className="mb-4">
                                    {this.state.permite_editar && this.state.botoes_atendimento.length > 0 && (
                                        <>
                                            {this.renderModalBotao()}
                                            
                                                {this.state.botoes_atendimento.map((botao, index) => (
                                                    <React.Fragment key={index}>
                                                    {botao.tipo_usuario ? (
                                                        <>
                                                            {(dados_usuario.is_superuser || (dados_usuario['tipo_usuario'] == botao.tipo_usuario) || (dados_usuario['prestador_id'] > 0 && dados_usuario['prestador_categoria'] == botao.tipo_usuario && dados_usuario['prestador_categoria'] == this.state.etapa_atual.responsavel_etapa && !verificarOcultarEtapa(ocultar_etapa_atual, dados_usuario['prestador_categoria']))) && !this.state.finalizado && (
                                                                <Col sm={12} md={4} lg={4} className="mb-3">
                                                                    <Button type="button" variant="secondary" size="sm" className="w-100" onClick={() => this.handleShowModalBotao(botao)}>
                                                                        <FaEdit /> {botao.titulo}
                                                                    </Button>
                                                                </Col>
                                                            )}
                                                        </>
                                                    ): (
                                                        <>
                                                            {(dados_usuario['tipo_usuario'] == 'operador' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == '') && (
                                                                <Col sm={12} md={4} lg={4} className="mb-3">
                                                                    <Button type="button" variant="secondary" size="sm" className="w-100" onClick={() => this.handleShowModalBotao(botao)}>
                                                                        <FaEdit /> {botao.titulo}
                                                                    </Button>
                                                                </Col>
                                                            )}
                                                        </>
                                                    )}
                                                    </React.Fragment>
                                                ))}
                                            
                                        </>                                    
                                    )} 

                                    {/** Botão de envio de whatsapp manual */}
                                    {this.state.templates_whatsapp?.length > 0 && (
                                        <>
                                            {this.renderModalTemplateWhatsapp()}
                                            <Col sm={12} md={4} lg={4} className="mb-3">
                                                <Button type="button" variant="secondary" size="sm" className="w-100" onClick={() => this.handleShowModalTemplateWhatsapp()}>
                                                    <FaWhatsapp /> Enviar Template Whatsapp
                                                </Button>
                                            </Col>
                                        </>
                                    )}
                                </Row> 

                                {/* Próxima ação */}
                                <Row>
                                    {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') && this.state.proxima_acao && this.state.proxima_acao.data_acao && !this.state.finalizado && !this.state.cancelado && (         
                                        <Col sm={6}>
                                            <Alert variant="warning">
                                                <h6><FaExclamationTriangle className="mb-1" /> Próxima Ação</h6>
                                                <p>{this.state.proxima_acao.descricao}</p>
                                                <p>Data prevista: <strong>{formataDataExibicao(this.state.proxima_acao.data_acao)}</strong> às <strong>{this.state.proxima_acao.hora_acao?.split('.')[0]}</strong></p>
                                                {/*this.state.proxima_acao.observacoes && (
                                                    <>
                                                        <hr />
                                                        <strong>Observações</strong>
                                                        <p>{this.state.proxima_acao.observacoes}</p>
                                                    </>
                                                )*/}
                                                <Button
                                                    variant="warning"
                                                    size="sm"
                                                    onClick={() => this.handleSelectTabs("acoesAtendimento")}
                                                >
                                                    Ver Ações
                                                </Button>
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={this.handleMarcarAcaoProximaComoRealizada}
                                                >
                                                    Marcar como realizado
                                                </Button>
                                            </Alert>
                                        </Col>                                                        
                                    )}
                                
                                    {this.state.atendimento_id && 
                                    this.state.dados_agendamento && 
                                    this.state.dados_agendamento.some(ag => ag.servico_procedimento__nome === "Exame de Níveis de fenilalanina (Phe)") && (
                                        <Col sm={12}>
                                            <PhenylalanineHistoryChart atendimentoId={this.state.atendimento_id} />
                                        </Col>
                                    )}
                                </Row>               
                                <Row>                                 

                                    {this.state.atendimento_id && (this.state.programa_dados.termo_paciente_pdf || this.state.termo_programa_pdf || this.state.termo_paciente_pdf_comprovante) && (indiceEtapaAtual > termos_indice_etapa_exibir || this.state.etapa_atual.etapa_termo) && (
                                    <>
                                    {(this.state.optin_data && (this.state.optin_ip || this.state.termo_paciente_pdf_comprovante || this.state.optin_telefone)) ? (
                                        <Col sm={6}>
                                            <Card className="cardDestaque mt-2 mb-4">
                                                <Card.Body> 
                                                    <h6><FaCheckCircle className="text-success" /> Termo de Consentimento Programa {this.state.programa_nome}</h6>
                                                    {this.state.optin_telefone ? (
                                                        <p className="mb-0"><strong>O paciente já aceitou o termo através do telefone em {formataDataHoraExibicao(this.state.optin_data)}. ID da Chamada: {this.state.optin_telefone_chamada_id}</strong></p>
                                                    ) : (
                                                        <p className="mb-0"><strong>O paciente já aceitou o termo em {formataDataHoraExibicao(this.state.optin_data)}{this.state.optin_ip ? ` no IP: ${this.state.optin_ip}` : ''}.</strong></p>
                                                    )}

                                                    {this.state.historicoPendente && (
                                                        <p className="mb-0 text-danger"><FaExclamationTriangle className="me-1" /> Novo termo {this.state.historicoPendente.termo_versao || '(sem versão)'} pendente de consentimento.</p>
                                                    )}
                                                    
                                                    {this.state.permite_editar
                                                    &&
                                                    <>
                                                        {this.state.termo_paciente_pdf_comprovante ? (
                                                            <>
                                                                <Button
                                                                    variant="light"
                                                                    className="btn-sm ms-2 mt-2"
                                                                    onClick={() => window.open(this.state.termo_paciente_pdf_comprovante, '_blank')}
                                                            >
                                                                Ver Termo Assinado
                                                            </Button>
                                                            {hasPerm('view_atendimentos_termos_aceite_historico') && (
                                                                <Button
                                                                    variant="outline-primary"
                                                                    className="btn-sm ms-2 mt-2"
                                                                    onClick={this.handleOpenHistoricoTermos}
                                                                >
                                                                    Histórico de Aceites
                                                                </Button>
                                                            )}
                                                            {hasPerm('view_autorizacoes') && (
                                                                <Button
                                                                    variant="outline-warning"
                                                                    className="btn-sm ms-2 mt-2"
                                                                    onClick={() => this.handleExcluirTermoLaudo('termo_programa')}
                                                                >
                                                                    Excluir Termo
                                                                </Button>
                                                            )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {this.state.programa_dados.termo_paciente_pdf ? (
                                                                    <a className="btn btn-sm btn-light mt-2" href={this.state.programa_dados.termo_paciente_pdf} target="_blank" rel="noreferrer">Ver Termo</a>
                                                                ) : (
                                                                    <a className="btn btn-sm btn-light mt-2" onClick={this.handleShowModalTermosPaciente}>Ver Termo</a>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                    }                                                    
                                                </Card.Body>
                                            </Card> 
                                            <Modal size="lg" show={this.state.showModalTermosPaciente} onHide={this.handleCloseModalTermosPaciente}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Termo do Programa {this.state.programa_nome}</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div>
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.optin_termo_conteudo }} />
                                                    </div>    
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={this.handleCloseModalTermosPaciente}>
                                                        Fechar
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>

                                            <Modal show={this.state.showHistoricoModal} onHide={this.handleCloseHistoricoTermos} size="xl" centered>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Histórico de Aceites</Modal.Title>
                                                </Modal.Header>

                                                <Modal.Body>
                                                    {this.state.historicoLoading ? (
                                                        <div className="d-flex justify-content-center my-4"><Spinner animation="border" /></div>
                                                    ) : this.state.historicoError ? (
                                                        <div className="alert alert-danger mb-0">{this.state.historicoError}</div>
                                                    ) : (
                                                        <Table bordered hover>
                                                            <thead>
                                                                <tr>
                                                                <th>Versão</th>
                                                                <th>Data de aceite</th>
                                                                <th>Termo Assinado</th>
                                                                <th>Ações</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.historicoAceites.length === 0 ? (
                                                                <tr><td colSpan={4} className="text-center">Nenhum aceite encontrado</td></tr>
                                                                ) : (
                                                                this.state.historicoAceites.map((item, idx, arr) => {
                                                                    const isUltimo = idx === arr.length - 1;
                                                                    const isUltimoPendente =
                                                                    isUltimo &&
                                                                    this.state.historicoPendente &&
                                                                    item.id === this.state.historicoPendente.id;

                                                                    return (
                                                                    <tr key={item.id}>
                                                                        <td>{item.termo_versao || '-'}</td>
                                                                        <td>{item.data_assinatura ? formataDataHoraExibicao(item.data_assinatura) : '-'}</td>
                                                                        <td>
                                                                        {item.termo_pdf_assinado ? (
                                                                            <a href={item.termo_pdf_assinado} target="_blank" rel="noopener noreferrer">Ver Termo Assinado</a>
                                                                        ) : '-'}
                                                                        </td>
                                                                        <td>
                                                                            {isUltimoPendente && this.state.permite_editar ? (
                                                                                <>
                                                                                    <Button
                                                                                    variant="outline-info"
                                                                                    size="sm"
                                                                                    disabled={this.state.loading}
                                                                                    onClick={this.handleReenviarTermoHistorico}
                                                                                    >
                                                                                    Reenviar termo
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="outline-secondary"
                                                                                        size="sm"
                                                                                        className="ms-2"
                                                                                        disabled={this.state.loading}
                                                                                        onClick={() => this.clickFileInputTermoAssinado(item.id)}
                                                                                    >
                                                                                        {this.state.loading ? (
                                                                                            <span className="spinner-border spinner-border-sm"></span>
                                                                                        ) : (
                                                                                            <>
                                                                                                Upload do Termo Assinado
                                                                                            </>
                                                                                        )}
                                                                                    </Button>
                                                                                </>                                                                                
                                                                            ) : (
                                                                                <span className="text-muted">—</span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                    );
                                                                })
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    )}
                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        ref={this.fileInputTermoAssinado}
                                                        onChange={this.handleChangeTermoAssinado}
                                                        accept="application/pdf"
                                                    />
                                                </Modal.Body>

                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={this.handleCloseHistoricoTermos}>Fechar</Button>
                                                </Modal.Footer>
                                            </Modal>
                                        </Col>
                                    ) : (
                                        <Col sm={6}>
                                            <Card className="cardDestaque mt-2 mb-4">
                                                <Card.Body> 
                                                    <h6><FaExclamationTriangle className="text-warning" /> Termo de Consentimento Programa {this.state.programa_nome}</h6>
                                                    <p className="mb-0"><strong>O paciente ainda não assinou o termo</strong>.</p>
                                                    {this.state.permite_editar
                                                    &&
                                                    <>
                                                        {!getConfig(this.state.programa_dados?.configuracoes, 'termo_paciente.ocultar_envio_termo', false) && (
                                                        <button className="btn btn-light btn-sm mt-2 me-2" onClick={this.handleReenviarTermo}>Envio de Termo</button>
                                                        )}

                                                        {this.state.programa_dados.termo_paciente_pdf && !getConfig(this.state.programa_dados?.configuracoes, 'termo_paciente.ocultar_termo_impressao', false) && termos_exibir_impressao_medico && (
                                                            <a className="btn btn-light btn-sm mt-2" href={this.state.programa_dados.termo_paciente_pdf} target="_blank" rel="noreferrer">
                                                                <FaFilePdf /> Termo para impressão
                                                            </a>
                                                        )}      
                                                        {this.state.termo_programa_pdf && !getConfig(this.state.programa_dados?.configuracoes, 'termo_paciente.ocultar_termo_impressao', false) && termos_exibir_impressao_medico && (
                                                            <a className="btn btn-light btn-sm mt-2" href={this.state.termo_programa_pdf} target="_blank" rel="noreferrer">
                                                                <FaFilePdf /> Termo para impressão
                                                            </a>
                                                        )}                                              
                                                        {this.state.termo_paciente_pdf_comprovante ? (
                                                            <Button
                                                                variant="light"
                                                                className="btn-sm ms-2 mt-2"
                                                                onClick={() => window.open(this.state.termo_paciente_pdf_comprovante, '_blank')}
                                                            >
                                                                Ver Termo Assinado
                                                            </Button>
                                                        ) : (
                                                            <>
                                                                <Button
                                                                    variant="light"
                                                                    className="btn-sm ms-2 mt-2"
                                                                    disabled={this.state.loading}
                                                                    onClick={() => this.fileInputComprovante.current.click()}
                                                                >
                                                                    {this.state.loading ? (
                                                                        <span className="spinner-border spinner-border-sm"></span>
                                                                    ) : (
                                                                        <>
                                                                            Upload do Termo Assinado
                                                                        </>
                                                                    )}
                                                                </Button>
                                                                {this.state.programa_dados.habilitar_optin_telefone && dados_usuario['tipo_usuario'] !== 'prestador' && (
                                                                    <Button
                                                                        variant="light"
                                                                        className="btn-sm ms-2 mt-2"
                                                                        disabled={this.state.loading}
                                                                        onClick={this.handleAceiteTermoTelefone}
                                                                    >
                                                                        {this.state.loading ? (
                                                                            <span className="spinner-border spinner-border-sm"></span>
                                                                        ) : (
                                                                            <>
                                                                                Aceite por Telefone
                                                                            </>
                                                                        )}
                                                                    </Button>
                                                                )}
                                                            </>
                                                        )}
                                                    </>
                                                    }
                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        ref={this.fileInputComprovante}
                                                        onChange={this.handleChangeComprovante}
                                                        accept="application/pdf"
                                                    />
                                                </Card.Body>
                                            </Card> 
                                        </Col>
                                    )}

                                    {!this.state.lets_sign_documento_id && this.state.pdf_termo_prestador && (
                                        <>
                                        {((this.state.optin_data_laboratorio && this.state.optin_ip) || (this.state.optin_data_laboratorio && this.state.termo_prestador_pdf_comprovante)) ? (
                                            <Col sm={6}>
                                                <Card className="cardDestaque mt-2 mb-4">
                                                    <Card.Body> 
                                                        <h6><FaCheckCircle className="text-success" /> Termo de Consentimento Laboratório {this.state.laboratorio_nome?.replace(/\s*\(.*?\)/, '')}</h6>
                                                        <p className="mb-0"><strong>O paciente já aceitou o termo em {formataDataHoraExibicao(this.state.optin_data_laboratorio)}{this.state.optin_ip ? ` no IP: ${this.state.optin_ip}` : ''}.</strong></p>
                                                        {this.state.permite_editar
                                                        &&
                                                        <>
                                                            {this.state.termo_prestador_pdf_comprovante ? (
                                                                <>
                                                                    <Button
                                                                        variant="light"
                                                                        className="btn-sm ms-2 mt-2"
                                                                        onClick={() => window.open(this.state.termo_prestador_pdf_comprovante, '_blank')}
                                                                >
                                                                    Ver Termo Assinado
                                                                    </Button>
                                                                    {hasPerm('view_autorizacoes') && (
                                                                        <Button
                                                                            variant="warning"
                                                                            className="btn-sm ms-2 mt-2"
                                                                            onClick={() => this.handleExcluirTermoLaudo('termo_laboratorio')}
                                                                        >
                                                                            Excluir Termo
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <a className="btn btn-sm btn-light mt-2" href={this.state.pdf_termo_prestador} target="_blank" rel="noreferrer">Ver Termo</a>
                                                            )}
                                                        </>
                                                        }
                                                    </Card.Body>
                                                </Card> 
                                            </Col>
                                        ) : (
                                            <Col sm={6}>
                                                <Card className="cardDestaque mt-2 mb-4">
                                                    <Card.Body> 
                                                        <h6><FaExclamationTriangle className="text-warning" /> Termo de Consentimento Laboratório {this.state.laboratorio_nome?.replace(/\s*\(.*?\)/, '')}</h6>
                                                        <p className="mb-0"><strong>O paciente ainda não assinou o termo</strong>.</p>
                                                        {this.state.permite_editar
                                                        &&
                                                        <>
                                                            {!getConfig(this.state.programa_dados?.configuracoes, 'termo_paciente.ocultar_envio_termo', false) && (
                                                                <button className="btn btn-light btn-sm mt-2 me-2" onClick={this.handleReenviarTermo}>Envio de Termo</button>
                                                            )}
                                                            {!getConfig(this.state.programa_dados?.configuracoes, 'termo_paciente.ocultar_termo_impressao', false) && (
                                                                <a className="btn btn-sm btn-secondary mt-2" href={this.state.pdf_termo_prestador} target="_blank" rel="noreferrer"><FaFilePdf /> Termo para impressão</a>
                                                            )}
                                                        
                                                            {this.state.termo_prestador_pdf_comprovante ? (
                                                                <Button
                                                                    variant="light"
                                                                    className="btn-sm ms-2 mt-2"
                                                                    onClick={() => window.open(this.state.termo_prestador_pdf_comprovante, '_blank')}
                                                                >
                                                                    Ver Termo Assinado
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    variant="light"
                                                                    className="btn-sm ms-2 mt-2"
                                                                    disabled={this.state.loading}
                                                                    onClick={() => this.fileInputComprovanteLaboratorio.current.click()}
                                                                >
                                                                    {this.state.loading ? (
                                                                        <span className="spinner-border spinner-border-sm"></span>
                                                                    ) : (
                                                                        <>
                                                                            Upload do Termo Assinado
                                                                        </>
                                                                    )}
                                                                </Button>
                                                            )}
                                                        </>
                                                        }
                                                        <input
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            ref={this.fileInputComprovanteLaboratorio}
                                                            onChange={this.handleChangeComprovanteLaboratorio}
                                                            accept="application/pdf"
                                                        />
                                                    </Card.Body>
                                                </Card> 
                                            </Col>
                                        )}
                                        </>
                                    )}
                                    </>
                                )}
                                {this.state.lets_sign_documento_id && indiceEtapaAtual > 0 && (
                                    <Col sm={6}>
                                    {this.state.lets_assinatura_status === "Signed" ? (
                                        <Card className="cardDestaque mt-2 mb-4">
                                            <Card.Body> 
                                                <h6><FaCheckCircle className="text-success" /> Termo de Consentimento Laboratório {this.state.laboratorio_nome?.replace(/\s*\(.*?\)/, '')}</h6>
                                                <p className="mb-0"><strong>O paciente já assinou o termo</strong>.</p>
                                                {this.state.permite_editar
                                                &&
                                                <a className="btn btn-sm btn-light mt-2 me-2" href={this.state.lets_sign_documento_assinado_url} target="_blank" rel="noreferrer">Ver Termo Assinado</a>
                                                }
                                                {(dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['is_superuser']) && (
                                                    <Button
                                                        variant="light"
                                                        className="btn-sm mt-2"
                                                        disabled={this.state.regerandoTermoLaboratorio}
                                                        onClick={this.handleRegerarTermoLaboratorio}
                                                    >
                                                        {this.state.regerandoTermoLaboratorio ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : (
                                                            <>Gerar termo novamente</>
                                                        )}
                                                    </Button>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    ) : (
                                        <Card className="cardDestaque mt-2 mb-4">
                                            <Card.Body> 
                                                <h6><FaExclamationTriangle className="text-warning" /> Termo de Consentimento Laboratório {this.state.laboratorio_nome?.replace(/\s*\(.*?\)/, '')}</h6>
                                                <p className="mb-0"><strong>O paciente ainda não assinou o termo</strong>.</p>
                                                {this.state.permite_editar
                                                &&
                                                <>
                                                    {!getConfig(this.state.programa_dados?.configuracoes, 'termo_paciente.ocultar_envio_termo', false) && (
                                                        <button className="btn btn-sm btn-light mt-2 me-2" onClick={this.handleReenviarTermoLaboratorio}>Envio de Termo</button>
                                                    )}
                                                    {!getConfig(this.state.programa_dados?.configuracoes, 'termo_paciente.ocultar_termo_impressao', false) && (
                                                        <a className="btn btn-sm btn-light mt-2" href={this.state.pdf_termo_prestador} target="_blank" rel="noreferrer"><FaFilePdf /> Termo para impressão</a>
                                                    )}
                                                    <Button
                                                        variant="light"
                                                        className="btn-sm ms-2 mt-2"
                                                        disabled={this.state.loading}
                                                        onClick={() => this.fileInputComprovanteLaboratorio.current.click()}
                                                    >
                                                        {this.state.loading ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : (
                                                            <>
                                                                Upload do Termo Assinado
                                                            </>
                                                        )}
                                                    </Button>
                                                    <input
                                                        type="file"
                                                        style={{ display: 'none' }}
                                                        ref={this.fileInputComprovanteLaboratorio}
                                                        onChange={this.handleChangeComprovanteLaboratorio}
                                                        accept="application/pdf"
                                                    />
                                                </>
                                                }
                                            </Card.Body>
                                        </Card> 
                                    )}
                                    </Col>
                                )}
                                </Row>
                                {/*this.state.atendimento_id && this.state.programa_dados.termo_paciente_pdf && !this.state.optin_data && indiceEtapaAtual > 0 && (
                                    <Row>
                                        <Col sm={12}>
                                            <i><p className="mb-0">Os termos de consentimento foram enviados para o E-mail e WhatsApp do paciente.</p> 

                                            <p className="mb-0">O paciente deverá escolher o meio de contato de sua preferência e aceitar os 2 termos através dele. Não é necessário aceitar os termos tanto no WhatsApp quanto no E-mail</p>

                                            <p>Em caso de dificuldades, o termo poderá ser reenviado ou impresso e assinado presencialmente. Nesse caso deverá ser feito o upload do documento ou enviada a foto para a central do programa</p></i>
                                        </Col>
                                    </Row>
                                )*/}
                            </>
                        )}
                        <Card className="cardDestaque">
                            <Card.Body>         
                                {this.state.atendimento_id && (
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <h6 className="mt-2 mb-4"><strong>Dados do Atendimento</strong></h6>
                                        </Col>
                                    </Row>
                                )}
                                {this.renderizaAlertaBloqueioPreCadastro()}
                                <Form onSubmit={this.enviaRegistro}>
                                    <Row>  
                                        {this.state.atendimento_id && (
                                            <Col sm={3} xs={12}>
                                                <Form.Group className="row-list mb-3">
                                                    <Form.Label className="mb-0">ID</Form.Label>
                                                    <hr className="mb-2 mt-1"></hr>
                                                    <h6 className="mb-3"><strong>#{this.state.atendimento_id}</strong></h6>
                                                </Form.Group>
                                            </Col>
                                        )} 
                                        {this.state.cliente_id && this.state.atendimento_id ? (
                                            <></>
                                        ) : (
                                            <>
                                                {dados_usuario['ambiente_cliente_id'] == '' && (
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Cliente</Form.Label>
                                                            <AsyncSelect
                                                                required
                                                                cacheOptions
                                                                loadOptions={this.carregaClientes}
                                                                defaultOptions
                                                                name="cliente_id"
                                                                placeholder={'Buscar cliente...'}
                                                                noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                                onChange={e => this.handleChange(e, 'cliente_id')}
                                                                value={this.state.cliente_id ? { value: this.state.cliente_id, label: this.state.cliente_nome } : null}
                                                            />
                                                            <Form.Text id="clienteHelper" className="text-danger">{this.state.clienteHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                            </>
                                        )}
                                        {this.state.cliente_id && (
                                            this.state.programa_id && this.state.atendimento_id ? (
                                                <></>
                                            ) : (
                                                <Col sm={4} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Programa</Form.Label>
                                                        <AsyncSelect
                                                            key={this.state.programa_select_key}
                                                            required
                                                            cacheOptions
                                                            loadOptions={this.carregaProgramas}
                                                            defaultOptions
                                                            name="programa_id"
                                                            placeholder={'Buscar programa...'}
                                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                                            onChange={e => this.handleChange(e, 'programa_id')}
                                                            value={this.state.programa_id ? { value: this.state.programa_id, label: this.state.programa_nome } : null}
                                                        />
                                                        <Form.Text id="programaHelper" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            )
                                        )}

                                        {(this.state.cliente_id || dados_usuario['ambiente_cliente_id'] > 0) && this.state.data && this.state.atendimento_id && (
                                            <Col sm={3} xs={12}>
                                                <Form.Group className="row-list mb-3">
                                                    <Form.Label className="mb-0">Data de Cadastro</Form.Label>
                                                    <hr className="mb-2 mt-1"></hr>
                                                    {this.state.data && this.state.atendimento_id ? (
                                                        <p><strong>{formataDataHoraExibicao(this.state.data)}</strong></p>
                                                    ) : (
                                                        <>
                                                            <Form.Control type="datetime-local" name="data" required placeholder="Data do atendimento" onChange={this.handleChange} />    
                                                            <Form.Text id="formDataAtendimentoHelpBlock" className="text-danger">{this.state.dataHelper}</Form.Text>
                                                        </>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {(dados_usuario['operador_id'] > 0 || dados_usuario['tipo_usuario'] == '' ) && this.state.programa_dados.habilitar_validacao_atendimento && this.state.atendimento_id && (
                                            <Col sm={3} xs={12}>
                                                <Form.Group className="row-list mb-3">
                                                    <Form.Label className="mb-0">Validação Atendimento</Form.Label>
                                                    <hr className="mb-2 mt-1"></hr>
                                                        <Button variant={this.state.atendimento_validado ? "success" : "danger"} className="mb-3 mb-sm-0" size="sm" onClick={() => this.alterarValidacaoAtendimento()}>
                                                            <FaCheckDouble /> {this.state.atendimento_validado ? 'Validado' : 'Validar'}
                                                        </Button> 
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {this.state.atendimento_id && this.state.programa_dados.dados_status?.length > 0 && (
                                            <Col sm={3} xs={12}>
                                                <Form.Group className="row-list">
                                                    <Form.Label>Status do Programa</Form.Label>
                                                    <Form.Control as="select" value={this.state.programa_status_id} name="programa_status_id" onChange={e => this.handleChange(e, 'programa_status_id')} disabled={(this.state.reativar_atendimento) ? false : desabilitar_edicao}>
                                                        <option value="">Selecione um status</option>
                                                        {this.state.programa_dados.dados_status.map(status => (
                                                            <option key={status.slug} value={status.id}>{status.nome}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        {this.state.atendimento_id && dados_usuario['tipo_usuario'] === '' && this.state.programa_dados.dados_status?.length > 0 && (() => {
                                            // Procura o status selecionado pelo programa_status_id
                                            const statusSelecionado = this.state.programa_dados.dados_status.find(
                                                status => status.id === this.state.programa_status_id
                                            );
                                            // Verifica se o slug contém "pre-cadastro" ou "pre_cadastro"
                                            if (statusSelecionado && statusSelecionado.slug && (
                                                statusSelecionado.slug.toLowerCase().includes('pre-cadastro') ||
                                                statusSelecionado.slug.toLowerCase().includes('pre_cadastro')
                                            )) {
                                                return (
                                                    <Col sm={3} xs={12}>
                                                        <Form.Group className="row-list ">
                                                            <Form.Label>Excluir Atendimento</Form.Label>
                                                            <hr className="mb-2 mt-1"></hr>
                                                            <Button
                                                                variant="danger"
                                                                className="mb-3 mb-sm-0"
                                                                size="sm"
                                                                onClick={() => this.handleExcluirAtendimento && this.handleExcluirAtendimento()}
                                                            >
                                                                Excluir Atendimento
                                                            </Button>
                                                        </Form.Group>
                                                    </Col>
                                                );
                                            }
                                            return null;
                                        })()}
                                        {this.state.beneficiario_id && this.state.atendimento_id && (
                                            <Col sm={6} xs={6} className="mb-1">
                                                {this.renderAlertasMascaraPaciente()}
                                                <div className="row-list">
                                                    <Form.Label className="mb-0">
                                                        PACIENTE
                                                        {this.state.tipo_paciente == 'interno' && ' (Interno)'}
                                                        {this.state.tipo_paciente == 'externo' && ' (Externo)'}
                                                    </Form.Label>
                                                    <hr className="mb-2 mt-1"></hr>
                                                    <p className="mb-1">
                                                        <small>NOME:</small> <strong>{(this.state.permite_editar) ? this.state.beneficiario_nome : 'Id: '+this.state.beneficiario_id}</strong>&nbsp;&nbsp;
                                                        {hasPerm('add_beneficiarios') && (
                                                            <a onClick={() => this.handleShowModalAtendimentoPaciente()} 
                                                            className="link-clicavel" style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                                                        >
                                                                Ver Cadastro
                                                            </a>
                                                        )}
                                                    </p>
                                                    <p className="mb-1">
                                                        <small>CPF:</small> <strong>{(this.state.beneficiario_dados.cpf) ? formataCPF(this.state.beneficiario_dados.cpf) : 'Não informado'}</strong>
                                                    </p>
                                                    {this.state.beneficiario_dados.data_nascimento && (
                                                        <>
                                                            <p className="mb-1">
                                                                <small>DATA DE NASCIMENTO: </small> 
                                                                <strong>{formataDataExibicao(this.state.beneficiario_dados.data_nascimento)}</strong>
                                                            </p>
                                                            <p className="mb-1">
                                                                <small>IDADE: </small> 
                                                                <strong className={idade_paciente <= this.state.idade_minima ? 'text-danger' : ''}>{this.calcularIdade(this.state.beneficiario_dados.data_nascimento)} anos</strong>
                                                                {' '}
                                                                <small className="ms-4">GRUPO ETÁRIO: </small>
                                                                <strong>
                                                                    {grupoEtario(this.state.beneficiario_dados.data_nascimento)}
                                                                </strong>
                                                            </p>
                                                        </>
                                                    )}
                                                    <p className="mb-1">
                                                        <small>CELULAR:</small> <strong>{this.state.beneficiario_dados.celular || 'Não informado'}</strong>
                                                    </p>
                                                    <p className="mb-1">
                                                        <small>E-MAIL:</small> <strong>{this.state.beneficiario_dados.email || 'Não informado'}</strong>
                                                    </p>
                                                    <p className="mb-1">
                                                        <small className="text-uppercase">{this.state.programa_dados.label_endereco_paciente || 'Endereço'}:</small>{' '}
                                                        <strong>
                                                            {this.state.beneficiario_dados.nome_local ? this.state.beneficiario_dados.nome_local + '. ' : ''}
                                                            {this.state.beneficiario_dados.endereco}, {this.state.beneficiario_dados.numero}. {(this.state.beneficiario_dados.complemento) ? `${this.state.beneficiario_dados.complemento}. ` : ''}{this.state.beneficiario_dados.bairro}, {this.state.beneficiario_dados.cidade}/{this.state.beneficiario_dados.uf} - {this.state.beneficiario_dados.cep}
                                                        </strong>
                                                    </p>
                                                    {this.state.beneficiario_dados.endereco_telefone && (
                                                        <p>
                                                            <small>TELEFONE DE CONTATO:</small> <strong>{this.state.beneficiario_dados.endereco_telefone || '-'}</strong>
                                                        </p>
                                                    )}
                                                    {this.state.programa_dados.ativar_detalhamento_card_paciente_inAtendimentos && (
                                                        <>
                                                            <hr className="mt-2 mb-2" />
                                                            {this.renderDetalhesExtrasPaciente()}
                                                        </>
                                                    )}

                                                    {this.state.programa_dados.optout_habilitado && (
                                                        <>
                                                            <hr />
                                                            <p>
                                                                <small>LINK DE OPTOUT: </small> <a href={`${import.meta.env.VITE_URL_COMPLETA}optout/${this.state.uuid}`}>{import.meta.env.VITE_URL_COMPLETA + 'optout/' + this.state.uuid}</a>
                                                            </p>
                                                        </>
                                                    )}
                                                    {this.state.programa_dados.habilitar_envio_kit_paciente && (dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador') && (
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group>
                                                        <Form.Label>Necessário envio de kit para paciente?</Form.Label>
                                                        <div>
                                                            <Button
                                                            variant={this.state.recebe_kit_paciente ? 'success' : 'outline-secondary'}
                                                            onClick={() => {
                                                                this.setState({ recebe_kit_paciente: true });
                                                                this.updateRecebeKitPaciente(true);
                                                            }}
                                                            >
                                                            Sim
                                                            </Button>
                                                            {' '}
                                                            {(() => {
                                                                let isKitStage = false;
                                                                if (this.state.etapa_atual?.configuracoes) {
                                                                    try {
                                                                        const config = typeof this.state.etapa_atual.configuracoes === 'string' 
                                                                            ? JSON.parse(this.state.etapa_atual.configuracoes) 
                                                                            : this.state.etapa_atual.configuracoes;
                                                                        if (config.etapa_kit === true) {
                                                                            isKitStage = true;
                                                                        }
                                                                    } catch (e) {}
                                                                }

                                                                return isKitStage ? (
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={<Tooltip>Para cancelar o kit, cancele primeiro a etapa atual.</Tooltip>}
                                                                    >
                                                                        <span className="d-inline-block">
                                                                            <Button
                                                                                variant={!this.state.recebe_kit_paciente ? 'danger' : 'outline-secondary'}
                                                                                disabled
                                                                                style={{ pointerEvents: 'none' }}
                                                                            >
                                                                                Não
                                                                            </Button>
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    <Button
                                                                        variant={!this.state.recebe_kit_paciente ? 'danger' : 'outline-secondary'}
                                                                        onClick={() => {
                                                                            this.setState({ recebe_kit_paciente: false });
                                                                            this.updateRecebeKitPaciente(false);
                                                                        }}
                                                                    >
                                                                        Não
                                                                    </Button>
                                                                );
                                                            })()}
                                                        </div>
                                                        </Form.Group>
                                                    </Col>
                                                    )}
                                                </div>
                                            </Col>
                                        )}
                                        {(this.state.cliente_id || !dados_usuario['prestador_id'] || dados_usuario['prestador_categoria'] != 'medicos') && this.state.programa_dados.medico_cadastro && (
                                            <>
                                            <Col sm={6} xs={12}>
                                                {this.state.medico_id && this.state.atendimento_id ? (
                                                    <div className="row-list">
                                                        <Form.Label className="mb-0">
                                                            MÉDICO
                                                        </Form.Label>
                                                        <hr className="mb-2 mt-1"></hr>
                                                        <p className="mb-1">
                                                            <small>NOME: </small> <strong>Dr(a) {this.state.dados_medico.nome}</strong>
                                                        </p>
                                                        <p className="mb-1">
                                                            <small>CRM: </small> <strong>{this.state.dados_medico.registro}/{this.state.dados_medico.registro_uf}</strong>
                                                        </p>
                                                        <p className="mb-1">
                                                            <small>ESPECIALIDADE: </small> <strong>{this.state.dados_medico.especialidades || '-'}</strong>
                                                        </p>
                                                        {this.state.medico_data_alteracao && (
                                                        <p className="mb-1">
                                                            <small>ALTERADO EM: </small> <strong>{formataDataHoraExibicao(this.state.medico_data_alteracao)}</strong>
                                                        </p>
                                                        )}
                                                        <hr />
                                                        {(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador' || (this.state.permite_editar && dados_usuario['tipo_usuario'] == 'gestor')) && (
                                                        <>
                                                            {this.state.alterar_medico ? (
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Selecione um médico e atualize o atendimento</Form.Label>
                                                                    <AsyncSelect
                                                                        key={this.state.medico_select_key} 
                                                                        required
                                                                        cacheOptions
                                                                        loadOptions={this.carregaMedicos}
                                                                        defaultOptions
                                                                        name="medico_id"
                                                                        placeholder={'Buscar médico...'}
                                                                        noOptionsMessage={() => "Nenhum médico encontrado"}
                                                                        onChange={e => this.handleChange(e, 'medico_id')}
                                                                        value={this.state.medico_id ? { value: this.state.medico_id, label: this.state.medico_nome } : null}
                                                                    />
                                                                    <Form.Text id="medicoHelper" className="text-danger">{this.state.medicoHelper}</Form.Text>
                                                                </Form.Group>
                                                            ) : (
                                                                <>
                                                                    {!this.state.finalizado && !this.state.cancelado && (
                                                                        <Button
                                                                            variant="warning"
                                                                            size="sm"
                                                                            onClick={() => this.setState({alterar_medico: true})}
                                                                        >
                                                                            Alterar Médico
                                                                        </Button>
                                                                    )}
                                                                </>
                                                                
                                                            )}   
                                                        </> 
                                                        )}                                                    
                                                    </div>
                                                ) : (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Médico</Form.Label>
                                                        <AsyncSelect
                                                            key={this.state.medico_select_key} 
                                                            required
                                                            cacheOptions
                                                            loadOptions={this.carregaMedicos}
                                                            defaultOptions
                                                            name="medico_id"
                                                            placeholder={'Buscar médico...'}
                                                            noOptionsMessage={() => "Nenhum médico encontrado"}
                                                            onChange={e => this.handleChange(e, 'medico_id')}
                                                            value={this.state.medico_id ? { value: this.state.medico_id, label: this.state.medico_nome } : null}
                                                            isDisabled={this.state.disabledInputMedico}
                                                        />
                                                        <Form.Text id="medicoHelper" className="text-danger">{this.state.medicoHelper}</Form.Text>
                                                        
                                                    </Form.Group>
                                                )}
                                            </Col>
                                            {!this.state.atendimento_id && (
                                                <Col sm={3} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>&nbsp;</Form.Label>
                                                        <br />
                                                        <Button variant="secondary" size="sm" className="btn-larger" onClick={() => this.handleShowModalMedico()}>
                                                            <FaPlus /> Novo Médico
                                                        </Button>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            </>
                                        )}

                                        {(this.state.programa_id || dados_usuario['ambiente_programa_id']) && this.state.programa_dados.validacao_doenca == 'atendimento' && (
                                            <>
                                                <Col sm={4} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>{this.state.programa_dados.label_doencas || 'Doença'}</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={this.carregarDoencas}
                                                            defaultOptions
                                                            isDisabled={
                                                                this.state.dados_usuario?.is_superuser
                                                                    ? false
                                                                    : this.state.reativar_atendimento
                                                                        ? false
                                                                        : (this.state.finalizado || this.state.cancelado)
                                                            }
                                                            name="doenca_id"
                                                            placeholder={`Selecionar ${this.state.programa_dados.label_doencas || 'Doença'}`}
                                                            noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                            onChange={e => this.handleChange(e, 'doenca_id')}
                                                            value={this.state.doenca_id ? { value: this.state.doenca_id, label: this.state.doenca_nome } : null}
                                                        />
                                                        <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                        {/*this.state.doenca_id && this.state.doenca_nome && this.state.atendimento_id ? (
                                                            <p><strong>{this.state.doenca_nome}</strong></p>
                                                        ) : (
                                                            <>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarDoencas}
                                                                    defaultOptions
                                                                    name="doenca_id"
                                                                    placeholder={(programa_id == '23') ? 'Selecionar quadro Clínico' : 'Selecionar doença...'}
                                                                    noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                                    onChange={e => this.handleChange(e, 'doenca_id')}
                                                                    value={this.state.doenca_id ? { value: this.state.doenca_id, label: this.state.doenca_nome } : null}
                                                                />
                                                                <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                            </>
                                                        )*/}
                                                    </Form.Group>
                                                </Col> 
                                                {this.state.programa_dados.doencas_exibir_opcao_outros && (this.state.doenca_id === 'outros' || this.state.doenca_id === 30) && (
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descreva o quadro clínico</Form.Label>
                                                            <Form.Control type="text" name="doenca_outros" value={this.state.doenca_outros} disabled={this.state.finalizado || this.state.cancelado} onChange={this.handleChange} />    
                                                        </Form.Group>
                                                    </Col> 
                                                )}
                                            </>
                                        )}
                                    
                                        {/*this.state.cliente_id && !dados_usuario['prestador_id'] && 1 != 1 && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Navegador</Form.Label>
                                                    {this.state.atendente_id && this.state.atendimento_id ? (
                                                        <p><strong>{this.state.atendente_nome}</strong></p>
                                                    ) : (
                                                        <>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregaAtendentes}
                                                                defaultOptions
                                                                name="atendente_id"
                                                                placeholder={'Buscar navegador...'}
                                                                noOptionsMessage={() => "Nenhum navegador encontrado"}
                                                                onChange={e => this.handleChange(e, 'atendente_id')}
                                                                value={this.state.atendente_id ? { value: this.state.atendente_id, label: this.state.atendente_nome } : null}
                                                            />
                                                            <Form.Text id="atendenteHelper" className="text-danger">{this.state.atendenteHelper}</Form.Text>
                                                        </>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        )*/}
                                        
                                        <Col sm={12}>
                                            {(this.state.cliente_id || dados_usuario['ambiente_cliente_id']) && (this.state.programa_id || dados_usuario['ambiente_programa_id']) && (this.state.programa_dados.validacao_doenca == 'paciente' || this.state.doenca_id || this.state.atendimento_id) && (
                                                <>
                                                    {/* PRÉ-CADASTRO: campos personalizados de elegibilidade (opt-in via mascara "pre-allow") */}
                                                    {this.state.programa_dados.habilitar_pre_cadastro_basico && !this.state.atendimento_id && (
                                                        this.renderizaCamposPreCadastro(desabilitar_edicao, programa_id)
                                                    )}

                                                    {!this.preCadDeveEsconderSelecaoPaciente() && (
                                                    <Row>
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                {this.state.beneficiario_id && this.state.atendimento_id ? (
                                                                    <>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Form.Label>Pacientes Cadastrados</Form.Label>
                                                                        <AsyncSelect
                                                                            key={this.state.beneficiario_select_key}
                                                                            required
                                                                            cacheOptions
                                                                            loadOptions={this.carregaBeneficiarios}
                                                                            defaultOptions
                                                                            name="beneficiario_id"
                                                                            placeholder={'Buscar paciente...'}
                                                                            noOptionsMessage={() => "Nenhum paciente encontrado"}
                                                                            onChange={e => this.handleChange(e, 'beneficiario_id')}
                                                                            value={this.state.beneficiario_id ? { value: this.state.beneficiario_id, label: this.state.beneficiario_nome } : null}
                                                                            isDisabled={this.state.disabledInputBeneficiario}
                                                                        />
                                                                        <Form.Text id="beneficiarioHelper" className="text-danger">{this.state.beneficiarioHelper}</Form.Text>
                                                                    </>
                                                                )}
                                                            </Form.Group>
                                                        </Col>
                                                        {(!this.state.atendimento_id) && (
                                                            <Col sm={3} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>&nbsp;</Form.Label>
                                                                    <br />
                                                                    {/*this.state.beneficiario_atendimentos && this.state.beneficiario_id && (
                                                                        <Button variant="light" href={"/atendimentos/?paciente="+this.state.beneficiario_id} size="sm" className="btn-larger me-2">
                                                                            <FaEye /> Ver Atendimentos
                                                                        </Button>
                                                                    )*/}
                                                                    <Button variant="secondary" size="sm" className="btn-larger" onClick={() => this.handleShowModalPaciente()}>
                                                                        <FaPlus /> Novo Paciente
                                                                    </Button>
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                    )}
                                                    {/*this.state.beneficiario_id &&
                                                        //campos extra do atendimento
                                                        this.renderizaCamposExtra()
                                                    */}
                                                </>
                                            )}
                                        </Col>
                                        {this.state.beneficiario_atendimento_aberto_id ? (
                                            <Col sm={4} xs={12}>
                                                <Alert variant="success">
                                                    <p>O paciente {this.state.beneficiario_nome} possui um atendimento em andamento</p>
                                                    <Button variant="success" href={"/atendimentos/edit/"+this.state.beneficiario_atendimento_aberto_id+"/"} size="sm" className="btn-larger me-2">
                                                        <FaEye /> Ver Atendimento
                                                    </Button>   
                                                </Alert>
                                            </Col>
                                        ) : (
                                            <>
                                                {(this.state.programa_id || dados_usuario['ambiente_programa_id']) && !this.state.is_loading_paciente && !this.state.plano_unico && this.state.beneficiario_id && (
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Plano</Form.Label>
                                                            {this.state.plano_id && this.state.atendimento_id ? (
                                                                <p><strong>{this.state.plano_nome}</strong></p>
                                                            ) : (
                                                                <AsyncSelect
                                                                    required
                                                                    cacheOptions
                                                                    loadOptions={this.carregaPlanos}
                                                                    defaultOptions
                                                                    name="plano_id"
                                                                    placeholder={'Buscar plano...'}
                                                                    noOptionsMessage={() => "Nenhum plano encontrado"}
                                                                    onChange={e => this.handleChange(e, 'plano_id')}
                                                                    value={this.state.plano_id ? { value: this.state.plano_id, label: this.state.plano_nome } : null}
                                                                />
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                                {!this.state.programa_dados.habilitar_escolha_laboratorio && this.state.programa_dados.laboratorio_cadastro && this.state.beneficiario_id && !this.state.is_loading_paciente && (this.state.medico_id || (dados_usuario['prestador_categoria'] == 'medicos' && dados_usuario['prestador_id'] > 0)) && (
                                                    <Col sm={4} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                {this.isDefinicaoAutomaticaLaboratorio() ? (
                                                                    <>Laboratório parceiro</>
                                                                ) : this.state.atendimento_id ? (
                                                                    <>Laboratório parceiro</>
                                                                ) : (
                                                                    <>Escolher o laboratório parceiro de sua preferência</>
                                                                )}
                                                            </Form.Label>
                                                            {this.isDefinicaoAutomaticaLaboratorio() ? (
                                                                <p><strong>{this.state.laboratorio_nome?.replace(/\s*\(.*?\)/, '') || 'Definindo automaticamente...'}</strong></p>
                                                            ) : this.state.laboratorio_id && !this.state.is_creating ? (
                                                                <p><strong>{this.state.laboratorio_nome?.replace(/\s*\(.*?\)/, '')}</strong></p>
                                                            ) : (
                                                                <>
                                                                    <div className="d-flex flex-wrap">
                                                                        {this.state.laboratorios.map(laboratorio => (
                                                                            <div key={laboratorio.id} className="p-2">
                                                                                <Form.Check
                                                                                    type="checkbox"
                                                                                    id={`laboratorio-${laboratorio.id}`}
                                                                                    label={laboratorio.nome?.replace(/\s*\(.*?\)/, '')}
                                                                                    checked={this.state.laboratorio_id === laboratorio.id}
                                                                                    onChange={e => this.handleLaboratorioVinculadoChange(e, laboratorio.id, laboratorio.nome)}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    {/*<AsyncSelect
                                                                        required
                                                                        cacheOptions
                                                                        loadOptions={this.carregaLaboratorios}
                                                                        defaultOptions
                                                                        name="laboratorio_id"
                                                                        placeholder={'Buscar laboratório...'}
                                                                        noOptionsMessage={() => "Nenhum laboratório encontrado"}
                                                                        onChange={e => this.handleChange(e, 'laboratorio_id')}
                                                                        value={this.state.laboratorio_id ? { value: this.state.laboratorio_id, label: this.state.laboratorio_nome } : null}
                                                                    />
                                                                    <Form.Text id="laboratorioHelper" className="text-danger">{this.state.laboratorioHelper}</Form.Text>*/}
                                                                </>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                                {!this.state.is_loading_paciente && this.state.cliente_id && !this.state.loading && this.state.programa_dados && this.state.programa_dados.id &&(
                                                    <>
                                                    {this.state.programa_dados.habilitar_escolha_laboratorio &&(
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group>
                                                                <Form.Label>Laboratório:</Form.Label>
                                                                {desabilitar_edicao ? (
                                                                    <p>{this.state.laboratorio_nome || 'Não vinculado'}</p>
                                                                ) : (
                                                                    <AsyncSelect
                                                                        loadOptions={this.carregaLaboratorios}
                                                                        defaultOptions
                                                                        name="laboratorio_id"
                                                                        placeholder={'Buscar laboratório...'}
                                                                        noOptionsMessage={() => "Nenhum laboratório encontrado"}
                                                                        onChange={e => this.handleChange(e, 'laboratorio_id')}
                                                                        value={this.state.laboratorio_id ? { value: this.state.laboratorio_id, label: this.state.laboratorio_nome } : null}
                                                                    />
                                                                )}
                                                            </Form.Group>
                                                        </Col>   
                                                    )}
                                                    {this.state.programa_dados.habilitar_escolha_multiprofissional &&(
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Escolha um multiprofissional:</Form.Label>
                                                                <AsyncSelect
                                                                    loadOptions={this.carregaMultiProfissional}
                                                                    defaultOptions
                                                                    disabled={desabilitar_edicao}
                                                                    name="multiprofissional_id"
                                                                    placeholder={'Buscar multiprofissional...'}
                                                                    noOptionsMessage={() => "Nenhum multiprofissional encontrado"}
                                                                    onChange={e => this.handleChange(e, 'multiprofissional_id')}
                                                                    //value={this.state.laboratorio_id ? { value: this.state.laboratorio_id, label: this.state.laboratorio_nome } : null}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                    </>
                                                )}

                                                {this.state.cliente_id && this.state.atendimento_id && (dados_usuario['tipo_usuario'] != 'prestador') && this.state.programa_dados.habilitar_vinculo_atendente && (
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Navegador</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregaAtendentes}
                                                                defaultOptions
                                                                name="atendente_id"
                                                                placeholder={'Buscar navegador...'}
                                                                noOptionsMessage={() => "Nenhum navegador encontrado"}
                                                                onChange={e => this.handleChange(e, 'atendente_id')}
                                                                value={this.state.atendente_id ? { value: this.state.atendente_id, label: this.state.atendente_nome } : null}
                                                            />
                                                            <Form.Text id="atendenteHelper" className="text-danger">{this.state.atendenteHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                                
                                            </>
                                        )}                                        
                                    </Row>

                                    {/* Produto associado ao atendimento */}
                                    {this.state.programa_dados.habilitar_gestao_produtos && ('results' in this.state.produtos && this.state.produtos.results.length > 0) && (
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3"></Form.Group>
                                            <Form.Label>Medicamento/Produto</Form.Label>
                                            <p>
                                            {this.state.produtos.results[0].dados_produto.nome}
                                            {' '}
                                            (<em>{this.state.produtos.results[0].dados_produto.descricao}</em>)
                                            </p>
                                        </Col>
                                    </Row>
                                    )}

                                    {(this.state.atendimento_id || (!this.state.programa_dados.habilitar_pre_cadastro_basico && this.state.beneficiario_id)) &&
                                        //exibe os campos extra cadastrados
                                        <div className="mt-3">
                                            {this.renderizaCamposExtra(desabilitar_edicao, programa_id)}
                                        </div>
                                    }

                                    {
                                        //exibe o botao atualizar somente na atualizacao
                                        this.state.atendimento_id && (!this.state.finalizado || this.state.reativar_atendimento || dados_usuario.is_superuser) && (!this.state.cancelado || this.state.reativar_atendimento) && (dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador' || (this.state.permite_editar && dados_usuario['tipo_usuario'] == 'gestor')) &&
                                        <Button 
                                            variant="success" 
                                            size="sm" 
                                            className="mt-2" 
                                            disabled={this.state.loading} 
                                            onClick={() => {
                                                if (this.validarCamposExtra()) {
                                                    this.atualizarAtendimento();
                                                }
                                            }}
                                        >
                                            {this.state.loading ? (
                                                <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                                <>
                                                    <FaCheck className="me-1" /> Atualizar Atendimento
                                                </>
                                            )}                                     
                                        </Button>
                                    }

                                    {this.state.erroLoadRegistro ? ( 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert>) : (''
                                    )}       
                                    {!this.state.atendimento_id && !this.state.beneficiario_atendimento_aberto_id && !this.state.is_loading_paciente && !this.preCadGateAtivo() && (this.preCadIsBloqueado() || (this.state.beneficiario_id && this.state.plano_id && (this.state.laboratorio_id || !this.state.programa_dados.laboratorio_cadastro))) ? (
                                        <>
                                            {(dados_usuario['tipo_usuario'] == 'navegador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['is_superuser']) && (
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Atendimento Teste?</Form.Label>
                                                            <div>
                                                                <Button 
                                                                    variant={this.state.cadastro_teste ? "success" : "outline-secondary"}
                                                                    onClick={(e) => this.handleChange(e, "cadastro_teste", true)}>
                                                                    Sim
                                                                </Button>
                                                                {' '}
                                                                <Button 
                                                                    variant={!this.state.cadastro_teste ? "danger" : "outline-secondary"}
                                                                    onClick={(e) => this.handleChange(e, "cadastro_teste", false)}>
                                                                    Não
                                                                </Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            )}
                                            <Button variant="success" type="submit" size="sm" className="mt-3" disabled={this.state.loading}>
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    <>
                                                        <FaCheck className="me-1" /> {this.preCadIsBloqueado() ? 'Salvar Informações' : this.state.programa_dados.label_botao_atendimento}
                                                    </>
                                                )}                                     
                                            </Button>
                                        </>                                        
                                    ) : ('')}     
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab> 

                    {(this.state.atendimento_id && this.state.permite_editar && !dados_usuario['groups'].includes('Laboratórios') || (this.state.etapas_atendimento.length > etapasOcultasCount && dados_usuario['groups'].includes('Laboratórios'))) && (
                        <Tab eventKey="historicoEtapas" title="Histórico das Etapas">
                            <Card className="cardDestaque">
                                <Card.Body>       
                                    <h4><strong>Etapas:</strong></h4>   
                                    {(() => {
                                        // Lista completa (com instâncias extras, se houver)
                                        const lista = (this.state.etapas_exibicao || this.state.etapas_atendimento || []);
                                        const total = lista.length;

                                        // Janela configurável no state (defaults seguros)
                                        const size = this.state.etapasWindowSize || 10;
                                        // Se ainda não definimos um início, começamos na última janela (mais recentes)
                                        const defaultStart = Math.max(0, total - size);
                                        const start = (typeof this.state.etapasWindowStart === 'number') ? this.state.etapasWindowStart : defaultStart;
                                        const end = Math.min(total, start + size);

                                        const visiveis = lista.slice(start, end);

                                        const irParaAnteriores = () => {
                                            const novoStart = Math.max(0, start - size);
                                            this.setState({ etapasWindowStart: novoStart });
                                        };

                                        const irParaRecentes = () => {
                                            const novoStart = Math.min(Math.max(0, total - size), start + size);
                                            this.setState({ etapasWindowStart: novoStart });
                                        };

                                        const mudarTamanho = (novo) => {
                                            const n = parseInt(novo, 10);
                                            if (isNaN(n)) return;
                                            // ao mudar o tamanho, “gruda” na janela mais recente
                                            const novoStart = Math.max(0, total - n);
                                            this.setState({ etapasWindowSize: n, etapasWindowStart: novoStart });
                                        };

                                        return (
                                            <>
                                            {/* Barra de navegação/controle */}
                                            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
                                                <div>
                                                <small>
                                                    Mostrando <strong>{total ? (start + 1) : 0}–{end}</strong> de <strong>{total}</strong> etapas
                                                </small>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                <Form.Select
                                                    size="sm"
                                                    style={{ width: 120 }}
                                                    value={size}
                                                    onChange={(e) => mudarTamanho(e.target.value)}
                                                    aria-label="Quantidade por página"
                                                >
                                                    <option value="5">Últimas 5</option>
                                                    <option value="10">Últimas 10</option>
                                                    <option value="20">Últimas 20</option>
                                                    <option value={Math.max(50, total)}>Todas</option>
                                                </Form.Select>

                                                <Button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    onClick={irParaAnteriores}
                                                    disabled={start === 0 || total === 0}
                                                >
                                                    ← Etapas anteriores
                                                </Button>

                                                <Button
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    onClick={irParaRecentes}
                                                    disabled={end >= total || total === 0}
                                                >
                                                    Etapas mais recentes →
                                                </Button>
                                                </div>
                                            </div>

                                            {/* Accordion usando só as etapas visíveis */}
                                            <Accordion
                                                activeKey={this.state.activeKey}
                                                onSelect={this.handleHistoricoEtapaSelect}
                                            >
                                                {visiveis.map((item) => {
                                                const dados_usuario = getCurrentUser?.() || {};
                                                const etapa = item?.etapa || item;
                                                const instance = item?.instance || 0;

                                                const statusEtapa = this.getStatusDaEtapa(etapa.id, instance);
                                                const statusLabel = statusEtapa
                                                    ? (this.statusConfig[statusEtapa.status] || this.statusConfig['aguardando'])
                                                    : this.statusConfig['aguardando'];

                                                const relatos_flutuantes = this.getRelatosFlutuantesDaInstancia(etapa.id, instance);
                                                const relatosDaInstancia = this.getRelatosDaEtapaInstancia(etapa.id, instance);
                                                const carregandoRelatos = this.state.relatosPorEtapa[etapa.id]?.carregando;

                                                if (etapa.ocultar_etapa != '') {
                                                    const ocultar_etapa = (etapa.ocultar_etapa) ? etapa.ocultar_etapa.split(',') : [];
                                                    if (ocultar_etapa.includes(dados_usuario['tipo_usuario']) ||
                                                        (dados_usuario['tipo_usuario'] == 'prestador' && verificarOcultarEtapa(ocultar_etapa, dados_usuario['prestador_categoria']))) {
                                                        return null;
                                                    }
                                                }

                                                const compKey = `${etapa.id}-${instance}`;
                                                const etapaBloqueadaExpansao = this.isEtapaExpansionDenied(etapa, dados_usuario);

                                                return (
                                                    <React.Fragment key={compKey}>
                                                    <Accordion.Item
                                                        eventKey={compKey}
                                                        className={etapaBloqueadaExpansao ? 'etapa-bloqueada-expansao' : ''}
                                                        style={{ border: `2px solid ${statusLabel.background}`, opacity: etapaBloqueadaExpansao ? 0.95 : 1 }}
                                                    >
                                                        <Accordion.Header
                                                            onClick={etapaBloqueadaExpansao ? (e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                            } : undefined}
                                                        >
                                                        <div>
                                                            {etapa.nome}{instance > 0 ? ` (ciclo ${instance + 1})` : ''}
                                                            <div>
                                                            <span
                                                                style={{
                                                                backgroundColor: statusLabel.background,
                                                                color: statusLabel.color,
                                                                padding: '5px 10px',
                                                                fontSize: '12px',
                                                                borderRadius: '5px',
                                                                display: 'inline-block',
                                                                marginRight: '10px'
                                                                }}
                                                            >
                                                                {statusLabel.icon}
                                                                <span style={{ marginLeft: '5px' }}>{statusLabel.text}</span>
                                                            </span>
                                                            {etapa.responsavel_etapa && (
                                                                <span
                                                                style={{
                                                                    backgroundColor: '#f2f2f2',
                                                                    color: '#252f4a',
                                                                    padding: '5px 10px',
                                                                    fontSize: '12px',
                                                                    borderRadius: '5px',
                                                                    display: 'inline-block'
                                                                }}
                                                                >
                                                                <FaUser />
                                                                <span style={{ marginLeft: '5px' }}>
                                                                    {responsaveisEtapas[etapa.responsavel_etapa]}
                                                                </span>
                                                                </span>
                                                            )}
                                                            {/* {etapaBloqueadaExpansao && (
                                                                <span
                                                                style={{
                                                                    backgroundColor: '#f8d7da',
                                                                    color: '#842029',
                                                                    padding: '5px 10px',
                                                                    fontSize: '12px',
                                                                    borderRadius: '5px',
                                                                    display: 'inline-block',
                                                                    marginLeft: '10px'
                                                                }}
                                                                >
                                                                    <FaLock />
                                                                    <span style={{ marginLeft: '5px' }}>
                                                                        Detalhes bloqueados para seu perfil
                                                                    </span>
                                                                </span>
                                                            )} */}
                                                            </div>
                                                        </div>
                                                        </Accordion.Header>

                                                        <Accordion.Body>
                                                        {(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador') && (
                                                            <div>
                                                            {etapa.alerta_navegador && (
                                                                <div className="alert alert-info">
                                                                {etapa.alerta_navegador}
                                                                </div>
                                                            )}
                                                            </div>
                                                        )}

                                                        {(statusEtapa && (dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['tipo_usuario'] == '')) &&
                                                            <div className="mb-3">
                                                            {statusLabel.text === 'Em Andamento' ? (
                                                                <>
                                                                    <Button variant="outline-primary" className="btn-sm" onClick={() => this.handleShowModalRelatosAdicionar(etapa)}>
                                                                        <FaEdit className="me-2" /> Cadastrar Ocorrência
                                                                    </Button>
                                                                    <Button variant="success" className="btn-sm" onClick={() => this.handleShowModalRelatosEdit()}>
                                                                        <FaCheckDouble className="me-2" /> Registrar Etapa
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <Button variant="outline-primary" className="btn-sm" onClick={() => this.handleShowModalRelatosAdicionar(etapa)}>
                                                                    <FaEdit className="me-2" /> Cadastrar Ocorrência
                                                                </Button>
                                                            )}
                                                            <Button type="button" variant="secondary" className="btn-sm" disabled={this.state.loading} onClick={() => this.handleShowModalAcoes()}>
                                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Lembrete de Ação'}
                                                            </Button>
                                                            </div>
                                                        }

                                                        {carregandoRelatos ? (
                                                            <p>Carregando informações da etapa...</p>
                                                        ) : relatosDaInstancia && relatosDaInstancia.length > 0 ? (
                                                            relatosDaInstancia.map(relato => (
                                                            <div key={relato.id} className="row-list list-style-2 row-relato-etapa">
                                                                <Row>
                                                                    <Col sm={10}>
                                                                        {relato.titulo != '' ? (
                                                                            <h6 className="relato-titulo">{relato.titulo}</h6>
                                                                        ) : (
                                                                            <h6 className="relato-titulo">Registro da Etapa</h6>
                                                                        )}
                                                                        <p>
                                                                            {relato.for}Data: <strong>{formataDataHoraExibicao(relato.data)}</strong> {'nome' in relato.dados_cadastrado_por ? 'por '+relato.dados_cadastrado_por.nome+' '+relato.dados_cadastrado_por.sobrenome : ''}
                                                                        </p>
                                                                        {
                                                                        relato.dados_servico_procedimento &&
                                                                        <p>
                                                                            Serviço relacionado: {relato.dados_servico_procedimento.servico_procedimento__nome}
                                                                        </p>
                                                                        } 
                                                                    </Col>
                                                                    <Col sm={2} className="text-end">
                                                                        {hasPerm('delete_atendimentos_relatos') && dados_usuario.is_superuser && (
                                                                        <Button
                                                                            variant="outline-danger"
                                                                            size="sm"
                                                                            onClick={() => this.handleExcluirRelato(relato, etapa.id)}
                                                                            title="Excluir relato"
                                                                        >
                                                                            <FaTrash />
                                                                        </Button>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                                {relato.valores_list
                                                                .filter(valor => valor.arquivo || relato.dados_autorizacoes?.length > 0 || (valor.valor && valor.valor.toString().trim() !== ''))
                                                                .map(valor => (
                                                                    <div key={valor.id}>
                                                                        {valor.arquivo ? (
                                                                        <>
                                                                            <Button variant="light" className="btn-sm mb-3" href={valor.arquivo} target="_blank">
                                                                            <FaEye /> Ver {valor.formulario_campo__nome}
                                                                            </Button>
                                                                            {hasPerm('view_autorizacoes') && (
                                                                            <Button variant="outline-danger" className="btn-sm mb-3" onClick={() => this.handleExcluirTermoLaudo('relatos', valor.id)}>
                                                                                <FaTrash className="me-2" /> Excluir {valor.formulario_campo__nome}
                                                                            </Button>
                                                                            )}
                                                                        </>
                                                                        ) : relato.dados_autorizacoes?.length > 0 ? (
                                                                        <>
                                                                            {relato.dados_autorizacoes.filter(autorizacao => (
                                                                            autorizacao.campo_alterado == valor.id
                                                                            )).map(autorizacao => (
                                                                            <div key={autorizacao.id}>
                                                                                <a href={`/autorizacoes/edit/${autorizacao.id}`} target="_blank" rel="noreferrer">
                                                                                <strong>Visualizar Autorização ao campo {valor.formulario_campo__nome}</strong>
                                                                                </a><br />
                                                                                <p>{autorizacao.observacao}</p>
                                                                                <hr />
                                                                            </div>
                                                                            ))}
                                                                        </>
                                                                        ) : (
                                                                        <>
                                                                            <strong>{valor.formulario_campo__nome}:</strong>
                                                                            <p>{formatarValorRelato(valor.valor)}</p>
                                                                        </>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                                {relato.dados_agendamento && (
                                                                    <>
                                                                        <hr className="my-3" />
                                                                        <div className="mb-3">
                                                                            <h6 className="text-uppercase mb-3">Dados da Confirmação do Serviço</h6>
                                                                            
                                                                            {relato.dados_agendamento.data_realizacao && (
                                                                                <div className="mb-2">
                                                                                    <strong>Data de Realização:</strong>{' '}
                                                                                    <span className="ms-1">{formataDataHoraExibicao(relato.dados_agendamento.data_realizacao)}</span>
                                                                                </div>
                                                                            )}
                                                                            
                                                                            {relato.dados_agendamento.situacao && (
                                                                                <div className="mb-2">
                                                                                    <strong>Situação:</strong>{' '}
                                                                                    <span className="ms-1">{relato.dados_agendamento.situacao}</span>
                                                                                </div>
                                                                            )}
                                                                            
                                                                            {relato.dados_agendamento.dados_formulario_dinamico_servicos && (() => {
                                                                                if (isDadosConfirmacaoBloqueadosParaUsuarioAtual(this.state.programa_dados?.configuracoes)) {
                                                                                    return (
                                                                                        <div className="mb-3 border-top pt-3 text-muted small">
                                                                                            <FaExclamationTriangle className="me-1 text-warning"/> Respostas bloqueadas para o seu perfil
                                                                                        </div>
                                                                                    );
                                                                                }

                                                                                let configFormulario = relato.dados_agendamento?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;

                                                                                if (!configFormulario && relato.dados_servico_procedimento?.configuracoes) {
                                                                                    configFormulario = relato.dados_servico_procedimento.configuracoes.formulario_dinamico_servicos_procedimentos;
                                                                                }

                                                                                if (!configFormulario && (relato.dados_agendamento?.servico_procedimento_id || relato.servico_procedimento_id)) {
                                                                                    const servicoId = relato.dados_agendamento?.servico_procedimento_id || relato.servico_procedimento_id;
                                                                                    // Procura em servicos_atendimento se disponível
                                                                                    const servicoEncontrado = this.state.servicos_atendimento_all?.find(s => s.servico_procedimento_id === servicoId);
                                                                                    configFormulario = servicoEncontrado?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
                                                                                }

                                                                                const respostasRaw = relato.dados_agendamento.dados_formulario_dinamico_servicos;

                                                                                // Normaliza: se for array [{slug, tipo, label, value}], converte para objeto {slug: value}
                                                                                let respostas = respostasRaw;
                                                                                let camposFromArray = [];
                                                                                if (Array.isArray(respostasRaw)) {
                                                                                    respostas = {};
                                                                                    camposFromArray = respostasRaw.map(item => {
                                                                                        respostas[item.slug] = item.value;
                                                                                        return {
                                                                                            slug: item.slug,
                                                                                            label: item.label || item.slug.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' '),
                                                                                            tipo: item.tipo || 'text',
                                                                                            'control-show': { 'deny-profiles': [] }
                                                                                        };
                                                                                    });
                                                                                }

                                                                                let camposConfig = configFormulario?.campos || [];

                                                                                if (Object.keys(respostas).length === 0) return null;

                                                                                if (camposConfig.length === 0) {
                                                                                    // Se veio do array normalizado, usa os campos extraídos (com labels corretos)
                                                                                    camposConfig = camposFromArray.length > 0 ? camposFromArray : Object.keys(respostas).map(key => ({
                                                                                        slug: key,
                                                                                        label: key.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' '),
                                                                                        tipo: 'text',
                                                                                        'control-show': { 'deny-profiles': [] }
                                                                                    }));
                                                                                }

                                                                                const camposParaRenderizar = camposConfig.filter(campo => {
                                                                                    if (!respostas[campo.slug]) return false;
                                                                                    const denyProfiles = campo['control-show']?.['deny-profiles'] || [];
                                                                                    const userProfile = dados_usuario['tipo_usuario'];
                                                                                    const isDenied = denyProfiles.includes(userProfile) || 
                                                                                                    (userProfile === 'prestador' && denyProfiles.includes(dados_usuario['prestador_categoria']));
                                                                                    
                                                                                    return !isDenied;
                                                                                });

                                                                                if (camposParaRenderizar.length === 0) return null;

                                                                                return (
                                                                                    <div className="mb-3 border-top pt-3">
                                                                                        <h6 className="text-uppercase mb-3">{configFormulario?.titulo_botao || 'Dados do Formulário'}</h6>
                                                                                        {camposParaRenderizar.map((campo) => {
                                                                                            const valor = respostas[campo.slug];
                                                                                            return (
                                                                                                <div key={campo.slug} className="mb-2">
                                                                                                    <strong>{campo.label}:</strong>{' '}
                                                                                                    <span className="ms-1">
                                                                                                        {campo.tipo === 'file' ? (
                                                                                                                <a href={valor} target="_blank" rel="noopener noreferrer">Ver Arquivo</a>
                                                                                                        ) : (
                                                                                                            formatarValorRelato(valor)
                                                                                                        )}
                                                                                                    </span>
                                                                                                </div>
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                );
                                                                            })()}

                                                                            {(() => {
                                                                                const dadosAgendamento = relato.dados_agendamento || {};
                                                                                const arquivos = dadosAgendamento.arquivos || [];
                                                                                const hasArquivos = arquivos.length > 0;
                                                                                
                                                                                const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(this.state.programa_dados?.configuracoes);

                                                                                if (!hasArquivos && dadosAgendamento.arquivo_confirmacao) {
                                                                                    return (
                                                                                        <div className="mb-2">
                                                                                            <strong>Arquivo de Confirmação:</strong> <br/>
                                                                                            {isBloqueadoVisualizarLaudo ? (
                                                                                                <span className="text-muted mt-1 d-inline-block">
                                                                                                    <FaExclamationTriangle className="me-1 text-warning"/> Visualização bloqueada
                                                                                                </span>
                                                                                            ) : (
                                                                                                <a 
                                                                                                    href={dadosAgendamento.arquivo_confirmacao} 
                                                                                                    target="_blank" 
                                                                                                    rel="noopener noreferrer" 
                                                                                                    className="btn btn-sm btn-outline-primary mt-1"
                                                                                                >
                                                                                                    <FaDownload className="me-1"/> Visualizar Arquivo
                                                                                                </a>
                                                                                            )}
                                                                                        </div>
                                                                                    );
                                                                                }

                                                                                const arquivosFiltrados = arquivos.filter(arq => arq.aprovado !== false);
                                                                                
                                                                                if (arquivosFiltrados.length === 0) return null;

                                                                                return (
                                                                                    <div className="mb-2">
                                                                                        <strong>{arquivosFiltrados.length > 1 ? 'Arquivos de Confirmação:' : 'Arquivo de Confirmação:'}</strong>
                                                                                        <div className="d-flex flex-wrap gap-2 mt-1">
                                                                                            {arquivosFiltrados.map((arq, idx) => (
                                                                                                <div key={arq.id || idx}>
                                                                                                    {isBloqueadoVisualizarLaudo ? (
                                                                                                        <span className="text-muted d-inline-block small">
                                                                                                            <FaExclamationTriangle className="me-1 text-warning"/> {arq.nome || 'Arquivo'} (Bloqueado)
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <a 
                                                                                                            href={arq.arquivo} 
                                                                                                            target="_blank" 
                                                                                                            rel="noopener noreferrer" 
                                                                                                            className="btn btn-sm btn-outline-primary"
                                                                                                            title={arq.nome}
                                                                                                        >
                                                                                                            <FaDownload className="me-1"/> {arq.nome || `Arquivo ${idx + 1}`}
                                                                                                        </a>
                                                                                                    )}
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })()}
                                                                            
                                                                            {(() => {
                                                                                const dadosAgendamento = relato.dados_agendamento || {};
                                                                                let configuracoes = dadosAgendamento.dados_servico_procedimento?.configuracoes;
                                                                                
                                                                                if (!configuracoes && relato.dados_servico_procedimento?.configuracoes) {
                                                                                    configuracoes = relato.dados_servico_procedimento.configuracoes;
                                                                                }
                                                                                if (!configuracoes) {
                                                                                    const listaAgendamentos = Array.isArray(this.state.agendamentos) ? this.state.agendamentos : [];
                                                                                    const agendamentoRelato = listaAgendamentos.find(a => a.id === relato.agendamento_id);
                                                                                    configuracoes = agendamentoRelato?.dados_servico_procedimento?.configuracoes;
                                                                                }

                                                                                const camposConfig = [
                                                                                    ...(configuracoes?.modal_confirmacao?.campos || []),
                                                                                    ...(configuracoes?.formulario_dinamico_servicos_procedimentos?.campos || [])
                                                                                ];

                                                                                return (
                                                                                    <>
                                                                                        {this.renderDynamicData(dadosAgendamento.dados_confirmacao, null, camposConfig, dadosAgendamento)}

                                                                                        {/* Alerta MLPA */}
                                                                                        {(() => {
                                                                                            const confirmacao = dadosAgendamento.dados_confirmacao;
                                                                                            if (!confirmacao) return null;
                                                                                            const items = Array.isArray(confirmacao) ? confirmacao : Object.entries(confirmacao).map(([k, v]) => ({ slug: k, value: v }));
                                                                                            const mlpa = items.find(item => item.slug === 'amostra_seguira_mlpa');
                                                                                            if (mlpa?.value !== 'Sim') return null;
                                                                                            return (
                                                                                                <Alert variant="info" className="mt-3">
                                                                                                    <FaInfoCircle className="me-2" />
                                                                                                    Para solicitar Teste MLPA por favor acesse:
                                                                                                    <Button
                                                                                                        variant="secondary"
                                                                                                        size="sm"
                                                                                                        className="ms-2"
                                                                                                        onClick={() => {
                                                                                                            this.setState({
                                                                                                                tab_key: 'exames',
                                                                                                                autoSolicitarExames: true
                                                                                                            });
                                                                                                        }}
                                                                                                    >
                                                                                                        Pedido de Exames
                                                                                                    </Button>
                                                                                                </Alert>
                                                                                            );
                                                                                        })()}

                                                                                        {/*this.renderDynamicData(dadosAgendamento.dados_formulario_dinamico_servicos, "Formulário Dinâmico:", camposConfig, dadosAgendamento)*/}
                                                                                        {this.renderDynamicData(dadosAgendamento.dados_formulario_aprovacao, "Formulário de Aprovação:", [], dadosAgendamento)}
                                                                                    </>
                                                                                );
                                                                            })()}

                                                                        </div>
                                                                    </>
                                                                )}  
                                                                {relato.motivo_cancelamento && (
                                                                <>
                                                                    <strong>Motivo do cancelamento:</strong>
                                                                    <p>{relato.motivo_cancelamento}</p>
                                                                </>
                                                                )}
                                                                {relato.monitoramento_pdf && (
                                                                    <>
                                                                        <Button variant="secondary" className="btn-sm mb-3" href={relato.monitoramento_pdf} target="_blank">
                                                                            <FaEye /> Ver arquivo enviado
                                                                        </Button>
                                                                    </>
                                                                )}
                                                                {relato.dados_monitoramento && (
                                                                <Row className="mb-12">
                                                                    <Col xs={12}>
                                                                    <Row>
                                                                        {relato.dados_monitoramento.map((monitoramento, indexMonitoramento) => (
                                                                        <Col xs={3} key={indexMonitoramento}>
                                                                            <strong>{monitoramento.chave}:</strong>
                                                                            <p>{monitoramento.valor}</p>
                                                                        </Col>
                                                                        ))}
                                                                    </Row>
                                                                    </Col>
                                                                </Row>
                                                                )}
                                                            </div>
                                                            ))
                                                        ) : (
                                                            <p className="mt-3">Não há registros nesta etapa.</p>
                                                        )}
                                                        </Accordion.Body>
                                                    </Accordion.Item>

                                                    {(['', 'operador', 'gestor'].includes(dados_usuario['tipo_usuario'])) && relatos_flutuantes.length > 0 && (
                                                        relatos_flutuantes.map((relato, relatoIndex) => (
                                                        <div key={`${compKey}-relato-${relatoIndex}`} className="row-list list-style-2 mb-2 pb-0 row-relato-etapa">
                                                            <Row>
                                                                <Col sm={10}>
                                                                    {relato.titulo != '' ? (
                                                                        <h6 className="relato-titulo">{relato.titulo}</h6>
                                                                    ) : (
                                                                        <h6 className="relato-titulo">Registro da Etapa</h6>
                                                                    )}
                                                                    <p>
                                                                        Data: <strong>{formataDataHoraExibicao(relato.data)}</strong> {'nome' in relato.dados_cadastrado_por ? 'por '+relato.dados_cadastrado_por.nome+' '+relato.dados_cadastrado_por.sobrenome : ''}
                                                                    </p>
                                                                </Col>
                                                                <Col sm={2} className="text-end">
                                                                    {hasPerm('delete_atendimentos_relatos') && dados_usuario.is_superuser && (
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => this.handleExcluirRelatoFlutuante(relato, etapa.id)}
                                                                        title="Excluir relato"
                                                                        >
                                                                            <FaTrash />
                                                                    </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            {this.state.exibirDetalhesRelato[relato.id] && (
                                                            <div className="relato-valores">
                                                                {this.renderizaCamposHistorico(relato.valores_list)}
                                                            </div>
                                                            )}
                                                            <div className="text-center show-hide-relato" onClick={() => this.toggleDetalhesRelato(relato.id)}>
                                                            {this.state.exibirDetalhesRelato[relato.id] ? (
                                                                <>Ocultar <FaChevronUp /></>
                                                            ) : (
                                                                <>Ver Informações <FaChevronDown /></>
                                                            )}
                                                            </div>
                                                        </div>
                                                        ))
                                                    )}
                                                    </React.Fragment>
                                                );
                                                })}
                                            </Accordion>
                                            </>
                                        );
                                        })()}

                                </Card.Body>
                            </Card>
                        </Tab>
                    )}       
                    {(this.state.atendimento_id && this.state.permite_editar && !this.state.programa_dados.ocultar_servicos_relacionados && (dados_usuario['tipo_usuario'] == 'operador' || (this.state.permite_editar && dados_usuario['tipo_usuario'] == 'gestor') || dados_usuario['tipo_usuario'] == '')) && (
                        <Tab eventKey="servicosRelacionados" title="Serviços Relacionados">
                            <Card className="cardDestaque">
                                <Card.Body>       
                                    <h4><strong>Serviços relacionados ao atendimento:</strong></h4>   
                                    <p><small>Legenda: <strong>CA = </strong>Crédito de Antecipação</small></p>
                                    <Table responsive className="custom-table mt-3">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Serviço</th>
                                                {/*<th>Etapa</th>*/}
                                                <th>Prestador</th>                                              
                                                <th>Data</th>
                                                <th>Data Agendamento</th>
                                                <th>Agendamento ID</th>
                                                <th>Faturamento</th>
                                                {/*<th>Status Pgto</th>*/}
                                                <th>Valor</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                            this.state.servicos_atendimento.map((item) =>
                                                <tr key={item.id}>
                                                    <td>
                                                        #{item.id}
                                                    </td>
                                                    <td>
                                                        {item.servico_procedimento_id ? item.dados_servico_procedimento.nome : '---'}
                                                    </td>
                                                    {/*<td>
                                                        {item.etapa_id ? item.dados_etapa.nome : '---'}
                                                    </td>*/}
                                                    <td>
                                                        {item.prestador_id ? item.dados_prestador.nome : '---'}
                                                        <FaEye
                                                            className="ms-2 cursor-pointer"
                                                            onClick={() => this.handleShowModalPrestador(item.prestador_id, null, item)}
                                                        />
                                                        <p className="mb-0 p-info">{item.dados_prestador.nome_fantasia}</p>
                                                    </td>                                               
                                                    <td>{formataDataHoraExibicao(item.data)}</td>
                                                    <td>{formataDataHoraExibicao(item.dados_agendamento.data_agendamento)}</td>       
                                                    <td>{item.agendamento_id ? item.agendamento_id : '---'}</td>       
                                                    <td>
                                                        {item.faturamento ? (
                                                            <a href={`/faturamentos/edit/${item.faturamento}/`} target="_blank" rel="noreferrer">#{item.faturamento}</a>
                                                        ) : (item.credito_antecipacao) ? (
                                                            <a href={`/creditosantecipacao/edit/${item.credito_antecipacao}/`} target="_blank" rel="noreferrer">CA #{item.credito_antecipacao}</a>
                                                        ) : (
                                                            ' - '
                                                        )}     
                                                    </td>
                                                    {/*<td>{item.dados_faturamento.pago ? 'Sim' : 'Não'}</td>*/}
                                                    <td>
                                                        {item.credito_antecipacao ? (
                                                            ' - '
                                                        ) : (
                                                            formatarValorLocal(item.valor)
                                                        )}  
                                                    </td>
                                                    <td>
                                                        {hasPerm('change_atendimentos_servicos') &&  (!item.dados_faturamento.nota || !item.dados_faturamento.pago) && !item.credito_antecipacao &&
                                                        <>
                                                            <Button variant="outline-info" className="btn-sm" onClick={() => this.handleShowModalServicoAtendimento(item)} disabled={this.state.loading}>
                                                                <FaEdit />
                                                            </Button>
                                                        </>
                                                        }  
                                                        {hasPerm('delete_atendimentos_servicos') && !item.faturamento && (!item.dados_faturamento.nota || !item.dados_faturamento.pago) && !item.credito_antecipacao &&
                                                        <Button variant="outline-danger" className="btn-sm" onClick={() => this.deletarServicoAtendimento(item)} disabled={this.state.loading}>
                                                            <FaTrash />
                                                        </Button>
                                                        }                                                        
                                                    </td>
                                                </tr>
                                            )
                                            }   
                                            {
                                            this.state.servicos_atendimento.length === 0 &&
                                                <tr>
                                                    <td colSpan={9} align="center">Nenhum serviço relacionado</td>
                                                </tr>
                                            }                                        
                                        </tbody>                                                                                
                                    </Table>  
                                    {this.state.servicos_atendimento_data && this.state.servicos_atendimento_data.results && this.state.servicos_atendimento_data.results.length > 0 &&
                                        <Paginacao dados={this.state.servicos_atendimento_data} limit={this.state.servicos_atendimento_limite} loading={this.state.servicos_atendimento_loading} page_numb={this.state.servicos_atendimento_page_numb} _onClickPagina={this.onClickPaginaServicosAtendimento} />
                                    }
                                    <Modal show={this.state.showModalServicoAtendimento} onHide={this.handleCloseModalServicoAtendimento}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Editar Serviço do Atendimento</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col xs={12}>
                                                    <p>Serviço: <strong>{this.state.servico_modal.servico_procedimento_id ? this.state.servico_modal.dados_servico_procedimento.nome : '---'}</strong></p>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Valor</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="valor_servico_edicao"
                                                            value={this.state.valor_servico_edicao} 
                                                            onChange={e => this.handleChangeAgendamento(e, 'valor_servico_edicao')}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Data de Realização do Serviço</Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name="data_servico_edicao"
                                                            value={this.state.data_servico_edicao} 
                                                            onChange={e => this.handleChangeAgendamento(e, 'data_servico_edicao')}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12}>
                                                    <Button variant="success" className="btn-sm" onClick={() => this.alterarServicoAtendimento(this.state.servico_modal.id, this.state.servico_modal.servico_procedimento_id, this.state.servico_modal.faturamento)} disabled={this.state.loading}>
                                                        Salvar
                                                    </Button>
                                                </Col>
                                            </Row>                                                                    
                                        </Modal.Body>
                                    </Modal>
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}  
                    {this.state.atendimento_id && this.state.programa_dados.habilitar_gestao_produtos && (dados_usuario['tipo_usuario'] === '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == 'operador') && (     
                    <Tab eventKey="produtos" title="Medicamentos">
                        <Card className="cardDestaque mt-4">
                            <Card.Body>                   
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h6><strong>Medicamentos</strong></h6>
                                    </Col>
                                    {this.state.finalizado === false && !dados_usuario['prestador_id'] && (
                                        <Col sm={6} xs={6} className="text-end">                       
                                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalProduto()}>
                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Medicamento'}                                       
                                            </Button>
                                        </Col>
                                    )} 
                                </Row>
                                {('results' in this.state.produtos && this.state.produtos.results.length > 0) ? (
                                
                                        <Row>
                                            <Col sm={12} lg={12}>
                                                <Table responsive className="custom-table">
                                                    <thead>
                                                        <tr>
                                                            <th>ID</th>
                                                            {/*<th>Tipo</th>*/}
                                                            <th>Medicamento</th>
                                                            <th>Descricao</th>
                                                            <th>Opções</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.produtos.results.map((produto, index) => ( 
                                                            <tr key={index}>
                                                                <td className="bg-id">#{produto.id}</td>
                                                                <td><div className="td-border">{produto.dados_produto.nome}</div></td>
                                                                <td><div className="td-border">{produto.dados_produto.descricao}</div></td>
                                                                <td>
                                                                    {/*<Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalProduto(produto)}>
                                                                        Atualizar Medicamento
                                                                    </Button> */}
                                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.deletarProdutoAtendimento(produto.id)}>
                                                                        Excluir Medicamento
                                                                    </Button>  
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>   
                                ) : (this.state.produto_descricao) ? (
                                    <p>Medicamento relacionado no cadastro do atendimento: <strong>{this.state.produto_descricao}</strong></p>
                                ) : (
                                    <p>Nenhum medicamento adicionado até o momento</p>
                                )}
                            </Card.Body>                
                        </Card>
                             
                    </Tab>
                    )}
                    {this.state.atendimento_id  && ( dados_usuario['tipo_usuario'] == '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == 'operador') && (     
                    <Tab eventKey="acoesAtendimento" title="Ações">
                        <Card className="cardDestaque mt-4">
                            <Card.Body>                   
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h6><strong>Ações do Atendimento</strong></h6>
                                    </Col>
                                    <Col sm={6} xs={6} className="text-end">                       
                                        <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalAcoes()}>
                                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Nova Ação'}                                       
                                        </Button>
                                    </Col>
                                </Row>
                                {('results' in this.state.acoes && this.state.acoes.results.length > 0) ? (
                            
                                    <Row>
                                        <Col sm={12} lg={12}>
                                            <Table responsive className="custom-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Descrição</th>
                                                        <th>Data / Hora </th>
                                                        <th>Realizado</th>  
                                                        <th>Opções</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.acoes.results.map((acoes, index) => ( 
                                                        <tr key={index}>
                                                            <td className="bg-id">#{acoes.id}</td>
                                                            <td className="td-border">{acoes.descricao}</td>
                                                            {/*<td className="bg-id">{agendamento.tipo}</td>*/}
                                                            <td>
                                                                <div className="td-border">
                                                                        {formataDataExibicao(acoes.data_acao)} {acoes.hora_acao?.split('.')[0]}
                                                                </div>
                                                            </td>
                                                            <td className="td-border">{acoes.realizado ? 'Sim' : 'Não'}</td>
                                                            <td>
                                                                {!acoes.realizado && (
                                                                <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalAcoes(acoes)}>
                                                                    Atualizar Ação
                                                                </Button>  
                                                                )} 
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>   
                            ) : (
                                <p>Nenhuma ação cadastrada até o momento</p>
                            )}
                                        
                            </Card.Body>                
                        </Card>
                             
                    </Tab>
                    )}    
                    {this.state.atendimento_id && this.state.programa_dados.habilitar_agendamentos_servicos && hasPerm('view_agendamentos') && (dados_usuario['tipo_usuario'] == '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == 'operador' || (dados_usuario['tipo_usuario'] == 'prestador' && dados_usuario['prestador_categoria'] != 'medicos')) && (     
                    <Tab eventKey="agendamentoServicos" title="Agendamento de Serviços">
                        <Card className="cardDestaque mt-4">
                            <Card.Body>                   
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h6><strong>Agendamentos de Serviços</strong></h6>
                                    </Col>
                                    {!dados_usuario['prestador_id'] && (
                                        <Col sm={6} xs={6} className="text-end">                       
                                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModal()}>
                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Agendar Serviço'}                                       
                                            </Button>
                                        </Col>
                                    )} 
                                </Row>
                            {(this.state.agendamentos && this.state.agendamentos.length > 0) ? (
                            
                                    <Row>
                                        <Col sm={12} lg={12}>
                                            <Table responsive className="custom-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        {/*<th>Tipo</th>*/}
                                                        <th>Agendamento</th>
                                                        <th>Serviço</th>
                                                        <th>Prestador</th>
                                                        <th>Status</th>
                                                        {this.state.recebe_kit_paciente && (
                                                            <th>Envio Kit</th>
                                                        )}
                                                        <th>Opções</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.agendamentos.map((agendamento, index) => ( 
                                                        <tr key={index}>
                                                            <td className="bg-id">#{agendamento.id}</td>
                                                            {/*<td className="bg-id">{agendamento.tipo}</td>*/}
                                                            <td>
                                                                <div className="td-border">
                                                                    {agendamento.data_agendamento == '1900-01-01T00:00:00' ? (
                                                                        <>
                                                                            -
                                                                        </>
                                                                    ) : (
                                                                        formataDataHoraExibicao(agendamento.data_agendamento)
                                                                    )}
                                                                    {agendamento.data_solicitacao && (
                                                                        <p className="mb-1 p-info">Solicitado em: {formataDataHoraExibicao(agendamento.data_solicitacao)}</p>
                                                                    )}
                                                                    {agendamento.data_liberacao && (
                                                                        <p className="mb-1 p-info">Liberado em: {formataDataHoraExibicao(agendamento.data_liberacao)}</p>
                                                                    )}
                                                                    {agendamento.data_realizacao && agendamento.situacao === 'finalizado' && (
                                                                        <p className="mb-1 p-info">Finalizado em: {formataDataHoraExibicao(agendamento.data_realizacao)}</p>
                                                                    )}
                                                                    {agendamento.data_cancelamento && (
                                                                        <OverlayTrigger
                                                                            placement="bottom-start"
                                                                            overlay={
                                                                            <Tooltip id={`tooltip-motivo-${agendamento.id}`}>
                                                                                {/* Se houver nome do motivo, exibe */}
                                                                                {agendamento.dados_motivo?.nome}
                                                                                {/* Se houver motivo_outro, exibe numa linha nova */}
                                                                                {agendamento.motivo_outro && (
                                                                                <>
                                                                                    {agendamento.motivo_outro}
                                                                                </>
                                                                                )}
                                                                            </Tooltip>
                                                                            }
                                                                        >
                                                                            {/* cursor-pointer torna óbvio que há hover */}
                                                                            <p className="mb-1 p-info cursor-pointer">
                                                                            Cancelado em: {formataDataHoraExibicao(agendamento.data_cancelamento)}
                                                                            </p>
                                                                        </OverlayTrigger>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {agendamento.dados_servico_procedimento.nome}
                                                                    {(agendamento.situacao === 'liberado' && agendamento.dados_meeting && agendamento.dados_meeting.whereby_sala_host_url) && (
                                                                        <p className="mb-0">
                                                                            <a 
                                                                                href="#" 
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    this.handleCopy(`${import.meta.env.VITE_URL_COMPLETA}meetings/view/${agendamento.id}`);
                                                                                }}
                                                                            >
                                                                                Link {agendamento.meeting_host == 'operador' ? 'Navegador' : 'Profissional'}
                                                                            </a>
                                                                        </p>
                                                                    )}

                                                                    {(agendamento.situacao === 'liberado' && agendamento.dados_meeting && agendamento.dados_meeting.whereby_sala_url) && (
                                                                        <p className="mb-0">
                                                                            <a 
                                                                                href="#" 
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    this.handleCopy(agendamento.dados_meeting.whereby_sala_url);
                                                                                }}
                                                                            >
                                                                                Link Paciente
                                                                            </a>
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {'nome' in agendamento.dados_prestador ? (
                                                                        <>
                                                                            {agendamento.dados_prestador.nome}
                                                                            <FaEye
                                                                                className="ms-2 cursor-pointer"
                                                                                onClick={() => this.handleShowModalPrestador(agendamento.prestador_id, agendamento)}
                                                                            />
                                                                            <p className="mb-0 p-info">{agendamento.dados_prestador.nome_fantasia}</p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            ---
                                                                            <a className="btn btn-sm btn-link p-0" onClick={() => this.handleShowModalPrestador(agendamento.prestador_id, agendamento)}>Atribuir</a>
                                                                        </>
                                                                    )}
                                                                    
                                                                    {agendamento.nome_profissional && (
                                                                        <p className="mb-1 p-info">Profissional: {agendamento.nome_profissional}</p>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="td-border">
                                                                    <span className={`badge-agendamento badge-status-${agendamento.situacao}`}>{situacoesAgendamento[agendamento.situacao]}</span>
                                                                    {habilitarAceiteRecusa && agendamento.envia_aceite === true && (
                                                                        <div className="mt-1">
                                                                            <span className={`badge-aceite badge-aceite-${(agendamento.status_aceite || 'aguardando').toLowerCase()}`} title="Status do aceite/recusa">
                                                                                {(agendamento.status_aceite || 'aguardando')
                                                                                    .replace(/^./, c => c.toUpperCase())}
                                                                            </span>
                                                                        </div>
                                                                    )} 
                                                                </div>
                                                            </td>
                                                            {this.state.recebe_kit_paciente && (
                                                            <td>
                                                                {agendamento.atendimento_kit_id ? (
                                                                    <>
                                                                        {agendamento.dados_atendimento_kit?.status === 'cancelado' ? (
                                                                            <span>Cancelado</span>
                                                                        ) : (
                                                                            <>
                                                                                <span>Sim</span>
                                                                                {agendamento.dados_atendimento_kit.data_envio && (
                                                                                    <p className="mb-1 p-info">Previsão: {formataDataExibicao(agendamento.dados_atendimento_kit.data_envio)}</p>
                                                                                )}
                                                                                {agendamento.dados_atendimento_kit.data_envio_realizado && (
                                                                                    <p className="mb-1 p-info">Enviado em: {formataDataExibicao(agendamento.dados_atendimento_kit.data_envio_realizado)}</p>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <span>Não</span>
                                                                )}
                                                            </td> 
                                                            )}      
                                                            {(!habilitarAceiteRecusa && !habilitarDespesasAgendamento) ? (
                                                                <td>
                                                                    <div className="d-flex flex-wrap align-items-center">
                                                                        {agendamento.situacao != 'cancelado' && (
                                                                        <Button variant="light" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleShowModalArquivos(agendamento)}>
                                                                            <FaFile/> Arquivos
                                                                        </Button>  
                                                                        )}
                                                                        {(agendamento.dados_servico_procedimento.servico_dados_monitoramento || (agendamento.dados_servico_procedimento.nome || '').startsWith("Monitoria")) && agendamento.situacao != 'finalizado' && agendamento.situacao != 'cancelado' && (
                                                                            <Button variant="light" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleShowModalArquivoMonitoramento(agendamento)}>
                                                                                <FaFile/> Enviar Arquivo de Monitoramento
                                                                            </Button>
                                                                        )}
                                                                        {agendamento.anotacoes && (
                                                                            <Button variant="light" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleShowModalAnotacoes(agendamento)}>
                                                                                <FaNotesMedical/> Anotações
                                                                            </Button>
                                                                        )}
                                                                        <Button variant="secondary" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleShowModalAgendamento(agendamento)}>
                                                                            Visualizar
                                                                        </Button>
                                                                        
                                                                        {/* Permitir Faturar $ (para agendamentos finalizados sem serviço relacionado) */}
                                                                        {agendamento.situacao === 'finalizado' && 
                                                                        (['', 'gestor', 'operador'].includes(dados_usuario['tipo_usuario']) || dados_usuario['is_superuser']) && 
                                                                        !this.state.servicos_atendimento_all.some(s => s.agendamento_id == agendamento.id) && (
                                                                            <Button 
                                                                                variant="light" 
                                                                                size="sm" 
                                                                                className="me-2 mb-1 mt-1" 
                                                                                onClick={() => this.gerarServicoRelacionadoAgendamento(agendamento)}
                                                                                title="Permitir Faturar $"
                                                                            >
                                                                                $
                                                                            </Button>
                                                                        )}

                                                                        {/* Botão de Formulário Dinâmico */}
                                                                        {this.deveMostrarBotaoFormularioDinamico(agendamento) && agendamento.situacao != 'finalizado' && agendamento.situacao != 'cancelado' && (
                                                                            <Button variant="info" size="sm" className="me-2 mb-1 mt-1 text-white" onClick={() => this.handleEnviaCadastroFormularioDinamico(agendamento)}>
                                                                                <i className="fa fa-list-alt me-1"></i>
                                                                                {this.getTituloBotaoFormularioDinamico(agendamento)}
                                                                            </Button>
                                                                        )}  
                                                                        {agendamento.situacao != 'finalizado' && agendamento.situacao != 'cancelado' && (
                                                                            <>
                                                                                {dados_usuario['tipo_usuario'] === 'prestador' ? (
                                                                                    <>
                                                                                        {agendamento.situacao !== 'arquivo_pendente' && (
                                                                                            <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarServico(agendamento)}>
                                                                                                Confirmar Realização do Serviço
                                                                                            </Button>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        {agendamento.situacao !== 'arquivo_pendente' && (
                                                                                            <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarServico(agendamento)}>
                                                                                                Confirmar Realização do Serviço
                                                                                            </Button>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}

                                                                        {/* Excluir Agendamento (somente cancelados, com permissão) */}
                                                                        {agendamento.situacao === 'cancelado' && hasPerm('delete_agendamentos') && (
                                                                            <Button variant="outline-danger" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleExcluirAgendamento(agendamento.id)} title="Excluir Agendamento">
                                                                                <FaTrash /> Excluir
                                                                            </Button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            ) : (
                                                                <td>
                                                                    {this.renderDropdownAgendamento(agendamento, dados_usuario, habilitarAceiteRecusa, habilitarDespesasAgendamento)}
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            {this.state.agendamentos_data && this.state.agendamentos_data.results && this.state.agendamentos_data.results.length > 0 &&
                                                <Paginacao dados={this.state.agendamentos_data} limit={this.state.agendamentos_limite} loading={this.state.loadingAgendamentos} page_numb={this.state.agendamentos_page_numb} _onClickPagina={this.onClickPaginaAgendamentos} />
                                            }
                                        </Col>
                                    </Row>   
                            ) : (
                                <>
                                    {this.state.loadingAgendamentos ? (
                                        <div className="text-center p-5">
                                            <Spinner animation="border" role="status" variant="primary">
                                                <span className="visually-hidden">Carregando...</span>
                                            </Spinner>
                                             <p className="mt-2 text-muted">Carregando agendamentos...</p>
                                        </div>
                                    ) : (
                                        <p>Nenhum serviço agendado até o momento</p>
                                    )}
                                </>
                            )}
                                        
                            </Card.Body>                
                        </Card>
                             
                    </Tab>
                    )}

                    {this.state.atendimento_id && this.state.programa_dados.habilitar_registro_dosagens && (hasPerm('view_agendamentos') || dados_usuario['tipo_usuario'] == '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == 'operador') && (     
                    <Tab eventKey="registroDeDosagens" title="Registro de Dosagens">
                        <Card className="cardDestaque mt-4">
                            <Card.Body>                   
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h6><strong>Registro de Dosagens</strong></h6>
                                    </Col>
                                    {this.state.finalizado === false && !dados_usuario['prestador_id'] && (
                                        <Col sm={6} xs={6} className="text-end">                       
                                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalDosagem()}>
                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Dosagem'}                                       
                                            </Button>
                                        </Col>
                                    )} 
                                </Row>
                            {('results' in this.state.dosagens && this.state.dosagens.results.length > 0) ? (
                            
                                    <Row>
                                        <Col sm={12} lg={12}>
                                            <Table responsive className="custom-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Produto</th>
                                                        <th>Apresentação</th>
                                                        <th>Data de Cadastro</th>
                                                        <th>Dosagem</th>
                                                        <th>Frequência</th>
                                                        <th>Opções</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.dosagens.results.map((dosagem, index) => ( 
                                                        <tr key={index}>
                                                            <td className="bg-id">#{dosagem.id}</td>
                                                            <td><div className="td-border">{dosagem.dados_produto.nome}</div></td>
                                                            <td><div className="td-border">{dosagem.dados_apresentacao?.descricao ? dosagem.dados_apresentacao.descricao : '-'}</div></td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {dosagem.data_cadastro == '1900-01-01T00:00:00' ? (
                                                                        <>
                                                                            -
                                                                        </>
                                                                    ) : (
                                                                        formataDataHoraExibicao(dosagem.data_cadastro)
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td><div className="td-border">{dosagem.dosagem} {dosagem.dosagem_tipo}</div></td>
                                                            <td><div className="td-border">{dosagem.frequencia} </div></td>
                                                            <td>
                                                                {<Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalDosagem(dosagem)}>
                                                                    Atualizar Dosagem
                                                                </Button> }
                                                                <Button variant="secondary" size="sm" className="me-2" onClick={() => this.deletarDosagem(dosagem.id)}>
                                                                    Excluir Dosagem
                                                                </Button>  
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>   
                            ) : (
                                <p>Nenhum produto adicionado até o momento</p>
                            )}
                                        
                            </Card.Body>                
                        </Card>
                             
                    </Tab>
                    )}    
                    {this.state.atendimento_id && this.state.programa_dados.habilitar_registro_compras && (hasPerm('view_agendamentos') || dados_usuario['tipo_usuario'] == '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == 'operador') && (     
                    <Tab eventKey="registroDeCompras" title="Registro de Compras">
                        <Card className="cardDestaque mt-4">
                            <Card.Body>                   
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h6><strong>Registro de Compras</strong></h6>
                                    </Col>
                                    {this.state.finalizado === false && !dados_usuario['prestador_id'] && (
                                        <Col sm={6} xs={6} className="text-end">                       
                                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalCompra()}>
                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Compra'}                                       
                                            </Button>
                                        </Col>
                                    )} 
                                </Row>
                            {('results' in this.state.compras && this.state.compras.results.length > 0) ? (
                            
                                    <Row>
                                        <Col sm={12} lg={12}>
                                            <Table responsive className="custom-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Produto</th>
                                                        <th>Etapa</th>
                                                        <th>Data de Compra</th>
                                                        <th>Farmácia</th>
                                                        <th>Data Próxima Compra</th>
                                                        <th>Opções</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.compras.results.map((compra, index) => ( 
                                                        <tr key={index}>
                                                            <td className="bg-id">#{compra.id}</td>
                                                            <td><div className="td-border">{compra.dados_produto.nome}</div></td>
                                                            <td><div className="td-border">{compra.dados_etapa.nome}</div></td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {compra.data_compra == '1900-01-01T00:00:00' ? (
                                                                        <>
                                                                            -
                                                                        </>
                                                                    ) : (
                                                                        formataDataHoraExibicao(compra.data_compra)
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td><div className="td-border">{compra.dados_farmacia.nome}</div></td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {compra.data_proxima_compra == '1900-01-01T00:00:00' ? (
                                                                        <>
                                                                            -
                                                                        </>
                                                                    ) : (
                                                                        formataDataHoraExibicao(compra.data_proxima_compra)
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {<Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalCompra(compra)}>
                                                                    Atualizar Compra
                                                                </Button> }
                                                                <Button variant="secondary" size="sm" className="me-2" onClick={() => this.deletarCompra(compra.id)}>
                                                                    Excluir Compra
                                                                </Button>  
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>   
                            ) : (
                                <p>Nenhuma compra adicionada até o momento</p>
                            )}
                                        
                            </Card.Body>                
                        </Card>
                             
                    </Tab>
                    )}    
                    {this.state.atendimento_id && this.state.programa_dados.habilitar_gestao_aplicacoes && (dados_usuario['tipo_usuario'] == '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == 'operador') && (           
                    <Tab eventKey="monitoria" title="Histórico de Terapia">
                        <Card className="cardDestaque mt-4">
                            <Card.Body>                   
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h6><strong>Histórico de Terapia</strong></h6>
                                    </Col>
                                    <Col sm={6} lg={6} className="text-end">               
                                        <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalMonitoria()}>
                                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Agendar nova terapia'}                                       
                                        </Button>
                                    </Col>
                                </Row>
                            {('results' in this.state.monitoria && this.state.monitoria.results.length > 0) ? (
                            
                                    <Row>
                                        <Col sm={12} lg={12}>
                                            <Table responsive className="custom-table">
                                                <thead>
                                                    <tr>
                                                        <th className="cursor-pointer" onClick={() => this.handleOrderChangeMonitoria('id')}>ID
                                                            {/*<span className="sort-icons">
                                                                <FaSortUp className={`sort-up ${this.state.monitoria_ordem === 'id' && this.state.monitoria_ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                                <FaSortDown className={`sort-down ${this.state.monitoria_ordem === 'id' && this.state.monitoria_ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                            </span>*/}
                                                        </th>
                                                        <th className="cursor-pointer" onClick={() => this.handleOrderChangeMonitoria('data_agendada')}>Data Agendamento
                                                            {/*<span className="sort-icons">
                                                                <FaSortUp className={`sort-up ${this.state.monitoria_ordem === 'data_agendada' && this.state.monitoria_ordem_direcao === 'asc' ? 'active' : ''}`} />
                                                                <FaSortDown className={`sort-down ${this.state.monitoria_ordem === 'data_agendada' && this.state.monitoria_ordem_direcao === 'desc' ? 'active' : ''}`} />
                                                            </span>*/}
                                                        </th>
                                                        <th>Tipo</th>
                                                        <th>Status</th>
                                                        <th>Motivo</th>
                                                        <th>Opções</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.monitoria.results.map((resultado, index) => {

                                                        const nomeStatus = (resultado.dados_aplicacao_status.nome || '')
                                                            .trim()
                                                            .toLowerCase();
                                                        const realizadoStatuses = [
                                                            'realizado',
                                                            'realizada',
                                                            'não realizado',
                                                            'não realizada'
                                                        ];
                                                        let isRealizado = false;

                                                        if(!(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'gestor')) {
                                                            isRealizado = realizadoStatuses.includes(nomeStatus);
                                                        }

                                                        return (
                                                            <tr key={index}>
                                                                <td className="bg-id">#{resultado.id}</td>
                                                                <td>
                                                                    <div className="td-border">
                                                                        {formataDataExibicao(resultado.data_agendada)}
                                                                        {resultado.data_realizacao && (
                                                                            <p className="mb-1 p-info">Realizado em: {formataDataExibicao(resultado.data_realizacao)}</p>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>{resultado.dados_aplicacao_tipo.nome || '-'}</td>
                                                                <td>{resultado.dados_aplicacao_status.nome || '-'}</td>
                                                                <td>{(resultado.dados_aplicacao_status.nome === 'Não Realizada') ? resultado.motivo : '-'}</td>
                                                                <td>
                                                                    <Button variant="secondary" size="sm" className="me-2" onClick={(e) => this.handleChangeMonitoria(resultado.id, "monitoria_id", isRealizado)}>
                                                                        {isRealizado ? (
                                                                            <>
                                                                                <FaEye /> Visualizar
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <FaEdit /> Editar
                                                                            </>
                                                                        )}
                                                                    </Button> 
                                                                    {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'gestor') && !isRealizado && (
                                                                    <Button variant="danger" size="sm" className="me-2" onClick={(e) => this.handleExcluirMonitoria(resultado.id)}>
                                                                        <FaTrash /> Excluir
                                                                    </Button>
                                                                    )} 
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                            { 
                                                'results' in this.state.monitoria && this.state.monitoria.results.length > 0 && 
                                                <Paginacao dados={this.state.monitoria} limit={this.state.monitoria_limite} loading={this.state.monitoria_loading} page_numb={this.state.monitoria_page_numb} _onClickPagina={this.onClickPaginaMonitoria} />
                                            }  
                                        </Col>
                                    </Row>   
                            ) : (
                                <p>Nenhuma monitoria encontrada</p>
                            )}
                                        
                            </Card.Body>                
                        </Card>
                    </Tab>   
                    )} 
                    {this.state.atendimento_id && this.state.recebe_kit_paciente && (dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador') && (
                        <Tab eventKey="kitsPrograma" title="Kits do Programa">
                            <Card className="cardDestaque mt-4">
                                <Card.Body>
                                    <Row className="align-items-center mb-3">
                                        <Col sm={6} lg={6}>
                                            <h6><strong>Kits do Programa</strong></h6>
                                        </Col>
                                        {this.state.finalizado === false && !dados_usuario['prestador_id'] && (
                                            <Col sm={6} xs={6} className="text-end">                       
                                                <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalKit()}>
                                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Envio de Kit'}                                       
                                                </Button>
                                            </Col>
                                        )}
                                    </Row>

                                    <Row>
                                        <Col sm={12} lg={12}>
                                            <Table responsive className="custom-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Kit</th>
                                                        <th>Descrição</th>
                                                        <th>Data Agendada</th>
                                                        <th>Data Envio Realizado</th>
                                                        <th>Status</th>
                                                        <th>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.kitsEnviados.map((kit) => ( 
                                                        <tr key={kit.id}>
                                                            <td className="bg-id">#{kit.id}</td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {kit.dados_kit.titulo}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {kit.descricao}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {kit.data_envio === '1900-01-01' 
                                                                        ? '-' 
                                                                        : formataDataExibicao(kit.data_envio)
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {kit.data_envio_realizado
                                                                        ? formataDataExibicao(kit.data_envio_realizado)
                                                                        : '-' 
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="td-border">
                                                                    <span className={`badge-agendamento badge-status-${kit.status}`}>{kitsStatus[kit.status]}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Button 
                                                                    variant="secondary" 
                                                                    size="sm" 
                                                                    className="me-2" 
                                                                    onClick={() => this.handleOpenEditKit(kit)}
                                                                >
                                                                    Visualizar
                                                                </Button>
                                                                {(kit.status != 'enviado' || (dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'])) && (
                                                                    <Button 
                                                                        variant="danger" 
                                                                        size="sm" 
                                                                        className="me-2" 
                                                                        onClick={() => this.handleDeleteKit(kit.id)}
                                                                    >
                                                                        Excluir
                                                                    </Button>  
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            <Modal show={this.state.showModalEndereco} onHide={this.handleCloseModalEndereco}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Detalhes do Endereço</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    {this.state.enderecoVisualizado ? (
                                                        <>
                                                            <p><strong>Nome:</strong> {this.state.enderecoVisualizado.nome}</p>
                                                            <p><strong>CEP:</strong> {this.state.enderecoVisualizado.cep}</p>
                                                            <p><strong>Endereço:</strong> {this.state.enderecoVisualizado.endereco}</p>
                                                            <p><strong>Número:</strong> {this.state.enderecoVisualizado.numero}</p>
                                                            <p><strong>Complemento:</strong> {this.state.enderecoVisualizado.complemento}</p>
                                                            <p><strong>Bairro:</strong> {this.state.enderecoVisualizado.bairro}</p>
                                                            <p><strong>Cidade:</strong> {this.state.enderecoVisualizado.cidade}</p>
                                                            <p><strong>UF:</strong> {this.state.enderecoVisualizado.uf}</p>
                                                        </>
                                                    ) : (
                                                        <p>Carregando...</p>
                                                    )}
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={this.handleCloseModalEndereco}>
                                                        Fechar
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>
                                            <Modal show={this.state.showModalEditKit} onHide={this.handleCloseModalEditKit} size="lg" backdrop="static">
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Editar {this.state.editKit?.dados_kit.titulo} (#{this.state.editKit?.id})</Modal.Title>
                                                </Modal.Header>

                                                <Modal.Body>
                                                    {this.state.editKitLoading ? (
                                                    <div className="d-flex align-items-center">
                                                        <span className="spinner-border me-2" />
                                                        Carregando...
                                                    </div>
                                                    ) : (
                                                    <Form onSubmit={this.handleUpdateKit}>
                                                        <Row className="mb-3">
                                                        <Col md={8}>
                                                            <Form.Group>
                                                            <Form.Label>Descrição</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="descricao"
                                                                value={this.state.editKit.descricao}
                                                                onChange={this.handleEditKitChange}
                                                                required
                                                            />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={4}>
                                                            <Form.Group>
                                                            <Form.Label>Status</Form.Label>
                                                                <Form.Control
                                                                    as="select" 
                                                                    name="status"
                                                                    value={this.state.editKit.status}
                                                                    onChange={this.handleEditKitStatusChange}
                                                                    required
                                                                    >
                                                                        <option value="">Selecione...</option>
                                                                        {Object.entries(kitsStatus).map(([key, label]) => (
                                                                        <option key={key} value={key}>{label}</option>
                                                                        ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        </Row>

                                                        <Row className="mb-3">
                                                        <Col md={6}>
                                                            <Form.Group>
                                                            <Form.Label>Data de Envio Agendado</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                name="data_envio"
                                                                value={this.state.editKit.data_envio || ''}
                                                                onChange={this.handleEditKitChange}
                                                                required
                                                            />
                                                            </Form.Group>
                                                        </Col>
                                                        {String(this.state.editKit.status).toLowerCase() === 'enviado' && (
                                                            <Col md={6}>
                                                                <Form.Group>
                                                                <Form.Label>Data de Envio Realizado</Form.Label>
                                                                <Form.Control
                                                                    type="date"
                                                                    name="data_envio_realizado"
                                                                    value={this.state.editKit.data_envio_realizado || ''}
                                                                    onChange={this.handleEditKitChange}
                                                                    required={
                                                                    String(this.state.editKit.status).toLowerCase() === 'enviado'}
                                                                />
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                        </Row>

                                                        <div className="mb-3">
                                                        <Form.Label>Endereço do Envio</Form.Label>
                                                        <div className="p-2 border rounded bg-light small">
                                                            {this.state.editKit.endereco_compacto || '-'}
                                                        </div>
                                                        </div>

                                                        <div className="d-flex justify-content-end">
                                                        <Button variant="secondary" className="me-2" onClick={this.handleCloseModalEditKit}>
                                                            Cancelar
                                                        </Button>
                                                        <Button type="submit" variant="success" disabled={this.state.editKitLoading}>
                                                            {this.state.editKitLoading ? <span className="spinner-border spinner-border-sm" /> : 'Salvar Alterações'}
                                                        </Button>
                                                        </div>
                                                    </Form>
                                                    )}
                                                </Modal.Body>
                                            </Modal>
                                        </Col>
                                    </Row>   

                                </Card.Body>                
                            </Card>
                            {/* Modal para adicionar kit */}
                            <Modal show={this.state.showModalKit} onHide={this.handleCloseModalKit}  size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Adicionar Envio de Kit</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={this.handleSubmitKit}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Kit do Programa</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="programa_kit_id"
                                                value={this.state.kitSelecionadoId}
                                                onChange={this.handleChangeKitSelecionado}
                                                required
                                                disabled={this.state.kitsProgramaLoading}
                                            >
                                                <option value="">
                                                {this.state.kitsProgramaLoading ? 'Carregando kits...' : 'Selecione um kit'}
                                                </option>
                                                {this.state.kitsProgramaOptions.map(k => (
                                                <option key={k.id} value={String(k.id)}>
                                                    {k.titulo || `Kit #${k.id}`}
                                                </option>
                                                ))}
                                            </Form.Control>
                                            {(!this.state.kitsProgramaLoading && this.state.kitsProgramaOptions.length === 0) && (
                                                <Form.Text className="text-danger">
                                                Nenhum kit disponível para este programa.
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Data de Envio Agendado</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="data_envio"
                                                value={this.state.data_envio}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </Form.Group>
                                        <br />
                                        <Form.Group>
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="descricao"
                                                value={this.state.descricao}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </Form.Group>
                                        <br />
                                        <Form.Group>
                                            <Form.Label>Endereço de Envio</Form.Label>
                                            {enderecos.map(endereco => (
                                                <Form.Check
                                                    key={endereco.id} 
                                                    type="radio"
                                                    label={`${endereco.nome} - ${endereco.endereco}, ${endereco.numero}, ${endereco.complemento}, ${endereco.bairro}, ${endereco.cidade}, ${endereco.uf}`}
                                                    name="endereco"
                                                    value={endereco.id}
                                                    onChange={() => this.handleSelectEndereco(endereco.id)}
                                                />
                                            ))}
                                            <br />
                                        </Form.Group>
                                        <Button type="button" variant="outline-primary" size="sm" onClick={this.handleShowModalNovoEndereco}>Adicionar Novo Endereço</Button>
                                        <Button
                                            type="button"
                                            variant="outline-success"
                                            size="sm"
                                            onClick={this.handleUsarEnderecoAtual}
                                        >
                                            Usar Endereço Atual
                                        </Button>
                                        <hr />
                                        <div className="d-flex justify-content-between">
                                            <Button type="submit" variant="success" size="sm">Cadastrar Envio de Kit</Button>
                                            
                                        </div>
                                    </Form>
                                </Modal.Body>
                            </Modal>

                            {/* Modal para adicionar novo endereço */}
                            <Modal show={this.state.showModalNovoEndereco} onHide={this.handleCloseModalNovoEndereco}>
                                <Modal.Header closeButton>
                                    <Modal.Title>{this.state.tituloModalNovoEndereco}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={this.handleSubmitNovoEndereco}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome do Local/Responsável <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                required 
                                                placeholder="Nome do Local" 
                                                name="nome" 
                                                // value={novoEndereco.nome} 
                                                value={this.state.usingEnderecoAtual ? "Endereço Atual" : this.state.novoEndereco.nome || ""} 
                                                onChange={this.handleChangeNovoEndereco} 
                                            />
                                            <Form.Text id="formNomeLocalHelpBlock" className="text-danger">
                                                {this.state.nomeLocalHelper}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CEP <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                as={IMaskInput} 
                                                required 
                                                mask="00000-000" 
                                                name="cep" 
                                                type="text" 
                                                placeholder="CEP" 
                                                value={this.state.usingEnderecoAtual 
                                                        ? (this.state.beneficiario_dados.cep || '') 
                                                        : (this.state.novoEndereco.cep || '') || ""} 
                                                onChange={this.onChangeCepNovoEndereco} 
                                                onPaste={this.handlePasteCepNovoEndereco} 
                                            />
                                            <Form.Text id="formCEPHelpBlock" className="text-danger">
                                                {this.state.cepHelper}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Endereço <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                required 
                                                placeholder="Endereço" 
                                                name="endereco" 
                                                value={novoEndereco.endereco || ""} 
                                                onChange={this.handleChangeNovoEndereco} 
                                            />
                                            <Form.Text id="formEnderecoHelpBlock" className="text-danger">
                                                {this.state.enderecoHelper}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Número <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                required 
                                                placeholder="Número" 
                                                name="numero" 
                                                value={novoEndereco.numero || ""} 
                                                onChange={this.handleChangeNovoEndereco} 
                                            />
                                            <Form.Text id="formNumeroHelpBlock" className="text-danger">
                                                {this.state.numeroHelper}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Complemento</Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                placeholder="Complemento" 
                                                name="complemento" 
                                                value={novoEndereco.complemento || ""} 
                                                onChange={this.handleChangeNovoEndereco} 
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bairro <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                placeholder="Bairro" 
                                                name="bairro" 
                                                value={novoEndereco.bairro || ""} 
                                                onChange={this.handleChangeNovoEndereco} 
                                            />
                                            <Form.Text id="formBairroHelpBlock" className="text-danger">
                                                {this.state.bairroHelper}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cidade <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                placeholder="Cidade" 
                                                name="cidade" 
                                                value={novoEndereco.cidade || ""} 
                                                onChange={this.handleChangeNovoEndereco} 
                                            />
                                            <Form.Text id="formCidadeHelpBlock" className="text-danger">
                                                {this.state.cidadeHelper}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>UF <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                value={novoEndereco.uf || ""} 
                                                name="uf" 
                                                required 
                                                onChange={this.handleChangeNovoEndereco}
                                            >
                                                <option value="">Selecione o Estado</option>
                                                {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Text id="formUFHelpBlock" className="text-danger">
                                                {this.state.ufHelper}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="checkbox"
                                                label="Marcar como endereço principal"
                                                checked={this.state.novoEndereco.endereco_principal || false}
                                                onChange={(e) =>
                                                    this.setState((prevState) => ({
                                                        novoEndereco: {
                                                            ...prevState.novoEndereco,
                                                            endereco_principal: e.target.checked,
                                                        },
                                                    }))
                                                }
                                            />
                                        </Form.Group>
                                        
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.handleCloseModalNovoEndereco}>
                                        Fechar
                                    </Button>
                                    <Button variant="primary" onClick={this.handleSubmitNovoEndereco}>
                                        Salvar
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </Tab>
                    )}
                    {hasPerm('view_viewatendimentoscompliance') && this.state.atendimento_id && this.state.programa_dados.habilitar_gestao_aplicacoes && (dados_usuario['tipo_usuario'] === '' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] === 'operador') && (           
                    <Tab eventKey="compliance" title="Compliance do Paciente">
                        <ComplianceAtendimento atendimento_id={this.state.atendimento_id} cliente_id={this.state.cliente_id} programa_id={this.state.programa_id} />
                    </Tab>   
                    )} 
                    {this.shouldShowExamesTab() && (
                    <Tab eventKey="exames" title={getConfig(this.state.programa_dados?.configuracoes, "exames.nomenclatura", 'Exames')}>
                        <ExamesComponent 
                            atendimento_id={this.state.atendimento_id}
                            programa_id={this.state.programa_id}
                            doenca_id={this.state.doenca_id}
                            habilitar_selecionar_multiplos_exames={this.state.programa_dados?.habilitar_selecionar_multiplos_exames} 
                            exames_extras_solicitacao={this.state.exames_extras_solicitacao} 
                            medico_logado_id={this.state.dados_usuario['prestador_id']} 
                            medico_atendimento_id={this.state.medico_id} 
                            medico_atendimento_dados={this.state.dados_medico} 
                            autoSolicitarExames={this.state.autoSolicitarExames}
                            onAutoSolicitarDone={() => this.setState({ autoSolicitarExames: false })} 
                            onExameAtualizado={() => this.carregarAgendamentos()} 
                            onExamesSolicitadosSucesso={this.concluirEtapaAtualSemCampos}
                            beneficiario_id={this.state.beneficiario_id} 
                            programa_configuracoes={this.state.programa_dados?.configuracoes}
                            programa_dados={this.state.programa_dados}
                            paciente_dados={this.state.beneficiario_dados}
                            etapa_nome={this.state.etapa_nome}
                        />
                    </Tab>   
                    )} 
                    {(this.state.atendimento_id && this.state.permite_editar && (this.state.dados_usuario['tipo_usuario'] == 'operador' || (this.state.permite_editar && this.state.dados_usuario['tipo_usuario'] === 'gestor') || this.state.dados_usuario['tipo_usuario'] == '')) && (
                        <Tab eventKey="logsAtendimento" title="Logs">
                            <Card className="cardDestaque">
                                <Card.Body>       
                                    <h4><strong>Logs do atendimento:</strong></h4>   

                                    <Button variant="primary" className="btn-sm" onClick={() => this.abrirModalCamposHistorico()} disabled={this.state.loading}>
                                        <FaHistory /> Campos personalizados
                                    </Button>

                                    <Table responsive className="custom-table mt-3">
                                        <thead>
                                            <tr>
                                                <th>Data</th>
                                                <th>Descrição</th>
                                                <th>Ação</th>                                              
                                                <th>Usuário</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                            'results' in this.state.logs_atendimento && this.state.logs_atendimento.results.length > 0 &&
                                            this.state.logs_atendimento.results.map((item) =>
                                            <tr key={item.id}>
                                                <td>
                                                    {formataDataHoraExibicao(item.action_time)}
                                                </td>
                                                <td>
                                                    {item.change_message ? this.quebraLinhaHistorico(item.change_message) : item.object_repr}
                                                </td>
                                                <td>
                                                    {item.action_flag}
                                                </td>
                                                <td>
                                                    {item.user__first_name} {item.user__last_name}
                                                </td>
                                            </tr>
                                            )
                                            }                                                                                     
                                        </tbody>                                                                                
                                    </Table>  
                                    { 
                                        'results' in this.state.logs_atendimento && this.state.logs_atendimento.results.length > 0 && 
                                        <Paginacao dados={this.state.logs_atendimento} limit={this.state.logs_limite} loading={this.state.loading} page_numb={this.state.logs_page_numb} _onClickPagina={this.logsOnClickPagina} />
                                    }
                                    <Modal show={this.state.showModalCamposHistorico} onHide={this.handleCloseModalCamposHistorico}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Campos personalizados</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Table responsive className="custom-table mt-3">
                                                <thead>
                                                    <tr>
                                                        <th>Data</th>
                                                        <th>Descrição</th>                                          
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                    this.state.logs_atendimento_campos.length > 0 ? 
                                                        this.state.logs_atendimento_campos.map((item) =>
                                                        <tr key={item.id}>
                                                            <td>
                                                                {formataDataHoraExibicao(item.data_historico)}
                                                            </td>
                                                            <td>
                                                                O valor do campo "{item.atendimento_campo__nome}" foi alterado para {item.arquivo ? item.arquivo : item.valor}
                                                            </td>
                                                        </tr>
                                                        )
                                                    :
                                                    <tr>
                                                        <td colSpan={2}>Nenhum registro encontrado</td>
                                                    </tr>
                                                    }
                                                </tbody>                                                                                
                                            </Table>                                                                  
                                        </Modal.Body>
                                    </Modal>
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}

                    {this.state.atendimento_id && this.state.permite_editar && hasPerm('view_atendimentos_hi_platform') && (
                        <Tab 
                            eventKey="atendimentosHiPlatform" 
                            title="Atendimentos HiPlatform"
                            mountOnEnter
                            unmountOnExit
                        >
                            <AtendimentosHiPlatformParaAtendimento 
                                atendimento_id={this.state.atendimento_id}
                                programa_id={this.state.programa_id}
                                beneficiario_dados={this.state.beneficiario_dados}
                            />
                        </Tab>
                    )}  

                    {this.state.atendimento_id && this.state.permite_editar && hasPerm('view_goto_connect') && (
                        <Tab 
                            eventKey="gotoConnect" 
                            title="GotoConnect"
                            mountOnEnter
                            unmountOnExit
                        >
                            <GotoConnectAtendimentos 
                                atendimento_id={this.state.atendimento_id}
                                programa_id={this.state.programa_id}
                                beneficiario_dados={this.state.beneficiario_dados}
                            />
                        </Tab>
                    )}  

                </Tabs>
                <Modal size="xl" show={this.state.showModalMedico} onHide={this.handleCloseModalMedico}>
                    <Modal.Header closeButton>
                        <Modal.Title>Cadastrar Novo Médico</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <MedicosEdit onAtualizar={this.handleAtualizarMedico} dados_programa={this.state.dados_programa} dados_cliente={this.state.dados_cliente} />
                    </Modal.Body>
                </Modal>

                <Modal size="xl" show={this.state.showModalPaciente} onHide={this.handleCloseModalPaciente}>
                    <Modal.Header closeButton>
                        <Modal.Title>{getConfig(this.state.programa_dados?.configuracoes, "cadastro_paciente.titulo_aba", 'Cadastrar Novo Paciente')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PacientesEdit 
                            somenteDados={true}  
                            contexto="atendimento" 
                            onAtualizar={this.handleAtualizarPaciente} 
                            dados_programa={this.state.dados_programa} 
                            dados_cliente={this.state.dados_cliente} 
                            medico_id={dados_usuario?.prestador_categoria === 'medicos' ? dados_usuario.prestador_id : this.state.medico_id} 
                            doenca_id={this.state.doenca_id} 
                            doenca_idade_minima={this.state.doenca_idade_minima} 
                            doenca_idade_maxima={this.state.doenca_idade_maxima} 
                            onUpdateKitFlag={this.handleUpdateKitFlag}
                            doenca_nome={this.state.doenca_nome} />
                    </Modal.Body>
                </Modal>

                <Modal size="xl" show={this.state.showModalAtendimentoPaciente} onHide={this.handleCloseModalAtendimentoPaciente}>
                    <Modal.Header closeButton>
                        <Modal.Title>Editando Paciente</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <PacientesEdit 
                            somenteDados={true} 
                            onAtualizar={this.handleAtualizarEdicaoPaciente} 
                            cliente_id={this.state.cliente_id} 
                            id={this.state.beneficiario_id} 
                            medico_id={this.state.medico_id} 
                            doenca_id={this.state.doenca_id} 
                            doenca_idade_minima={this.state.doenca_idade_minima} 
                            doenca_idade_maxima={this.state.doenca_idade_maxima} 
                            onUpdateKitFlag={this.handleUpdateKitFlag}
                            doenca_nome={this.state.doenca_nome} />
                    </Modal.Body>
                </Modal>

                <Modal 
                size="xl"
                show={this.state.showModalConsultaHistoricoLigacoes} 
                onHide={this.handleCloseModalconsultarHistoricoLigacoes}
                dialogClassName="modal-level-2"
                backdropClassName="backdrop-level-2"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Consulta de histórico de ligações da GotoConnect</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Use os filtros abaixo para encontrar o atendimento desejado.</p>
                        <Form onSubmit={this.consultarHistoricoLigacoes}>
                            <Row>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data de início</Form.Label>
                                        <Form.Control 
                                        type="datetime-local" 
                                        name="goto_hist_data_inicio" 
                                        value={this.state.goto_hist_data_inicio} 
                                        placeholder="Data de início" 
                                        onChange={this.handleChange} 
                                        required
                                        />    
                                    </Form.Group>
                                </Col>                               
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data final</Form.Label>
                                        <Form.Control 
                                        type="datetime-local" 
                                        name="goto_hist_data_final" 
                                        value={this.state.goto_hist_data_final} 
                                        placeholder="Data final" 
                                        onChange={this.handleChange} 
                                        required
                                        />    
                                    </Form.Group>
                                </Col>    
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Número do telefone <small>(Opcional)</small></Form.Label>
                                        <Form.Control 
                                        type="text" 
                                        name="goto_hist_num_telefone" 
                                        value={this.state.goto_hist_num_telefone} 
                                        placeholder="Número do telefone" 
                                        onChange={this.handleChange} 
                                        />    
                                    </Form.Group>
                                </Col>                           
                                <Col sm={12} xs={12}>
                                    <Button type="submit" variant="secondary">
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Consultar'}      
                                    </Button>
                                </Col>
                            </Row>

                            {
                            this.state.lista_historico_ligacoes.length > 0 ?
                            <div className="mt-4">
                                <p>Resultados encontrados: {this.state.lista_historico_ligacoes.length}</p>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Quem ligou</th>
                                            <th>Quem atendeu</th>
                                            <th>Data ligação</th>
                                            <th>LEG ID</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.lista_historico_ligacoes.map((historico) => {                                            

                                            return (
                                                <tr key={historico.id}>
                                                    <td>
                                                        <p className="mb-0">Nome: {historico.caller_nome}</p>
                                                        <p className="mb-0">Telefone: {historico.caller_numero}</p>
                                                    </td>
                                                    <td>
                                                        <p className="mb-0">Nome: {historico.callee_nome}</p>
                                                        <p className="mb-0">Telefone: {historico.callee_numero}</p>
                                                    </td>
                                                    <td>{formataDataHoraExibicao(historico.data_inicio)}</td>
                                                    <td>{historico.legId}</td>
                                                    <td>
                                                        <Button 
                                                        className="mt-1"
                                                        variant={"outline-primary"} 
                                                        size="sm" 
                                                        type="button" 
                                                        onClick={() => this.usarGotoLegId(historico.legId)}
                                                        >
                                                            Usar este
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                            :
                            <div className="mt-4 mb-4 text-center">
                                Os resultados vão aparecer aqui.
                            </div>
                            }
                        </Form>
                    </Modal.Body>
                </Modal>

                {this.state.atendimento_id && (
                    <>
                        <Modal size="lg" show={this.state.showModalRelatosEdit} onHide={this.handleCloseModalRelatosEdit}>
                            <Modal.Header closeButton>
                                <Modal.Title>Etapa {this.state.etapa_titulo_exibicao || this.state.etapa_relato.nome}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>{this.state.etapa_descricao_exibicao || this.state.etapa_relato.descricao}</p>
                                {this.state.modal_relato_tipo !== 'cancelar-etapa' ? (
                                    <Form onSubmit={this.handleSubmit}>
                                        <FormularioRender
                                            campos={camposFormulario}
                                            valoresCampos={valoresCampos}
                                            camposOutro={camposOutro}
                                            onChangeCampo={this.handleChangeCampo}
                                            onChangeCampoAsync={this.handleChangeCampoAsync}
                                            onChangeCampoCheckSim={this.handleChangeCampoCheckSim}
                                            onChangeOutro={this.handleChangeOutro}
                                            dadosUsuario={dados_usuario}
                                            opcaoModalRelato={opcaoModalRelato}
                                            tiposSessoesCampos={tiposSessoesCampos}
                                            carregarProdutosPrograma={this.carregarProdutosPrograma}
                                            gotoConfig={gotoConfig}
                                            doencaId={this.state.doenca_id}
                                            produtosOpcoes={this.state.produtosOpcoes}
                                        />
                                        <Row>
                                        {
                                        //(this.state.servicos_etapa.length > 0) && (dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['tipo_usuario'] == '') && 
                                        (this.state.servicos_etapa.length > 0) && 
                                        <Col sm={12}>
                                            <Row>
                                                <Col sm={6} className="mb-3">
                                                    <Form.Group className="mb-2">                                            
                                                        <Form.Label>Serviço da Etapa</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={this.carregaServicosEtapa}
                                                            defaultOptions
                                                            name="relato_servico_procedimento_id"
                                                            placeholder="Buscar serviço/procedimento..."
                                                            noOptionsMessage={() => "Nenhum serviço encontrado"}
                                                            onChange={e => this.handleChange(e, 'relato_servico_procedimento_id')}
                                                            required={this.state.etapa_relato.servico_obrigatorio}
                                                            value={this.state.relato_servico_procedimento_id ? { value: this.state.relato_servico_procedimento_id, label: this.state.relato_servico_procedimento_nome } : null}
                                                        />                       
                                                    </Form.Group>
                                                        <Button variant={"outline-primary"} size="sm" type="button" onClick={() => this.agendarServico(this.state.relato_servico_procedimento_id, this.state.relato_servico_procedimento_nome)}>Agendar Serviço</Button>
                                                    { this.state.etapa_relato.servico_fixo &&
                                                        <Button variant={(this.state.relato_servico_procedimento_id) ? "outline-dark" : "dark"} size="sm" type="button" onClick={() => this.setState({relato_servico_procedimento_id: '', relato_servico_procedimento_nome: ''})}>Serviço não Realizado</Button>
                                                    }
                                                </Col>
                                            </Row>
                                        </Col>
                                        }

                                        {
                                        this.state.etapa_relato.etapa_tipo_paciente &&
                                        <Col sm={6} className="mb-3">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo do paciente</Form.Label>
                                                <Form.Control as="select" name="relato_tipo_paciente" value={this.state.relato_tipo_paciente} required onChange={e => this.handleChange(e, 'relato_tipo_paciente')}>
                                                    <option value="">Selecione...</option>
                                                    {Object.entries(tiposPaciente).map(([sigla, nome]) => {                                                    
                                                        return <option key={sigla} value={sigla}>{nome}</option>;
                                                    })}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        }
                                        </Row>
                                        
                                        {
                                        this.state.etapa_relato.tipo_recorrencia === 'final' &&
                                        <Row>
                                            <Col sm={12}>
                                                <Form.Check 
                                                    type="checkbox" 
                                                    name="finalizar_recorrencia" 
                                                    id="check_finalizar_recorrencia"
                                                    label="Encerrar a recorrencia?"
                                                    checked={this.state.finalizar_recorrencia} 
                                                    onChange={this.handleChangeFinalizarRecorrencia}
                                                />
                                            </Col>
                                        </Row>
                                        }

                                        <Row>
                                            <Col sm={12}>
                                                {this.state.loadingCamposFormulario ? (
                                                    <div className="text-center py-3">
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        <span>Carregando formulário...</span>
                                                    </div>
                                                ) : (
                                                    <Button variant="success" size="sm" type="submit" disabled={this.state.loading}>
                                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'SALVAR INFORMAÇÕES'}
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </Form>     
                                ) : (
                                    <>
                                        <Row>
                                            <Col sm={12}>
                                                <hr />
                                            </Col>
                                        </Row>
                                        <Row className="align-items-end">
                                            <Col sm={12}>
                                                <h6 className="mt-4"><strong>Cancelamento de Etapa</strong></h6>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tipo do cancelamento</Form.Label>
                                                    <Form.Control as="select" name="tipo_cancelamento" value={this.state.tipo_cancelamento} onChange={e => this.handleChange(e, 'tipo_cancelamento')}>
                                                        <option value="">Selecione...</option>
                                                        {Object.entries(tiposCancelamento).map(([sigla, nome]) => {                                                                
                                                            return <option key={sigla} value={sigla}>{nome}</option>;
                                                        })}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            {
                                            this.state.tipo_cancelamento == 'somente_etapa' &&
                                            <Col sm={8} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Escolha a etapa para voltar</Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions
                                                        loadOptions={this.carregarEtapasSelect}
                                                        defaultOptions
                                                        name="etapa_voltar"
                                                        placeholder={'Buscar etapa...'}
                                                        noOptionsMessage={() => "Nenhuma etapa encontrada"}
                                                        onChange={e => this.handleChange(e, 'etapa_voltar')}
                                                        value={this.state.etapa_voltar ? { value: this.state.etapa_voltar, label: this.state.etapa_voltar_nome } : null}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            }
                                            <Col xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Motivo do Cancelamento</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        name="motivo_cancelamento"
                                                        value={this.state.motivo_cancelamento}
                                                        onChange={e => this.handleChange(e, 'motivo_cancelamento')}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>&nbsp;</Form.Label>
                                                    <Button variant="secondary" disabled={this.state.loading} onClick={() => this.state.etapa_atendimento_status == 'cancelado' ? this.cancelarAtendimento() : this.atualizarStatusEtapa()}>
                                                        {this.state.loading ? <span className="spinner-border spinner-border-sm mt-4"></span> : this.state.label_outras_acoes}
                                                    </Button>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={12}>
                                                <hr />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                {(this.state.opcaoModalRelato != 'cadastrar_etapa' && (dados_usuario['tipo_usuario'] == 'operador' || (this.state.permite_editar && dados_usuario['tipo_usuario'] === 'gestor') || dados_usuario['tipo_usuario'] == '')) && (
                                    <>
                                        <Row>
                                            <Col sm={12}>
                                                <hr />
                                            </Col>
                                        </Row>
                                        <Row className="align-items-end">
                                            <Col sm={12}>
                                                <h6><strong>Outras Ações</strong></h6>
                                            </Col>
                                            <Col sm={12}>
                                                <Button type="button" variant="secondary" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalAcoes()}>
                                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Lembrete de Ação'}                                       
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                {/*this.state.etapa_relato.midias_contato && 1 != 1 && this.state.etapa_relato.destinatario_mensagem && this.state.etapa_relato.conteudo_mensagem && (dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor') && (
                                <Row>
                                    <Col sm={12}>
                                    <Form.Check
                                        type="checkbox"
                                        name="finalizar_recorrencia"
                                        id="check_finalizar_recorrencia"
                                        label="Encerrar a recorrencia?"
                                        checked={this.state.finalizar_recorrencia}
                                        onChange={this.handleChangeFinalizarRecorrencia}
                                    />
                                    </Col>
                                </Row>
                                )*/}
                                
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalRelatosEdit}>
                                    Fechar
                                </Button>
                            </Modal.Footer>
                        </Modal>


                        <Modal show={this.state.showModalDescricao} onHide={this.handleCloseModalDescricao}>
                            <Modal.Header closeButton>
                                <Modal.Title>{this.state.etapa_atual.nome}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>{this.state.etapa_atual.descricao}</Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={this.handleCloseModalDescricao}>
                                    Fechar
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal size="xl" show={this.state.showModalArquivos} onHide={this.handleCloseModalArquivos} enforceFocus={false}>
                            <Modal.Header closeButton>
                                <Modal.Title>Arquivos do Agendamento</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={12}>
                                        <div className="row-list">
                                            <Form.Label className="mb-0">
                                                DADOS DO AGENDAMENTO
                                            </Form.Label>
                                            <hr className="mb-2 mt-1"></hr>
                                            <p className="mb-1">
                                                <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>PACIENTE:</small> <strong>{(this.state.permite_editar) ? this.state.beneficiario_nome : 'Id: '+this.state.beneficiario_id}</strong>&nbsp;&nbsp;
                                                {hasPerm('add_beneficiarios') && (
                                                    <a href={`/pacientes/edit/${this.state.beneficiario_id}/?cliente_id=${this.state.cliente_id}`} target="_blank" rel="noreferrer">Ver Cadastro</a>
                                                )}
                                            </p>
                                            {this.state.beneficiario_dados.celular && (
                                                <p>
                                                    <small>TELEFONE PACIENTE:</small> <strong>{this.state.beneficiario_dados.celular || '-'}</strong>
                                                </p>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                {this.state.arquivos.length > 0 ? (
                                    (() => {
                                        // A coluna status deve aparecer APENAS se o programa NÃO aprova automático (ex: Raros em Foco)
                                        const aprovaAutomatico = getConfig(
                                            this.state.programa_dados?.configuracoes, 
                                            'aprova_laudo_automatico', 
                                            true
                                        );
                                        const showStatusColumn = !aprovaAutomatico;
                                        
                                        return (
                                        <Row>
                                            <Col sm={12}>
                                            <div className="arquivo-item-noflex arquivo-item-header">
                                                <Row>
                                                <Col sm={showStatusColumn ? 3 : 4}>
                                                    <strong>Arquivo</strong>
                                                </Col>
                                                <Col sm={showStatusColumn ? 3 : 4}>
                                                    <strong>Data</strong>
                                                </Col>
                                                <Col sm={2}>
                                                    <strong>Tipo</strong>
                                                </Col>
                                                {showStatusColumn && (
                                                    <Col sm={2}>
                                                        <strong>Status</strong>
                                                    </Col>
                                                )}
                                                <Col sm={2} className="text-end"></Col>
                                                </Row>
                                            </div>

                                            {(() => {
                                                const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(this.state.programa_dados?.configuracoes);

                                                return this.state.arquivos.map((arquivo) => {
                                                const dados_user = getCurrentUser();
                                                const usuarioLogadoId = String(dados_user.id);
                                                const arquivoAutorId = String(arquivo.cadastrado_por_id);

                                                const isAutor = usuarioLogadoId === arquivoAutorId;

                                                const isNavegadora =
                                                    dados_user.tipo_usuario === 'operador' ||
                                                    dados_user.tipo_usuario === 'gestor' ||
                                                    dados_user.tipo_usuario === '';

                                                const podeAvaliar = !isAutor && isNavegadora;

                                                const podeEditarExcluir =
                                                    this.state.permite_editar &&
                                                    (dados_user['tipo_usuario'] == '' || dados_user['tipo_usuario'] === 'gestor') &&
                                                    arquivo.aprovado !== true;

                                                return (
                                                    <div key={arquivo.id} className="arquivo-item-noflex">
                                                    <Row className="align-items-center">
                                                        <Col sm={showStatusColumn ? 3 : 4}>
                                                        {isBloqueadoVisualizarLaudo ? (
                                                            <span className="arquivo-link text-muted" title="Visualização bloqueada">
                                                            {arquivo.nome} <FaExclamationTriangle className="text-warning" />
                                                            </span>
                                                        ) : (
                                                            <a
                                                            href={arquivo.arquivo}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="arquivo-link"
                                                            title="Baixar"
                                                            >
                                                            {arquivo.nome} <FaDownload />
                                                            </a>
                                                        )}
                                                        </Col>

                                                        <Col sm={showStatusColumn ? 3 : 4}>{formataDataHoraExibicao(arquivo.data)}</Col>

                                                        <Col sm={2}>{tiposArquivos[arquivo.tipo]}</Col>
                                                        
                                                        {showStatusColumn && (
                                                            <Col sm={2}>
                                                            {/* Badge de Status Visual (mantém pendente/recusado + tooltip) */}
                                                            {arquivo.aprovado === true && <Badge bg="success">Aprovado</Badge>}
                                                            {arquivo.aprovado === null && (
                                                                <Badge bg="warning" text="dark">
                                                                Pendente
                                                                </Badge>
                                                            )}
                                                            {arquivo.aprovado === false && (
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{arquivo.motivo_recusa}</Tooltip>}>
                                                                <Badge bg="danger" style={{ cursor: 'help' }}>
                                                                    Recusado <FaExclamationTriangle />
                                                                </Badge>
                                                                </OverlayTrigger>
                                                            )}
                                                            </Col>
                                                        )}

                                                <Col sm={2} className="text-end">
                                                <div className="d-flex justify-content-end gap-1">
                                                    {/* Lógica de botões de avaliação (da 1ª versão) */}
                                                    {podeAvaliar && (
                                                    <>
                                                        {/* Aprovar só se estiver pendente (null) */}
                                                        {arquivo.aprovado === null && (
                                                        <Button
                                                            variant="outline-success"
                                                            size="sm"
                                                            className="ms-1"
                                                            onClick={() => this.handleAprovarArquivo(arquivo.id)}
                                                            title="Aprovar"
                                                        >
                                                            <FaCheck />
                                                        </Button>
                                                        )}

                                                        {/* Recusar se estiver pendente (null) - Antes era !== false */}
                                                        {arquivo.aprovado === null && (
                                                        <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            className="ms-1"
                                                            onClick={() => this.handleRecusarArquivo(arquivo.id)}
                                                            title="Recusar"
                                                        >
                                                            <FaTimes />
                                                        </Button>
                                                        )}
                                                    </>
                                                    )}

                                                    {/* Editar/Excluir (mesclado) */}
                                                    {podeEditarExcluir && (
                                                    <>
                                                        <button
                                                        onClick={() => this.editarArquivo(arquivo)}
                                                        className="arquivo-editar-btn ms-1"
                                                        title="Editar"
                                                        >
                                                        <FaEdit />
                                                        </button>
                                                        <button
                                                        onClick={() => this.excluirArquivo(arquivo.id)}
                                                        className="arquivo-excluir-btn"
                                                        title="Excluir"
                                                        >
                                                        <FaTrash />
                                                        </button>
                                                    </>
                                                    )}
                                                </div>
                                                </Col>
                                            </Row>
                                            </div>
                                        );
                                            });
                                        })()}
                                        </Col>
                                        </Row>
                                    );
                                    })()
                                    ) : (
                                    <p className="text-center text-muted">Nenhum arquivo encontrado.</p>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalArquivos}>
                                    Fechar
                                </Button>
                                {/* Regra Solicitada: Liberar botão para laboratório (prestador) quando status for 'arquivo_pendente'.
                                    Mantém visível para Operador/Gestor ou se estiver status liberado.*/}
                                {(
                                    this.state.agendamento_selecionado.situacao === 'liberado' || 
                                    this.state.agendamento_selecionado.situacao === 'arquivo_pendente' || 
                                    (dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'gestor' || dados_usuario['tipo_usuario'] === 'operador')
                                ) && (
                                <Button variant="secondary" onClick={() => this.handleShowModalArquivosEdit(this.state.agendamento_selecionado)}>
                                    Cadastrar Novo Arquivo
                                </Button>
                                )}
                            </Modal.Footer>
                        </Modal>

                        <Modal size="lg" show={this.state.showModalArquivosEdit} onHide={this.handleCloseModalArquivosEdit}>
                            <Modal.Header closeButton>
                                <Modal.Title>{(this.state.tipo_arquivo_agendamento == 'monitoramento') ? 'Arquivo de Monitoramento' : 'Arquivo do Agendamento'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form onSubmit={this.saveArquivo}>
                                    <Row>
                                        <Col sm={12}>
                                            <div className="row-list">
                                                <Form.Label className="mb-0">
                                                    DADOS DO AGENDAMENTO
                                                </Form.Label>
                                                <hr className="mb-2 mt-1"></hr>
                                                <p className="mb-1">
                                                    <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                                </p>
                                                <p className="mb-1">
                                                    <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                                </p>
                                                <p className="mb-1">
                                                    <small>PACIENTE:</small> <strong>{(this.state.permite_editar) ? this.state.beneficiario_nome : 'Id: '+this.state.beneficiario_id}</strong>&nbsp;&nbsp;
                                                    {hasPerm('add_beneficiarios') && (
                                                        <a href={`/pacientes/edit/${this.state.beneficiario_id}/?cliente_id=${this.state.cliente_id}`} target="_blank" rel="noreferrer">Ver Cadastro</a>
                                                    )}
                                                </p>
                                                {this.state.beneficiario_dados.celular && (
                                                    <p>
                                                        <small>TELEFONE PACIENTE:</small> <strong>{this.state.beneficiario_dados.celular || '-'}</strong>
                                                    </p>
                                                )}
                                            </div>
                                        </Col>
                                        {!this.state.arquivo_id && (
                                            <Col sm={12} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Anexe abaixo um arquivo novo a este agendamento</Form.Label>
                                                    <Form.Control type="file" name="arquivo_upload" onChange={this.onChangeArquivo} ref={this.fileInput} />
                                                    <Form.Text id="formArquivoHelper" className="text-danger">{this.state.arquivoHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        {this.state.tipo_arquivo_agendamento != 'monitoramento' && (
                                            <>
                                                <Col sm={5} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Descrição do Arquivo</Form.Label>
                                                        <Form.Control type="text" name="arquivo_nome" value={this.state.arquivo_nome} placeholder="Descrição do arquivo" onChange={this.handleChange} />    
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={4} xs={6}> 
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Tipo do Arquivo</Form.Label>
                                                        <Form.Control as="select" name="arquivo_tipo" value={this.state.arquivo_tipo} required onChange={e => this.handleChange(e, 'arquivo_tipo')}>
                                                            <option value="">Selecione um tipo</option>
                                                            {Object.entries(tiposArquivos).map(([sigla, nome]) => {
                                                                // Se 'prestador_id' existe, exibe apenas 'laudo' e 'exame'
                                                                if (dados_usuario['prestador_id']) {
                                                                    if (sigla === "laudo" || sigla === "exame") {
                                                                        return <option key={sigla} value={sigla}>{nome}</option>;
                                                                    }
                                                                } else {
                                                                    // Se não existe 'prestador_id', exibe todas as opções
                                                                    return <option key={sigla} value={sigla}>{nome}</option>;
                                                                }

                                                                // Caso não atenda a nenhum dos casos, retorna null
                                                                return null;
                                                            })}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                {/*!dados_usuario['prestador_id'] && (
                                                    <Col sm={3} xs={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Aprovado</Form.Label>
                                                            <div>
                                                                <Button 
                                                                    variant={this.state.arquivo_aprovado ? "success" : "outline-secondary"}
                                                                    onClick={() => this.setState({ arquivo_aprovado: true })}>
                                                                    Sim
                                                                </Button>
                                                                {' '}
                                                                <Button 
                                                                    variant={!this.state.arquivo_aprovado ? "danger" : "outline-secondary"}
                                                                    onClick={() => this.setState({ arquivo_aprovado: false })}>
                                                                    Não
                                                                </Button>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                )*/}
                                            </> 
                                        )}
                                        <Col sm={12} xs={12}>
                                            <Button type="submit" variant="secondary">
                                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.arquivo_id) ? 'Atualizar Arquivo' : 'Enviar Arquivo'}      
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalArquivosEdit}>
                                    Fechar
                                </Button>
                                
                            </Modal.Footer>
                        </Modal>
                        
                        <Modal size="xl" show={this.state.showModalAnotacoes} onHide={this.handleCloseModalAnotacoes}>
                            <Modal.Header closeButton>
                                <Modal.Title>Anotações do Agendamento</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={12}>
                                        <p>{this.state.agendamento_selecionado.anotacoes}</p>
                                    </Col>
                                </Row>
                                
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalAnotacoes}>
                                    Fechar
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        {/* Modal de Prestador */}
                        <Modal
                            size="lg"
                            show={this.state.showModalPrestador}
                            onHide={this.handleCloseModalPrestador}
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Dados do Prestador</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {this.state.prestadorDados?.nome && (
                                <Row>
                                    <Col sm={12}>
                                        <p><strong>Prestador:</strong> {this.state.prestadorDados.nome}</p>
                                        {this.state.prestadorDados.tipo_pessoa === 'fisica' ? (
                                            <>
                                                <p><strong>CPF:</strong> {formataCPF(this.state.prestadorDados.cpf_cnpj)}</p>
                                            </>
                                        ) : (
                                            <>
                                                <p><strong>CNPJ:</strong> {formataCNPJ(this.state.prestadorDados.cpf_cnpj)}</p>
                                                <p><strong>Razão Social:</strong> {this.state.prestadorDados.razao_social}</p>
                                                <p><strong>Nome Fantasia:</strong> {this.state.prestadorDados.nome_fantasia}</p>
                                            </>
                                        )}
                                        <hr />
                                        <p><strong>E‑mail:</strong> {this.state.prestadorDados.email}</p>
                                        <p><strong>Telefone:</strong> {this.state.prestadorDados.telefone}</p>
                                        <p><strong>Endereço:</strong> {this.state.prestadorDados.endereco}, {this.state.prestadorDados.numero}</p>
                                        <p><strong>Complemento:</strong> {this.state.prestadorDados.complemento}</p>
                                        <p><strong>Bairro:</strong> {this.state.prestadorDados.bairro}</p>
                                        <p><strong>CEP:</strong> {this.state.prestadorDados.cep}</p>
                                        <p><strong>Cidade/UF:</strong> {this.state.prestadorDados.cidade} / {this.state.prestadorDados.uf}</p>
                                    </Col>
                                </Row>
                                )}

                                {/* AsyncSelect para alterar prestador - apenas para superuser e status liberado */}
                                {((dados_usuario.is_superuser || dados_usuario.tipo_usuario === 'gestor') || (dados_usuario.tipo_usuario === 'operador' && !this.state.prestadorDados?.nome)) && 
                                    this.state.prestadorAgendamento && 
                                    this.state.prestadorAgendamento.situacao === 'liberado' && (
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                            <hr />
                                            <Form.Group>
                                                <Form.Label><strong>Alterar Prestador</strong></Form.Label>
                                                {this.state.loadingAlterarPrestador ? (
                                                    <div className="d-flex align-items-center py-2">
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        <span>Alterando prestador...</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            defaultOptions
                                                            loadOptions={this.carregaPrestadoresAlteracao(
                                                                this.state.prestadorAgendamento.servico_procedimento_id
                                                            )}
                                                            placeholder="Buscar novo prestador..."
                                                            noOptionsMessage={() => "Nenhum prestador encontrado"}
                                                            loadingMessage={() => "Buscando..."}
                                                            onChange={(option) => {
                                                                if (option) {
                                                                    this.handleAlterarPrestadorAgendamento(
                                                                        this.state.prestadorAgendamento.id, 
                                                                        this.state.prestadorAgendamento,
                                                                        option
                                                                    );
                                                                }
                                                            }}
                                                            value={null}
                                                            isDisabled={this.state.loadingAlterarPrestador}
                                                            menuPortalTarget={document.body}
                                                            styles={{ 
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }) 
                                                            }}
                                                        />
                                                        <Form.Text className="text-muted">
                                                            Selecione um novo prestador para substituir o atual.
                                                        </Form.Text>
                                                    </>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}
                                
                                {/* Alerta para agendamentos finalizados - orienta a alterar via aba Serviços Relacionados */}
                                {(dados_usuario.is_superuser || dados_usuario.tipo_usuario === 'gestor') && 
                                    this.state.prestadorAgendamento && 
                                    this.state.prestadorAgendamento.situacao === 'finalizado' && (
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                            <hr />
                                            <Alert variant="info" className="mb-0">
                                                <FaExclamationTriangle className="me-2" />
                                                <strong>Agendamento finalizado.</strong> Para alterar o prestador deste agendamento, acesse o serviço correspondente na aba <strong>Serviços Relacionados</strong>.
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}
                                
                                {/* AsyncSelect para alterar prestador de SERVIÇO - apenas para superuser e serviço sem faturamento */}
                                {(dados_usuario.is_superuser || dados_usuario.tipo_usuario === 'gestor') && 
                                    this.state.prestadorServico && 
                                    !this.state.prestadorServico.faturamento && (
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                            <hr />
                                            <Form.Group>
                                                <Form.Label>
                                                    <strong>Alterar Prestador do Serviço</strong>
                                                    {this.state.prestadorServico.agendamento_id && (
                                                        <Badge bg="info" className="ms-2">
                                                            Agendamento #{this.state.prestadorServico.agendamento_id} será atualizado
                                                        </Badge>
                                                    )}
                                                </Form.Label>
                                                {this.state.loadingAlterarPrestador ? (
                                                    <div className="d-flex align-items-center py-2">
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        <span>Alterando prestador...</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            defaultOptions
                                                            loadOptions={this.carregaPrestadoresAlteracao(
                                                                this.state.prestadorServico.servico_procedimento_id
                                                            )}
                                                            placeholder="Buscar novo prestador..."
                                                            noOptionsMessage={() => "Nenhum prestador encontrado"}
                                                            loadingMessage={() => "Buscando..."}
                                                            onChange={(option) => {
                                                                if (option) {
                                                                    this.handleAlterarPrestadorServico(
                                                                        this.state.prestadorServico, 
                                                                        option
                                                                    );
                                                                }
                                                            }}
                                                            value={null}
                                                            isDisabled={this.state.loadingAlterarPrestador}
                                                            menuPortalTarget={document.body}
                                                            styles={{ 
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }) 
                                                            }}
                                                        />
                                                        <Form.Text className="text-muted">
                                                            Selecione um novo prestador para substituir o atual.
                                                        </Form.Text>
                                                    </>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                {/* Alerta para serviços faturado - orienta a remover do faturamento */}
                                {(dados_usuario.is_superuser || dados_usuario.tipo_usuario === 'gestor') && 
                                    this.state.prestadorServico && 
                                    this.state.prestadorServico.faturamento && (
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                            <hr />
                                            <Alert variant="info" className="mb-0">
                                                <FaExclamationTriangle className="me-2" />
                                                <strong>Serviço já faturado.</strong> Para alterar o prestador deste serviço, acesse o faturamento <strong><a href={`/faturamentos/edit/${this.state.prestadorServico.faturamento}`} target="_blank" rel="noreferrer">#{this.state.prestadorServico.faturamento}</a></strong> e remova o serviço do faturamento (caso ainda não esteja pago).
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalPrestador}>
                                    Fechar
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalAgendamento} size="lg" onHide={this.handleCloseModalAgendamento}>
                            <Modal.Header closeButton>
                                <Modal.Title>Agendamento</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={12} xs={12} className="mb-1">
                                        <div className="row-list">
                                            <Form.Label className="mb-0">
                                                DADOS DO AGENDAMENTO
                                            </Form.Label>
                                            <hr className="mb-2 mt-1"></hr>
                                            <p className="mb-1">
                                                <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                            </p>
                                            {showMedicoSolicitante && (
                                            <p className="mb-1">
                                                <small>MÉDICO SOLICITANTE:</small>{" "}
                                                <strong>
                                                    {this.state.dados_medico_solicitante ? `${this.state.dados_medico_solicitante?.nome || ""}${
                                                        this.state.dados_medico_solicitante?.registro ? ` (${String(this.state.dados_medico_solicitante.registro).trim()}${
                                                            this.state.dados_medico_solicitante?.registro_uf ? `/${String(this.state.dados_medico_solicitante.registro_uf).trim().toUpperCase()}` : ""
                                                        })` : ""
                                                    }` : (this.state.agendamento_medico_nome || (this.state.agendamento_selecionado?.prestador_solicitante ? `Id: ${this.state.agendamento_selecionado.prestador_solicitante}` : "-"))}
                                                </strong>
                                            </p>
                                            )}
                                            <p className="mb-1">
                                                <small>PACIENTE:</small> <strong>{(this.state.permite_editar) ? this.state.beneficiario_nome : 'Id: '+this.state.beneficiario_id}</strong>&nbsp;&nbsp;
                                                {hasPerm('add_beneficiarios') && (
                                                    <a href={`/pacientes/edit/${this.state.beneficiario_id}/?cliente_id=${this.state.cliente_id}`} target="_blank" rel="noreferrer">Ver Cadastro</a>
                                                )}
                                            </p>
                                            {this.state.beneficiario_dados.celular && (
                                                <p>
                                                    <small>TELEFONE PACIENTE:</small> <strong>{this.state.beneficiario_dados.celular || '-'}</strong>
                                                </p>
                                            )}
                                        </div>
                                    </Col>
                                    {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') ? (
                                        <>
                                            {this.state.agendamento_selecionado?.envia_aceite === true &&
                                                this.state.agendamento_selecionado?.status_aceite === 'recusado' && (
                                                <Col sm={12} xs={12}>
                                                    <Form.Group className="mb-3">
                                                    <Form.Label>Selecionar novo prestador</Form.Label>
        
                                                    <AsyncSelect
                                                        // importante: amarra o carregamento ao serviço do agendamento selecionado
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={this.carregaPrestadoresComServico(
                                                        this.state.agendamento_selecionado?.servico_procedimento_id
                                                        )}
                                                        placeholder="Buscar prestador..."
                                                        noOptionsMessage={() => "Nenhum prestador encontrado"}
                                                        onChange={this.handleChangePrestadorSelecionado}
                                                        value={
                                                        this.state.agendamento_selecionado?.prestador_id
                                                            ? {
                                                                value: this.state.agendamento_selecionado.prestador_id,
                                                                label:
                                                                this.state.agendamento_selecionado?.dados_prestador?.nome ||
                                                                "Prestador selecionado",
                                                            }
                                                            : null
                                                        }
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Ao selecionar um novo prestador, o status de aceite será reiniciado.
                                                    </Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            <Col sm={6} xs={12}> 
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Data de Agendamento</Form.Label>
                                                    <Form.Control type="datetime-local" name="data_agendamento" required placeholder="Data de Agendamento" value={(this.state.agendamento_selecionado.data_agendamento != '1900-01-01T00:00:00') ? this.state.agendamento_selecionado.data_agendamento : ''} onChange={e => this.handleChangeAgendamentoEdit(e, 'data_agendamento')} />    
                                                </Form.Group>
                                            </Col>
                                        </>
                                    ) : (
                                        <Col sm={6} xs={12}> 
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data de Agendamento</Form.Label>
                                                <p>{formataDataHoraExibicao(this.state.agendamento_selecionado.data_agendamento)}</p>
                                            </Form.Group>
                                        </Col>
                                    )}
                                    {this.state.agendamento_selecionado.situacao === 'finalizado' ? (
                                        <>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Status</Form.Label>
                                                    <p>{situacoesAgendamento[this.state.agendamento_selecionado.situacao]}</p>
                                                </Form.Group>
                                            </Col>
                                            {(dados_usuario.is_superuser || dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['tipo_usuario'] === 'gestor') && (
                                                <Col sm={12}>
                                                    <Alert variant="info" className="mb-3">
                                                        <FaExclamationTriangle className="me-2" />
                                                        <strong>Agendamento finalizado.</strong> Para cancelar ou liberar novamente este agendamento, é necessário excluir o serviço vinculado na aba <strong>Serviços Relacionados</strong>.
                                                    </Alert>
                                                </Col>
                                            )}
                                        </>
                                    ) : (dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') ? (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status</Form.Label>
                                                <Form.Control as="select" name="agendamento_situacao" value={this.state.agendamento_selecionado.situacao} required onChange={this.handleSituacaoChange}>
                                                    <option value="">Status</option>
                                                    {Object.entries(situacoesAgendamento)
                                                        .filter(([sigla, nome]) => sigla !== "finalizado") // Ignora o status "finalizado" - usado com o botão Confirmar realização do atendimento
                                                        .map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    ) : (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status</Form.Label>
                                                <p>{situacoesAgendamento[this.state.agendamento_selecionado.situacao]}</p>
                                            </Form.Group>
                                        </Col>
                                    )}
                                    {this.state.reagendamentos && this.state.reagendamentos.length > 0 && (
                                        <Col sm={6}>
                                            <p className="mt-1">
                                                <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ showModalReagendamentos: true }); }}>
                                                    Histórico de reagendamentos deste serviço ({this.state.reagendamentos.length})
                                                </a>
                                            </p>
                                        </Col>
                                    )}
                                    {this.state.agendamento_selecionado.situacao === 'cancelado' && (dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') && (
                                        <>
                                            {this.state.motivosCancelamento.length > 0 ? (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Motivo do cancelamento</Form.Label>
                                                    <Form.Control
                                                    as="select"
                                                    required
                                                    value={this.state.motivoSelecionado}
                                                    onChange={this.handleMotivoChange}
                                                    >
                                                    <option value="">Selecione...</option>
                                                    {this.state.motivosCancelamento.map(m => (
                                                        <option key={m.id} value={m.id}>{m.titulo}</option>
                                                    ))}
                                                    <option value="outro">Outro</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            ) : null}

                                            {(
                                                this.state.motivosCancelamento.length === 0 ||
                                                this.state.motivoSelecionado === 'outro'
                                            ) && (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Descreva o motivo</Form.Label>
                                                    <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    required
                                                    value={this.state.motivoOutro}
                                                    onChange={this.handleMotivoOutroChange}
                                                    />
                                                </Form.Group>
                                            )}
                                        </>
                                    )}
                                    {this.state.agendamento_selecionado?.atendimento_kit_id && (
                                        <>
                                            <Col sm={12}>
                                                <hr />
                                                <h6 className="text-uppercase">Envio de kit</h6>
                                                <p>
                                                    <strong>Endereço para envio: </strong>
                                                    {this.state.novoEndereco.endereco}, {this.state.novoEndereco.numero}. {(this.state.novoEndereco.complemento) ? `${this.state.novoEndereco.complemento}. ` : ''}{this.state.novoEndereco.bairro}, {this.state.novoEndereco.cidade}/{this.state.novoEndereco.uf} - {this.state.novoEndereco.cep}
                                                </p>
                                                {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') && 1 !== 1 ? (
                                                    <Col sm={6} xs={12}> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Data Prevista de Envio do Kit</Form.Label>
                                                            <Form.Control type="date" name="dataEnvioKit" required value={this.state.agendamento_selecionado.dados_atendimento_kit.data_envio} onChange={e => this.handleChangeAgendamento()} />    
                                                        </Form.Group>
                                                    </Col>
                                                ) : (
                                                    <Col sm={6} xs={12}> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Data Prevista de Envio do Kit</Form.Label>
                                                            <p>{formataDataExibicao(this.state.agendamento_selecionado.dados_atendimento_kit.data_envio)}</p>
                                                        </Form.Group>
                                                    </Col>
                                                )}
                                            </Col>
                                        </>
                                    )}

                                    {/* Terapia Vinculada */}
                                    {this.state.agendamento_selecionado?.aplicacao_id && (
                                        <>
                                            <Col sm={12}>
                                                <hr />
                                                <h6 className="text-uppercase">Terapia Vinculada</h6>
                                            </Col>
                                            {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['tipo_usuario'] === 'prestador') ? (
                                                <Col sm={12} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Terapia do Histórico</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={this.carregarTerapiasAtendimento}
                                                            defaultOptions
                                                            name="agendamento_terapia_id"
                                                            placeholder="Selecione uma terapia do histórico..."
                                                            noOptionsMessage={() => "Nenhuma terapia encontrada"}
                                                            onChange={(e) => this.handleChangeAgendamentoEditTerapia(e)}
                                                            value={this.state.agendamento_selecionado?.aplicacao_id ? { 
                                                                value: this.state.agendamento_selecionado.aplicacao_id, 
                                                                label: this.state.agendamento_selecionado?.dados_aplicacao 
                                                                    ? `#${this.state.agendamento_selecionado.aplicacao_id} - ${this.state.agendamento_selecionado.dados_aplicacao?.dados_aplicacao_tipo?.nome || 'N/A'} - ${formataDataExibicao(this.state.agendamento_selecionado.dados_aplicacao?.data_agendada)}`
                                                                    : `#${this.state.agendamento_selecionado.aplicacao_id}`
                                                            } : null}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            ) : (
                                                <Col sm={12} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Terapia do Histórico</Form.Label>
                                                        <p>
                                                            #{this.state.agendamento_selecionado?.aplicacao_id} - 
                                                            {this.state.agendamento_selecionado?.dados_aplicacao?.dados_aplicacao_tipo?.nome || 'N/A'} - 
                                                            {formataDataExibicao(this.state.agendamento_selecionado?.dados_aplicacao?.data_agendada)}
                                                        </p>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                        </>
                                    )}
                                    
                                    {/*this.state.agendamento_selecionado.situacao == 'liberado' && (
                                        <Col sm={12} xs={12}> 
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data da Liberação</Form.Label>
                                                <Form.Control type="datetime-local" name="agendamento_data_liberacao" required placeholder="Data da Liberação" value={this.state.agendamento_selecionado.data_liberacao} onChange={e => this.handleChangeAgendamentoEdit(e, 'data_liberacao')} />    
                                            </Form.Group>
                                        </Col>
                                    )*/}
                                    {this.state.agendamento_selecionado.situacao == 'finalizado' && (
                                    <Col sm={6} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data da Realização</Form.Label>
                                            <Form.Control type="datetime-local" name="agendamento_data_realizacao" required placeholder="Data da Liberação" value={this.state.agendamento_selecionado.data_realizacao} onChange={e => this.handleChangeAgendamentoEdit(e, 'data_realizacao')} />    
                                        </Form.Group>
                                    </Col>
                                    )}

                                    {/* Dados da Aplicação - exibir quando finalizado e tem terapia */}
                                    {this.state.agendamento_selecionado?.situacao === 'finalizado' && this.state.agendamento_selecionado?.aplicacao_id && (
                                        <>
                                            <Col sm={12}>
                                                <hr />
                                                <h6 className="text-uppercase">Dados da Aplicação</h6>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Lote</Form.Label>
                                                    <p><strong>{this.state.agendamento_selecionado?.aplicacao_lote || '-'}</strong></p>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Validade</Form.Label>
                                                    <p><strong>{this.state.agendamento_selecionado?.aplicacao_validade ? formataDataExibicao(this.state.agendamento_selecionado.aplicacao_validade) : '-'}</strong></p>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Dose Aplicada</Form.Label>
                                                    <p><strong>{this.state.agendamento_selecionado?.aplicacao_dose || '-'}</strong></p>
                                                </Form.Group>
                                            </Col>
                                        </>
                                    )}

                                    {/* */}
                                    {showLocalProcedimento && (
                                        <>
                                            <h6 className="mt-3">Local do Procedimento</h6>
                                            <Col sm={12} xs={12}>
                                                <Row>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome do local</Form.Label>
                                                            <Form.Control type="text" placeholder="Nome do local" value={this.state.agendamento_selecionado.local_nome} onChange={e => this.handleChangeAgendamentoEdit(e, 'local_nome')} />
                                                            <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>CEP</Form.Label>
                                                            <Form.Control as={IMaskInput} required mask="00000-000"  type="text" placeholder="CEP" value={this.state.agendamento_selecionado.local_cep}  onAccept={(val) => { this.handleChangeAgendamentoEdit(val, 'local_cep'); if (val.length === 9) this.buscarCep(val); }}/>
                                                            <Form.Text id="formCEPHelpBlock" className="text-danger">{this.state.cepHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Endereço</Form.Label>
                                                            <Form.Control type="text" required placeholder="Endereço" value={this.state.agendamento_selecionado.local_endereco} onChange={e => this.handleChangeAgendamentoEdit(e, 'local_endereco')} />
                                                            <Form.Text id="formEnderecoHelpBlock" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Número</Form.Label>
                                                            <Form.Control type="text" required placeholder="Número" value={this.state.agendamento_selecionado.local_numero} onChange={e => this.handleChangeAgendamentoEdit(e, 'local_numero')} />
                                                            <Form.Text id="formNumeroHelpBlock" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Complemento</Form.Label>
                                                            <Form.Control type="text" placeholder="Complemento" value={this.state.agendamento_selecionado.local_complemento} onChange={e => this.handleChangeAgendamentoEdit(e, 'local_complemento')} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Cidade</Form.Label>
                                                            <Form.Control type="text" placeholder="Cidade" value={this.state.agendamento_selecionado.local_cidade} onChange={e => this.handleChangeAgendamentoEdit(e, 'local_cidade')} />
                                                            <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>UF</Form.Label>
                                                            <Form.Control as="select" value={this.state.agendamento_selecionado.local_uf} required onChange={e => this.handleChangeAgendamentoEdit(e, 'local_uf')}>
                                                                <option value="">Selecione o Estado</option>
                                                                {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                                ))}
                                                            </Form.Control>
                                                            <Form.Text id="formUFHelpBlock" className="text-danger">{this.state.ufHelper}</Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>                                    
                                            </Col>
                                        </>
                                    )}

                                    {this.renderDadosConfirmacao()}
                                    {this.renderDadosFormularioDinamicoServicos(this.state.agendamento_selecionado)}
                                    {this.renderDadosFormularioAprovacao(this.state.agendamento_selecionado)}
                                </Row>  
                                {this.state.agendamento_exige_termo_aceite && (
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                        <h6 className="mt-3">Termo de Aceite do Serviço</h6>
                                        <div className="d-flex flex-column gap-2">

                                            {/* Botão de download do termo do serviço */}
                                            <div className="d-flex align-items-center gap-2">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                disabled={!this.state.agendamento_termo_pdf_url}
                                                onClick={() => window.open(this.state.agendamento_termo_pdf_url, '_blank')}
                                            >
                                                Baixar Termo (PDF)
                                            </Button>

                                            {/* Se já existir termo assinado no agendamento (edição), mostra um "ver atual" */}
                                            {this.state.agendamento_termo_assinado_url && (
                                                <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => window.open(this.state.agendamento_termo_assinado_url, '_blank')}
                                                >
                                                Ver Termo Assinado Atual
                                                </Button>
                                            )}
                                            </div>

                                            {/* Upload do termo assinado */}
                                            <Form.Group className="mt-2">
                                            <Form.Label className="mb-1">Termo assinado (PDF)</Form.Label>
                                            <div className="d-flex align-items-center gap-2">
                                                <Form.Control
                                                type="file"
                                                accept="application/pdf"
                                                ref={this.fileInputTermoAssinado}
                                                onChange={this.onChangeTermoAssinado}
                                                />
                                                {this.state.agendamento_termo_assinado_file && (
                                                <>
                                                    <span className="text-success small">
                                                        {this.state.agendamento_termo_assinado_file.name}
                                                    </span>
                                                    <Button variant="outline-danger" size="sm" onClick={this.limparTermoAssinado}>
                                                    Remover
                                                    </Button>
                                                </>
                                                )}
                                            </div>
                                            {this.state.agendamento_termo_helper && (
                                                <Form.Text className="text-danger">{this.state.agendamento_termo_helper}</Form.Text>
                                            )}
                                            </Form.Group>
                                        </div>
                                        </Col>
                                    </Row>
                                )}  
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalAgendamento}>
                                    Fechar
                                </Button>
                                {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') && (
                                <Button variant="secondary" onClick={this.enviaSituacaoAgendamento}>
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Atualizar'}      
                                </Button>
                                )}
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalVisualizarAgendamento} onHide={this.handleCloseModalVisualizarAgendamento} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>Dados Agendamento</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={12} xs={12} className="mb-1">
                                        <div className="row-list">
                                            <Form.Label className="mb-0">
                                                DADOS DO AGENDAMENTO
                                            </Form.Label>
                                            <hr className="mb-2 mt-1"></hr>
                                            <p className="mb-1">
                                                <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>MÉDICO SOLICITANTE:</small>{" "}
                                                <strong>
                                                    {this.state.dados_medico_solicitante ? `${this.state.dados_medico_solicitante?.nome || ""}${
                                                        this.state.dados_medico_solicitante?.registro ? ` (${String(this.state.dados_medico_solicitante.registro).trim()}${
                                                            this.state.dados_medico_solicitante?.registro_uf ? `/${String(this.state.dados_medico_solicitante.registro_uf).trim().toUpperCase()}` : ""
                                                        })` : ""
                                                    }` : (this.state.agendamento_medico_nome || (this.state.agendamento_selecionado?.prestador_solicitante ? `Id: ${this.state.agendamento_selecionado.prestador_solicitante}` : "-"))}
                                                </strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>PACIENTE:</small> <strong>{(this.state.permite_editar) ? this.state.beneficiario_nome : 'Id: '+this.state.beneficiario_id}</strong>&nbsp;&nbsp;
                                                {hasPerm('add_beneficiarios') && (
                                                    <a href={`/pacientes/edit/${this.state.beneficiario_id}/?cliente_id=${this.state.cliente_id}`} target="_blank" rel="noreferrer">Ver Cadastro</a>
                                                )}
                                            </p>
                                            {this.state.beneficiario_dados.celular && (
                                                <p>
                                                    <small>TELEFONE PACIENTE:</small> <strong>{this.state.beneficiario_dados.celular || '-'}</strong>
                                                </p>
                                            )}
                                        </div>
                                    </Col>
                                </Row>  
                            </Modal.Body>
                        </Modal>

                        <Modal show={this.state.showModalReagendamentos} size="md" centered onHide={() => this.setState({ showModalReagendamentos: false })}>
                            <Modal.Header closeButton>
                                <Modal.Title>Histórico de Reagendamentos</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <table className="table table-sm">
                                <thead>
                                    <tr>
                                    <th>Data Original</th>
                                    <th>Data Reagendada</th>
                                    <th>Justificativa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.reagendamentos.map(r => (
                                    <tr key={r.id || (r.data_original + r.data_reagendada)}>
                                        <td>{formataDataHoraExibicao(r.data_original)}</td>
                                        <td>{formataDataHoraExibicao(r.data_reagendada)}</td>
                                        <td style={{whiteSpace: 'pre-wrap'}}>{r.justificativa}</td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                                {this.state.reagendamentos.length === 0 && <p>Nenhum registro encontrado.</p>}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.setState({ showModalReagendamentos: false })}>Fechar</Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalReagendamentos} size="md" centered onHide={() => this.setState({ showModalReagendamentos: false })}>
                            <Modal.Header closeButton>
                                <Modal.Title>Histórico de Reagendamentos</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <table className="table table-sm">
                                <thead>
                                    <tr>
                                    <th>Data Original</th>
                                    <th>Data Reagendada</th>
                                    <th>Justificativa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.reagendamentos.map(r => (
                                    <tr key={r.id || (r.data_original + r.data_reagendada)}>
                                        <td>{formataDataHoraExibicao(r.data_original)}</td>
                                        <td>{formataDataHoraExibicao(r.data_reagendada)}</td>
                                        <td style={{whiteSpace: 'pre-wrap'}}>{r.justificativa}</td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                                {this.state.reagendamentos.length === 0 && <p>Nenhum registro encontrado.</p>}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.setState({ showModalReagendamentos: false })}>Fechar</Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModal} onHide={this.handleCloseModal} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>{((this.state.entrega_id) ? 'Editar Agendamento' : 'Adicionar Agendamento')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={12} xs={12} className="mb-1">
                                        <div className="row-list">
                                            <Form.Label className="mb-0">
                                                PACIENTE
                                            </Form.Label>
                                            <hr className="mb-2 mt-1"></hr>
                                            <p className="mb-1">
                                                <small>NOME:</small> <strong>{(this.state.permite_editar) ? this.state.beneficiario_nome : 'Id: '+this.state.beneficiario_id}</strong>&nbsp;&nbsp;
                                                {hasPerm('add_beneficiarios') && (
                                                    <a href={`/pacientes/edit/${this.state.beneficiario_id}/?cliente_id=${this.state.cliente_id}`} target="_blank" rel="noreferrer">Ver Cadastro</a>
                                                )}
                                            </p>
                                            <p className="mb-1">
                                                <small>CPF:</small> <strong>{(this.state.beneficiario_dados.cpf) ? formataCPF(this.state.beneficiario_dados.cpf) : 'Não Informado'}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>DATA DE NASCIMENTO: </small> <strong>{this.state.beneficiario_dados.data_nascimento ? formataDataExibicao(this.state.beneficiario_dados.data_nascimento) : 'Não informado'}</strong>
                                            </p>
                                        
                                            <p className="mb-1">
                                                <small className="text-uppercase">{this.state.programa_dados.label_endereco_paciente || 'Endereço'}:</small>{' '}
                                                <strong>
                                                    {this.state.beneficiario_dados.nome_local ? this.state.beneficiario_dados.nome_local + '. ' : ''}
                                                    {this.state.beneficiario_dados.endereco}, {this.state.beneficiario_dados.numero}. {(this.state.beneficiario_dados.complemento) ? `${this.state.beneficiario_dados.complemento}. ` : ''}{this.state.beneficiario_dados.bairro}, {this.state.beneficiario_dados.cidade}/{this.state.beneficiario_dados.uf} - {this.state.beneficiario_dados.cep}
                                                </strong>
                                            </p>
                                            {this.state.beneficiario_dados.endereco_telefone && (
                                                <p>
                                                    <small>TELEFONE DE CONTATO:</small> <strong>{this.state.beneficiario_dados.endereco_telefone || '-'}</strong>
                                                </p>
                                            )}
                                        </div>
                                    </Col>
                                    {getConfig(this.state.programa_dados?.configuracoes, 'agendamento.tipo_prestador_operador', false) === false && (
                                    <Col sm={12} xs={12}>
                                        <Form.Label>
                                            Tipo de Agendamento
                                            {getConfig(this.state.programa_dados?.configuracoes, 'agendamento.tipo_agendamento_obrigatorio', false) && (
                                                <span className="text-danger">*</span>
                                            )}
                                        </Form.Label>
                                        <div className="mb-3">
                                        {
                                            Object.keys(this.list_tipo_agendamento).map((key, index) => ( 
                                                <Form.Check inline type="radio" label={this.list_tipo_agendamento[key]} key={key} id={key} name="agendamento_tipo" value={key} onChange={this.handleChangeAgendamento} checked={ key === this.state.agendamento_tipo ? true : false } required={getConfig(this.state.programa_dados?.configuracoes, 'agendamento.tipo_agendamento_obrigatorio', false)} />
                                            ))
                                        }                                              
                                        </div>
                                    </Col>
                                    )}
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço/Procedimento <span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregaServicoProcedimento}
                                                defaultOptions
                                                name="agendamento_servico_procedimento_id"
                                                placeholder="Buscar serviço/procedimento..."
                                                noOptionsMessage={() => "Nenhum serviço encontrado"}
                                                onChange={(e) => this.handleChangeAgendamento(e, 'agendamento_servico_procedimento_id')}
                                                value={this.state.agendamento_servico_procedimento_id ? { value: this.state.agendamento_servico_procedimento_id, label: this.state.agendamento_servico_procedimento_nome } : null}
                                            />                       
                                        </Form.Group>
                                    </Col>
                                    {this.state.agendamento_servico_video_conferencia ? (
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Metting - Tipo do host</Form.Label>
                                                <div className="mb-3">
                                                {
                                                    Object.keys(this.list_meeting_tipos_host).map((key, index) => ( 
                                                    <Form.Check inline type="radio" label={this.list_meeting_tipos_host[key]} key={key} id={key} name="meeting_tipo_host" value={key} onChange={this.handleChangeAgendamento} checked={ key === this.state.meeting_tipo_host ? true : false } />
                                                    ))
                                                }                                              
                                                </div>       
                                            </Form.Group>
                                        </Col>
                                    ) : (
                                        <>
                                        {getConfig(this.state.programa_dados?.configuracoes, 'agendamento.tipo_prestador_operador', false) === true && (
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo do Agendamento</Form.Label>
                                                <div className="mb-3">
                                                {
                                                    Object.keys(this.list_meeting_tipos_host).map((key, index) => ( 
                                                    <Form.Check inline type="radio" label={this.list_meeting_tipos_host[key]} key={key} id={key} name="meeting_tipo_host" value={key} onChange={this.handleChangeAgendamento} checked={ key === this.state.meeting_tipo_host ? true : false } />
                                                    ))
                                                }                                              
                                                </div>       
                                            </Form.Group>
                                        </Col>  
                                        )}
                                        </>
                                    )}
                                    {(this.state.agendamento_servico_procedimento_id && this.state.meeting_tipo_host == 'prestador') && (
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prestador do Serviço <span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                key={this.state.servico_agendamento_key}       
                                                cacheOptions
                                                loadOptions={this.carregaPrestadoresDebounced}
                                                defaultOptions
                                                name="agendamento_prestador_id"
                                                placeholder="Buscar por nome, razão social, nome fantasia ou CNPJ..."
                                                noOptionsMessage={() => "Nenhum prestador encontrado"}
                                                onChange={e => this.handleChangeAgendamento(e, 'agendamento_prestador_id')}
                                                value={this.state.agendamento_prestador_id ? { value: this.state.agendamento_prestador_id, label: this.state.agendamento_prestador_nome } : null}
                                            />                       
                                        </Form.Group>
                                    </Col>
                                    )}
                                    {this.state.agendamento_servico_terapia && (
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Vincular Terapia do Histórico <span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarTerapiasAtendimento}
                                                defaultOptions
                                                name="agendamento_terapia_id"
                                                placeholder="Selecione uma terapia do histórico..."
                                                noOptionsMessage={() => "Nenhuma terapia encontrada"}
                                                onChange={(e) => this.handleChangeAgendamento(e, 'agendamento_terapia_id')}
                                                value={this.state.agendamento_terapia_id ? { value: this.state.agendamento_terapia_id, label: this.state.agendamento_terapia_nome } : null}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    )}
                                    {(this.state.permite_alterar_valor_agendamento && this.state.agendamento_prestador_id) && (
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                            <NumericFormat
                                                customInput={Form.Control}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                prefix={'R$ '}
                                                name="agendamento_valor"
                                                value={this.state.agendamento_valor}
                                                required
                                                readOnly={!this.state.permite_alterar_valor_agendamento}
                                                onValueChange={(values) => {
                                                    this.setState({ agendamento_valor: values.value });
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    )}
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data de Solicitação <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                type="datetime-local" 
                                                name="data_solicitacao" 
                                                required 
                                                placeholder="Data de Solicitação" 
                                                value={this.state.data_solicitacao} 
                                                onChange={this.handleChangeAgendamento} 
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data do agendamento <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="datetime-local" name="agendamento_data" required placeholder="Data do Agendamento" value={this.state.agendamento_data} onChange={this.handleChangeAgendamento} />    
                                        </Form.Group>
                                    </Col>


                                    {showMedicoSolicitante && (
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Médico Solicitante</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregaMedicos}
                                                defaultOptions
                                                name="agendamento_medico_id"
                                                placeholder="Buscar médico solicitante..."
                                                noOptionsMessage={() => "Nenhum médico solicitante encontrado"}
                                                onChange={e => this.handleChangeAgendamento(e, 'agendamento_medico_id')}
                                                value={this.state.agendamento_medico_id ? { value: this.state.agendamento_medico_id, label: this.state.agendamento_medico_nome } : null}
                                            />                       
                                        </Form.Group>
                                    </Col>
                                    )}
                                    {/** Kit do programa */}
                                    {this.state.agendamento_servico_procedimento_nome === 'Envio Kit ODC' && this.state.programa_dados.habilitar_envio_kit_paciente && (dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'operador') && (
                                        <>
                                            <Col sm={12}>
                                                <Form.Label className="mt-4">Enviar kit?</Form.Label>
                                                <div className="mb-2">
                                                    <Form.Check
                                                        inline type="radio" name="enviarKitAgendamento" id="enviarKitAgendamento_sim" label="Sim"
                                                        checked={this.state.enviarKitAgendamento === 'sim'}
                                                        onChange={() => this.setState({ enviarKitAgendamento: 'sim' })}
                                                    />
                                                    <Form.Check
                                                        inline type="radio" name="enviarKitAgendamento" id="enviarKitAgendamento_nao" label="Não"
                                                        checked={this.state.enviarKitAgendamento === 'nao'}
                                                        onChange={() => this.setState({ enviarKitAgendamento: 'nao' })}
                                                    />
                                                </div>
                                            </Col>
                                            {this.state.enviarKitAgendamento === 'sim' && (
                                                <>
                                                <Col sm={12}>
                                                    <p>
                                                        <strong>Endereço do paciente: </strong>
                                                        {this.state.novoEndereco.nome_local ? this.state.novoEndereco.nome_local + '. ' : ''}
                                                        {this.state.novoEndereco.endereco}, {this.state.novoEndereco.numero}. {(this.state.novoEndereco.complemento) ? `${this.state.novoEndereco.complemento}. ` : ''}{this.state.novoEndereco.bairro}, {this.state.novoEndereco.cidade}/{this.state.novoEndereco.uf} - {this.state.novoEndereco.cep}
                                                    </p>
                                                </Col>
                                                {/*<Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Data Prevista de Envio do Kit <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control 
                                                            type="date" 
                                                            name="dataEnvioKit" 
                                                            required 
                                                            placeholder="Data de Envio do kit" 
                                                            value={this.state.dataEnvioKit} 
                                                            onChange={this.handleChangeAgendamento} 
                                                        />
                                                    </Form.Group>
                                                </Col>*/}
                                                </>
                                            )}
                                        </>
                                    )}
                                    {showObservacoes && (
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Observações</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="anotacoes"
                                                value={this.state.anotacoes}
                                                onChange={this.handleChangeAgendamento}
                                                placeholder="Observações adicionais"
                                            />
                                        </Form.Group>
                                    </Col>
                                    )}
                                </Row>
                                {showLocalProcedimento && (
                                    <Row>
                                    {this.state.informarLocalRealizacao && (
                                    <>
                                        <h6 className="mt-3">Local do Procedimento</h6>
                                        <Col sm={12} xs={12}>
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nome do local</Form.Label>
                                                        <Form.Control type="text" placeholder="Nome do local" value={this.state.local_nome} onChange={this.onChangeNome} />
                                                        <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CEP</Form.Label>
                                                        <Form.Control as={IMaskInput} required mask="00000-000"  type="text" placeholder="CEP" value={this.state.local_cep} onChange={this.onChangeCep} />
                                                        <Form.Text id="formCEPHelpBlock" className="text-danger">{this.state.cepHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Endereço</Form.Label>
                                                        <Form.Control type="text" required placeholder="Endereço" value={this.state.local_endereco} onChange={this.onChangeEndereco} />
                                                        <Form.Text id="formEnderecoHelpBlock" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Número</Form.Label>
                                                        <Form.Control type="text" required placeholder="Número" value={this.state.local_numero} onChange={this.onChangeNumero} />
                                                        <Form.Text id="formNumeroHelpBlock" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Complemento</Form.Label>
                                                        <Form.Control type="text" placeholder="Complemento" value={this.state.local_complemento} onChange={this.onChangeComplemento} />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cidade</Form.Label>
                                                        <Form.Control type="text" placeholder="Cidade" value={this.state.local_cidade} onChange={this.onChangeCidade} />
                                                        <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>UF</Form.Label>
                                                        <Form.Control as="select" value={this.state.local_uf} required onChange={this.onChangeUF}>
                                                            <option value="">Selecione o Estado</option>
                                                            {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                                <option key={sigla} value={sigla}>{nome}</option>
                                                            ))}
                                                        </Form.Control>
                                                        <Form.Text id="formUFHelpBlock" className="text-danger">{this.state.ufHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </Row>                                    
                                        </Col>
                                    </>
                                    
                                    )}
                                    </Row>
                                )}
                                {this.state.agendamento_exige_termo_aceite && (
                                    <Row className="mt-3">
                                        <Col sm={12}>
                                        <h6 className="mt-3">Termo de Aceite do Serviço</h6>
                                        <div className="d-flex flex-column gap-2">
    
                                            {/* Botão de download */}
                                            <div className="d-flex align-items-center gap-2">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                disabled={!this.state.agendamento_termo_pdf_url}
                                                onClick={() => window.open(this.state.agendamento_termo_pdf_url, '_blank')}
                                            >
                                                Baixar Termo (PDF)
                                            </Button>
    
                                            {this.state.agendamento_termo_assinado_url && (
                                                <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => window.open(this.state.agendamento_termo_assinado_url, '_blank')}
                                                >
                                                Ver Termo Assinado Atual
                                                </Button>
                                            )}
                                            </div>
    
                                            {/* Upload */}
                                            <Form.Group className="mt-2">
                                            <Form.Label className="mb-1">Termo assinado (PDF)</Form.Label>
                                            <div className="d-flex align-items-center gap-2">
                                                <Form.Control
                                                type="file"
                                                accept="application/pdf"
                                                ref={this.fileInputTermoAssinado}
                                                onChange={this.onChangeTermoAssinado}
                                                />
                                                {this.state.agendamento_termo_assinado_file && (
                                                <>
                                                    <span className="text-success small">
                                                    ✅ {this.state.agendamento_termo_assinado_file.name}
                                                    </span>
                                                    <Button variant="outline-danger" size="sm" onClick={this.limparTermoAssinado}>
                                                    Remover
                                                    </Button>
                                                </>
                                                )}
                                            </div>
                                            {this.state.agendamento_termo_helper && (
                                                <Form.Text className="text-danger">{this.state.agendamento_termo_helper}</Form.Text>
                                            )}
                                            </Form.Group>
                                        </div>
                                        </Col>
                                    </Row>
                                    )}

                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModal}>
                                Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.enviaAgendamento}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.entrega_id) ? 'Editar Agendamento' : 'Cadastrar Agendamento'}      
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalAcoes} onHide={this.handleCloseModalAcoes} size="lg" enforceFocus={false} // Evita conflitos de foco com o primeiro modal
                            className="modal-overlay-top"
                            backdropClassName="backdrop-overlay-top" >
                            <Modal.Header closeButton>
                                <Modal.Title>{this.state.acao_id ? 'Editar Lembrete de Ação' : 'Adicionar Lembrete de Ação'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={12} xs={12} className="mb-1">
                                        <div className="row-list">
                                            <Form.Label className="mb-0">
                                                Ação
                                            </Form.Label>
                                            <hr className="mb-2 mt-1"></hr>
                                            <Form.Group className="mb-3">
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregaAcoes}
                                                    defaultOptions
                                                    name="programa_acao_id"
                                                    placeholder="Buscar ação..."
                                                    noOptionsMessage={() => "Nenhuma ação encontrada"}
                                                    onChange={(e) => this.handleChangeAcao(e, 'programa_acao_id')}
                                                    value={this.state.programa_acao_id ? { value: this.state.programa_acao_id, label: this.state.programa_acao_nome } : null}
                                                />    
                                            </Form.Group>
                                        </div>
                                    </Col>

                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="acao_descricao"
                                                value={this.state.acao_descricao}
                                                onChange={this.handleChangeAcao}
                                                placeholder="Descrição da ação"
                                            />
                                        </Form.Group>
                                    </Col>

                                    {/*<Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Observações</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                name="acao_observacoes"
                                                value={this.state.acao_observacoes}
                                                onChange={this.handleChangeAcao}
                                                placeholder="Observações adicionais"
                                            />
                                        </Form.Group>
                                    </Col>*/}

                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data da Ação</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="acao_data"
                                                value={this.state.acao_data}
                                                onChange={this.handleChangeAcao}
                                                required
                                                min={new Date().toISOString().split("T")[0]}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Hora da Ação</Form.Label>
                                            <Form.Control
                                                type="time"
                                                name="acao_hora"
                                                value={this.state.acao_hora}
                                                onChange={this.handleChangeAcao}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    {this.state.acao_id && ( // Mostrar somente se for edição
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Realizado</Form.Label>
                                                <div>
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        label="Sim"
                                                        value="Sim"
                                                        checked={this.state.acao_realizado === "Sim"}
                                                        onChange={this.handleChangeAcao}
                                                        name="acao_realizado"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        type="radio"
                                                        label="Não"
                                                        value="Não"
                                                        checked={this.state.acao_realizado === "Não"}
                                                        onChange={this.handleChangeAcao}
                                                        name="acao_realizado"
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    )}

                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalAcoes}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.enviaAcao}>
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.acao_id ? 'Editar Ação' : 'Cadastrar Ação')}
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalProduto} onHide={this.handleCloseModalProduto} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>{((this.state.produto_id) ? 'Editar Medicamento' : 'Adicionar Medicamento')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Medicamento</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarProdutosProgramaAtendimento}
                                                defaultOptions
                                                name="programa_produto_id"
                                                onChange={e => this.handleChangeProduto(e, 'programa_produto_id')}
                                                placeholder="Buscar produto..."
                                                noOptionsMessage={() => "Nenhum produto encontrado"}
                                                value={this.state.programa_produto_id ? { value: this.state.programa_produto_id, label: this.state.programa_produto_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalProduto}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.enviaProduto}>
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.produto_id) ? 'Editar Medicamento' : 'Cadastrar Medicamento'}      
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalDosagem} onHide={this.handleCloseModalDosagem} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>{((this.state.dosagem_id) ? 'Editar Dosagem' : 'Adicionar Dosagem')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Produto</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarProdutosProgramaAtendimento}
                                                defaultOptions
                                                name="dosagem_produto_id"
                                                onChange={e => this.handleChangeDosagem(e, 'dosagem_produto_id')}
                                                placeholder="Buscar produto..."
                                                noOptionsMessage={() => "Nenhum produto encontrado"}
                                                value={this.state.dosagem_produto_id ? { value: this.state.dosagem_produto_id, label: this.state.dosagem_produto_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Apresentação</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarProdutoApresentacao}
                                                defaultOptions
                                                name="dosagem_apresentacao_id"
                                                onChange={e => this.handleChangeDosagem(e, 'dosagem_apresentacao_id')}
                                                placeholder="Buscar apresentação..."
                                                noOptionsMessage={() => "Nenhuma apresentação encontrada"}
                                                value={this.state.dosagem_apresentacao_id ? { value: this.state.dosagem_apresentacao_id, label: this.state.dosagem_apresentacao_descricao } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Quantidade</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="dosagem_quantidade"
                                                value={this.state.dosagem_quantidade ? this.state.dosagem_quantidade : ""} 
                                                required
                                                onChange={e => this.handleChangeDosagem(e, 'dosagem_quantidade')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Dosagem</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="dosagem_dosagem"
                                                value={this.state.dosagem_dosagem ? this.state.dosagem_dosagem : ""} 
                                                onChange={e => this.handleChangeDosagem(e, 'dosagem_dosagem')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Frequência</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="dosagem_frequencia"
                                                value={this.state.dosagem_frequencia ? this.state.dosagem_frequencia : ""} 
                                                required
                                                onChange={e => this.handleChangeDosagem(e, 'dosagem_frequencia')}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalDosagem}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.enviaDosagem}>
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.dosagem_id) ? 'Editar Dosagem' : 'Cadastrar Dosagem'}      
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalCompra} onHide={this.handleCloseModalCompra} size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>{((this.state.compra_id) ? 'Editar Compra' : 'Adicionar Compra')}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={4} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Produto</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarProdutosProgramaAtendimento}
                                                defaultOptions
                                                name="compra_produto_id"
                                                onChange={e => this.handleChangeCompra(e, 'compra_produto_id')}
                                                placeholder="Buscar produto..."
                                                noOptionsMessage={() => "Nenhum produto encontrado"}
                                                value={this.state.compra_produto_id ? { value: this.state.compra_produto_id, label: this.state.compra_produto_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Etapa</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarEtapasPrograma}
                                                defaultOptions
                                                name="compra_etapa_id"
                                                onChange={e => this.handleChangeCompra(e, 'compra_etapa_id')}
                                                placeholder="Buscar etapa..."
                                                noOptionsMessage={() => "Nenhuma etapa encontrada"}
                                                value={this.state.compra_etapa_id ? { value: this.state.compra_etapa_id, label: this.state.compra_etapa_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Farmácia</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarFarmacias}
                                                defaultOptions
                                                name="compra_farmacia_id"
                                                onChange={e => this.handleChangeCompra(e, 'compra_farmacia_id')}
                                                placeholder="Buscar farmácia..."
                                                noOptionsMessage={() => "Nenhuma farmácia encontrada"}
                                                value={this.state.compra_farmacia_id ? { value: this.state.compra_farmacia_id, label: this.state.compra_farmacia_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data da Compra</Form.Label>
                                            <Form.Control type="date" name="compra_data_compra" required placeholder="Data da Compra" value={this.state.compra_data_compra} onChange={e => this.handleChangeCompra(e, 'compra_data_compra')} />    
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data da próxima compra</Form.Label>
                                            <Form.Control type="date" name="compra_data_proxima_compra" required placeholder="Data da próxima compra" value={this.state.compra_data_proxima_compra} onChange={e => this.handleChangeCompra(e, 'compra_data_proxima_compra')} />    
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalCompra}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.enviaCompra}>
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.compra_id) ? 'Editar Compra' : 'Cadastrar Compra'}      
                                </Button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showModalMonitoria} onHide={this.handleCloseModalMonitoria} size="lg">
                            <Form onSubmit={this.onSubmitMonitoria}>
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        {this.state.is_aplicacao_realizado ? (
                                            <>
                                                Visualizar
                                            </>
                                        ) : (
                                            <>
                                                {((this.state.monitoria_id) ? 'Editar' : 'Adicionar nova data')}
                                            </>
                                        )}
                                        </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Card className="cardDestaque mt-4">
                                        <Card.Body>                   
                                            <Row className="align-items-center mb-3">
                                                <Col sm={12}>
                                                    <Form.Group controlId="formBasicRadio">
                                                        <Form.Label>Escolha a via de administração</Form.Label>
                                                        <Row style={{marginBottom: "20px"}}>
                                                        {('results' in this.state.monitoria_tipos && this.state.monitoria_tipos.results.length > 0) && (
                                                                this.state.monitoria_tipos.results.map((tipos, index) => ( 
                                                                    <Col sm={4} key={index}>
                                                                        <Form.Check 
                                                                            type="radio"
                                                                            label={tipos.nome}
                                                                            name="administração"
                                                                            value={tipos.id}
                                                                            disabled={this.state.is_aplicacao_realizado}
                                                                            checked={this.state.monitoria_tipo_id == tipos.id}
                                                                            onChange={(e) => {this.handleChangeMonitoria(e, "monitoria_tipo_id")}}
                                                                        />
                                                                    </Col>
                                                                ))
                                                            )}
                                                        </Row>
                                                    </Form.Group>       
                                                </Col>
                                                <Col sm={12}>
                                                    <Row>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                            <Form.Label>Data Prevista <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control 
                                                                type="date" 
                                                                required 
                                                                placeholder="Data Prevista" 
                                                                name="data_prevista" 
                                                                disabled={this.state.is_aplicacao_realizado}
                                                                value={this.state.monitoria_data_prevista} 
                                                                onChange={(e) => this.handleChangeMonitoria(e, "monitoria_data_prevista")} 
                                                            />                       
                                                            </Form.Group>     
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Label>Status da Utilização <span className="text-danger">*</span></Form.Label>
                                                            {this.state.is_aplicacao_realizado ? (
                                                                <p>{this.state.monitoria_status}</p>   
                                                            ) : (
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarMonitoriaStatus}
                                                                    defaultOptions
                                                                    required
                                                                    name="monitoria_status"
                                                                    placeholder="Buscar status..."
                                                                    noOptionsMessage={() => "Nenhum status encontrado"}
                                                                    onChange={(e) => this.handleChangeMonitoria(e, 'monitoria_status_id')}
                                                                    value={this.state.monitoria_status_id ? { value: this.state.monitoria_status_id, label: this.state.monitoria_status } : null}
                                                                    isDisabled={this.state.is_aplicacao_realizado}
                                                                />
                                                            )}
                                                            {/*
                                                            <Form.Control as="select" value={this.monitoria_status} name="monitoria_status" required onChange={(e) => this.handleChangeMonitoria(e, "monitoria_status")}>
                                                                <option value="">Selecione o Status</option>
                                                                <option value="Realizada">Realizada</option>
                                                                <option value="Não Realizada">Não Realizada</option>
                                                                <option value="Não Realizada/Farmacovigilância">Não Realizada/Farmacovigilância</option>
                                                                <option value="Reagendada">Reagendada</option>
                                                            </Form.Control>
                                                            */}
                                                        </Col>
                                                        {(this.state.monitoria_status === 'Realizado' || this.state.monitoria_status === 'Realizada') && (
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                <Form.Label>Data de Realização <span className="text-danger">*</span></Form.Label>
                                                                <Form.Control 
                                                                    type="date" 
                                                                    required 
                                                                    placeholder="Data Prevista" 
                                                                    name="data_realizacao" 
                                                                    value={this.state.monitoria_data_realizacao} 
                                                                    onChange={(e) => this.handleChangeMonitoria(e, "monitoria_data_realizacao")} 
                                                                    disabled={this.state.is_aplicacao_realizado}
                                                                />                       
                                                                </Form.Group>     
                                                            </Col>
                                                        )}
                                                        {(this.state.monitoria_status === 'Não Realizada' || this.state.monitoria_status === 'Não Realizado') && (
                                                            <Col sm={4}>
                                                                <Form.Label>Motivo não Realização <span className="text-danger">*</span></Form.Label>
                                                                <Form.Control as="select" value={this.state.monitoria_motivo || ''} disabled={this.state.is_aplicacao_realizado} name="monitoria_motivo" onChange={(e) => this.handleChangeMonitoria(e, "monitoria_motivo")}>
                                                                    <option value="">Selecione um motivo</option>                                                                
                                                                    {Object.keys(motivosAplicacao).map((motivo, idx) => (
                                                                        <option key={idx} value={motivo}>{motivo}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                    {(this.state.monitoria_status === "Realizada" || this.state.monitoria_status === "Realizado") && (
                                    <Card className="cardDestaque">
                                        <Card.Body>   
                                            <h4>Dosagens</h4>
                                            {this.state.monitoria_dosagens.map((dosagem, index) => {

                                                let valorInt = 0;
                                                let unidade = '';

                                                if(dosagem.dosagem_nome) {
                                                    const [valorStr, ...unidadeArr] = dosagem.dosagem_nome.split(' ');
                                                    valorInt = Math.trunc(parseFloat(valorStr));       // tira as casas decimais
                                                    unidade = unidadeArr.join(' ');                     // junta "mg" ou "ml"
                                                }

                                                return (
                                                    <div key={index} className="row-list">
                                                        <Row style={{marginBottom: "10px"}}>    
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Dosagem Aplicada</Form.Label>   
                                                                    {this.state.is_aplicacao_realizado && dosagem.dosagem_nome ? (
                                                                        <p>{`${valorInt}${unidade ? ' ' + unidade : ''}`}</p>
                                                                    ) : (
                                                                        <AsyncSelect
                                                                            isDisabled={this.state.is_aplicacao_realizado}
                                                                            required
                                                                            cacheOptions
                                                                            loadOptions={this.carregarDosagensPrograma}
                                                                            defaultOptions
                                                                            name="dosagem_id"
                                                                            placeholder={'Buscar dosagem...'}
                                                                            noOptionsMessage={() => "Nenhuma dosagem encontrada"}
                                                                            onChange={e => this.handleChangeMonitoriaDosagem(e, 'dosagem_id', index)}
                                                                            value={dosagem.dosagem_id ? { value: dosagem.dosagem_id, label: dosagem.dosagem_nome } : null}
                                                                        />
                                                                    )}
                                                                </Form.Group>
                                                            </Col>                                            
                                                            <Col sm={6} xs={12}>
                                                                <Form.Group>
                                                                    <Form.Label>Quantidade Aplicada</Form.Label>   
                                                                    {this.state.is_aplicacao_realizado ? (
                                                                        <p>{dosagem.quantidade}</p>
                                                                    ) : (
                                                                        <Form.Control 
                                                                            type="number"                                                             
                                                                            name="quantidade"
                                                                            value={dosagem.quantidade} 
                                                                            onChange={(e) => this.handleChangeMonitoriaDosagem(e, 'quantidade', index)}
                                                                            disabled={this.state.is_aplicacao_realizado}
                                                                        />
                                                                    )}
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        {!this.state.is_aplicacao_realizado && (
                                                        <Row>
                                                            <Col sm={12}>
                                                                {this.state.monitoria_id && (
                                                                    <Button variant="success" className="btn-sm" onClick={() => this.salvarMonitoriaDosagem(index)}><FaCheck className="me-1" /> Salvar Dosagem</Button>
                                                                )}
                                                                <Button variant="danger" className="btn-sm ms-2" onClick={() => this.removerMonitoriaDosagem(index)}><FaTimes className="me-1" /> Remover Dosagem</Button>
                                                            </Col>
                                                        </Row>
                                                        )}
                                                    </div>
                                                )
                                            })}
                                            {!this.state.is_aplicacao_realizado && (
                                                <Button variant="secondary" onClick={this.adicionarMonitoriaDosagem}><FaStream /> Adicionar Dosagem</Button>
                                            )}
                                        </Card.Body>                
                                    </Card>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary-outline" onClick={this.handleCloseModalMonitoria}>
                                    Fechar
                                    </Button>
                                    {!this.state.is_aplicacao_realizado && (
                                    <Button type="submit" variant="secondary">
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.monitoria_id) ? 'Salvar' : 'Salvar'}      
                                    </Button>
                                    )}
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    </>
                )}

                {!this.state.atendimento_id && this.state.dicas.length > 0 && (
                <div className="cardDestaque mod-2 card my-3">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12">
                                <h2>Como funciona</h2>
                                <p className="mb-1">
                                    {this.state.programa_dados.dicas_texto}
                                </p>
                            </div>
                            {this.state.dicas.map((dica, index) => (
                            <div className="col-12 col-md-6 col-xl-3 text-center mt-3" key={index}>
                                <div className="card align-items-center justify-content-center text-bg-light p-4 rounded-3 border-0">
                                    {dica.imagem && (
                                    <img className="img-fluid mb-4" src={dica.imagem} alt={dica.titulo} />
                                    )}

                                    <h4 className="text-primary mb-2">{dica.titulo}</h4>
                                    <p className="mb-0">{dica.descricao || ''}</p>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
                )}

                <Modal
                    show={this.state.showModalHistorico}
                    onHide={this.handleCloseHistorico}
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Histórico de Valores</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h6><strong>{this.state.nomeCampoHistorico}</strong></h6>
                        <hr />
                        {this.state.historicoCampos.length > 0 ? (
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.historicoCampos.map((historico) => {
                                        // tenta parsear como JSON
                                        let conteudo;
                                        try {
                                            const arr = JSON.parse(historico.valor);
                                            if (Array.isArray(arr)) {
                                                // agrupa em “blocos” sempre que voltamos ao primeiro subcampo
                                                const groups = [];
                                                let current = [];
                                                arr.forEach((item, idx) => {
                                                if (
                                                    idx > 0 &&
                                                    item.subcampo_id === arr[0].subcampo_id &&
                                                    current.length
                                                ) {
                                                    groups.push(current);
                                                    current = [];
                                                }
                                                current.push(item);
                                                });
                                                if (current.length) groups.push(current);

                                                // monta a saída
                                                conteudo = groups.map((grp, gi) => (
                                                <div key={gi} style={{ marginBottom: gi < groups.length - 1 ? 8 : 0 }}>
                                                    {grp.map((it, ii) => (
                                                    <p key={ii} style={{ margin: 0 }}>
                                                        <strong>{it.subcampo_nome}:</strong> {it.valor}
                                                    </p>
                                                    ))}
                                                    {gi < groups.length - 1 && <hr />}
                                                </div>
                                                ));
                                            } else {
                                                // se não for array JSON, mostra o valor bruto
                                                conteudo = historico.valor;
                                            }
                                        } catch {
                                            // não era JSON
                                            conteudo = historico.valor;
                                        }

                                        return (
                                            <tr key={historico.atendimento_campo_id}>
                                                <td>{formataDataHoraExibicao(historico.data_historico)}</td>
                                                <td>{conteudo}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        ) : (
                            <p>Nenhum histórico disponível.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-primary" onClick={this.handleCloseHistorico}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showHistoricoAgendamentosModal} onHide={this.handleCloseHistoricoAgendamentos} size="lg" centered >
                    <Modal.Header closeButton>
                        <Modal.Title>Histórico de aceites/recusas</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {this.state.historicoAgendamentosLoading && (
                        <div className="text-muted">Carregando…</div>
                        )}

                        {!this.state.historicoAgendamentosLoading && this.state.historicoAgendamentosErro && (
                        <div className="text-danger">{this.state.historicoAgendamentosErro}</div>
                        )}

                        {!this.state.historicoAgendamentosLoading && !this.state.historicoAgendamentosErro && (
                        this.state.historicoAgendamentosRows.length > 0 ? (
                            <table className="table table-sm table-striped mb-0">
                            <thead>
                                <tr>
                                <th>Prestador</th>
                                <th>Aceito</th>
                                <th>Data</th>
                                <th>Observações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.historicoAgendamentosRows.map((it, idx) => (
                                    <tr key={idx}>
                                        <td>
                                            {(() => {
                                                const p = this.state.historicoAgendamentosPrestadoresMap[it.prestador_id];
                                                return p
                                                ? (
                                                    <>
                                                        {p.nome}
                                                        {p.nome_fantasia && <p className="mb-0 p-info">{p.nome_fantasia}</p>}
                                                    </>
                                                    )
                                                : (it.prestador_id != null ? `#${it.prestador_id}` : '-');
                                            })()}
                                        </td>
                                        <td>
                                        {it.aceite
                                            ? <span className="badge bg-success">Sim</span>
                                            : <span className="badge bg-warning text-dark">Não</span>}
                                        </td>
                                        <td>
                                        {it.data_criacao
                                            ? new Date(it.data_criacao).toLocaleString('pt-BR')
                                            : '-'}
                                        </td>
                                        <td> {it.observacao} </td>
                                    </tr>
                                ))}
                            </tbody>
                            </table>
                        ) : (
                            <div className="text-muted">Nenhum registro encontrado.</div>
                        )
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseHistoricoAgendamentos}>
                        Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showDespesasAgendamentosModal} onHide={this.handleCloseDespesasAgendamentos} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Despesas do Agendamento</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {this.state.despesasAgendamentosLoading && <div className="text-muted">Carregando…</div>}

                        {!this.state.despesasAgendamentosLoading && this.state.despesasAgendamentosErro && (
                        <div className="text-danger">{this.state.despesasAgendamentosErro}</div>
                        )}

                        {!this.state.despesasAgendamentosLoading && !this.state.despesasAgendamentosErro && (
                        this.state.despesasAgendamentosRows.length > 0 ? (
                            <table className="table table-sm table-striped align-middle">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Data</th>
                                        <th>Categoria</th>
                                        <th>Prestador</th>
                                        <th>Valor</th>
                                        <th>Comprovante</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.despesasAgendamentosRows.map((d) => {
                                        const catLabel = d.categoria_outros
                                            ? `Outros: ${d.categoria_outros}`
                                            : (d.dados_categoria?.nome || '-');

                                        const valorLabel = (() => {
                                            // tenta formatar pt-BR
                                            const num = Number(String(d.valor).replace(/[^\d.-]+/g, '').replace(',', '.'));
                                            if (!isNaN(num)) return num.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
                                            return d.valor ?? '-';
                                        })(); 

                                        return (
                                            <tr key={d.id}>
                                                <td>{d.descricao || '-'}</td>
                                                <td>{d.data ? new Date(d.data).toLocaleDateString('pt-BR') : '-'}</td>
                                                <td>{catLabel}</td>
                                                <td>{d.dados_prestador?.nome}</td>
                                                <td>{valorLabel}</td>
                                                <td>
                                                    {d.comprovante
                                                    ? <a href={d.comprovante} target="_blank" rel="noreferrer">Abrir</a>
                                                    : '-'}
                                                </td>
                                                <td>
                                                    <Button 
                                                        variant="outline-danger" 
                                                        size="sm" 
                                                        onClick={() => this.handleExcluirDespesa(d.id)}
                                                        title="Excluir despesa"
                                                    >
                                                        <FaTrash />
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    {this.state.despesasAgendamentosRows.length > 0 && (
                                        <tr>
                                            <td colSpan={4} className="text-end fw-bold">Total</td>
                                            <td className="fw-bold">
                                            {(() => {
                                                const total = this.state.despesasAgendamentosRows.reduce((acc, d) => {
                                                const num = Number(String(d.valor).replace(/[^\d.-]+/g, '').replace(',', '.'));
                                                return acc + (isNaN(num) ? 0 : num);
                                                }, 0);
                                                return total.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
                                            })()}
                                            </td>
                                            <td colSpan={2}></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-muted">Nenhuma despesa cadastrada.</div>
                        )
                        )}

                        <hr className="my-3" />

                        <div className="d-flex justify-content-end">
                            <Button
                                variant={this.state.despesasAgendamentosShowForm ? "outline-secondary" : "primary"}
                                size="sm"
                                onClick={() => this.setState(s => ({ despesasAgendamentosShowForm: !s.despesasAgendamentosShowForm }))}
                            >
                                {this.state.despesasAgendamentosShowForm ? (
                                    <>
                                        Cancelar Nova Despesa
                                    </>
                                ) : (
                                    <>
                                        <FaPlus className="me-1" /> Nova Despesa
                                    </>
                                )}
                            </Button>
                        </div>

                        {/* Formulário de nova despesa */}
                        {this.state.despesasAgendamentosShowForm && (
                            <Form className="mt-3" onSubmit={this.handleSubmitDespesaAgendamentos}>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Form.Group controlId="despesaDescricao">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="descricao"
                                            value={this.state.despesasAgendamentosForm.descricao}
                                            onChange={this.handleChangeDespesasAgendamentosForm}
                                            required
                                        />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId="despesaValor">
                                            <Form.Label>Valor</Form.Label>
                                            <NumericFormat
                                                name="valor"
                                                thousandSeparator={'.'}
                                                decimalSeparator={','}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                prefix={'R$ '}
                                                value={this.state.despesasAgendamentosForm.valor}
                                                onChange={this.handleChangeDespesasAgendamentosForm}
                                                className="form-control"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId="despesaData">
                                            <Form.Label>Data</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="data"
                                                value={this.state.despesasAgendamentosForm.data}
                                                onChange={this.handleChangeDespesasAgendamentosForm}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="despesaCategoria">
                                            <Form.Label>Categoria</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions={[...(this.state.despesasAgendamentosCategorias || []).map(c => ({value: String(c.id), label: c.titulo, slug: c.slug || ''})),{ value: '__outros__', label: 'Outros', slug: 'outros' },]}
                                                loadOptions={this.carregaCategoriasDespesas}
                                                name="despesa_categoria_id"
                                                placeholder="Buscar categoria..."
                                                noOptionsMessage={() => "Nenhuma categoria encontrada"}
                                                isClearable
                                                onChange={(opt) => this.setState(s => ({
                                                despesasAgendamentosForm: {
                                                    ...s.despesasAgendamentosForm,
                                                    despesa_categoria_id: (opt?.slug === 'outros') ? '' : (opt?.value || ''),
                                                    despesa_categoria_nome: opt?.label || '',
                                                    despesa_categoria_slug: opt?.slug || '',
                                                    categoria_outros: (opt?.slug === 'outros')
                                                    ? s.despesasAgendamentosForm.categoria_outros
                                                    : ''
                                                }
                                                }))}
                                                value={(() => {const f = this.state.despesasAgendamentosForm; if ((f.despesa_categoria_slug || '').toLowerCase() === 'outros') { return { value: '__outros__', label: 'Outros', slug: 'outros' };}
                                                    return f.despesa_categoria_id
                                                        ? { value: String(f.despesa_categoria_id), label: f.despesa_categoria_nome || 'Selecionada' }
                                                        : null;
                                                    })()}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />

                                            <Collapse
                                                in={(this.state.despesasAgendamentosForm.despesa_categoria_slug || '').toLowerCase() === 'outros'}
                                                mountOnEnter
                                                unmountOnExit
                                            >
                                                <div>
                                                <Form.Group controlId="despesaCategoriaOutros" className="mt-2">
                                                    <Form.Label>Descrever (Outros)</Form.Label>
                                                    <Form.Control
                                                    type="text"
                                                    name="categoria_outros"
                                                    value={this.state.despesasAgendamentosForm.categoria_outros}
                                                    onChange={this.handleChangeDespesasAgendamentosForm}
                                                    required
                                                    />
                                                </Form.Group>
                                                </div>
                                            </Collapse>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="despesaComprovante">
                                        <Form.Label>Comprovante (imagem ou PDF)</Form.Label>
                                        <Form.Control
                                            type="file"
                                            name="comprovante"
                                            accept="image/*,.pdf"
                                            onChange={this.handleChangeDespesasAgendamentosForm}
                                        />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Informar km */}
                                <Form.Group className="mt-3" controlId="despesaInformarKm">
                                <Form.Label className="me-3">Informar km</Form.Label>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="informarKmNao"
                                        label="Não"
                                        name="informar_km_choice"
                                        checked={!this.state.despesasAgendamentosForm.informar_km}
                                        onChange={() => this.setState(s => ({
                                        despesasAgendamentosForm: { ...s.despesasAgendamentosForm, informar_km: false }
                                        }))}
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="informarKmSim"
                                        label="Sim"
                                        name="informar_km_choice"
                                        checked={this.state.despesasAgendamentosForm.informar_km}
                                        onChange={() => this.setState(s => ({
                                        despesasAgendamentosForm: { ...s.despesasAgendamentosForm, informar_km: true }
                                        }))}
                                    />
                                </Form.Group>

                                <Collapse in={this.state.despesasAgendamentosForm.informar_km} mountOnEnter unmountOnExit>
                                    <div>
                                        <Row className="g-3 mt-1">
                                            <Col md={6}>
                                                <Form.Group controlId="enderecoOrigem">
                                                <Form.Label>Endereço de origem</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="endereco_origem"
                                                        value={this.state.despesasAgendamentosForm.endereco_origem}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="enderecoOrigem">
                                                <Form.Label>Endereço de Destino</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="endereco_destino"
                                                        value={this.state.despesasAgendamentosForm.endereco_destino}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={4}>
                                                <Form.Group controlId="kmTotal">
                                                <Form.Label>Km total</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="0,00"
                                                        name="km_total"
                                                        value={this.state.despesasAgendamentosForm.km_total}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={8}>
                                                <Form.Group controlId="kmMotivo">
                                                <Form.Label>Motivo do deslocamento</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        name="motivo"
                                                        value={this.state.despesasAgendamentosForm.motivo}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Collapse>

                                <div className="d-flex justify-content-end mt-3">
                                    <Button type="submit" variant="success" size="sm"><FaCheck className="me-1" /> Adicionar Despesa</Button>
                                </div>
                            </Form>
                            )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={this.handleCloseDespesasAgendamentos}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Confirmação de Realização de Serviço */}
                <ConfirmarRealizacaoModal
                    show={this.state.showConfirmarRealizacaoModal}
                    onHide={() => this.setState({ showConfirmarRealizacaoModal: false, agendamentoParaConfirmar: null })}
                    agendamento={this.state.agendamentoParaConfirmar}
                    contextData={{
                        beneficiario_id: this.state.beneficiario_id,
                        atendimento_id: this.state.atendimento_id,
                        etapa_atual: this.state.etapa_atual,
                        prestador_nome: this.state.agendamento_selecionado?.prestador_nome || this.state.agendamento_selecionado?.dados_prestador?.nome,
                    }}
                    programa_config={this.state.programa_dados?.configuracoes}
                    onSuccess={() => {
                        this.setState({ showConfirmarRealizacaoModal: false, agendamentoParaConfirmar: null });
                        this.carregarAgendamentos();
                        this.carregarDadosAtendimento(this.state.atendimento_id);
                    }}
                />

                {/* Modal de Formulário Dinâmico de Serviços */}
                <ModalPersonalizadoServicos
                    show={this.state.showModalPersonalizadoServicos}
                    onHide={() => this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false })}
                    agendamento={this.state.agendamentoFormularioDinamico}
                    contextData={{
                        atendimento_id: this.state.atendimento_id,
                        etapa_atual: this.state.etapa_atual,
                    }}
                    onSuccess={() => {
                        this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false });
                        this.carregarAgendamentos();
                    }}
                    readOnly={this.state.formularioDinamicoReadOnly}
                />

                {/* Modal de Formulário por Evento (aprovação de laudo) */}
                <FormularioEventoModal
                    show={this.state.showFormularioEventoModal}
                    onHide={() => this.setState({ 
                        showFormularioEventoModal: false, 
                        formularioEventoData: null, 
                        arquivoParaAprovar: null 
                    })}
                    formulario={this.state.formularioEventoData}
                    onSuccess={this.handleFormularioEventoSuccess}
                />
                
                {/* Modal de Formulário para Aprovação Durante Confirmação */}
                <FormularioEventoModal
                    show={this.state.showFormularioEventoModalConfirmacao}
                    onHide={() => this.setState({
                        showFormularioEventoModalConfirmacao: false,
                        formularioEventoDataConfirmacao: null,
                        agendamentoParaConfirmarComFormulario: null
                    })}
                    formulario={this.state.formularioEventoDataConfirmacao}
                    onSuccess={this.handleFormularioConfirmacaoSuccess}
                />

                {/* Modal de visualização dos relatos da etapa atual */}
                <ModalRelatosEtapaAtual
                    show={this.state.showModalRelatosEtapaAtual}
                    onHide={() => this.setState({ showModalRelatosEtapaAtual: false })}
                    etapaId={this.state.etapa_atual?.id}
                    etapaNome={this.state.etapa_atual?.nome || this.state.etapa_nome}
                    atendimentoId={this.state.atendimento_id}
                />
            </div>
        )
    }
}

export default withRouter(AtendimentosEdit);
